import { SVGProps } from "react";

export const EducationIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2037_8001)">
        <path
          d="M25.7305 34.1003V33.6058C25.7365 33.5022 25.7197 33.3985 25.6811 33.3022C25.6425 33.2059 25.5832 33.1192 25.5073 33.0484C25.4314 32.9776 25.3409 32.9243 25.2421 32.8925C25.1433 32.8606 25.0388 32.8509 24.9358 32.8641C24.7701 32.8848 24.617 32.9636 24.5039 33.0865C24.3907 33.2093 24.3248 33.3683 24.3177 33.5352L24.2471 35.0362"
          fill="white"
        />
        <path
          d="M25.9955 34.0826C25.9955 33.8177 26.0662 33.4998 25.9779 33.2526C25.8946 33.0423 25.7417 32.867 25.5449 32.7558C25.348 32.6446 25.1189 32.6042 24.8959 32.6414C24.6728 32.6786 24.4693 32.791 24.3191 32.9601C24.1689 33.1292 24.0812 33.3446 24.0706 33.5704C24.0529 33.8353 24.0529 34.0826 24.0353 34.3475L23.9999 35.0539C23.9823 35.3188 24.5121 35.2658 24.5297 35.0186L24.5827 33.7117C24.6004 33.5175 24.6004 33.3055 24.7417 33.1643C24.7866 33.1126 24.8455 33.075 24.9114 33.0562C24.9772 33.0374 25.0471 33.0381 25.1125 33.0583C25.2581 33.1126 25.3779 33.2198 25.4481 33.3585C25.4952 33.4824 25.5074 33.6167 25.4834 33.747V34.1179C25.4657 34.3828 25.9955 34.3298 26.0132 34.0826H25.9955Z"
          fill="#00244C"
        />
        <path
          d="M23.1172 35.76L23.2055 34.6121C23.2233 34.3094 23.3457 34.0223 23.5519 33.8C23.7581 33.5777 24.0352 33.434 24.3357 33.3936L24.2651 35.0712"
          fill="white"
        />
        <path
          d="M23.3816 35.7426L23.4523 34.6654C23.4597 34.4345 23.5266 34.2094 23.6465 34.012C23.7213 33.8955 23.8196 33.7961 23.9352 33.72C24.0508 33.644 24.1811 33.593 24.3176 33.5705L24.088 33.4292L23.9997 35.1069C23.9821 35.3541 24.5119 35.2658 24.5119 35.0539L24.6002 33.3762C24.6002 33.2526 24.4589 33.2173 24.3706 33.2173C24.0615 33.2524 23.7684 33.3736 23.5249 33.5672C23.2813 33.7608 23.0971 34.0189 22.9931 34.3122C22.8872 34.6477 22.9225 35.0186 22.8872 35.3541V35.778C22.8695 36.0429 23.3816 35.9546 23.3993 35.7426H23.3816Z"
          fill="#00244C"
        />
        <path
          d="M22.1812 36.0426L22.2165 35.3892C22.2302 35.1393 22.3416 34.9048 22.5266 34.7364C22.7116 34.5679 22.9554 34.4789 23.2054 34.4885L23.1171 35.8483"
          fill="white"
        />
        <path
          d="M22.446 36.0074L22.4813 35.4423C22.4757 35.3293 22.4876 35.2161 22.5167 35.1068L22.5696 35.0185L22.6403 34.9125H22.6579L22.6933 34.8595L22.7286 34.8242H22.7639C22.7286 34.8419 22.7816 34.7889 22.7639 34.8242L22.8169 34.7712H23.0994L22.9405 34.6476L22.8699 36.0074C22.8522 36.1134 22.9935 36.1487 23.0994 36.131C23.2054 36.1134 23.3643 36.0604 23.382 35.9544L23.4526 34.5946C23.4703 34.4887 23.382 34.4534 23.2937 34.4534C23.0657 34.4418 22.8385 34.4894 22.6343 34.5915C22.4301 34.6936 22.2557 34.8468 22.1281 35.0361C21.9925 35.2907 21.9313 35.5784 21.9515 35.8661V36.184C21.9339 36.3076 22.0752 36.343 22.1811 36.3253C22.2871 36.3076 22.4637 36.2547 22.4637 36.131L22.446 36.0074Z"
          fill="#00244C"
        />
        <path
          d="M7.68188 20.0252L10.5075 19.7603L16.7768 19.1599L23.2934 18.5418L26.9137 18.1886C27.7137 18.0918 28.5246 18.2331 29.2448 18.5948C29.6786 18.8194 30.0611 19.1315 30.3681 19.5115C30.6751 19.8914 30.9 20.331 31.0285 20.8023C31.6112 22.7802 30.5516 24.9876 28.4678 25.4468C28.1068 25.521 27.7408 25.5682 27.3728 25.5881L25.5009 25.7647L19.3728 26.3474L12.768 26.9832L8.81213 27.354H8.61787L8.40595 27.5483C9.71279 27.407 9.92471 25.9059 9.97769 24.8287C10.0074 24.0709 9.94816 23.3122 9.80109 22.5682C9.69687 21.8903 9.48209 21.234 9.16533 20.6257C8.88277 20.1488 8.49425 19.7603 7.91147 19.7956C7.82316 19.8133 7.61124 19.831 7.55826 19.9193C7.50528 20.0076 7.61124 20.0076 7.68188 20.0076C8.05275 19.9722 8.40595 20.3784 8.60021 20.6786C8.9017 21.1979 9.11084 21.7656 9.21831 22.3563C9.51853 23.6102 9.62449 25.0583 9.25363 26.3298C9.18953 26.596 9.07568 26.8476 8.91809 27.0715C8.86196 27.1602 8.79015 27.238 8.70617 27.3011L8.60021 27.354H8.61787C8.52957 27.354 8.33531 27.3894 8.28233 27.4777C8.22935 27.566 8.33531 27.566 8.40595 27.5483L11.2845 27.2834L17.7128 26.6653L24.2647 26.0472L27.6731 25.7293C28.6444 25.6234 29.598 25.3408 30.3574 24.7227C30.7372 24.4053 31.0499 24.0153 31.2773 23.5757C31.5047 23.136 31.6423 22.6555 31.6819 22.1621C31.7798 21.1895 31.5157 20.2149 30.9402 19.4248C30.6179 19.0129 30.2154 18.6706 29.757 18.4186C29.2987 18.1667 28.794 18.0103 28.2735 17.959C27.7785 17.9237 27.2812 17.9415 26.7901 18.012L25.0064 18.1709L18.8784 18.7537L12.1499 19.3895L8.10573 19.778H7.91147C7.82316 19.7956 7.61124 19.8133 7.55826 19.9016C7.50528 19.9899 7.61124 20.0252 7.68188 20.0252Z"
          fill="#00244C"
        />
        <path
          d="M39.0818 32.6518C38.8875 33.3405 38.5873 33.7997 38.1811 33.7997H19.8853C18.8787 33.7997 18.4372 31.4686 18.5785 29.4554C18.6844 27.919 19.1259 26.5415 19.8853 26.5415H38.1811C39.3643 26.5415 39.6645 30.6033 39.0818 32.6518Z"
          fill="#00244C"
        />
        <path
          d="M20.1499 13.1025C20.1499 14.6389 20.1852 16.193 20.1499 17.7294C20.1323 18.1003 19.9027 18.4711 19.4965 18.4888H3.07265C2.7725 18.5094 2.47111 18.5035 2.17199 18.4711C1.65985 18.3652 1.50091 17.906 1.50091 17.4469V13.2968C1.50091 12.9259 1.53623 12.5021 1.94241 12.3432C2.05584 12.3043 2.17673 12.2922 2.29561 12.3078H15.8938C17.0241 12.3078 18.172 12.2902 19.3022 12.3078C19.5271 12.3078 19.7427 12.3972 19.9016 12.5561C20.0606 12.7151 20.1499 12.9307 20.1499 13.1555C20.1499 13.3145 20.6621 13.2085 20.6621 13.0142C20.6444 12.3961 20.0969 12.0253 19.5142 12.0076H2.89605C2.40157 12.0076 1.88943 11.9723 1.46559 12.2725C1.04175 12.5727 0.98877 12.9083 0.98877 13.3321V17.7824C0.997793 17.9638 1.05488 18.1395 1.15419 18.2916C1.25349 18.4436 1.39144 18.5665 1.55389 18.6477C1.77669 18.7428 2.01845 18.7851 2.26029 18.7713H16.1058C17.183 18.7713 18.2603 18.789 19.3376 18.7713C19.9557 18.7713 20.6444 18.3652 20.6621 17.6764V13.0496C20.6621 12.8376 20.1499 12.9436 20.1499 13.1025Z"
          fill="#00244C"
        />
        <g opacity="0.7">
          <path
            d="M10.0308 24.2813L10.0484 24.2637V24.2813H10.0308Z"
            fill="white"
          />
          <path
            d="M10.0308 24.2989V24.2812H10.0484L10.0308 24.2989Z"
            fill="white"
          />
          <path
            d="M13.0154 24.7227V24.758C12.9977 24.7756 12.9977 24.7756 12.98 24.758C12.9624 24.7403 12.9624 24.7227 12.98 24.7227H13.0154Z"
            fill="#204063"
          />
          <path
            d="M13.1037 24.7755H13.086C13.0813 24.7755 13.0768 24.7736 13.0735 24.7703C13.0702 24.767 13.0684 24.7625 13.0684 24.7578C13.086 24.7401 13.1213 24.7578 13.1037 24.7755Z"
            fill="#204063"
          />
          <path
            d="M11.0201 21.1554C11.0201 21.1554 11.0024 21.1377 11.0201 21.1377V21.1554Z"
            fill="#204063"
          />
          <path
            d="M11.8324 23.575H11.8147C11.8139 23.5654 11.815 23.5558 11.8181 23.5466C11.8211 23.5375 11.826 23.5291 11.8324 23.522C11.8324 23.5396 11.85 23.5573 11.8324 23.575Z"
            fill="#204063"
          />
          <path
            d="M10.9845 21.3322C10.9845 21.3499 10.9669 21.3499 10.9492 21.3322V21.2969C10.9845 21.2969 10.9845 21.3145 10.9845 21.3322Z"
            fill="#204063"
          />
          <path
            d="M11.6382 20.3608C11.6558 20.3962 11.6912 20.4315 11.6735 20.4668C11.6558 20.5021 11.6558 20.4491 11.6558 20.4315C11.6558 20.4138 11.6558 20.3785 11.6382 20.3608Z"
            fill="#204063"
          />
          <path
            d="M12.044 25.9234H12.0616C12.097 25.9057 12.0793 25.9411 12.097 25.9411C12.097 25.9548 12.0938 25.9683 12.0876 25.9806C12.0815 25.9928 12.0726 26.0035 12.0616 26.0117H12.0087C12.0087 25.994 11.9557 26.0117 11.9733 25.9764V25.9234H12.0263H12.044Z"
            fill="#204063"
          />
          <path
            d="M11.6733 20.5904C11.6733 20.5904 11.691 20.6081 11.6733 20.6081V20.5727C11.6733 20.5551 11.6733 20.5727 11.6733 20.5904Z"
            fill="#204063"
          />
          <path
            d="M11.7791 20.6609C11.7728 20.6537 11.7679 20.6453 11.7649 20.6362C11.7618 20.6271 11.7607 20.6175 11.7615 20.6079L11.7791 20.6609Z"
            fill="#204063"
          />
          <path
            d="M11.7617 20.6431C11.7794 20.6431 11.7617 20.6431 11.7617 20.6255V20.6431Z"
            fill="white"
          />
          <path
            d="M12.4504 22.0912C12.4504 22.1089 12.4504 22.1265 12.4328 22.1265H12.3975C12.3986 22.1129 12.4049 22.1003 12.4151 22.0912C12.4328 22.0559 12.4328 22.0735 12.4504 22.0912Z"
            fill="#204063"
          />
          <path
            d="M12.2916 22.1265C12.2739 22.1441 12.2739 22.1441 12.2739 22.1265H12.2916Z"
            fill="#204063"
          />
          <path
            d="M11.9029 22.3033C11.8982 22.3033 11.8937 22.3014 11.8904 22.2981C11.8871 22.2948 11.8853 22.2903 11.8853 22.2856L11.9029 22.3033Z"
            fill="#204063"
          />
          <path
            d="M11.585 21.2789L11.5674 21.2612L11.585 21.2789Z"
            fill="#204063"
          />
          <path
            d="M11.5852 21.3851C11.5852 21.4028 11.5852 21.4204 11.5675 21.4204C11.5499 21.4204 11.5499 21.3674 11.5322 21.3498C11.5322 21.3498 11.5499 21.3321 11.5499 21.3498C11.5499 21.3674 11.5675 21.3321 11.5499 21.3145C11.5609 21.3227 11.5698 21.3333 11.5759 21.3456C11.582 21.3579 11.5852 21.3714 11.5852 21.3851Z"
            fill="#204063"
          />
          <path
            d="M12.2559 22.2681C12.2736 22.2857 12.2559 22.2857 12.2559 22.2857C12.2559 22.2857 12.2382 22.2681 12.2559 22.2681Z"
            fill="#204063"
          />
          <path
            d="M11.9737 22.4268H11.9561C11.9737 22.4092 11.9914 22.4092 11.9737 22.4268Z"
            fill="#204063"
          />
          <path
            d="M12.1324 22.4093H12.1148C12.1148 22.4093 12.0971 22.4093 12.1148 22.3916C12.1148 22.3963 12.1166 22.4008 12.12 22.4041C12.1233 22.4074 12.1278 22.4093 12.1324 22.4093Z"
            fill="#204063"
          />
          <path
            d="M12.0088 22.4444C11.9911 22.4444 12.0264 22.4797 11.9911 22.4797C11.9558 22.4797 11.9734 22.4444 11.9911 22.4268L12.0088 22.4444Z"
            fill="#204063"
          />
          <path
            d="M11.6912 21.5791V21.6144C11.6912 21.5968 11.6912 21.5968 11.7088 21.5968C11.7179 21.6434 11.7179 21.6914 11.7088 21.738H11.6558C11.6735 21.7027 11.6382 21.6851 11.6382 21.6674H11.6558C11.655 21.6578 11.6562 21.6482 11.6592 21.6391C11.6623 21.63 11.6671 21.6216 11.6735 21.6144L11.6912 21.5791Z"
            fill="#204063"
          />
          <path
            d="M11.5319 21.738C11.4966 21.7557 11.4966 21.7027 11.4966 21.6851H11.5142C11.5319 21.6851 11.5496 21.7027 11.5319 21.738Z"
            fill="#204063"
          />
          <path
            d="M11.5318 21.7203H11.5142V21.7026V21.7203H11.5318Z"
            fill="white"
          />
          <path
            d="M11.6911 24.387H11.6734C11.6381 24.3516 11.6734 24.2987 11.6734 24.2633V24.228C11.6967 24.2776 11.703 24.3335 11.6911 24.387Z"
            fill="#204063"
          />
          <path
            d="M11.5322 21.9325H11.5145C11.5145 21.9501 11.4969 21.9325 11.4969 21.9325C11.4882 21.9227 11.4834 21.9102 11.4834 21.8971C11.4834 21.8841 11.4882 21.8715 11.4969 21.8618C11.4792 21.8618 11.4969 21.8618 11.4969 21.8795C11.4969 21.8971 11.4969 21.8618 11.4969 21.8618C11.4969 21.8618 11.5322 21.9148 11.5322 21.9325Z"
            fill="#204063"
          />
          <path
            d="M11.4967 22.0033C11.5108 22.024 11.517 22.049 11.5144 22.0739H11.4967C11.4791 22.0739 11.4614 22.0562 11.4614 22.0209C11.4614 21.9856 11.4791 22.0033 11.4791 21.9856C11.4791 21.9679 11.4791 22.0209 11.4967 22.0033Z"
            fill="#204063"
          />
          <path
            d="M10.9318 22.3914H10.9141C10.8965 22.3914 10.8965 22.3561 10.8965 22.3561C10.8965 22.3561 10.8965 22.3385 10.8965 22.3208C10.9075 22.329 10.9164 22.3397 10.9225 22.352C10.9286 22.3642 10.9318 22.3777 10.9318 22.3914Z"
            fill="#204063"
          />
          <path
            d="M13.1393 22.2503C13.104 22.2503 13.104 22.215 13.104 22.1973C13.104 22.1797 13.1217 22.1267 13.104 22.0737H13.1217C13.1217 22.1091 13.1746 22.1797 13.1393 22.2503Z"
            fill="#204063"
          />
          <path
            d="M11.4259 22.8507H11.4082V22.8154H11.4259C11.4259 22.7977 11.4259 22.833 11.4259 22.8507Z"
            fill="#204063"
          />
          <path
            d="M11.4615 23.151C11.4792 23.151 11.4615 23.1333 11.4615 23.1333L11.4968 23.1863C11.4968 23.2039 11.4968 23.2039 11.4792 23.2216H11.4438C11.4438 23.2039 11.4615 23.1863 11.4438 23.1863V23.151H11.4615Z"
            fill="#204063"
          />
          <path
            d="M12.7681 22.5505H12.7505V22.5151L12.7681 22.5505Z"
            fill="#204063"
          />
          <path
            d="M11.9557 22.9922C11.9557 23.0275 11.991 23.0628 11.9733 23.0981H11.938C11.9204 23.0628 11.938 23.0452 11.938 23.0098L11.9557 22.9922Z"
            fill="#204063"
          />
          <path
            d="M11.3909 23.3804C11.3909 23.398 11.3909 23.4157 11.3732 23.4157C11.3556 23.4157 11.3556 23.4157 11.3556 23.4157C11.3509 23.4157 11.3464 23.4138 11.3431 23.4105C11.3398 23.4072 11.3379 23.4027 11.3379 23.398C11.3379 23.3933 11.3398 23.3889 11.3431 23.3855C11.3464 23.3822 11.3509 23.3804 11.3556 23.3804H11.3909Z"
            fill="#204063"
          />
          <path
            d="M12.4152 23.0451C12.4152 23.0627 12.4152 23.0804 12.3975 23.0804C12.3929 23.0804 12.3884 23.0785 12.3851 23.0752C12.3817 23.0719 12.3799 23.0674 12.3799 23.0627V23.0274C12.3975 23.0097 12.3975 23.0451 12.4152 23.0451Z"
            fill="#204063"
          />
          <path
            d="M11.3022 23.4338H11.3199C11.3022 23.4338 11.3022 23.4161 11.3199 23.3984C11.3246 23.4008 11.3282 23.4049 11.3298 23.4099C11.3315 23.4148 11.3311 23.4202 11.3287 23.4249C11.3264 23.4296 11.3223 23.4332 11.3173 23.4348C11.3124 23.4365 11.3069 23.4361 11.3022 23.4338Z"
            fill="#204063"
          />
          <path
            d="M13.1213 22.9745C13.1213 22.9922 13.1213 23.0099 13.1037 23.0099C13.086 23.0099 13.0684 23.0275 13.0684 23.0099C13.0684 22.9922 13.1037 22.9569 13.1213 22.9745Z"
            fill="#204063"
          />
          <path
            d="M12.8033 23.0627H12.821C12.821 23.098 12.8386 23.1333 12.821 23.1686C12.821 23.1733 12.8191 23.1778 12.8158 23.1811C12.8125 23.1844 12.808 23.1863 12.8033 23.1863C12.7986 23.1863 12.7941 23.1844 12.7908 23.1811C12.7875 23.1778 12.7856 23.1733 12.7856 23.1686V23.098H12.8033C12.8029 23.0733 12.809 23.0489 12.821 23.0273L12.8033 23.0627Z"
            fill="#204063"
          />
          <path
            d="M12.2384 23.2041H12.256C12.2647 23.2138 12.2695 23.2264 12.2695 23.2394C12.2695 23.2525 12.2647 23.265 12.256 23.2747H12.2207V23.2218H12.2384V23.2041Z"
            fill="#204063"
          />
          <path
            d="M10.9139 23.6453C10.9092 23.6453 10.9047 23.6434 10.9014 23.6401C10.8981 23.6368 10.8962 23.6323 10.8962 23.6276C10.8786 23.6276 10.9139 23.5923 10.8962 23.5923C10.8786 23.5923 10.9315 23.6276 10.9139 23.6453Z"
            fill="#204063"
          />
          <path
            d="M11.2143 25.2525H11.232C11.232 25.2525 11.1967 25.2878 11.232 25.2878C11.2673 25.2878 11.2143 25.3584 11.179 25.3761H11.1967C11.1967 25.4114 11.2143 25.4291 11.179 25.4467H11.1614C11.126 25.4114 11.2143 25.3761 11.1437 25.3408C11.0731 25.3055 11.1437 25.2701 11.1437 25.2525H11.1967C11.1967 25.2348 11.1967 25.2525 11.2143 25.2525Z"
            fill="#204063"
          />
          <path
            d="M11.32 23.6279C11.32 23.6456 11.32 23.6632 11.3024 23.6632H11.2847C11.267 23.6456 11.2847 23.6456 11.2847 23.6456H11.32V23.6279Z"
            fill="#204063"
          />
          <path
            d="M12.715 23.2925V23.3455H12.6973C12.6797 23.3455 12.6797 23.3101 12.6973 23.2925H12.715Z"
            fill="#204063"
          />
          <path
            d="M11.1788 23.8042H11.1965V23.8395H11.1611V23.8042H11.1788Z"
            fill="#204063"
          />
          <path
            d="M11.1787 23.8042V23.8219V23.8042H11.1964H11.1787Z"
            fill="white"
          />
          <path
            d="M11.2316 24.0514C11.2493 24.0514 11.2669 24.0691 11.2493 24.0868H11.2316C11.1963 24.0868 11.2139 24.0514 11.1963 24.0514C11.2139 24.0338 11.2139 24.0338 11.2139 24.0161C11.2093 24.0185 11.2057 24.0226 11.204 24.0275C11.2024 24.0325 11.2028 24.0379 11.2051 24.0426C11.2075 24.0473 11.2116 24.0508 11.2165 24.0525C11.2215 24.0542 11.2269 24.0538 11.2316 24.0514Z"
            fill="#204063"
          />
          <path
            d="M10.7725 24.0869C10.7725 24.1046 10.7902 24.1222 10.7725 24.1576V24.1222C10.7549 24.1046 10.7725 24.1046 10.7725 24.0869Z"
            fill="#204063"
          />
          <path
            d="M12.821 23.5923C12.821 23.6099 12.8386 23.6453 12.821 23.6629V23.6982L12.7856 23.6629V23.6276C12.8033 23.6453 12.7856 23.5923 12.8033 23.6099C12.8033 23.6099 12.8033 23.6099 12.821 23.5923Z"
            fill="#204063"
          />
          <path
            d="M11.0906 24.1221H11.1083C11.0906 24.1397 11.1083 24.175 11.0906 24.1927C11.073 24.2104 11.0553 24.175 11.0376 24.1574C11.02 24.1397 11.0376 24.1397 11.0376 24.1397H11.0906V24.1221Z"
            fill="#204063"
          />
          <path
            d="M12.3976 23.7337C12.3929 23.7337 12.3884 23.7319 12.3851 23.7286C12.3818 23.7252 12.3799 23.7207 12.3799 23.7161V23.6807C12.3623 23.6631 12.3799 23.6807 12.3799 23.6984C12.3976 23.6807 12.3976 23.6807 12.3976 23.6631C12.3976 23.6807 12.4152 23.7161 12.3976 23.7337Z"
            fill="#204063"
          />
          <path
            d="M12.2031 24.5461H12.2208V24.5107C12.2245 24.5141 12.2276 24.5181 12.2296 24.5227C12.2317 24.5273 12.2327 24.5322 12.2327 24.5372C12.2327 24.5422 12.2317 24.5472 12.2296 24.5518C12.2276 24.5563 12.2245 24.5604 12.2208 24.5637C12.217 24.5604 12.214 24.5563 12.212 24.5518C12.2099 24.5472 12.2088 24.5422 12.2088 24.5372C12.2088 24.5322 12.2099 24.5273 12.212 24.5227C12.214 24.5181 12.217 24.5141 12.2208 24.5107L12.2031 24.5461Z"
            fill="#204063"
          />
          <path
            d="M11.32 24.9876H11.3023C11.2847 25.0052 11.2847 24.9875 11.2847 24.9699C11.3023 24.9522 11.2847 24.9522 11.3023 24.9346H11.32C11.32 24.9522 11.3376 24.9699 11.32 24.9876Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.7759C11.9382 24.7935 11.9558 24.8289 11.9205 24.8289C11.8852 24.8289 11.9029 24.8289 11.9029 24.8112V24.7759H11.9205C11.9232 24.7774 11.9262 24.7782 11.9293 24.7782C11.9324 24.7782 11.9355 24.7774 11.9382 24.7759Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.8112H11.9205C11.9158 24.8112 11.9113 24.8093 11.908 24.806C11.9047 24.8027 11.9028 24.7982 11.9028 24.7935C11.9028 24.7889 11.9047 24.7844 11.908 24.781C11.9113 24.7777 11.9158 24.7759 11.9205 24.7759C11.9205 24.7935 11.9382 24.7759 11.9382 24.8112Z"
            fill="white"
          />
          <path
            d="M11.2496 24.8464C11.2496 24.864 11.2496 24.8464 11.2319 24.8464V24.811H11.2496C11.2496 24.8287 11.2673 24.8464 11.2496 24.8464Z"
            fill="#204063"
          />
          <path
            d="M12.0264 24.9172V24.8818C12.0264 24.8818 12.044 24.8995 12.0264 24.9172Z"
            fill="#204063"
          />
          <path
            d="M10.7373 26.2769H10.7726C10.7726 26.2769 10.755 26.2769 10.7726 26.2946C10.7773 26.2946 10.7818 26.2927 10.7851 26.2894C10.7884 26.2861 10.7903 26.2816 10.7903 26.2769C10.7903 26.2723 10.7884 26.2678 10.7851 26.2645C10.7818 26.2611 10.7773 26.2593 10.7726 26.2593C10.7903 26.2769 10.7726 26.3123 10.7903 26.3123H10.8079C10.8079 26.3476 10.8256 26.3476 10.8256 26.3652C10.8264 26.3748 10.8253 26.3844 10.8222 26.3935C10.8192 26.4027 10.8143 26.4111 10.8079 26.4182C10.8433 26.4006 10.8079 26.4535 10.8256 26.4535C10.8209 26.4535 10.8164 26.4554 10.8131 26.4587C10.8098 26.462 10.8079 26.4665 10.8079 26.4712L10.7373 26.5065H10.6843C10.6667 26.5065 10.649 26.4889 10.6667 26.4712H10.649C10.6517 26.4463 10.6454 26.4213 10.6313 26.4006H10.6667V26.3652C10.6843 26.3652 10.6667 26.3476 10.6843 26.3299C10.702 26.3123 10.702 26.3476 10.7196 26.3299C10.7174 26.3203 10.7178 26.3103 10.7209 26.3009C10.7241 26.2916 10.7297 26.2832 10.7373 26.2769Z"
            fill="#204063"
          />
          <path
            d="M11.9205 25.0582V25.0935C11.9028 25.1112 11.9028 25.0758 11.9028 25.0758C11.9028 25.0758 11.9028 25.0582 11.9028 25.0405L11.9205 25.0582Z"
            fill="#204063"
          />
          <path
            d="M11.8501 25.27H11.7971C11.7971 25.2877 11.7794 25.2877 11.7618 25.2877C11.7557 25.2658 11.7559 25.2427 11.7621 25.2209C11.7683 25.1991 11.7804 25.1794 11.7971 25.1641H11.8147C11.8249 25.1676 11.8341 25.1735 11.8417 25.1812C11.8493 25.1888 11.855 25.1982 11.8584 25.2084C11.8618 25.2186 11.8628 25.2295 11.8614 25.2402C11.8599 25.2509 11.8561 25.2611 11.8501 25.27Z"
            fill="#204063"
          />
          <path
            d="M11.1966 27.4601H11.2143V27.4954H11.2319C11.2143 27.5308 11.2319 27.5484 11.2143 27.5661C11.1966 27.5837 11.1966 27.6014 11.1966 27.6191H11.126C11.1249 27.6055 11.1185 27.5928 11.1083 27.5837H11.0553C11.02 27.5837 11.0377 27.5484 11.02 27.5308V27.4954C11.0377 27.5131 11.0377 27.4778 11.0553 27.4601H11.126V27.4248H11.1613C11.1613 27.4248 11.179 27.4778 11.1966 27.4601Z"
            fill="#204063"
          />
          <path
            d="M11.0731 25.7114C11.0731 25.7291 11.1084 25.7467 11.1084 25.7821L11.0731 25.835L11.0024 25.7997C11.0201 25.7821 11.0024 25.7467 11.0024 25.7467H11.0201C11.0201 25.7291 11.0201 25.7114 11.0378 25.7114H11.0731Z"
            fill="#204063"
          />
          <path
            d="M11.6029 25.5703H11.6205C11.6382 25.6056 11.5675 25.6056 11.6029 25.6409C11.6382 25.6762 11.5852 25.6939 11.5675 25.6939C11.5499 25.6939 11.5322 25.6586 11.5322 25.6409C11.5499 25.6586 11.5499 25.6233 11.5499 25.6233H11.5852C11.5782 25.6209 11.5724 25.6159 11.5691 25.6093C11.5657 25.6026 11.5652 25.595 11.5675 25.5879C11.5699 25.5809 11.5749 25.5751 11.5815 25.5718C11.5882 25.5685 11.5958 25.5679 11.6029 25.5703Z"
            fill="#204063"
          />
          <path
            d="M11.4083 26.3652V26.4006C11.3907 26.4182 11.4437 26.4182 11.4083 26.4535C11.373 26.4889 11.3907 26.4712 11.3907 26.4889H11.32V26.4535C11.3377 26.4535 11.3024 26.4359 11.32 26.4359V26.4006H11.373C11.3907 26.3476 11.3907 26.3829 11.4083 26.3652Z"
            fill="#204063"
          />
          <path
            d="M10.7019 26.7008C10.7019 26.7184 10.7019 26.7184 10.7196 26.7184C10.7372 26.7184 10.7019 26.7714 10.6842 26.7537H10.6489C10.6666 26.7361 10.6489 26.7361 10.6489 26.7184C10.6536 26.7184 10.6581 26.7166 10.6614 26.7133C10.6647 26.7099 10.6666 26.7054 10.6666 26.7008C10.6666 26.6961 10.6684 26.6916 10.6718 26.6883C10.6751 26.685 10.6796 26.6831 10.6842 26.6831L10.7019 26.7008Z"
            fill="#204063"
          />
          <path
            d="M10.6842 26.7007V26.7183H10.6665L10.6842 26.7007Z"
            fill="white"
          />
          <path
            d="M9.99577 26.5592C9.99577 26.5768 9.97811 26.5945 9.96045 26.5768V26.5415C9.97811 26.5238 10.0134 26.5415 9.99577 26.5592Z"
            fill="#204063"
          />
          <path
            d="M10.8784 27.2481C10.8784 27.2481 10.8784 27.2304 10.8961 27.2481H10.8784Z"
            fill="#204063"
          />
          <path
            d="M10.4903 26.8066C10.508 26.8066 10.4903 26.8243 10.4903 26.8243H10.4727C10.4727 26.8243 10.4903 26.8066 10.4903 26.8243V26.8066Z"
            fill="#204063"
          />
          <path
            d="M10.1899 27.0186H10.2252C10.2075 27.0186 10.2252 27.0362 10.2252 27.0362C10.2252 27.0715 10.2252 27.1069 10.1722 27.1245L10.1192 27.0892C10.1016 27.0715 10.1192 27.0539 10.1016 27.0362H10.1192C10.1016 27.0186 10.1192 27.0362 10.1192 27.0186H10.1899Z"
            fill="#204063"
          />
          <path
            d="M10.6135 27.2481H10.6489V27.2834C10.6665 27.3011 10.6312 27.3011 10.6312 27.3364H10.5429C10.5429 27.3188 10.5076 27.3541 10.5076 27.3188C10.4722 27.3364 10.4899 27.3011 10.4722 27.3011H10.4546C10.4593 27.3011 10.4638 27.2992 10.4671 27.2959C10.4704 27.2926 10.4722 27.2881 10.4722 27.2834C10.4722 27.2788 10.4704 27.2743 10.4671 27.271C10.4638 27.2676 10.4593 27.2658 10.4546 27.2658C10.4546 27.2481 10.4899 27.2481 10.4722 27.2305C10.4546 27.2128 10.5076 27.2305 10.4899 27.1951C10.5076 27.1951 10.5076 27.2128 10.5076 27.1951C10.5076 27.1775 10.5076 27.1951 10.5076 27.1775C10.5076 27.1598 10.5252 27.2128 10.5429 27.1951H10.5959C10.5782 27.2305 10.6135 27.2305 10.6135 27.2481Z"
            fill="#204063"
          />
          <path
            d="M10.066 27.5835L10.1014 27.6188C10.0837 27.6365 10.119 27.6365 10.1014 27.6541C10.0837 27.6718 10.119 27.6718 10.1014 27.6718H10.119C10.1014 27.6895 10.1014 27.7248 10.066 27.7424H9.96008C9.94242 27.7248 9.96008 27.7071 9.94242 27.7071C9.92476 27.7071 9.94242 27.6895 9.94242 27.6718C9.9471 27.6718 9.9516 27.6699 9.95491 27.6666C9.95822 27.6633 9.96008 27.6588 9.96008 27.6541C9.96008 27.6495 9.95822 27.645 9.95491 27.6416C9.9516 27.6383 9.9471 27.6365 9.94242 27.6365H9.96008C9.96008 27.6365 9.94242 27.6188 9.96008 27.6188H10.0307L10.066 27.5835Z"
            fill="#204063"
          />
          <path
            d="M10.9137 27.778H10.8961C10.8914 27.778 10.8869 27.7761 10.8836 27.7728C10.8803 27.7695 10.8784 27.765 10.8784 27.7603C10.8784 27.7557 10.8803 27.7512 10.8836 27.7478C10.8869 27.7445 10.8914 27.7427 10.8961 27.7427C10.9137 27.7603 10.9137 27.7603 10.9137 27.778Z"
            fill="#204063"
          />
          <path
            d="M11.3199 28.131C11.3022 28.131 11.3022 28.1134 11.3022 28.0957H11.3199C11.3199 28.0957 11.3376 28.131 11.3199 28.131Z"
            fill="#204063"
          />
          <path
            d="M10.6136 28.043H10.6313V28.0959C10.5959 28.0959 10.5959 28.1136 10.5606 28.0959H10.543C10.543 28.0783 10.5606 28.0606 10.543 28.0606H10.5606C10.543 28.0606 10.5606 28.0606 10.5606 28.043C10.5606 28.0477 10.5625 28.0521 10.5658 28.0555C10.5691 28.0588 10.5736 28.0606 10.5783 28.0606H10.6136V28.043Z"
            fill="#204063"
          />
          <path
            d="M10.5075 28.0604H10.5252C10.5075 28.0604 10.5252 28.078 10.5252 28.078H10.5075L10.4722 28.1134H10.4192C10.4192 28.078 10.3839 28.0957 10.3662 28.0604H10.3839C10.3662 28.0427 10.3839 28.0251 10.3839 28.0074H10.4015C10.4015 27.9897 10.4192 27.9897 10.4015 27.9897C10.3839 27.9897 10.4369 28.0074 10.4369 27.9897H10.4545C10.4898 28.0074 10.4898 28.0604 10.5075 28.0604Z"
            fill="#204063"
          />
          <path
            d="M10.2076 28.2192H10.2606C10.2606 28.2369 10.2429 28.2546 10.2606 28.2546H10.2783C10.2783 28.2722 10.2606 28.2899 10.2783 28.2899H10.2959C10.2959 28.2899 10.3136 28.2899 10.2959 28.3075H10.3489C10.3313 28.3252 10.3489 28.3252 10.3489 28.3252H10.3313C10.3489 28.3252 10.3313 28.3252 10.3313 28.3429H10.137C10.137 28.3075 10.1017 28.3252 10.1017 28.3252H10.0663V28.2899H10.031C10.031 28.2899 10.0663 28.2899 10.0487 28.2722C10.0487 28.2369 9.99571 28.2369 10.0134 28.2016C10.031 28.1663 10.031 28.2016 10.031 28.2016C10.031 28.2016 10.0134 28.1663 10.031 28.1663L10.0663 28.1309C10.0663 28.1309 10.0487 28.1133 10.0663 28.1133C10.0663 28.118 10.0682 28.1225 10.0715 28.1258C10.0748 28.1291 10.0793 28.1309 10.084 28.1309H10.1193C10.1193 28.1309 10.1193 28.1486 10.137 28.1309H10.2253L10.2076 28.2192Z"
            fill="#204063"
          />
          <path
            d="M11.4791 26.9302C11.4615 26.9478 11.4791 26.9655 11.4438 26.9655C11.4085 26.9655 11.4085 26.9478 11.4262 26.9302H11.4791Z"
            fill="#204063"
          />
          <path
            d="M11.4082 27.0539V27.0362H11.4259L11.4082 27.0186H11.4259L11.4082 27.0539Z"
            fill="#204063"
          />
          <path
            d="M11.4261 27.1065H11.4437V27.1418C11.4614 27.1595 11.4437 27.1948 11.4437 27.2125C11.4437 27.2301 11.3908 27.2301 11.3908 27.2655H11.3378C11.3201 27.2301 11.3201 27.2301 11.3025 27.2301C11.3025 27.2125 11.3201 27.1948 11.3025 27.1772C11.2848 27.1595 11.3201 27.1418 11.3025 27.1418C11.2848 27.1418 11.3378 27.1595 11.3554 27.1595C11.3731 27.1595 11.3378 27.1418 11.3554 27.1418C11.3731 27.1418 11.3731 27.1595 11.3731 27.1595V27.1065C11.3908 27.0712 11.3908 27.1065 11.4261 27.1065Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M19.7262 23.8751L19.6909 23.8574H19.7262V23.8751Z"
            fill="white"
          />
          <path
            d="M19.797 23.8751L19.7617 23.8927V23.8574L19.797 23.8751Z"
            fill="white"
          />
          <path
            d="M19.8323 17.0583L19.8853 17.0229C19.8977 17.0339 19.9073 17.0476 19.9134 17.0629C19.9196 17.0782 19.922 17.0948 19.9206 17.1112C19.903 17.1466 19.8677 17.1466 19.8323 17.1289C19.8237 17.1192 19.8188 17.1066 19.8188 17.0936C19.8188 17.0806 19.8237 17.068 19.8323 17.0583Z"
            fill="#204063"
          />
          <path
            d="M19.9028 16.8286C19.9205 16.8286 19.9205 16.8462 19.9205 16.8639L19.8675 16.8992C19.8322 16.8816 19.8498 16.7933 19.9028 16.8286Z"
            fill="#204063"
          />
          <path
            d="M11.9557 21.1026C11.9557 21.1203 11.938 21.1556 11.9204 21.1379H11.9027C11.9018 21.1313 11.9027 21.1246 11.9054 21.1185C11.9082 21.1125 11.9125 21.1073 11.9181 21.1036C11.9236 21.0999 11.9301 21.0978 11.9367 21.0977C11.9434 21.0975 11.9499 21.0992 11.9557 21.1026Z"
            fill="#204063"
          />
          <path
            d="M17.4145 19.8689L17.397 19.8711L17.3981 19.8799L17.4156 19.8777L17.4145 19.8689Z"
            fill="#204063"
          />
          <path
            d="M17.7133 19.9367C17.6779 19.972 17.6249 19.9367 17.6073 19.9013C17.5896 19.866 17.6779 19.9013 17.7133 19.9367Z"
            fill="#204063"
          />
          <path
            d="M12.4325 21.1909C12.4501 21.2262 12.4501 21.2616 12.4148 21.2616C12.3795 21.2616 12.3618 21.2439 12.3618 21.2262C12.3618 21.2086 12.4148 21.1909 12.4325 21.1909Z"
            fill="#204063"
          />
          <path
            d="M10.8962 19.0538H10.8785C10.9096 19.0393 10.9439 19.0333 10.978 19.0364C11.0121 19.0395 11.0448 19.0516 11.0728 19.0714C11.0728 19.1067 11.0374 19.0891 11.0021 19.1067L10.8608 19.0714L10.8962 19.0538Z"
            fill="#204063"
          />
          <path
            d="M22.7108 18.5594H22.6755L22.7108 18.5241C22.6755 18.4711 22.7638 18.4711 22.7638 18.4358C22.8135 18.4305 22.8636 18.443 22.905 18.4711C22.9404 18.5241 22.9227 18.5241 22.9404 18.577C22.958 18.63 22.958 18.683 22.8697 18.683C22.7814 18.683 22.8167 18.6653 22.7638 18.7007C22.7108 18.736 22.7461 18.6653 22.7284 18.6653H22.7108C22.7284 18.63 22.7108 18.6124 22.6755 18.5947C22.6401 18.577 22.6931 18.577 22.7108 18.5594Z"
            fill="#204063"
          />
          <path
            d="M11.3554 19.1597L11.4084 19.195C11.3907 19.2303 11.3377 19.2126 11.3201 19.2126H11.2671L11.3554 19.1597Z"
            fill="#204063"
          />
          <path
            d="M11.5498 19.0011H11.5675C11.5321 19.0187 11.4792 18.9834 11.4438 18.9834L11.5498 19.0011Z"
            fill="#204063"
          />
          <path
            d="M14.3048 19.6895C14.3224 19.7071 14.3224 19.7071 14.3224 19.7248H14.2871C14.2871 19.7248 14.2695 19.6895 14.3048 19.6895Z"
            fill="#204063"
          />
          <path
            d="M14.6578 18.8066H14.6931L14.6578 18.8596C14.6401 18.8596 14.6401 18.8243 14.6578 18.8066Z"
            fill="#204063"
          />
          <path
            d="M14.6579 18.312C14.6756 18.3297 14.7286 18.3297 14.7109 18.365C14.6933 18.4003 14.7109 18.4356 14.6756 18.4356C14.6403 18.4356 14.6403 18.4003 14.605 18.4003C14.5696 18.4003 14.6403 18.3473 14.6579 18.312Z"
            fill="#204063"
          />
          <path
            d="M14.6931 18.7007C14.6931 18.7007 14.7107 18.6831 14.7107 18.7007V18.736C14.6754 18.736 14.6578 18.7007 14.6931 18.7007Z"
            fill="#204063"
          />
          <path
            d="M14.958 19.6016H14.9933C14.9757 19.6192 14.9933 19.6369 14.9757 19.6545C14.958 19.6722 14.905 19.6192 14.958 19.6016Z"
            fill="#204063"
          />
          <path
            d="M12.6799 19.8662L12.627 19.8839L12.6446 19.8662H12.6799Z"
            fill="#204063"
          />
          <path
            d="M12.9096 19.9193C12.9273 19.9369 12.9802 19.9369 12.9626 19.9722C12.9449 20.0076 12.839 20.0076 12.8036 20.0076H12.786C12.8036 19.9899 12.786 19.9899 12.786 19.9722C12.786 19.9546 12.7683 19.9193 12.7153 19.9369C12.7773 19.9138 12.8444 19.9077 12.9096 19.9193Z"
            fill="#204063"
          />
          <path
            d="M14.9932 18.7891C15.0109 18.7891 15.0109 18.8067 15.0109 18.8244C15.0109 18.842 14.9932 18.842 14.9756 18.8244L14.9932 18.7891Z"
            fill="#204063"
          />
          <path
            d="M15.2227 19.478C15.2404 19.478 15.2404 19.4956 15.2404 19.5133H15.2051C15.1874 19.4956 15.2051 19.4603 15.2227 19.478Z"
            fill="#204063"
          />
          <path
            d="M15.2232 19.1421C15.2409 19.1421 15.2585 19.1774 15.2409 19.1774C15.2232 19.1774 15.2056 19.1951 15.2056 19.1774L15.2232 19.1421Z"
            fill="#204063"
          />
          <path
            d="M15.2759 19.4248C15.2936 19.4425 15.3642 19.4071 15.3466 19.4601C15.3289 19.5131 15.2936 19.4954 15.2583 19.4601C15.223 19.4248 15.2583 19.4248 15.2759 19.4248Z"
            fill="#204063"
          />
          <path
            d="M13.3687 19.7957C13.4041 19.7957 13.4217 19.7957 13.4217 19.7604V19.7251C13.51 19.7428 13.6336 19.7074 13.7043 19.7957C13.7749 19.884 13.7043 19.8487 13.6866 19.8664H13.5983C13.563 19.8311 13.4924 19.9017 13.4394 19.8664H13.4747L13.3511 19.8134L13.3687 19.7957Z"
            fill="#204063"
          />
          <path
            d="M13.6337 20.2193C13.6514 20.3076 13.5454 20.2723 13.5101 20.2723L13.4395 20.2369C13.4674 20.2171 13.5001 20.2051 13.5342 20.202C13.5683 20.1989 13.6027 20.2048 13.6337 20.2193Z"
            fill="#204063"
          />
          <path
            d="M13.5808 20.2373L13.5632 20.255L13.5278 20.2373L13.5632 20.255L13.5808 20.2373Z"
            fill="white"
          />
          <path
            d="M19.5499 20.131H19.5676C19.5146 20.2193 19.3733 20.184 19.285 20.1486H19.2144C19.2649 20.1195 19.3217 20.1027 19.38 20.0996C19.4383 20.0966 19.4965 20.1073 19.5499 20.131Z"
            fill="#204063"
          />
          <path
            d="M13.8102 20.3077L13.7749 20.29H13.8102V20.3077Z"
            fill="#204063"
          />
          <path
            d="M14.0397 20.3253H14.0927L14.0574 20.3783C14.0097 20.3905 13.9593 20.3842 13.9161 20.3606C13.8984 20.3783 13.9338 20.3606 13.9338 20.343H13.8984C13.9183 20.3278 13.9419 20.3182 13.9667 20.3151C13.9915 20.312 14.0167 20.3155 14.0397 20.3253Z"
            fill="#204063"
          />
          <path
            d="M14.0047 20.3606H13.987C13.9693 20.3959 13.987 20.3606 13.9693 20.3783C13.9517 20.3959 13.9693 20.3253 14.0047 20.3606Z"
            fill="white"
          />
          <path
            d="M14.1812 20.4311C14.2038 20.4144 14.2304 20.404 14.2583 20.4009C14.2862 20.3978 14.3145 20.4021 14.3402 20.4135C14.3578 20.4135 14.3755 20.4312 14.3578 20.4665C14.3147 20.49 14.2642 20.4963 14.2166 20.4841C14.2166 20.4488 14.1636 20.4665 14.1459 20.4665C14.1283 20.4665 14.2166 20.4665 14.1812 20.4311Z"
            fill="#204063"
          />
          <path
            d="M14.2339 20.4136L14.2515 20.4312H14.2339V20.4136Z"
            fill="white"
          />
          <path
            d="M14.8519 21.8441C14.8696 21.8441 14.8519 21.8617 14.8519 21.8617C14.8519 21.8617 14.7813 21.8971 14.7459 21.8971C14.7106 21.8971 14.7106 21.9147 14.6753 21.8794C14.7287 21.8487 14.7907 21.8363 14.8519 21.8441Z"
            fill="#204063"
          />
          <path
            d="M15.0817 16.8286C15.117 16.8992 15.0287 16.8992 15.0111 16.9169C14.9934 16.9345 14.8521 16.8462 14.7815 16.8462H14.7285C14.8345 16.8462 14.9934 16.7226 15.0817 16.8286Z"
            fill="#204063"
          />
          <path
            d="M16.0527 20.8022C16.0704 20.8022 16.0881 20.8022 16.0881 20.8199C16.0881 20.8376 16.1057 20.8552 16.0704 20.8729H15.9468C15.9644 20.8022 16.0174 20.8022 16.0527 20.8022Z"
            fill="#204063"
          />
          <path
            d="M15.4172 20.873L15.3818 20.8907V20.873H15.4172Z"
            fill="white"
          />
          <path
            d="M16.7418 20.7668H16.7241C16.7594 20.7315 16.7948 20.7315 16.8477 20.7139C16.8631 20.7157 16.8778 20.7216 16.8902 20.7309C16.9026 20.7402 16.9123 20.7526 16.9184 20.7668C16.936 20.8022 16.9007 20.8022 16.8831 20.8375C16.8654 20.8728 16.8124 20.8022 16.7771 20.8375H16.7948L16.7241 20.8022L16.7418 20.7668Z"
            fill="#204063"
          />
          <path
            d="M15.5939 17.5704L15.5586 17.5527H15.5939V17.5704Z"
            fill="#204063"
          />
          <path
            d="M15.647 17.7471H15.6823C15.7 17.7647 15.7176 17.7647 15.7176 17.8001H15.647V17.7471Z"
            fill="#204063"
          />
          <path
            d="M16.4414 19.6544C16.512 19.6544 16.6003 19.5661 16.671 19.6368C16.6737 19.6437 16.675 19.6511 16.6747 19.6586C16.6743 19.666 16.6725 19.6733 16.6691 19.68C16.6658 19.6867 16.6611 19.6925 16.6553 19.6973C16.6496 19.702 16.6429 19.7054 16.6357 19.7074C16.565 19.7251 16.512 19.6721 16.4414 19.6544Z"
            fill="#204063"
          />
          <path
            d="M17.2891 20.9434C17.3245 20.9434 17.3774 20.9257 17.3951 20.961C17.4128 20.9964 17.3598 21.014 17.3598 21.0317H17.2715C17.2715 21.014 17.2891 20.9964 17.2715 20.9964C17.2538 20.9964 17.2715 20.9787 17.2891 20.9434Z"
            fill="#204063"
          />
          <path
            d="M16.6006 18.6124C16.6146 18.6106 16.6288 18.613 16.6414 18.6193C16.6539 18.6256 16.6644 18.6355 16.6713 18.6477C16.6713 18.6654 16.6536 18.683 16.636 18.7007H16.5477C16.53 18.6301 16.5653 18.6301 16.6006 18.6124Z"
            fill="#204063"
          />
          <path
            d="M17.4304 21.1203C17.4481 21.1026 17.4127 21.085 17.4304 21.085V21.1203Z"
            fill="#204063"
          />
          <path
            d="M16.4594 17.0229C16.4947 17.0053 16.5124 17.0229 16.5477 17.0406C16.583 17.0583 16.5477 17.1112 16.5124 17.1112C16.4771 17.1112 16.4241 17.0583 16.4594 17.0229Z"
            fill="#204063"
          />
          <path
            d="M16.6359 17.7296C16.6359 17.7119 16.6359 17.7119 16.6182 17.7119C16.6006 17.7119 16.6536 17.6942 16.6712 17.7119C16.6889 17.7296 16.8125 17.6413 16.8831 17.7119C16.9538 17.7825 16.8831 17.7649 16.8655 17.7825H16.7419C16.6901 17.7813 16.6404 17.7626 16.6006 17.7296H16.6359Z"
            fill="#204063"
          />
          <path
            d="M16.9005 19.0007C16.9005 19.0184 16.9181 19.0184 16.9181 19.0361C16.9214 19.0398 16.9255 19.0428 16.9301 19.0449C16.9347 19.0469 16.9396 19.048 16.9446 19.048C16.9496 19.048 16.9546 19.0469 16.9592 19.0449C16.9637 19.0428 16.9678 19.0398 16.9711 19.0361C16.9181 19.0361 16.9535 18.9831 16.9181 18.9654C16.8828 18.9478 17.0241 18.9301 17.0594 18.9831C17.0594 18.9968 17.0562 19.0103 17.0501 19.0226C17.044 19.0348 17.0351 19.0455 17.0241 19.0537C16.9888 19.0361 16.9711 19.0537 16.9358 19.0714H16.9005C16.9181 19.0537 16.9005 19.0537 16.9181 19.0361H16.8828C16.8828 19.0007 16.9005 19.0184 16.9005 19.0007Z"
            fill="#204063"
          />
          <path
            d="M17.9249 21.9856C17.9602 22.0033 17.9249 22.0386 17.9072 22.0386C17.8896 22.0386 17.8189 22.0209 17.7836 22.0563C17.7483 22.0916 17.8719 21.968 17.9249 21.9856Z"
            fill="#204063"
          />
          <path
            d="M16.9537 19.001C16.9714 19.001 16.936 19.0186 16.936 19.0186H16.9537V19.001Z"
            fill="white"
          />
          <path
            d="M16.9712 18.9831C16.9712 18.9654 16.9889 18.9654 16.9712 18.9478V18.9831Z"
            fill="white"
          />
          <path
            d="M21.7748 20.8197L21.7395 20.7843C21.7395 20.7667 21.8631 20.8197 21.8101 20.7314C21.7572 20.6431 22.0044 20.7314 22.075 20.802H22.0927L22.0574 20.7667C22.1104 20.7667 22.181 20.7137 22.234 20.7314C22.287 20.749 22.2693 20.7667 22.2516 20.7843C22.234 20.802 22.0221 20.749 21.9867 20.908C21.9514 21.0669 21.8455 20.9609 21.7925 20.9433L21.7395 20.9786C21.7925 20.9609 21.7395 20.9256 21.7395 20.908L21.6865 20.8726C21.7042 20.855 21.7572 20.855 21.7748 20.8197Z"
            fill="#204063"
          />
          <path
            d="M17.872 21.085C17.9073 21.1026 17.9603 21.0673 17.9779 21.1203C17.9956 21.1733 17.9249 21.1556 17.9073 21.1909C17.8896 21.2262 17.8896 21.1556 17.8543 21.1733H17.872C17.8543 21.1556 17.8366 21.085 17.872 21.085Z"
            fill="#204063"
          />
          <path
            d="M17.0951 17.9589C17.1304 17.9236 17.1481 17.9236 17.1834 17.9413C17.2187 17.9589 17.2187 17.9589 17.2011 17.9766C17.1834 17.9943 17.1304 17.9943 17.0951 17.9943C17.0598 17.9943 17.0774 17.9589 17.0951 17.9589Z"
            fill="#204063"
          />
          <path d="M17.13 17.959L17.0947 17.9766V17.959H17.13Z" fill="white" />
          <path
            d="M18.2959 21.4026C18.2783 21.4026 18.2959 21.3673 18.2959 21.3673C18.2959 21.3673 18.3489 21.3319 18.3666 21.3673C18.3842 21.4026 18.3489 21.4026 18.3489 21.4202L18.2959 21.4026Z"
            fill="#204063"
          />
          <path
            d="M18.3136 21.3848H18.3312V21.4025L18.2959 21.3848L18.3136 21.3672V21.3848Z"
            fill="white"
          />
          <path
            d="M18.8784 21.2261C18.8961 21.1908 18.9314 21.1555 18.9667 21.1732C18.9821 21.175 18.9968 21.1809 19.0092 21.1902C19.0216 21.1995 19.0313 21.2119 19.0374 21.2261C19.0374 21.2791 18.9667 21.2791 18.9314 21.2968C18.9138 21.2615 18.8961 21.2791 18.8608 21.2615C18.8255 21.2438 18.8784 21.2261 18.8784 21.2261Z"
            fill="#204063"
          />
          <path
            d="M19.0905 22.2856C19.0905 22.2809 19.0886 22.2764 19.0853 22.2731C19.082 22.2698 19.0775 22.2679 19.0728 22.2679H19.0552C19.1082 22.2502 19.1611 22.1973 19.2318 22.2326C19.3024 22.2679 19.2141 22.3032 19.1788 22.3032C19.1435 22.3032 19.0905 22.3032 19.0552 22.3032L19.0905 22.2856Z"
            fill="#204063"
          />
          <path
            d="M17.6954 17.7116L17.8014 17.6763C17.8367 17.6763 17.8543 17.6939 17.872 17.7292C17.8734 17.7457 17.8709 17.7623 17.8648 17.7776C17.8587 17.7929 17.849 17.8066 17.8367 17.8175C17.8014 17.8175 17.7837 17.7999 17.7484 17.8352C17.7131 17.8705 17.6777 17.8175 17.7131 17.7646H17.6777C17.6954 17.7646 17.6954 17.7292 17.6954 17.7116Z"
            fill="#204063"
          />
          <path
            d="M19.0905 21.5262C19.1435 21.5438 19.2141 21.4732 19.2494 21.5438C19.2848 21.6145 19.2141 21.6145 19.1788 21.6498C19.1435 21.6851 19.1435 21.6498 19.1258 21.6498H19.1435C19.0905 21.6498 19.1258 21.6321 19.0905 21.6321H19.0552C19.0905 21.5615 19.0552 21.5262 19.0905 21.5262Z"
            fill="#204063"
          />
          <path
            d="M18.0134 18.6652L17.9781 18.7005H17.9251C17.9251 18.7358 17.9605 18.7182 17.9605 18.7182V18.6829C17.9251 18.6475 17.9075 18.6829 17.8898 18.6829H17.8545C17.9075 18.6475 17.9781 18.6122 18.0134 18.6652Z"
            fill="#204063"
          />
          <path
            d="M19.6734 20.8023C19.6734 20.807 19.6752 20.8115 19.6785 20.8148C19.6819 20.8181 19.6864 20.82 19.691 20.82H19.6734V20.7847C19.6557 20.82 19.6734 20.8023 19.6734 20.8023Z"
            fill="#204063"
          />
          <path
            d="M19.7438 18.9125C19.7615 18.8949 19.7438 18.9125 19.7438 18.9302H19.7791C19.7968 18.9302 19.7791 18.9125 19.7791 18.8949L19.7262 18.9302C19.7398 18.9164 19.7565 18.906 19.7749 18.8999C19.7933 18.8938 19.8129 18.892 19.8321 18.8949V18.9302C19.816 18.9459 19.7954 18.956 19.7732 18.9592C19.751 18.9624 19.7283 18.9584 19.7085 18.9479L19.7438 18.9125Z"
            fill="#204063"
          />
          <path
            d="M19.797 18.9479L19.7793 18.9303L19.797 18.9126V18.9479Z"
            fill="white"
          />
          <path
            d="M21.0861 20.6963C21.1214 20.6963 21.1214 20.7316 21.1038 20.7669L21.0508 20.8022C21.0508 20.8022 21.0508 20.7493 21.0155 20.7669C20.9801 20.7846 21.0155 20.8022 20.9801 20.8199H20.9448C20.9752 20.7628 21.0255 20.7189 21.0861 20.6963Z"
            fill="#204063"
          />
          <path
            d="M20.3442 19.4249C20.3972 19.4249 20.4325 19.3896 20.4855 19.4249C20.486 19.4409 20.4811 19.4567 20.4714 19.4695C20.4618 19.4823 20.4481 19.4915 20.4325 19.4955H20.3619V19.4602H20.3442C20.3442 19.4602 20.3619 19.4425 20.3442 19.4249Z"
            fill="#204063"
          />
          <path
            d="M20.4153 19.4248H20.3976C20.4027 19.4266 20.4073 19.4295 20.4111 19.4334C20.4149 19.4372 20.4177 19.4419 20.4194 19.447C20.4211 19.4521 20.4217 19.4575 20.4209 19.4629C20.4202 19.4682 20.4183 19.4733 20.4153 19.4778C20.4153 19.5131 20.3623 19.4954 20.3623 19.4954C20.3623 19.4954 20.3623 19.4425 20.4153 19.4248Z"
            fill="white"
          />
          <path
            d="M20.8036 20.9259V20.9613L20.7329 20.9966L20.7682 20.9613V20.9259C20.7682 20.9436 20.7506 20.9613 20.7329 20.9436C20.742 20.9345 20.7533 20.9281 20.7658 20.925C20.7782 20.9218 20.7913 20.9222 20.8036 20.9259Z"
            fill="#204063"
          />
          <path
            d="M20.5918 19.1597H20.6095L20.5741 19.195H20.4858L20.5918 19.1597Z"
            fill="#204063"
          />
          <path
            d="M24.477 21.0673C24.477 21.0143 24.424 21.0496 24.4063 21.0496C24.3887 21.0496 24.4593 21.0496 24.4593 21.0143H24.3887C24.424 20.979 24.4946 20.9967 24.5123 20.9437C24.53 20.8907 24.477 20.926 24.4946 20.9084C24.5123 20.8907 24.5476 20.8554 24.6006 20.8377H24.7066C24.6712 20.7847 24.7772 20.8201 24.7595 20.7671C24.7419 20.7141 24.8302 20.8201 24.8478 20.7847C24.8655 20.7494 24.9715 20.8554 24.9715 20.926C24.9715 20.9967 24.9715 20.9613 24.9715 21.0143C24.9715 21.032 24.9538 21.0496 24.9715 21.0673C24.9891 21.085 24.9185 21.085 24.9185 21.1026C24.9185 21.1203 24.9008 21.1733 24.8832 21.1733C24.8655 21.1733 24.8655 21.1733 24.8655 21.1909H24.8478C24.7772 21.2262 24.7242 21.2262 24.6712 21.2969L24.6359 21.3499C24.6359 21.3145 24.6712 21.2969 24.6359 21.2616H24.6006C24.5829 21.2439 24.5476 21.2969 24.5123 21.2792C24.477 21.2616 24.5123 21.2086 24.477 21.1909H24.4063C24.4227 21.2003 24.4422 21.2028 24.4604 21.1978C24.4786 21.1928 24.4941 21.1808 24.5035 21.1644C24.5128 21.148 24.5153 21.1286 24.5103 21.1104C24.5054 21.0922 24.4934 21.0767 24.477 21.0673Z"
            fill="#204063"
          />
          <path
            d="M20.9623 19.3542C20.9446 19.3542 20.9446 19.3542 20.9446 19.3718H20.9976V19.3365C20.98 19.3188 20.9623 19.3542 20.9623 19.3365C20.9623 19.3188 21.0153 19.3188 21.0329 19.3188C21.0506 19.3188 21.0153 19.3718 20.98 19.3718C20.9446 19.3718 20.927 19.3542 20.9093 19.3542C20.8917 19.3542 20.9446 19.3365 20.9623 19.3542Z"
            fill="#204063"
          />
          <path
            d="M21.4393 19.3896C21.4746 19.4073 21.5099 19.4426 21.5099 19.4603C21.5099 19.4779 21.5099 19.4956 21.4923 19.4956C21.4746 19.4956 21.5806 19.5309 21.5629 19.5662C21.5453 19.6016 21.351 19.5662 21.2804 19.5486V19.5133H21.2627C21.2766 19.4775 21.3008 19.4467 21.3323 19.4247C21.3637 19.4027 21.4009 19.3905 21.4393 19.3896Z"
            fill="#204063"
          />
          <path
            d="M26.5431 18.948H26.5255C26.5608 18.9303 26.5608 18.9127 26.5785 18.895H26.5431C26.5431 18.8774 26.5961 18.8774 26.5608 18.8597C26.6314 18.8597 26.6314 18.8067 26.6844 18.8067C26.7374 18.8067 26.7904 18.7891 26.8257 18.7891C26.861 18.7891 26.861 18.8067 26.8787 18.8244V18.948L26.8257 19.0186C26.861 19.0363 26.914 19.054 26.9317 19.0893C26.9493 19.1246 26.8963 19.1599 26.8787 19.2129L26.7904 19.2482C26.808 19.1952 26.7197 19.2129 26.6844 19.2129H26.6668C26.6844 19.1952 26.7021 19.1952 26.7021 19.1776H26.6668C26.6668 19.1599 26.6844 19.1599 26.6844 19.1423H26.6668C26.6844 19.1599 26.6844 19.1423 26.6844 19.1246H26.7021C26.6668 19.1246 26.6491 19.1246 26.6491 19.0893H26.5608V19.054H26.5078C26.5255 18.9833 26.5961 18.9657 26.5431 18.948Z"
            fill="#204063"
          />
          <path
            d="M22.9054 20.855H22.8877C22.923 20.8197 22.9407 20.749 23.029 20.749C23.1173 20.749 23.0996 20.749 23.1526 20.7667C23.2056 20.7843 23.1526 20.8726 23.1173 20.9256C23.082 20.9786 23.029 20.9786 22.976 20.9786H22.8877C22.9054 20.908 22.8877 20.8726 22.9054 20.855Z"
            fill="#204063"
          />
          <path
            d="M21.9867 19.7603C21.9867 19.7427 21.969 19.725 21.9514 19.7427C21.9337 19.7603 21.9867 19.7427 21.9867 19.7603Z"
            fill="#204063"
          />
          <path
            d="M22.2515 19.7603H22.2339C22.2339 19.7603 22.2692 19.7427 22.2515 19.725C22.2339 19.7074 22.3752 19.8133 22.4281 19.725C22.4811 19.6367 22.5341 19.725 22.5694 19.778C22.5684 19.8004 22.5612 19.8221 22.5488 19.8408C22.5363 19.8594 22.5191 19.8744 22.4988 19.884L22.4281 19.9193C22.4281 19.9146 22.4263 19.9101 22.423 19.9068C22.4197 19.9035 22.4152 19.9016 22.4105 19.9016H22.3752C22.3928 19.8663 22.3398 19.9016 22.3222 19.8663C22.3222 19.831 22.2692 19.8486 22.2515 19.831H22.2339C22.2162 19.778 22.2339 19.778 22.2515 19.7603Z"
            fill="#204063"
          />
          <path
            d="M24.1059 19.6192C24.0883 19.6016 24.1413 19.6016 24.1059 19.5839C24.0706 19.5663 24.1413 19.5486 24.1589 19.5309H24.1413C24.1942 19.5486 24.1766 19.4426 24.2649 19.478C24.3532 19.5133 24.3355 19.5133 24.3532 19.4956C24.3708 19.478 24.4238 19.5663 24.4062 19.6192C24.3885 19.6722 24.3885 19.6369 24.3532 19.6899V19.7252C24.3355 19.6722 24.3179 19.7782 24.2825 19.7252L24.2296 19.7605V19.7252H24.1413V19.6899H24.1059C24.0883 19.6369 24.1589 19.6369 24.1059 19.6192Z"
            fill="#204063"
          />
          <path
            d="M24.2297 19.9194L24.1768 19.9371H24.2121L24.2297 19.9194Z"
            fill="white"
          />
          <path
            d="M25.5186 20.7491C25.5363 20.7491 25.5363 20.7314 25.5363 20.7137C25.5363 20.6961 25.6423 20.6961 25.6599 20.7314V20.802C25.6246 20.7844 25.6069 20.8197 25.5893 20.8374C25.5716 20.855 25.554 20.8374 25.554 20.8374H25.501C25.5186 20.7844 25.5363 20.7667 25.5186 20.7491Z"
            fill="#204063"
          />
          <path
            d="M25.5366 20.7847L25.5719 20.7671V20.7847H25.5366Z"
            fill="white"
          />
          <path
            d="M25.9602 22.3034C25.9955 22.2858 26.0485 22.3211 26.0132 22.3741C25.9778 22.427 25.9778 22.4094 25.9425 22.3917C25.9072 22.3741 25.8895 22.3034 25.9602 22.3034Z"
            fill="#204063"
          />
          <path
            d="M26.3311 19.9015V19.8662H26.4194C26.4371 19.8839 26.4371 19.9015 26.4194 19.9369H26.3841L26.3135 19.9015H26.3311Z"
            fill="#204063"
          />
          <path
            d="M26.4899 19.7778C26.4899 19.7955 26.4899 19.8132 26.4722 19.8132C26.4676 19.8132 26.4631 19.8113 26.4598 19.808C26.4564 19.8047 26.4546 19.8002 26.4546 19.7955L26.4899 19.7778Z"
            fill="#204063"
          />
          <path
            d="M25.9604 21.0495C25.9687 21.0385 25.9793 21.0296 25.9916 21.0235C26.0039 21.0174 26.0174 21.0142 26.0311 21.0142C26.0311 21.0318 26.0487 21.0318 26.0311 21.0495L25.9781 21.0848C25.9781 21.0848 25.9428 21.0671 25.9781 21.0495H25.9604Z"
            fill="#204063"
          />
          <path
            d="M25.9957 21.0494H26.0133C26.031 21.0317 25.978 21.0847 25.978 21.0494C25.978 21.0141 25.9957 21.0494 25.9957 21.0494Z"
            fill="white"
          />
          <path
            d="M26.8079 21.4029H26.7726C26.8079 21.4029 26.8079 21.3852 26.8256 21.3675C26.8433 21.3499 26.8256 21.3499 26.8079 21.3499C26.7903 21.3499 26.8433 21.3322 26.8609 21.3146H26.8433C26.9139 21.3146 27.0375 21.2439 27.1082 21.3499V21.4558H27.0905C27.0905 21.5088 27.0375 21.5265 27.0199 21.5618H26.9845C26.9669 21.5795 26.9669 21.5441 26.9492 21.5618L26.8962 21.5971V21.5618C26.8786 21.5441 26.8609 21.5618 26.8609 21.5795C26.8609 21.5971 26.8256 21.5265 26.7903 21.5088H26.7373C26.7726 21.4205 26.8256 21.4382 26.8079 21.4029Z"
            fill="#204063"
          />
          <path
            d="M26.7903 20.3254V20.29H26.7726C26.755 20.3077 26.7903 20.29 26.8079 20.3077C26.8256 20.3254 26.8079 20.2547 26.8433 20.2547C26.8786 20.2547 26.8256 20.2371 26.8079 20.2194C26.7903 20.2017 26.8609 20.2371 26.8962 20.2194C26.9316 20.2017 26.9845 20.2194 27.0199 20.1841H27.0728L27.1611 20.2547L27.1965 20.29C27.1965 20.29 27.1965 20.3077 27.2318 20.3254C27.2671 20.343 27.2848 20.3607 27.2318 20.3783C27.1788 20.396 27.2494 20.4137 27.2671 20.4137H27.2141C27.2671 20.449 27.1788 20.4666 27.2141 20.5196L27.1788 20.5549C27.1435 20.5373 27.1258 20.5903 27.1082 20.6079C27.0905 20.6256 27.0199 20.5549 27.0022 20.6256C26.9845 20.6962 26.9492 20.5549 26.9139 20.6079H26.8962C26.8786 20.5903 26.9316 20.5726 26.8962 20.5549C26.8609 20.5373 26.8786 20.5726 26.8609 20.5903C26.8433 20.6079 26.8962 20.5196 26.8433 20.5196H26.7903C26.8079 20.502 26.8079 20.4843 26.8079 20.449C26.8079 20.4137 26.7726 20.4843 26.7726 20.449C26.7726 20.4137 26.8079 20.4313 26.7903 20.4137H26.7373C26.7903 20.396 26.7726 20.343 26.7903 20.3254Z"
            fill="#204063"
          />
          <path
            d="M28.2384 20.9434C28.2384 20.9081 28.2737 20.8728 28.256 20.8375C28.2384 20.8022 28.2737 20.7492 28.3267 20.7668C28.3797 20.7845 28.3267 20.7139 28.3797 20.7315C28.4326 20.7315 28.4856 20.6962 28.5563 20.7315C28.6269 20.7668 28.5916 20.7845 28.6269 20.7668H28.6092C28.6269 20.7845 28.6799 20.8022 28.6622 20.8375V20.8728C28.6403 20.9039 28.628 20.9407 28.6269 20.9788C28.6092 20.9964 28.5739 20.9964 28.5916 21.0317C28.6092 21.0671 28.5563 21.0671 28.5386 21.0847H28.4856C28.4621 21.0847 28.4444 21.1024 28.4326 21.1377C28.4326 21.12 28.415 21.12 28.4326 21.1024C28.4503 21.0847 28.3973 21.12 28.3797 21.12H28.362C28.3443 21.1024 28.309 21.1377 28.2914 21.1377C28.2737 21.1377 28.309 21.1024 28.2914 21.0847H28.256V21.0317C28.2207 21.0141 28.2207 21.0671 28.2031 21.0494C28.1854 21.0317 28.2207 20.9788 28.2384 20.9434Z"
            fill="#204063"
          />
          <path
            d="M27.4967 19.1245C27.4967 19.1422 27.5144 19.1422 27.5144 19.1598C27.5144 19.1775 27.4614 19.1775 27.4614 19.1598C27.4614 19.1422 27.4614 19.1245 27.4967 19.1245Z"
            fill="#204063"
          />
          <path
            d="M27.638 17.8706H27.6733C27.691 17.8883 27.6557 17.9059 27.638 17.9236C27.6204 17.9412 27.638 17.9059 27.6027 17.8883C27.5674 17.8706 27.6204 17.8883 27.638 17.8706Z"
            fill="#204063"
          />
          <path
            d="M28.4681 20.3608H28.5211L28.4857 20.4138H28.4681C28.4504 20.3962 28.5034 20.3785 28.4681 20.3608V20.3962C28.4651 20.3846 28.4651 20.3724 28.4681 20.3608Z"
            fill="#204063"
          />
          <path
            d="M28.3796 19.3189C28.3788 19.3094 28.38 19.2997 28.383 19.2906C28.3861 19.2815 28.3909 19.2731 28.3973 19.2659C28.4091 19.249 28.425 19.2352 28.4435 19.2259C28.462 19.2167 28.4826 19.2122 28.5033 19.213C28.5562 19.2483 28.5916 19.2483 28.5916 19.3013C28.5916 19.3542 28.5562 19.3366 28.6092 19.3542C28.6622 19.3719 28.5562 19.3719 28.5739 19.4072C28.5916 19.4425 28.5386 19.4072 28.5209 19.4072H28.5033C28.4856 19.4425 28.4679 19.4072 28.4326 19.4249H28.4503C28.4503 19.4202 28.4484 19.4157 28.4451 19.4124C28.4418 19.4091 28.4373 19.4072 28.4326 19.4072C28.4279 19.4072 28.4235 19.4091 28.4201 19.4124C28.4168 19.4157 28.415 19.4202 28.415 19.4249L28.3796 19.3896V19.3189Z"
            fill="#204063"
          />
          <path
            d="M28.5562 19.478C28.5562 19.4603 28.6091 19.478 28.6091 19.4427H28.6445C28.6621 19.4427 28.6445 19.425 28.6621 19.4074H28.7328C28.7681 19.372 28.7857 19.4427 28.8211 19.4427C28.8564 19.4427 28.8387 19.4956 28.8917 19.4956C28.9447 19.4956 28.927 19.5839 28.874 19.6546H28.8564C28.8387 19.6722 28.8564 19.6899 28.8564 19.7076H28.8211C28.8211 19.7605 28.7504 19.7429 28.7328 19.7605C28.7151 19.7782 28.6974 19.7605 28.6974 19.7429H28.6798V19.6899C28.6621 19.7076 28.6445 19.6899 28.6445 19.7252C28.6445 19.7605 28.6268 19.6369 28.5915 19.6546C28.5962 19.6546 28.6006 19.6527 28.604 19.6494C28.6073 19.6461 28.6091 19.6416 28.6091 19.6369C28.6091 19.6322 28.6073 19.6278 28.604 19.6244C28.6006 19.6211 28.5962 19.6193 28.5915 19.6193C28.5208 19.5839 28.6091 19.5133 28.5562 19.478Z"
            fill="#204063"
          />
          <path
            d="M29.3158 19.7603C29.3334 19.7426 29.2981 19.725 29.2804 19.725C29.2628 19.725 29.2981 19.7073 29.2981 19.6897H29.2628C29.2628 19.672 29.3158 19.6897 29.2981 19.6543C29.3121 19.6543 29.3256 19.6487 29.3356 19.6388C29.3455 19.6289 29.3511 19.6154 29.3511 19.6014V19.5131C29.3864 19.5131 29.3334 19.4601 29.3864 19.4777C29.3773 19.437 29.3773 19.3948 29.3864 19.3541C29.4041 19.3541 29.3864 19.3365 29.4041 19.3188H29.4394C29.4217 19.2658 29.457 19.3188 29.457 19.2835C29.457 19.2482 29.51 19.3188 29.5453 19.3011C29.5807 19.2835 29.5807 19.3365 29.5807 19.3718C29.5807 19.4071 29.563 19.3188 29.5983 19.3011C29.6336 19.2835 29.5983 19.3718 29.6513 19.3718H29.669C29.6866 19.3718 29.6866 19.4248 29.7219 19.3894V19.4248H29.7396C29.7573 19.4424 29.7396 19.4601 29.7573 19.4601H29.7749L29.8102 19.5131H29.8279V19.566C29.8632 19.566 29.8279 19.619 29.8632 19.619C29.8985 19.619 29.8985 19.672 29.9162 19.672C29.9339 19.672 29.8809 19.672 29.8809 19.6897C29.8809 19.7073 29.9162 19.7073 29.9339 19.725H29.8985C29.8809 19.7426 29.8985 19.7603 29.9162 19.7779C29.9162 19.7956 29.8632 19.8309 29.9162 19.8309C29.9115 19.8309 29.907 19.8328 29.9037 19.8361C29.9004 19.8394 29.8985 19.8439 29.8985 19.8486C29.8985 19.8839 29.9162 19.8839 29.9339 19.9016C29.9515 19.9192 29.8632 19.8486 29.8632 19.9016V19.9722L29.8279 19.9192C29.7573 19.9545 29.8279 20.0605 29.7573 20.0782C29.7596 20.0688 29.7581 20.0589 29.7532 20.0506C29.7482 20.0423 29.7401 20.0364 29.7308 20.034C29.7214 20.0317 29.7115 20.0331 29.7032 20.0381C29.6949 20.0431 29.689 20.0511 29.6866 20.0605C29.6513 20.0605 29.6866 20.1135 29.6336 20.1135C29.5807 20.1135 29.563 20.0605 29.5277 20.0782C29.4924 20.0958 29.5277 20.1311 29.51 20.1311C29.4924 20.1311 29.5277 20.0782 29.4924 20.0605C29.51 20.0428 29.4924 20.0252 29.4747 20.0075H29.457C29.457 19.9899 29.4747 19.9722 29.4394 19.9722H29.4217C29.4041 19.9545 29.4394 19.9545 29.4217 19.9369C29.4041 19.9192 29.3864 19.9016 29.3687 19.9192C29.3511 19.9369 29.3864 19.8839 29.3511 19.8839H29.3334C29.3334 19.8662 29.3687 19.8662 29.3511 19.8309H29.2981V19.7956H29.2451C29.2804 19.7956 29.3158 19.7956 29.3158 19.7603Z"
            fill="#204063"
          />
          <path
            d="M25.2184 18.9302C25.236 18.9302 25.289 18.9125 25.3067 18.9479C25.3243 18.9832 25.3067 19.0715 25.2537 19.0538H25.236L25.183 19.0185C25.2184 18.9832 25.1477 18.9832 25.183 18.9479C25.2184 18.9125 25.2184 18.9655 25.2184 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5189 18.9302L25.4659 18.9655V18.9478L25.4482 18.9655V18.9478L25.5189 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5896 18.8595H25.5719C25.5719 18.8419 25.5896 18.8419 25.5896 18.8242H25.5543C25.5896 18.8066 25.5896 18.7889 25.6073 18.7712H25.5896C25.6424 18.7374 25.7035 18.7191 25.7662 18.7183C25.8015 18.7359 25.8368 18.7889 25.8898 18.7536C25.9428 18.7183 25.8545 18.7889 25.8898 18.7889L25.9428 18.8949C25.9075 18.9125 25.9251 18.9478 25.9251 18.9832C25.9251 19.0185 25.8722 19.0008 25.8898 19.0361H25.8722C25.8368 19.0538 25.8722 19.0715 25.8722 19.0891H25.8192C25.8192 19.1244 25.7485 19.1244 25.7309 19.1421C25.7132 19.1598 25.6602 19.1598 25.6426 19.1951C25.6249 19.2304 25.6779 19.1068 25.6249 19.0891C25.6249 19.0938 25.6231 19.0983 25.6197 19.1016C25.6164 19.1049 25.6119 19.1068 25.6073 19.1068C25.5719 19.0715 25.6426 19.0361 25.6073 19.0361L25.5366 19.0891C25.5719 18.9655 25.6249 18.9302 25.5896 18.8595Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M10.0308 24.2813L10.0484 24.2637V24.2813H10.0308Z"
            fill="white"
          />
          <path
            d="M10.0308 24.2989V24.2812H10.0484L10.0308 24.2989Z"
            fill="white"
          />
          <path
            d="M13.0154 24.7227V24.758C12.9977 24.7756 12.9977 24.7756 12.98 24.758C12.9624 24.7403 12.9624 24.7227 12.98 24.7227H13.0154Z"
            fill="#204063"
          />
          <path
            d="M13.1037 24.7755H13.086C13.0813 24.7755 13.0768 24.7736 13.0735 24.7703C13.0702 24.767 13.0684 24.7625 13.0684 24.7578C13.086 24.7401 13.1213 24.7578 13.1037 24.7755Z"
            fill="#204063"
          />
          <path
            d="M11.0201 21.1554C11.0201 21.1554 11.0024 21.1377 11.0201 21.1377V21.1554Z"
            fill="#204063"
          />
          <path
            d="M11.8324 23.575H11.8147C11.8139 23.5654 11.815 23.5558 11.8181 23.5466C11.8211 23.5375 11.826 23.5291 11.8324 23.522C11.8324 23.5396 11.85 23.5573 11.8324 23.575Z"
            fill="#204063"
          />
          <path
            d="M10.9845 21.3322C10.9845 21.3499 10.9669 21.3499 10.9492 21.3322V21.2969C10.9845 21.2969 10.9845 21.3145 10.9845 21.3322Z"
            fill="#204063"
          />
          <path
            d="M11.6382 20.3608C11.6558 20.3962 11.6912 20.4315 11.6735 20.4668C11.6558 20.5021 11.6558 20.4491 11.6558 20.4315C11.6558 20.4138 11.6558 20.3785 11.6382 20.3608Z"
            fill="#204063"
          />
          <path
            d="M12.044 25.9234H12.0616C12.097 25.9057 12.0793 25.9411 12.097 25.9411C12.097 25.9548 12.0938 25.9683 12.0876 25.9806C12.0815 25.9928 12.0726 26.0035 12.0616 26.0117H12.0087C12.0087 25.994 11.9557 26.0117 11.9733 25.9764V25.9234H12.0263H12.044Z"
            fill="#204063"
          />
          <path
            d="M11.6733 20.5904C11.6733 20.5904 11.691 20.6081 11.6733 20.6081V20.5727C11.6733 20.5551 11.6733 20.5727 11.6733 20.5904Z"
            fill="#204063"
          />
          <path
            d="M11.7791 20.6609C11.7728 20.6537 11.7679 20.6453 11.7649 20.6362C11.7618 20.6271 11.7607 20.6175 11.7615 20.6079L11.7791 20.6609Z"
            fill="#204063"
          />
          <path
            d="M11.7617 20.6431C11.7794 20.6431 11.7617 20.6431 11.7617 20.6255V20.6431Z"
            fill="white"
          />
          <path
            d="M12.4504 22.0912C12.4504 22.1089 12.4504 22.1265 12.4328 22.1265H12.3975C12.3986 22.1129 12.4049 22.1003 12.4151 22.0912C12.4328 22.0559 12.4328 22.0735 12.4504 22.0912Z"
            fill="#204063"
          />
          <path
            d="M12.2916 22.1265C12.2739 22.1441 12.2739 22.1441 12.2739 22.1265H12.2916Z"
            fill="#204063"
          />
          <path
            d="M11.9029 22.3033C11.8982 22.3033 11.8937 22.3014 11.8904 22.2981C11.8871 22.2948 11.8853 22.2903 11.8853 22.2856L11.9029 22.3033Z"
            fill="#204063"
          />
          <path
            d="M11.585 21.2789L11.5674 21.2612L11.585 21.2789Z"
            fill="#204063"
          />
          <path
            d="M11.5852 21.3851C11.5852 21.4028 11.5852 21.4204 11.5675 21.4204C11.5499 21.4204 11.5499 21.3674 11.5322 21.3498C11.5322 21.3498 11.5499 21.3321 11.5499 21.3498C11.5499 21.3674 11.5675 21.3321 11.5499 21.3145C11.5609 21.3227 11.5698 21.3333 11.5759 21.3456C11.582 21.3579 11.5852 21.3714 11.5852 21.3851Z"
            fill="#204063"
          />
          <path
            d="M12.2559 22.2681C12.2736 22.2857 12.2559 22.2857 12.2559 22.2857C12.2559 22.2857 12.2382 22.2681 12.2559 22.2681Z"
            fill="#204063"
          />
          <path
            d="M11.9737 22.4268H11.9561C11.9737 22.4092 11.9914 22.4092 11.9737 22.4268Z"
            fill="#204063"
          />
          <path
            d="M12.1324 22.4093H12.1148C12.1148 22.4093 12.0971 22.4093 12.1148 22.3916C12.1148 22.3963 12.1166 22.4008 12.12 22.4041C12.1233 22.4074 12.1278 22.4093 12.1324 22.4093Z"
            fill="#204063"
          />
          <path
            d="M12.0088 22.4444C11.9911 22.4444 12.0264 22.4797 11.9911 22.4797C11.9558 22.4797 11.9734 22.4444 11.9911 22.4268L12.0088 22.4444Z"
            fill="#204063"
          />
          <path
            d="M11.6912 21.5791V21.6144C11.6912 21.5968 11.6912 21.5968 11.7088 21.5968C11.7179 21.6434 11.7179 21.6914 11.7088 21.738H11.6558C11.6735 21.7027 11.6382 21.6851 11.6382 21.6674H11.6558C11.655 21.6578 11.6562 21.6482 11.6592 21.6391C11.6623 21.63 11.6671 21.6216 11.6735 21.6144L11.6912 21.5791Z"
            fill="#204063"
          />
          <path
            d="M11.5319 21.738C11.4966 21.7557 11.4966 21.7027 11.4966 21.6851H11.5142C11.5319 21.6851 11.5496 21.7027 11.5319 21.738Z"
            fill="#204063"
          />
          <path
            d="M11.5318 21.7203H11.5142V21.7026V21.7203H11.5318Z"
            fill="white"
          />
          <path
            d="M11.6911 24.387H11.6734C11.6381 24.3516 11.6734 24.2987 11.6734 24.2633V24.228C11.6967 24.2776 11.703 24.3335 11.6911 24.387Z"
            fill="#204063"
          />
          <path
            d="M11.5322 21.9325H11.5145C11.5145 21.9501 11.4969 21.9325 11.4969 21.9325C11.4882 21.9227 11.4834 21.9102 11.4834 21.8971C11.4834 21.8841 11.4882 21.8715 11.4969 21.8618C11.4792 21.8618 11.4969 21.8618 11.4969 21.8795C11.4969 21.8971 11.4969 21.8618 11.4969 21.8618C11.4969 21.8618 11.5322 21.9148 11.5322 21.9325Z"
            fill="#204063"
          />
          <path
            d="M11.4967 22.0033C11.5108 22.024 11.517 22.049 11.5144 22.0739H11.4967C11.4791 22.0739 11.4614 22.0562 11.4614 22.0209C11.4614 21.9856 11.4791 22.0033 11.4791 21.9856C11.4791 21.9679 11.4791 22.0209 11.4967 22.0033Z"
            fill="#204063"
          />
          <path
            d="M10.9318 22.3914H10.9141C10.8965 22.3914 10.8965 22.3561 10.8965 22.3561C10.8965 22.3561 10.8965 22.3385 10.8965 22.3208C10.9075 22.329 10.9164 22.3397 10.9225 22.352C10.9286 22.3642 10.9318 22.3777 10.9318 22.3914Z"
            fill="#204063"
          />
          <path
            d="M13.1393 22.2503C13.104 22.2503 13.104 22.215 13.104 22.1973C13.104 22.1797 13.1217 22.1267 13.104 22.0737H13.1217C13.1217 22.1091 13.1746 22.1797 13.1393 22.2503Z"
            fill="#204063"
          />
          <path
            d="M11.4259 22.8507H11.4082V22.8154H11.4259C11.4259 22.7977 11.4259 22.833 11.4259 22.8507Z"
            fill="#204063"
          />
          <path
            d="M11.4615 23.151C11.4792 23.151 11.4615 23.1333 11.4615 23.1333L11.4968 23.1863C11.4968 23.2039 11.4968 23.2039 11.4792 23.2216H11.4438C11.4438 23.2039 11.4615 23.1863 11.4438 23.1863V23.151H11.4615Z"
            fill="#204063"
          />
          <path
            d="M12.7681 22.5505H12.7505V22.5151L12.7681 22.5505Z"
            fill="#204063"
          />
          <path
            d="M11.9557 22.9922C11.9557 23.0275 11.991 23.0628 11.9733 23.0981H11.938C11.9204 23.0628 11.938 23.0452 11.938 23.0098L11.9557 22.9922Z"
            fill="#204063"
          />
          <path
            d="M11.3909 23.3804C11.3909 23.398 11.3909 23.4157 11.3732 23.4157C11.3556 23.4157 11.3556 23.4157 11.3556 23.4157C11.3509 23.4157 11.3464 23.4138 11.3431 23.4105C11.3398 23.4072 11.3379 23.4027 11.3379 23.398C11.3379 23.3933 11.3398 23.3889 11.3431 23.3855C11.3464 23.3822 11.3509 23.3804 11.3556 23.3804H11.3909Z"
            fill="#204063"
          />
          <path
            d="M12.4152 23.0451C12.4152 23.0627 12.4152 23.0804 12.3975 23.0804C12.3929 23.0804 12.3884 23.0785 12.3851 23.0752C12.3817 23.0719 12.3799 23.0674 12.3799 23.0627V23.0274C12.3975 23.0097 12.3975 23.0451 12.4152 23.0451Z"
            fill="#204063"
          />
          <path
            d="M11.3022 23.4338H11.3199C11.3022 23.4338 11.3022 23.4161 11.3199 23.3984C11.3246 23.4008 11.3282 23.4049 11.3298 23.4099C11.3315 23.4148 11.3311 23.4202 11.3287 23.4249C11.3264 23.4296 11.3223 23.4332 11.3173 23.4348C11.3124 23.4365 11.3069 23.4361 11.3022 23.4338Z"
            fill="#204063"
          />
          <path
            d="M13.1213 22.9745C13.1213 22.9922 13.1213 23.0099 13.1037 23.0099C13.086 23.0099 13.0684 23.0275 13.0684 23.0099C13.0684 22.9922 13.1037 22.9569 13.1213 22.9745Z"
            fill="#204063"
          />
          <path
            d="M12.8033 23.0627H12.821C12.821 23.098 12.8386 23.1333 12.821 23.1686C12.821 23.1733 12.8191 23.1778 12.8158 23.1811C12.8125 23.1844 12.808 23.1863 12.8033 23.1863C12.7986 23.1863 12.7941 23.1844 12.7908 23.1811C12.7875 23.1778 12.7856 23.1733 12.7856 23.1686V23.098H12.8033C12.8029 23.0733 12.809 23.0489 12.821 23.0273L12.8033 23.0627Z"
            fill="#204063"
          />
          <path
            d="M12.2384 23.2041H12.256C12.2647 23.2138 12.2695 23.2264 12.2695 23.2394C12.2695 23.2525 12.2647 23.265 12.256 23.2747H12.2207V23.2218H12.2384V23.2041Z"
            fill="#204063"
          />
          <path
            d="M10.9139 23.6453C10.9092 23.6453 10.9047 23.6434 10.9014 23.6401C10.8981 23.6368 10.8962 23.6323 10.8962 23.6276C10.8786 23.6276 10.9139 23.5923 10.8962 23.5923C10.8786 23.5923 10.9315 23.6276 10.9139 23.6453Z"
            fill="#204063"
          />
          <path
            d="M11.2143 25.2525H11.232C11.232 25.2525 11.1967 25.2878 11.232 25.2878C11.2673 25.2878 11.2143 25.3584 11.179 25.3761H11.1967C11.1967 25.4114 11.2143 25.4291 11.179 25.4467H11.1614C11.126 25.4114 11.2143 25.3761 11.1437 25.3408C11.0731 25.3055 11.1437 25.2701 11.1437 25.2525H11.1967C11.1967 25.2348 11.1967 25.2525 11.2143 25.2525Z"
            fill="#204063"
          />
          <path
            d="M11.32 23.6279C11.32 23.6456 11.32 23.6632 11.3024 23.6632H11.2847C11.267 23.6456 11.2847 23.6456 11.2847 23.6456H11.32V23.6279Z"
            fill="#204063"
          />
          <path
            d="M12.715 23.2925V23.3455H12.6973C12.6797 23.3455 12.6797 23.3101 12.6973 23.2925H12.715Z"
            fill="#204063"
          />
          <path
            d="M11.1788 23.8042H11.1965V23.8395H11.1611V23.8042H11.1788Z"
            fill="#204063"
          />
          <path
            d="M11.1787 23.8042V23.8219V23.8042H11.1964H11.1787Z"
            fill="white"
          />
          <path
            d="M11.2316 24.0514C11.2493 24.0514 11.2669 24.0691 11.2493 24.0868H11.2316C11.1963 24.0868 11.2139 24.0514 11.1963 24.0514C11.2139 24.0338 11.2139 24.0338 11.2139 24.0161C11.2093 24.0185 11.2057 24.0226 11.204 24.0275C11.2024 24.0325 11.2028 24.0379 11.2051 24.0426C11.2075 24.0473 11.2116 24.0508 11.2165 24.0525C11.2215 24.0542 11.2269 24.0538 11.2316 24.0514Z"
            fill="#204063"
          />
          <path
            d="M10.7725 24.0869C10.7725 24.1046 10.7902 24.1222 10.7725 24.1576V24.1222C10.7549 24.1046 10.7725 24.1046 10.7725 24.0869Z"
            fill="#204063"
          />
          <path
            d="M12.821 23.5923C12.821 23.6099 12.8386 23.6453 12.821 23.6629V23.6982L12.7856 23.6629V23.6276C12.8033 23.6453 12.7856 23.5923 12.8033 23.6099C12.8033 23.6099 12.8033 23.6099 12.821 23.5923Z"
            fill="#204063"
          />
          <path
            d="M11.0906 24.1221H11.1083C11.0906 24.1397 11.1083 24.175 11.0906 24.1927C11.073 24.2104 11.0553 24.175 11.0376 24.1574C11.02 24.1397 11.0376 24.1397 11.0376 24.1397H11.0906V24.1221Z"
            fill="#204063"
          />
          <path
            d="M12.3976 23.7337C12.3929 23.7337 12.3884 23.7319 12.3851 23.7286C12.3818 23.7252 12.3799 23.7207 12.3799 23.7161V23.6807C12.3623 23.6631 12.3799 23.6807 12.3799 23.6984C12.3976 23.6807 12.3976 23.6807 12.3976 23.6631C12.3976 23.6807 12.4152 23.7161 12.3976 23.7337Z"
            fill="#204063"
          />
          <path
            d="M12.2031 24.5461H12.2208V24.5107C12.2245 24.5141 12.2276 24.5181 12.2296 24.5227C12.2317 24.5273 12.2327 24.5322 12.2327 24.5372C12.2327 24.5422 12.2317 24.5472 12.2296 24.5518C12.2276 24.5563 12.2245 24.5604 12.2208 24.5637C12.217 24.5604 12.214 24.5563 12.212 24.5518C12.2099 24.5472 12.2088 24.5422 12.2088 24.5372C12.2088 24.5322 12.2099 24.5273 12.212 24.5227C12.214 24.5181 12.217 24.5141 12.2208 24.5107L12.2031 24.5461Z"
            fill="#204063"
          />
          <path
            d="M11.32 24.9876H11.3023C11.2847 25.0052 11.2847 24.9875 11.2847 24.9699C11.3023 24.9522 11.2847 24.9522 11.3023 24.9346H11.32C11.32 24.9522 11.3376 24.9699 11.32 24.9876Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.7759C11.9382 24.7935 11.9558 24.8289 11.9205 24.8289C11.8852 24.8289 11.9029 24.8289 11.9029 24.8112V24.7759H11.9205C11.9232 24.7774 11.9262 24.7782 11.9293 24.7782C11.9324 24.7782 11.9355 24.7774 11.9382 24.7759Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.8112H11.9205C11.9158 24.8112 11.9113 24.8093 11.908 24.806C11.9047 24.8027 11.9028 24.7982 11.9028 24.7935C11.9028 24.7889 11.9047 24.7844 11.908 24.781C11.9113 24.7777 11.9158 24.7759 11.9205 24.7759C11.9205 24.7935 11.9382 24.7759 11.9382 24.8112Z"
            fill="white"
          />
          <path
            d="M11.2496 24.8464C11.2496 24.864 11.2496 24.8464 11.2319 24.8464V24.811H11.2496C11.2496 24.8287 11.2673 24.8464 11.2496 24.8464Z"
            fill="#204063"
          />
          <path
            d="M12.0264 24.9172V24.8818C12.0264 24.8818 12.044 24.8995 12.0264 24.9172Z"
            fill="#204063"
          />
          <path
            d="M10.7373 26.2769H10.7726C10.7726 26.2769 10.755 26.2769 10.7726 26.2946C10.7773 26.2946 10.7818 26.2927 10.7851 26.2894C10.7884 26.2861 10.7903 26.2816 10.7903 26.2769C10.7903 26.2723 10.7884 26.2678 10.7851 26.2645C10.7818 26.2611 10.7773 26.2593 10.7726 26.2593C10.7903 26.2769 10.7726 26.3123 10.7903 26.3123H10.8079C10.8079 26.3476 10.8256 26.3476 10.8256 26.3652C10.8264 26.3748 10.8253 26.3844 10.8222 26.3935C10.8192 26.4027 10.8143 26.4111 10.8079 26.4182C10.8433 26.4006 10.8079 26.4535 10.8256 26.4535C10.8209 26.4535 10.8164 26.4554 10.8131 26.4587C10.8098 26.462 10.8079 26.4665 10.8079 26.4712L10.7373 26.5065H10.6843C10.6667 26.5065 10.649 26.4889 10.6667 26.4712H10.649C10.6517 26.4463 10.6454 26.4213 10.6313 26.4006H10.6667V26.3652C10.6843 26.3652 10.6667 26.3476 10.6843 26.3299C10.702 26.3123 10.702 26.3476 10.7196 26.3299C10.7174 26.3203 10.7178 26.3103 10.7209 26.3009C10.7241 26.2916 10.7297 26.2832 10.7373 26.2769Z"
            fill="#204063"
          />
          <path
            d="M11.9205 25.0582V25.0935C11.9028 25.1112 11.9028 25.0758 11.9028 25.0758C11.9028 25.0758 11.9028 25.0582 11.9028 25.0405L11.9205 25.0582Z"
            fill="#204063"
          />
          <path
            d="M11.8501 25.27H11.7971C11.7971 25.2877 11.7794 25.2877 11.7618 25.2877C11.7557 25.2658 11.7559 25.2427 11.7621 25.2209C11.7683 25.1991 11.7804 25.1794 11.7971 25.1641H11.8147C11.8249 25.1676 11.8341 25.1735 11.8417 25.1812C11.8493 25.1888 11.855 25.1982 11.8584 25.2084C11.8618 25.2186 11.8628 25.2295 11.8614 25.2402C11.8599 25.2509 11.8561 25.2611 11.8501 25.27Z"
            fill="#204063"
          />
          <path
            d="M11.1966 27.4601H11.2143V27.4954H11.2319C11.2143 27.5308 11.2319 27.5484 11.2143 27.5661C11.1966 27.5837 11.1966 27.6014 11.1966 27.6191H11.126C11.1249 27.6055 11.1185 27.5928 11.1083 27.5837H11.0553C11.02 27.5837 11.0377 27.5484 11.02 27.5308V27.4954C11.0377 27.5131 11.0377 27.4778 11.0553 27.4601H11.126V27.4248H11.1613C11.1613 27.4248 11.179 27.4778 11.1966 27.4601Z"
            fill="#204063"
          />
          <path
            d="M11.0731 25.7114C11.0731 25.7291 11.1084 25.7467 11.1084 25.7821L11.0731 25.835L11.0024 25.7997C11.0201 25.7821 11.0024 25.7467 11.0024 25.7467H11.0201C11.0201 25.7291 11.0201 25.7114 11.0378 25.7114H11.0731Z"
            fill="#204063"
          />
          <path
            d="M11.6029 25.5703H11.6205C11.6382 25.6056 11.5675 25.6056 11.6029 25.6409C11.6382 25.6762 11.5852 25.6939 11.5675 25.6939C11.5499 25.6939 11.5322 25.6586 11.5322 25.6409C11.5499 25.6586 11.5499 25.6233 11.5499 25.6233H11.5852C11.5782 25.6209 11.5724 25.6159 11.5691 25.6093C11.5657 25.6026 11.5652 25.595 11.5675 25.5879C11.5699 25.5809 11.5749 25.5751 11.5815 25.5718C11.5882 25.5685 11.5958 25.5679 11.6029 25.5703Z"
            fill="#204063"
          />
          <path
            d="M11.4083 26.3652V26.4006C11.3907 26.4182 11.4437 26.4182 11.4083 26.4535C11.373 26.4889 11.3907 26.4712 11.3907 26.4889H11.32V26.4535C11.3377 26.4535 11.3024 26.4359 11.32 26.4359V26.4006H11.373C11.3907 26.3476 11.3907 26.3829 11.4083 26.3652Z"
            fill="#204063"
          />
          <path
            d="M10.7019 26.7008C10.7019 26.7184 10.7019 26.7184 10.7196 26.7184C10.7372 26.7184 10.7019 26.7714 10.6842 26.7537H10.6489C10.6666 26.7361 10.6489 26.7361 10.6489 26.7184C10.6536 26.7184 10.6581 26.7166 10.6614 26.7133C10.6647 26.7099 10.6666 26.7054 10.6666 26.7008C10.6666 26.6961 10.6684 26.6916 10.6718 26.6883C10.6751 26.685 10.6796 26.6831 10.6842 26.6831L10.7019 26.7008Z"
            fill="#204063"
          />
          <path
            d="M10.6842 26.7007V26.7183H10.6665L10.6842 26.7007Z"
            fill="white"
          />
          <path
            d="M9.99577 26.5592C9.99577 26.5768 9.97811 26.5945 9.96045 26.5768V26.5415C9.97811 26.5238 10.0134 26.5415 9.99577 26.5592Z"
            fill="#204063"
          />
          <path
            d="M10.8784 27.2481C10.8784 27.2481 10.8784 27.2304 10.8961 27.2481H10.8784Z"
            fill="#204063"
          />
          <path
            d="M10.4903 26.8066C10.508 26.8066 10.4903 26.8243 10.4903 26.8243H10.4727C10.4727 26.8243 10.4903 26.8066 10.4903 26.8243V26.8066Z"
            fill="#204063"
          />
          <path
            d="M10.1899 27.0186H10.2252C10.2075 27.0186 10.2252 27.0362 10.2252 27.0362C10.2252 27.0715 10.2252 27.1069 10.1722 27.1245L10.1192 27.0892C10.1016 27.0715 10.1192 27.0539 10.1016 27.0362H10.1192C10.1016 27.0186 10.1192 27.0362 10.1192 27.0186H10.1899Z"
            fill="#204063"
          />
          <path
            d="M10.6135 27.2481H10.6489V27.2834C10.6665 27.3011 10.6312 27.3011 10.6312 27.3364H10.5429C10.5429 27.3188 10.5076 27.3541 10.5076 27.3188C10.4722 27.3364 10.4899 27.3011 10.4722 27.3011H10.4546C10.4593 27.3011 10.4638 27.2992 10.4671 27.2959C10.4704 27.2926 10.4722 27.2881 10.4722 27.2834C10.4722 27.2788 10.4704 27.2743 10.4671 27.271C10.4638 27.2676 10.4593 27.2658 10.4546 27.2658C10.4546 27.2481 10.4899 27.2481 10.4722 27.2305C10.4546 27.2128 10.5076 27.2305 10.4899 27.1951C10.5076 27.1951 10.5076 27.2128 10.5076 27.1951C10.5076 27.1775 10.5076 27.1951 10.5076 27.1775C10.5076 27.1598 10.5252 27.2128 10.5429 27.1951H10.5959C10.5782 27.2305 10.6135 27.2305 10.6135 27.2481Z"
            fill="#204063"
          />
          <path
            d="M10.066 27.5835L10.1014 27.6188C10.0837 27.6365 10.119 27.6365 10.1014 27.6541C10.0837 27.6718 10.119 27.6718 10.1014 27.6718H10.119C10.1014 27.6895 10.1014 27.7248 10.066 27.7424H9.96008C9.94242 27.7248 9.96008 27.7071 9.94242 27.7071C9.92476 27.7071 9.94242 27.6895 9.94242 27.6718C9.9471 27.6718 9.9516 27.6699 9.95491 27.6666C9.95822 27.6633 9.96008 27.6588 9.96008 27.6541C9.96008 27.6495 9.95822 27.645 9.95491 27.6416C9.9516 27.6383 9.9471 27.6365 9.94242 27.6365H9.96008C9.96008 27.6365 9.94242 27.6188 9.96008 27.6188H10.0307L10.066 27.5835Z"
            fill="#204063"
          />
          <path
            d="M10.9137 27.778H10.8961C10.8914 27.778 10.8869 27.7761 10.8836 27.7728C10.8803 27.7695 10.8784 27.765 10.8784 27.7603C10.8784 27.7557 10.8803 27.7512 10.8836 27.7478C10.8869 27.7445 10.8914 27.7427 10.8961 27.7427C10.9137 27.7603 10.9137 27.7603 10.9137 27.778Z"
            fill="#204063"
          />
          <path
            d="M11.3199 28.131C11.3022 28.131 11.3022 28.1134 11.3022 28.0957H11.3199C11.3199 28.0957 11.3376 28.131 11.3199 28.131Z"
            fill="#204063"
          />
          <path
            d="M10.6136 28.043H10.6313V28.0959C10.5959 28.0959 10.5959 28.1136 10.5606 28.0959H10.543C10.543 28.0783 10.5606 28.0606 10.543 28.0606H10.5606C10.543 28.0606 10.5606 28.0606 10.5606 28.043C10.5606 28.0477 10.5625 28.0521 10.5658 28.0555C10.5691 28.0588 10.5736 28.0606 10.5783 28.0606H10.6136V28.043Z"
            fill="#204063"
          />
          <path
            d="M10.5075 28.0604H10.5252C10.5075 28.0604 10.5252 28.078 10.5252 28.078H10.5075L10.4722 28.1134H10.4192C10.4192 28.078 10.3839 28.0957 10.3662 28.0604H10.3839C10.3662 28.0427 10.3839 28.0251 10.3839 28.0074H10.4015C10.4015 27.9897 10.4192 27.9897 10.4015 27.9897C10.3839 27.9897 10.4369 28.0074 10.4369 27.9897H10.4545C10.4898 28.0074 10.4898 28.0604 10.5075 28.0604Z"
            fill="#204063"
          />
          <path
            d="M10.2076 28.2192H10.2606C10.2606 28.2369 10.2429 28.2546 10.2606 28.2546H10.2783C10.2783 28.2722 10.2606 28.2899 10.2783 28.2899H10.2959C10.2959 28.2899 10.3136 28.2899 10.2959 28.3075H10.3489C10.3313 28.3252 10.3489 28.3252 10.3489 28.3252H10.3313C10.3489 28.3252 10.3313 28.3252 10.3313 28.3429H10.137C10.137 28.3075 10.1017 28.3252 10.1017 28.3252H10.0663V28.2899H10.031C10.031 28.2899 10.0663 28.2899 10.0487 28.2722C10.0487 28.2369 9.99571 28.2369 10.0134 28.2016C10.031 28.1663 10.031 28.2016 10.031 28.2016C10.031 28.2016 10.0134 28.1663 10.031 28.1663L10.0663 28.1309C10.0663 28.1309 10.0487 28.1133 10.0663 28.1133C10.0663 28.118 10.0682 28.1225 10.0715 28.1258C10.0748 28.1291 10.0793 28.1309 10.084 28.1309H10.1193C10.1193 28.1309 10.1193 28.1486 10.137 28.1309H10.2253L10.2076 28.2192Z"
            fill="#204063"
          />
          <path
            d="M11.4791 26.9302C11.4615 26.9478 11.4791 26.9655 11.4438 26.9655C11.4085 26.9655 11.4085 26.9478 11.4262 26.9302H11.4791Z"
            fill="#204063"
          />
          <path
            d="M11.4082 27.0539V27.0362H11.4259L11.4082 27.0186H11.4259L11.4082 27.0539Z"
            fill="#204063"
          />
          <path
            d="M11.4261 27.1065H11.4437V27.1418C11.4614 27.1595 11.4437 27.1948 11.4437 27.2125C11.4437 27.2301 11.3908 27.2301 11.3908 27.2655H11.3378C11.3201 27.2301 11.3201 27.2301 11.3025 27.2301C11.3025 27.2125 11.3201 27.1948 11.3025 27.1772C11.2848 27.1595 11.3201 27.1418 11.3025 27.1418C11.2848 27.1418 11.3378 27.1595 11.3554 27.1595C11.3731 27.1595 11.3378 27.1418 11.3554 27.1418C11.3731 27.1418 11.3731 27.1595 11.3731 27.1595V27.1065C11.3908 27.0712 11.3908 27.1065 11.4261 27.1065Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M19.7262 23.8751L19.6909 23.8574H19.7262V23.8751Z"
            fill="white"
          />
          <path
            d="M19.797 23.8751L19.7617 23.8927V23.8574L19.797 23.8751Z"
            fill="white"
          />
          <path
            d="M19.8323 17.0583L19.8853 17.0229C19.8977 17.0339 19.9073 17.0476 19.9134 17.0629C19.9196 17.0782 19.922 17.0948 19.9206 17.1112C19.903 17.1466 19.8677 17.1466 19.8323 17.1289C19.8237 17.1192 19.8188 17.1066 19.8188 17.0936C19.8188 17.0806 19.8237 17.068 19.8323 17.0583Z"
            fill="#204063"
          />
          <path
            d="M19.9028 16.8286C19.9205 16.8286 19.9205 16.8462 19.9205 16.8639L19.8675 16.8992C19.8322 16.8816 19.8498 16.7933 19.9028 16.8286Z"
            fill="#204063"
          />
          <path
            d="M11.9557 21.1026C11.9557 21.1203 11.938 21.1556 11.9204 21.1379H11.9027C11.9018 21.1313 11.9027 21.1246 11.9054 21.1185C11.9082 21.1125 11.9125 21.1073 11.9181 21.1036C11.9236 21.0999 11.9301 21.0978 11.9367 21.0977C11.9434 21.0975 11.9499 21.0992 11.9557 21.1026Z"
            fill="#204063"
          />
          <path
            d="M17.4145 19.8689L17.397 19.8711L17.3981 19.8799L17.4156 19.8777L17.4145 19.8689Z"
            fill="#204063"
          />
          <path
            d="M17.7133 19.9367C17.6779 19.972 17.6249 19.9367 17.6073 19.9013C17.5896 19.866 17.6779 19.9013 17.7133 19.9367Z"
            fill="#204063"
          />
          <path
            d="M12.4325 21.1909C12.4501 21.2262 12.4501 21.2616 12.4148 21.2616C12.3795 21.2616 12.3618 21.2439 12.3618 21.2262C12.3618 21.2086 12.4148 21.1909 12.4325 21.1909Z"
            fill="#204063"
          />
          <path
            d="M10.8962 19.0538H10.8785C10.9096 19.0393 10.9439 19.0333 10.978 19.0364C11.0121 19.0395 11.0448 19.0516 11.0728 19.0714C11.0728 19.1067 11.0374 19.0891 11.0021 19.1067L10.8608 19.0714L10.8962 19.0538Z"
            fill="#204063"
          />
          <path
            d="M22.7108 18.5594H22.6755L22.7108 18.5241C22.6755 18.4711 22.7638 18.4711 22.7638 18.4358C22.8135 18.4305 22.8636 18.443 22.905 18.4711C22.9404 18.5241 22.9227 18.5241 22.9404 18.577C22.958 18.63 22.958 18.683 22.8697 18.683C22.7814 18.683 22.8167 18.6653 22.7638 18.7007C22.7108 18.736 22.7461 18.6653 22.7284 18.6653H22.7108C22.7284 18.63 22.7108 18.6124 22.6755 18.5947C22.6401 18.577 22.6931 18.577 22.7108 18.5594Z"
            fill="#204063"
          />
          <path
            d="M11.3554 19.1597L11.4084 19.195C11.3907 19.2303 11.3377 19.2126 11.3201 19.2126H11.2671L11.3554 19.1597Z"
            fill="#204063"
          />
          <path
            d="M11.5498 19.0011H11.5675C11.5321 19.0187 11.4792 18.9834 11.4438 18.9834L11.5498 19.0011Z"
            fill="#204063"
          />
          <path
            d="M14.3048 19.6895C14.3224 19.7071 14.3224 19.7071 14.3224 19.7248H14.2871C14.2871 19.7248 14.2695 19.6895 14.3048 19.6895Z"
            fill="#204063"
          />
          <path
            d="M14.6578 18.8066H14.6931L14.6578 18.8596C14.6401 18.8596 14.6401 18.8243 14.6578 18.8066Z"
            fill="#204063"
          />
          <path
            d="M14.6579 18.312C14.6756 18.3297 14.7286 18.3297 14.7109 18.365C14.6933 18.4003 14.7109 18.4356 14.6756 18.4356C14.6403 18.4356 14.6403 18.4003 14.605 18.4003C14.5696 18.4003 14.6403 18.3473 14.6579 18.312Z"
            fill="#204063"
          />
          <path
            d="M14.6931 18.7007C14.6931 18.7007 14.7107 18.6831 14.7107 18.7007V18.736C14.6754 18.736 14.6578 18.7007 14.6931 18.7007Z"
            fill="#204063"
          />
          <path
            d="M14.958 19.6016H14.9933C14.9757 19.6192 14.9933 19.6369 14.9757 19.6545C14.958 19.6722 14.905 19.6192 14.958 19.6016Z"
            fill="#204063"
          />
          <path
            d="M12.6799 19.8662L12.627 19.8839L12.6446 19.8662H12.6799Z"
            fill="#204063"
          />
          <path
            d="M12.9096 19.9193C12.9273 19.9369 12.9802 19.9369 12.9626 19.9722C12.9449 20.0076 12.839 20.0076 12.8036 20.0076H12.786C12.8036 19.9899 12.786 19.9899 12.786 19.9722C12.786 19.9546 12.7683 19.9193 12.7153 19.9369C12.7773 19.9138 12.8444 19.9077 12.9096 19.9193Z"
            fill="#204063"
          />
          <path
            d="M14.9932 18.7891C15.0109 18.7891 15.0109 18.8067 15.0109 18.8244C15.0109 18.842 14.9932 18.842 14.9756 18.8244L14.9932 18.7891Z"
            fill="#204063"
          />
          <path
            d="M15.2227 19.478C15.2404 19.478 15.2404 19.4956 15.2404 19.5133H15.2051C15.1874 19.4956 15.2051 19.4603 15.2227 19.478Z"
            fill="#204063"
          />
          <path
            d="M15.2232 19.1421C15.2409 19.1421 15.2585 19.1774 15.2409 19.1774C15.2232 19.1774 15.2056 19.1951 15.2056 19.1774L15.2232 19.1421Z"
            fill="#204063"
          />
          <path
            d="M15.2759 19.4248C15.2936 19.4425 15.3642 19.4071 15.3466 19.4601C15.3289 19.5131 15.2936 19.4954 15.2583 19.4601C15.223 19.4248 15.2583 19.4248 15.2759 19.4248Z"
            fill="#204063"
          />
          <path
            d="M13.3687 19.7957C13.4041 19.7957 13.4217 19.7957 13.4217 19.7604V19.7251C13.51 19.7428 13.6336 19.7074 13.7043 19.7957C13.7749 19.884 13.7043 19.8487 13.6866 19.8664H13.5983C13.563 19.8311 13.4924 19.9017 13.4394 19.8664H13.4747L13.3511 19.8134L13.3687 19.7957Z"
            fill="#204063"
          />
          <path
            d="M13.6337 20.2193C13.6514 20.3076 13.5454 20.2723 13.5101 20.2723L13.4395 20.2369C13.4674 20.2171 13.5001 20.2051 13.5342 20.202C13.5683 20.1989 13.6027 20.2048 13.6337 20.2193Z"
            fill="#204063"
          />
          <path
            d="M13.5808 20.2373L13.5632 20.255L13.5278 20.2373L13.5632 20.255L13.5808 20.2373Z"
            fill="white"
          />
          <path
            d="M19.5499 20.131H19.5676C19.5146 20.2193 19.3733 20.184 19.285 20.1486H19.2144C19.2649 20.1195 19.3217 20.1027 19.38 20.0996C19.4383 20.0966 19.4965 20.1073 19.5499 20.131Z"
            fill="#204063"
          />
          <path
            d="M13.8102 20.3077L13.7749 20.29H13.8102V20.3077Z"
            fill="#204063"
          />
          <path
            d="M14.0397 20.3253H14.0927L14.0574 20.3783C14.0097 20.3905 13.9593 20.3842 13.9161 20.3606C13.8984 20.3783 13.9338 20.3606 13.9338 20.343H13.8984C13.9183 20.3278 13.9419 20.3182 13.9667 20.3151C13.9915 20.312 14.0167 20.3155 14.0397 20.3253Z"
            fill="#204063"
          />
          <path
            d="M14.0047 20.3606H13.987C13.9693 20.3959 13.987 20.3606 13.9693 20.3783C13.9517 20.3959 13.9693 20.3253 14.0047 20.3606Z"
            fill="white"
          />
          <path
            d="M14.1812 20.4311C14.2038 20.4144 14.2304 20.404 14.2583 20.4009C14.2862 20.3978 14.3145 20.4021 14.3402 20.4135C14.3578 20.4135 14.3755 20.4312 14.3578 20.4665C14.3147 20.49 14.2642 20.4963 14.2166 20.4841C14.2166 20.4488 14.1636 20.4665 14.1459 20.4665C14.1283 20.4665 14.2166 20.4665 14.1812 20.4311Z"
            fill="#204063"
          />
          <path
            d="M14.2339 20.4136L14.2515 20.4312H14.2339V20.4136Z"
            fill="white"
          />
          <path
            d="M14.8519 21.8441C14.8696 21.8441 14.8519 21.8617 14.8519 21.8617C14.8519 21.8617 14.7813 21.8971 14.7459 21.8971C14.7106 21.8971 14.7106 21.9147 14.6753 21.8794C14.7287 21.8487 14.7907 21.8363 14.8519 21.8441Z"
            fill="#204063"
          />
          <path
            d="M15.0817 16.8286C15.117 16.8992 15.0287 16.8992 15.0111 16.9169C14.9934 16.9345 14.8521 16.8462 14.7815 16.8462H14.7285C14.8345 16.8462 14.9934 16.7226 15.0817 16.8286Z"
            fill="#204063"
          />
          <path
            d="M16.0527 20.8022C16.0704 20.8022 16.0881 20.8022 16.0881 20.8199C16.0881 20.8376 16.1057 20.8552 16.0704 20.8729H15.9468C15.9644 20.8022 16.0174 20.8022 16.0527 20.8022Z"
            fill="#204063"
          />
          <path
            d="M15.4172 20.873L15.3818 20.8907V20.873H15.4172Z"
            fill="white"
          />
          <path
            d="M16.7418 20.7668H16.7241C16.7594 20.7315 16.7948 20.7315 16.8477 20.7139C16.8631 20.7157 16.8778 20.7216 16.8902 20.7309C16.9026 20.7402 16.9123 20.7526 16.9184 20.7668C16.936 20.8022 16.9007 20.8022 16.8831 20.8375C16.8654 20.8728 16.8124 20.8022 16.7771 20.8375H16.7948L16.7241 20.8022L16.7418 20.7668Z"
            fill="#204063"
          />
          <path
            d="M15.5939 17.5704L15.5586 17.5527H15.5939V17.5704Z"
            fill="#204063"
          />
          <path
            d="M15.647 17.7471H15.6823C15.7 17.7647 15.7176 17.7647 15.7176 17.8001H15.647V17.7471Z"
            fill="#204063"
          />
          <path
            d="M16.4414 19.6544C16.512 19.6544 16.6003 19.5661 16.671 19.6368C16.6737 19.6437 16.675 19.6511 16.6747 19.6586C16.6743 19.666 16.6725 19.6733 16.6691 19.68C16.6658 19.6867 16.6611 19.6925 16.6553 19.6973C16.6496 19.702 16.6429 19.7054 16.6357 19.7074C16.565 19.7251 16.512 19.6721 16.4414 19.6544Z"
            fill="#204063"
          />
          <path
            d="M17.2891 20.9434C17.3245 20.9434 17.3774 20.9257 17.3951 20.961C17.4128 20.9964 17.3598 21.014 17.3598 21.0317H17.2715C17.2715 21.014 17.2891 20.9964 17.2715 20.9964C17.2538 20.9964 17.2715 20.9787 17.2891 20.9434Z"
            fill="#204063"
          />
          <path
            d="M16.6006 18.6124C16.6146 18.6106 16.6288 18.613 16.6414 18.6193C16.6539 18.6256 16.6644 18.6355 16.6713 18.6477C16.6713 18.6654 16.6536 18.683 16.636 18.7007H16.5477C16.53 18.6301 16.5653 18.6301 16.6006 18.6124Z"
            fill="#204063"
          />
          <path
            d="M17.4304 21.1203C17.4481 21.1026 17.4127 21.085 17.4304 21.085V21.1203Z"
            fill="#204063"
          />
          <path
            d="M16.4594 17.0229C16.4947 17.0053 16.5124 17.0229 16.5477 17.0406C16.583 17.0583 16.5477 17.1112 16.5124 17.1112C16.4771 17.1112 16.4241 17.0583 16.4594 17.0229Z"
            fill="#204063"
          />
          <path
            d="M16.6359 17.7296C16.6359 17.7119 16.6359 17.7119 16.6182 17.7119C16.6006 17.7119 16.6536 17.6942 16.6712 17.7119C16.6889 17.7296 16.8125 17.6413 16.8831 17.7119C16.9538 17.7825 16.8831 17.7649 16.8655 17.7825H16.7419C16.6901 17.7813 16.6404 17.7626 16.6006 17.7296H16.6359Z"
            fill="#204063"
          />
          <path
            d="M16.9005 19.0007C16.9005 19.0184 16.9181 19.0184 16.9181 19.0361C16.9214 19.0398 16.9255 19.0428 16.9301 19.0449C16.9347 19.0469 16.9396 19.048 16.9446 19.048C16.9496 19.048 16.9546 19.0469 16.9592 19.0449C16.9637 19.0428 16.9678 19.0398 16.9711 19.0361C16.9181 19.0361 16.9535 18.9831 16.9181 18.9654C16.8828 18.9478 17.0241 18.9301 17.0594 18.9831C17.0594 18.9968 17.0562 19.0103 17.0501 19.0226C17.044 19.0348 17.0351 19.0455 17.0241 19.0537C16.9888 19.0361 16.9711 19.0537 16.9358 19.0714H16.9005C16.9181 19.0537 16.9005 19.0537 16.9181 19.0361H16.8828C16.8828 19.0007 16.9005 19.0184 16.9005 19.0007Z"
            fill="#204063"
          />
          <path
            d="M17.9249 21.9856C17.9602 22.0033 17.9249 22.0386 17.9072 22.0386C17.8896 22.0386 17.8189 22.0209 17.7836 22.0563C17.7483 22.0916 17.8719 21.968 17.9249 21.9856Z"
            fill="#204063"
          />
          <path
            d="M16.9537 19.001C16.9714 19.001 16.936 19.0186 16.936 19.0186H16.9537V19.001Z"
            fill="white"
          />
          <path
            d="M16.9712 18.9831C16.9712 18.9654 16.9889 18.9654 16.9712 18.9478V18.9831Z"
            fill="white"
          />
          <path
            d="M21.7748 20.8197L21.7395 20.7843C21.7395 20.7667 21.8631 20.8197 21.8101 20.7314C21.7572 20.6431 22.0044 20.7314 22.075 20.802H22.0927L22.0574 20.7667C22.1104 20.7667 22.181 20.7137 22.234 20.7314C22.287 20.749 22.2693 20.7667 22.2516 20.7843C22.234 20.802 22.0221 20.749 21.9867 20.908C21.9514 21.0669 21.8455 20.9609 21.7925 20.9433L21.7395 20.9786C21.7925 20.9609 21.7395 20.9256 21.7395 20.908L21.6865 20.8726C21.7042 20.855 21.7572 20.855 21.7748 20.8197Z"
            fill="#204063"
          />
          <path
            d="M17.872 21.085C17.9073 21.1026 17.9603 21.0673 17.9779 21.1203C17.9956 21.1733 17.9249 21.1556 17.9073 21.1909C17.8896 21.2262 17.8896 21.1556 17.8543 21.1733H17.872C17.8543 21.1556 17.8366 21.085 17.872 21.085Z"
            fill="#204063"
          />
          <path
            d="M17.0951 17.9589C17.1304 17.9236 17.1481 17.9236 17.1834 17.9413C17.2187 17.9589 17.2187 17.9589 17.2011 17.9766C17.1834 17.9943 17.1304 17.9943 17.0951 17.9943C17.0598 17.9943 17.0774 17.9589 17.0951 17.9589Z"
            fill="#204063"
          />
          <path d="M17.13 17.959L17.0947 17.9766V17.959H17.13Z" fill="white" />
          <path
            d="M18.2959 21.4026C18.2783 21.4026 18.2959 21.3673 18.2959 21.3673C18.2959 21.3673 18.3489 21.3319 18.3666 21.3673C18.3842 21.4026 18.3489 21.4026 18.3489 21.4202L18.2959 21.4026Z"
            fill="#204063"
          />
          <path
            d="M18.3136 21.3848H18.3312V21.4025L18.2959 21.3848L18.3136 21.3672V21.3848Z"
            fill="white"
          />
          <path
            d="M18.8784 21.2261C18.8961 21.1908 18.9314 21.1555 18.9667 21.1732C18.9821 21.175 18.9968 21.1809 19.0092 21.1902C19.0216 21.1995 19.0313 21.2119 19.0374 21.2261C19.0374 21.2791 18.9667 21.2791 18.9314 21.2968C18.9138 21.2615 18.8961 21.2791 18.8608 21.2615C18.8255 21.2438 18.8784 21.2261 18.8784 21.2261Z"
            fill="#204063"
          />
          <path
            d="M19.0905 22.2856C19.0905 22.2809 19.0886 22.2764 19.0853 22.2731C19.082 22.2698 19.0775 22.2679 19.0728 22.2679H19.0552C19.1082 22.2502 19.1611 22.1973 19.2318 22.2326C19.3024 22.2679 19.2141 22.3032 19.1788 22.3032C19.1435 22.3032 19.0905 22.3032 19.0552 22.3032L19.0905 22.2856Z"
            fill="#204063"
          />
          <path
            d="M17.6954 17.7116L17.8014 17.6763C17.8367 17.6763 17.8543 17.6939 17.872 17.7292C17.8734 17.7457 17.8709 17.7623 17.8648 17.7776C17.8587 17.7929 17.849 17.8066 17.8367 17.8175C17.8014 17.8175 17.7837 17.7999 17.7484 17.8352C17.7131 17.8705 17.6777 17.8175 17.7131 17.7646H17.6777C17.6954 17.7646 17.6954 17.7292 17.6954 17.7116Z"
            fill="#204063"
          />
          <path
            d="M19.0905 21.5262C19.1435 21.5438 19.2141 21.4732 19.2494 21.5438C19.2848 21.6145 19.2141 21.6145 19.1788 21.6498C19.1435 21.6851 19.1435 21.6498 19.1258 21.6498H19.1435C19.0905 21.6498 19.1258 21.6321 19.0905 21.6321H19.0552C19.0905 21.5615 19.0552 21.5262 19.0905 21.5262Z"
            fill="#204063"
          />
          <path
            d="M18.0134 18.6652L17.9781 18.7005H17.9251C17.9251 18.7358 17.9605 18.7182 17.9605 18.7182V18.6829C17.9251 18.6475 17.9075 18.6829 17.8898 18.6829H17.8545C17.9075 18.6475 17.9781 18.6122 18.0134 18.6652Z"
            fill="#204063"
          />
          <path
            d="M19.6734 20.8023C19.6734 20.807 19.6752 20.8115 19.6785 20.8148C19.6819 20.8181 19.6864 20.82 19.691 20.82H19.6734V20.7847C19.6557 20.82 19.6734 20.8023 19.6734 20.8023Z"
            fill="#204063"
          />
          <path
            d="M19.7438 18.9125C19.7615 18.8949 19.7438 18.9125 19.7438 18.9302H19.7791C19.7968 18.9302 19.7791 18.9125 19.7791 18.8949L19.7262 18.9302C19.7398 18.9164 19.7565 18.906 19.7749 18.8999C19.7933 18.8938 19.8129 18.892 19.8321 18.8949V18.9302C19.816 18.9459 19.7954 18.956 19.7732 18.9592C19.751 18.9624 19.7283 18.9584 19.7085 18.9479L19.7438 18.9125Z"
            fill="#204063"
          />
          <path
            d="M19.797 18.9479L19.7793 18.9303L19.797 18.9126V18.9479Z"
            fill="white"
          />
          <path
            d="M21.0861 20.6963C21.1214 20.6963 21.1214 20.7316 21.1038 20.7669L21.0508 20.8022C21.0508 20.8022 21.0508 20.7493 21.0155 20.7669C20.9801 20.7846 21.0155 20.8022 20.9801 20.8199H20.9448C20.9752 20.7628 21.0255 20.7189 21.0861 20.6963Z"
            fill="#204063"
          />
          <path
            d="M20.3442 19.4249C20.3972 19.4249 20.4325 19.3896 20.4855 19.4249C20.486 19.4409 20.4811 19.4567 20.4714 19.4695C20.4618 19.4823 20.4481 19.4915 20.4325 19.4955H20.3619V19.4602H20.3442C20.3442 19.4602 20.3619 19.4425 20.3442 19.4249Z"
            fill="#204063"
          />
          <path
            d="M20.4153 19.4248H20.3976C20.4027 19.4266 20.4073 19.4295 20.4111 19.4334C20.4149 19.4372 20.4177 19.4419 20.4194 19.447C20.4211 19.4521 20.4217 19.4575 20.4209 19.4629C20.4202 19.4682 20.4183 19.4733 20.4153 19.4778C20.4153 19.5131 20.3623 19.4954 20.3623 19.4954C20.3623 19.4954 20.3623 19.4425 20.4153 19.4248Z"
            fill="white"
          />
          <path
            d="M20.8036 20.9259V20.9613L20.7329 20.9966L20.7682 20.9613V20.9259C20.7682 20.9436 20.7506 20.9613 20.7329 20.9436C20.742 20.9345 20.7533 20.9281 20.7658 20.925C20.7782 20.9218 20.7913 20.9222 20.8036 20.9259Z"
            fill="#204063"
          />
          <path
            d="M20.5918 19.1597H20.6095L20.5741 19.195H20.4858L20.5918 19.1597Z"
            fill="#204063"
          />
          <path
            d="M24.477 21.0673C24.477 21.0143 24.424 21.0496 24.4063 21.0496C24.3887 21.0496 24.4593 21.0496 24.4593 21.0143H24.3887C24.424 20.979 24.4946 20.9967 24.5123 20.9437C24.53 20.8907 24.477 20.926 24.4946 20.9084C24.5123 20.8907 24.5476 20.8554 24.6006 20.8377H24.7066C24.6712 20.7847 24.7772 20.8201 24.7595 20.7671C24.7419 20.7141 24.8302 20.8201 24.8478 20.7847C24.8655 20.7494 24.9715 20.8554 24.9715 20.926C24.9715 20.9967 24.9715 20.9613 24.9715 21.0143C24.9715 21.032 24.9538 21.0496 24.9715 21.0673C24.9891 21.085 24.9185 21.085 24.9185 21.1026C24.9185 21.1203 24.9008 21.1733 24.8832 21.1733C24.8655 21.1733 24.8655 21.1733 24.8655 21.1909H24.8478C24.7772 21.2262 24.7242 21.2262 24.6712 21.2969L24.6359 21.3499C24.6359 21.3145 24.6712 21.2969 24.6359 21.2616H24.6006C24.5829 21.2439 24.5476 21.2969 24.5123 21.2792C24.477 21.2616 24.5123 21.2086 24.477 21.1909H24.4063C24.4227 21.2003 24.4422 21.2028 24.4604 21.1978C24.4786 21.1928 24.4941 21.1808 24.5035 21.1644C24.5128 21.148 24.5153 21.1286 24.5103 21.1104C24.5054 21.0922 24.4934 21.0767 24.477 21.0673Z"
            fill="#204063"
          />
          <path
            d="M20.9623 19.3542C20.9446 19.3542 20.9446 19.3542 20.9446 19.3718H20.9976V19.3365C20.98 19.3188 20.9623 19.3542 20.9623 19.3365C20.9623 19.3188 21.0153 19.3188 21.0329 19.3188C21.0506 19.3188 21.0153 19.3718 20.98 19.3718C20.9446 19.3718 20.927 19.3542 20.9093 19.3542C20.8917 19.3542 20.9446 19.3365 20.9623 19.3542Z"
            fill="#204063"
          />
          <path
            d="M21.4393 19.3896C21.4746 19.4073 21.5099 19.4426 21.5099 19.4603C21.5099 19.4779 21.5099 19.4956 21.4923 19.4956C21.4746 19.4956 21.5806 19.5309 21.5629 19.5662C21.5453 19.6016 21.351 19.5662 21.2804 19.5486V19.5133H21.2627C21.2766 19.4775 21.3008 19.4467 21.3323 19.4247C21.3637 19.4027 21.4009 19.3905 21.4393 19.3896Z"
            fill="#204063"
          />
          <path
            d="M26.5431 18.948H26.5255C26.5608 18.9303 26.5608 18.9127 26.5785 18.895H26.5431C26.5431 18.8774 26.5961 18.8774 26.5608 18.8597C26.6314 18.8597 26.6314 18.8067 26.6844 18.8067C26.7374 18.8067 26.7904 18.7891 26.8257 18.7891C26.861 18.7891 26.861 18.8067 26.8787 18.8244V18.948L26.8257 19.0186C26.861 19.0363 26.914 19.054 26.9317 19.0893C26.9493 19.1246 26.8963 19.1599 26.8787 19.2129L26.7904 19.2482C26.808 19.1952 26.7197 19.2129 26.6844 19.2129H26.6668C26.6844 19.1952 26.7021 19.1952 26.7021 19.1776H26.6668C26.6668 19.1599 26.6844 19.1599 26.6844 19.1423H26.6668C26.6844 19.1599 26.6844 19.1423 26.6844 19.1246H26.7021C26.6668 19.1246 26.6491 19.1246 26.6491 19.0893H26.5608V19.054H26.5078C26.5255 18.9833 26.5961 18.9657 26.5431 18.948Z"
            fill="#204063"
          />
          <path
            d="M22.9054 20.855H22.8877C22.923 20.8197 22.9407 20.749 23.029 20.749C23.1173 20.749 23.0996 20.749 23.1526 20.7667C23.2056 20.7843 23.1526 20.8726 23.1173 20.9256C23.082 20.9786 23.029 20.9786 22.976 20.9786H22.8877C22.9054 20.908 22.8877 20.8726 22.9054 20.855Z"
            fill="#204063"
          />
          <path
            d="M21.9867 19.7603C21.9867 19.7427 21.969 19.725 21.9514 19.7427C21.9337 19.7603 21.9867 19.7427 21.9867 19.7603Z"
            fill="#204063"
          />
          <path
            d="M22.2515 19.7603H22.2339C22.2339 19.7603 22.2692 19.7427 22.2515 19.725C22.2339 19.7074 22.3752 19.8133 22.4281 19.725C22.4811 19.6367 22.5341 19.725 22.5694 19.778C22.5684 19.8004 22.5612 19.8221 22.5488 19.8408C22.5363 19.8594 22.5191 19.8744 22.4988 19.884L22.4281 19.9193C22.4281 19.9146 22.4263 19.9101 22.423 19.9068C22.4197 19.9035 22.4152 19.9016 22.4105 19.9016H22.3752C22.3928 19.8663 22.3398 19.9016 22.3222 19.8663C22.3222 19.831 22.2692 19.8486 22.2515 19.831H22.2339C22.2162 19.778 22.2339 19.778 22.2515 19.7603Z"
            fill="#204063"
          />
          <path
            d="M24.1059 19.6192C24.0883 19.6016 24.1413 19.6016 24.1059 19.5839C24.0706 19.5663 24.1413 19.5486 24.1589 19.5309H24.1413C24.1942 19.5486 24.1766 19.4426 24.2649 19.478C24.3532 19.5133 24.3355 19.5133 24.3532 19.4956C24.3708 19.478 24.4238 19.5663 24.4062 19.6192C24.3885 19.6722 24.3885 19.6369 24.3532 19.6899V19.7252C24.3355 19.6722 24.3179 19.7782 24.2825 19.7252L24.2296 19.7605V19.7252H24.1413V19.6899H24.1059C24.0883 19.6369 24.1589 19.6369 24.1059 19.6192Z"
            fill="#204063"
          />
          <path
            d="M24.2297 19.9194L24.1768 19.9371H24.2121L24.2297 19.9194Z"
            fill="white"
          />
          <path
            d="M25.5186 20.7491C25.5363 20.7491 25.5363 20.7314 25.5363 20.7137C25.5363 20.6961 25.6423 20.6961 25.6599 20.7314V20.802C25.6246 20.7844 25.6069 20.8197 25.5893 20.8374C25.5716 20.855 25.554 20.8374 25.554 20.8374H25.501C25.5186 20.7844 25.5363 20.7667 25.5186 20.7491Z"
            fill="#204063"
          />
          <path
            d="M25.5366 20.7847L25.5719 20.7671V20.7847H25.5366Z"
            fill="white"
          />
          <path
            d="M25.9602 22.3034C25.9955 22.2858 26.0485 22.3211 26.0132 22.3741C25.9778 22.427 25.9778 22.4094 25.9425 22.3917C25.9072 22.3741 25.8895 22.3034 25.9602 22.3034Z"
            fill="#204063"
          />
          <path
            d="M26.3311 19.9015V19.8662H26.4194C26.4371 19.8839 26.4371 19.9015 26.4194 19.9369H26.3841L26.3135 19.9015H26.3311Z"
            fill="#204063"
          />
          <path
            d="M26.4899 19.7778C26.4899 19.7955 26.4899 19.8132 26.4722 19.8132C26.4676 19.8132 26.4631 19.8113 26.4598 19.808C26.4564 19.8047 26.4546 19.8002 26.4546 19.7955L26.4899 19.7778Z"
            fill="#204063"
          />
          <path
            d="M25.9604 21.0495C25.9687 21.0385 25.9793 21.0296 25.9916 21.0235C26.0039 21.0174 26.0174 21.0142 26.0311 21.0142C26.0311 21.0318 26.0487 21.0318 26.0311 21.0495L25.9781 21.0848C25.9781 21.0848 25.9428 21.0671 25.9781 21.0495H25.9604Z"
            fill="#204063"
          />
          <path
            d="M25.9957 21.0494H26.0133C26.031 21.0317 25.978 21.0847 25.978 21.0494C25.978 21.0141 25.9957 21.0494 25.9957 21.0494Z"
            fill="white"
          />
          <path
            d="M26.8079 21.4029H26.7726C26.8079 21.4029 26.8079 21.3852 26.8256 21.3675C26.8433 21.3499 26.8256 21.3499 26.8079 21.3499C26.7903 21.3499 26.8433 21.3322 26.8609 21.3146H26.8433C26.9139 21.3146 27.0375 21.2439 27.1082 21.3499V21.4558H27.0905C27.0905 21.5088 27.0375 21.5265 27.0199 21.5618H26.9845C26.9669 21.5795 26.9669 21.5441 26.9492 21.5618L26.8962 21.5971V21.5618C26.8786 21.5441 26.8609 21.5618 26.8609 21.5795C26.8609 21.5971 26.8256 21.5265 26.7903 21.5088H26.7373C26.7726 21.4205 26.8256 21.4382 26.8079 21.4029Z"
            fill="#204063"
          />
          <path
            d="M26.7903 20.3254V20.29H26.7726C26.755 20.3077 26.7903 20.29 26.8079 20.3077C26.8256 20.3254 26.8079 20.2547 26.8433 20.2547C26.8786 20.2547 26.8256 20.2371 26.8079 20.2194C26.7903 20.2017 26.8609 20.2371 26.8962 20.2194C26.9316 20.2017 26.9845 20.2194 27.0199 20.1841H27.0728L27.1611 20.2547L27.1965 20.29C27.1965 20.29 27.1965 20.3077 27.2318 20.3254C27.2671 20.343 27.2848 20.3607 27.2318 20.3783C27.1788 20.396 27.2494 20.4137 27.2671 20.4137H27.2141C27.2671 20.449 27.1788 20.4666 27.2141 20.5196L27.1788 20.5549C27.1435 20.5373 27.1258 20.5903 27.1082 20.6079C27.0905 20.6256 27.0199 20.5549 27.0022 20.6256C26.9845 20.6962 26.9492 20.5549 26.9139 20.6079H26.8962C26.8786 20.5903 26.9316 20.5726 26.8962 20.5549C26.8609 20.5373 26.8786 20.5726 26.8609 20.5903C26.8433 20.6079 26.8962 20.5196 26.8433 20.5196H26.7903C26.8079 20.502 26.8079 20.4843 26.8079 20.449C26.8079 20.4137 26.7726 20.4843 26.7726 20.449C26.7726 20.4137 26.8079 20.4313 26.7903 20.4137H26.7373C26.7903 20.396 26.7726 20.343 26.7903 20.3254Z"
            fill="#204063"
          />
          <path
            d="M28.2384 20.9434C28.2384 20.9081 28.2737 20.8728 28.256 20.8375C28.2384 20.8022 28.2737 20.7492 28.3267 20.7668C28.3797 20.7845 28.3267 20.7139 28.3797 20.7315C28.4326 20.7315 28.4856 20.6962 28.5563 20.7315C28.6269 20.7668 28.5916 20.7845 28.6269 20.7668H28.6092C28.6269 20.7845 28.6799 20.8022 28.6622 20.8375V20.8728C28.6403 20.9039 28.628 20.9407 28.6269 20.9788C28.6092 20.9964 28.5739 20.9964 28.5916 21.0317C28.6092 21.0671 28.5563 21.0671 28.5386 21.0847H28.4856C28.4621 21.0847 28.4444 21.1024 28.4326 21.1377C28.4326 21.12 28.415 21.12 28.4326 21.1024C28.4503 21.0847 28.3973 21.12 28.3797 21.12H28.362C28.3443 21.1024 28.309 21.1377 28.2914 21.1377C28.2737 21.1377 28.309 21.1024 28.2914 21.0847H28.256V21.0317C28.2207 21.0141 28.2207 21.0671 28.2031 21.0494C28.1854 21.0317 28.2207 20.9788 28.2384 20.9434Z"
            fill="#204063"
          />
          <path
            d="M27.4967 19.1245C27.4967 19.1422 27.5144 19.1422 27.5144 19.1598C27.5144 19.1775 27.4614 19.1775 27.4614 19.1598C27.4614 19.1422 27.4614 19.1245 27.4967 19.1245Z"
            fill="#204063"
          />
          <path
            d="M27.638 17.8706H27.6733C27.691 17.8883 27.6557 17.9059 27.638 17.9236C27.6204 17.9412 27.638 17.9059 27.6027 17.8883C27.5674 17.8706 27.6204 17.8883 27.638 17.8706Z"
            fill="#204063"
          />
          <path
            d="M28.4681 20.3608H28.5211L28.4857 20.4138H28.4681C28.4504 20.3962 28.5034 20.3785 28.4681 20.3608V20.3962C28.4651 20.3846 28.4651 20.3724 28.4681 20.3608Z"
            fill="#204063"
          />
          <path
            d="M28.3796 19.3189C28.3788 19.3094 28.38 19.2997 28.383 19.2906C28.3861 19.2815 28.3909 19.2731 28.3973 19.2659C28.4091 19.249 28.425 19.2352 28.4435 19.2259C28.462 19.2167 28.4826 19.2122 28.5033 19.213C28.5562 19.2483 28.5916 19.2483 28.5916 19.3013C28.5916 19.3542 28.5562 19.3366 28.6092 19.3542C28.6622 19.3719 28.5562 19.3719 28.5739 19.4072C28.5916 19.4425 28.5386 19.4072 28.5209 19.4072H28.5033C28.4856 19.4425 28.4679 19.4072 28.4326 19.4249H28.4503C28.4503 19.4202 28.4484 19.4157 28.4451 19.4124C28.4418 19.4091 28.4373 19.4072 28.4326 19.4072C28.4279 19.4072 28.4235 19.4091 28.4201 19.4124C28.4168 19.4157 28.415 19.4202 28.415 19.4249L28.3796 19.3896V19.3189Z"
            fill="#204063"
          />
          <path
            d="M28.5562 19.478C28.5562 19.4603 28.6091 19.478 28.6091 19.4427H28.6445C28.6621 19.4427 28.6445 19.425 28.6621 19.4074H28.7328C28.7681 19.372 28.7857 19.4427 28.8211 19.4427C28.8564 19.4427 28.8387 19.4956 28.8917 19.4956C28.9447 19.4956 28.927 19.5839 28.874 19.6546H28.8564C28.8387 19.6722 28.8564 19.6899 28.8564 19.7076H28.8211C28.8211 19.7605 28.7504 19.7429 28.7328 19.7605C28.7151 19.7782 28.6974 19.7605 28.6974 19.7429H28.6798V19.6899C28.6621 19.7076 28.6445 19.6899 28.6445 19.7252C28.6445 19.7605 28.6268 19.6369 28.5915 19.6546C28.5962 19.6546 28.6006 19.6527 28.604 19.6494C28.6073 19.6461 28.6091 19.6416 28.6091 19.6369C28.6091 19.6322 28.6073 19.6278 28.604 19.6244C28.6006 19.6211 28.5962 19.6193 28.5915 19.6193C28.5208 19.5839 28.6091 19.5133 28.5562 19.478Z"
            fill="#204063"
          />
          <path
            d="M29.3158 19.7603C29.3334 19.7426 29.2981 19.725 29.2804 19.725C29.2628 19.725 29.2981 19.7073 29.2981 19.6897H29.2628C29.2628 19.672 29.3158 19.6897 29.2981 19.6543C29.3121 19.6543 29.3256 19.6487 29.3356 19.6388C29.3455 19.6289 29.3511 19.6154 29.3511 19.6014V19.5131C29.3864 19.5131 29.3334 19.4601 29.3864 19.4777C29.3773 19.437 29.3773 19.3948 29.3864 19.3541C29.4041 19.3541 29.3864 19.3365 29.4041 19.3188H29.4394C29.4217 19.2658 29.457 19.3188 29.457 19.2835C29.457 19.2482 29.51 19.3188 29.5453 19.3011C29.5807 19.2835 29.5807 19.3365 29.5807 19.3718C29.5807 19.4071 29.563 19.3188 29.5983 19.3011C29.6336 19.2835 29.5983 19.3718 29.6513 19.3718H29.669C29.6866 19.3718 29.6866 19.4248 29.7219 19.3894V19.4248H29.7396C29.7573 19.4424 29.7396 19.4601 29.7573 19.4601H29.7749L29.8102 19.5131H29.8279V19.566C29.8632 19.566 29.8279 19.619 29.8632 19.619C29.8985 19.619 29.8985 19.672 29.9162 19.672C29.9339 19.672 29.8809 19.672 29.8809 19.6897C29.8809 19.7073 29.9162 19.7073 29.9339 19.725H29.8985C29.8809 19.7426 29.8985 19.7603 29.9162 19.7779C29.9162 19.7956 29.8632 19.8309 29.9162 19.8309C29.9115 19.8309 29.907 19.8328 29.9037 19.8361C29.9004 19.8394 29.8985 19.8439 29.8985 19.8486C29.8985 19.8839 29.9162 19.8839 29.9339 19.9016C29.9515 19.9192 29.8632 19.8486 29.8632 19.9016V19.9722L29.8279 19.9192C29.7573 19.9545 29.8279 20.0605 29.7573 20.0782C29.7596 20.0688 29.7581 20.0589 29.7532 20.0506C29.7482 20.0423 29.7401 20.0364 29.7308 20.034C29.7214 20.0317 29.7115 20.0331 29.7032 20.0381C29.6949 20.0431 29.689 20.0511 29.6866 20.0605C29.6513 20.0605 29.6866 20.1135 29.6336 20.1135C29.5807 20.1135 29.563 20.0605 29.5277 20.0782C29.4924 20.0958 29.5277 20.1311 29.51 20.1311C29.4924 20.1311 29.5277 20.0782 29.4924 20.0605C29.51 20.0428 29.4924 20.0252 29.4747 20.0075H29.457C29.457 19.9899 29.4747 19.9722 29.4394 19.9722H29.4217C29.4041 19.9545 29.4394 19.9545 29.4217 19.9369C29.4041 19.9192 29.3864 19.9016 29.3687 19.9192C29.3511 19.9369 29.3864 19.8839 29.3511 19.8839H29.3334C29.3334 19.8662 29.3687 19.8662 29.3511 19.8309H29.2981V19.7956H29.2451C29.2804 19.7956 29.3158 19.7956 29.3158 19.7603Z"
            fill="#204063"
          />
          <path
            d="M25.2184 18.9302C25.236 18.9302 25.289 18.9125 25.3067 18.9479C25.3243 18.9832 25.3067 19.0715 25.2537 19.0538H25.236L25.183 19.0185C25.2184 18.9832 25.1477 18.9832 25.183 18.9479C25.2184 18.9125 25.2184 18.9655 25.2184 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5189 18.9302L25.4659 18.9655V18.9478L25.4482 18.9655V18.9478L25.5189 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5896 18.8595H25.5719C25.5719 18.8419 25.5896 18.8419 25.5896 18.8242H25.5543C25.5896 18.8066 25.5896 18.7889 25.6073 18.7712H25.5896C25.6424 18.7374 25.7035 18.7191 25.7662 18.7183C25.8015 18.7359 25.8368 18.7889 25.8898 18.7536C25.9428 18.7183 25.8545 18.7889 25.8898 18.7889L25.9428 18.8949C25.9075 18.9125 25.9251 18.9478 25.9251 18.9832C25.9251 19.0185 25.8722 19.0008 25.8898 19.0361H25.8722C25.8368 19.0538 25.8722 19.0715 25.8722 19.0891H25.8192C25.8192 19.1244 25.7485 19.1244 25.7309 19.1421C25.7132 19.1598 25.6602 19.1598 25.6426 19.1951C25.6249 19.2304 25.6779 19.1068 25.6249 19.0891C25.6249 19.0938 25.6231 19.0983 25.6197 19.1016C25.6164 19.1049 25.6119 19.1068 25.6073 19.1068C25.5719 19.0715 25.6426 19.0361 25.6073 19.0361L25.5366 19.0891C25.5719 18.9655 25.6249 18.9302 25.5896 18.8595Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M10.0308 24.2813L10.0484 24.2637V24.2813H10.0308Z"
            fill="white"
          />
          <path
            d="M10.0308 24.2989V24.2812H10.0484L10.0308 24.2989Z"
            fill="white"
          />
          <path
            d="M13.0154 24.7227V24.758C12.9977 24.7756 12.9977 24.7756 12.98 24.758C12.9624 24.7403 12.9624 24.7227 12.98 24.7227H13.0154Z"
            fill="#204063"
          />
          <path
            d="M13.1037 24.7755H13.086C13.0813 24.7755 13.0768 24.7736 13.0735 24.7703C13.0702 24.767 13.0684 24.7625 13.0684 24.7578C13.086 24.7401 13.1213 24.7578 13.1037 24.7755Z"
            fill="#204063"
          />
          <path
            d="M11.0201 21.1554C11.0201 21.1554 11.0024 21.1377 11.0201 21.1377V21.1554Z"
            fill="#204063"
          />
          <path
            d="M11.8324 23.575H11.8147C11.8139 23.5654 11.815 23.5558 11.8181 23.5466C11.8211 23.5375 11.826 23.5291 11.8324 23.522C11.8324 23.5396 11.85 23.5573 11.8324 23.575Z"
            fill="#204063"
          />
          <path
            d="M10.9845 21.3322C10.9845 21.3499 10.9669 21.3499 10.9492 21.3322V21.2969C10.9845 21.2969 10.9845 21.3145 10.9845 21.3322Z"
            fill="#204063"
          />
          <path
            d="M11.6382 20.3608C11.6558 20.3962 11.6912 20.4315 11.6735 20.4668C11.6558 20.5021 11.6558 20.4491 11.6558 20.4315C11.6558 20.4138 11.6558 20.3785 11.6382 20.3608Z"
            fill="#204063"
          />
          <path
            d="M12.044 25.9234H12.0616C12.097 25.9057 12.0793 25.9411 12.097 25.9411C12.097 25.9548 12.0938 25.9683 12.0876 25.9806C12.0815 25.9928 12.0726 26.0035 12.0616 26.0117H12.0087C12.0087 25.994 11.9557 26.0117 11.9733 25.9764V25.9234H12.0263H12.044Z"
            fill="#204063"
          />
          <path
            d="M11.6733 20.5904C11.6733 20.5904 11.691 20.6081 11.6733 20.6081V20.5727C11.6733 20.5551 11.6733 20.5727 11.6733 20.5904Z"
            fill="#204063"
          />
          <path
            d="M11.7791 20.6609C11.7728 20.6537 11.7679 20.6453 11.7649 20.6362C11.7618 20.6271 11.7607 20.6175 11.7615 20.6079L11.7791 20.6609Z"
            fill="#204063"
          />
          <path
            d="M11.7617 20.6431C11.7794 20.6431 11.7617 20.6431 11.7617 20.6255V20.6431Z"
            fill="white"
          />
          <path
            d="M12.4504 22.0912C12.4504 22.1089 12.4504 22.1265 12.4328 22.1265H12.3975C12.3986 22.1129 12.4049 22.1003 12.4151 22.0912C12.4328 22.0559 12.4328 22.0735 12.4504 22.0912Z"
            fill="#204063"
          />
          <path
            d="M12.2916 22.1265C12.2739 22.1441 12.2739 22.1441 12.2739 22.1265H12.2916Z"
            fill="#204063"
          />
          <path
            d="M11.9029 22.3033C11.8982 22.3033 11.8937 22.3014 11.8904 22.2981C11.8871 22.2948 11.8853 22.2903 11.8853 22.2856L11.9029 22.3033Z"
            fill="#204063"
          />
          <path
            d="M11.585 21.2789L11.5674 21.2612L11.585 21.2789Z"
            fill="#204063"
          />
          <path
            d="M11.5852 21.3851C11.5852 21.4028 11.5852 21.4204 11.5675 21.4204C11.5499 21.4204 11.5499 21.3674 11.5322 21.3498C11.5322 21.3498 11.5499 21.3321 11.5499 21.3498C11.5499 21.3674 11.5675 21.3321 11.5499 21.3145C11.5609 21.3227 11.5698 21.3333 11.5759 21.3456C11.582 21.3579 11.5852 21.3714 11.5852 21.3851Z"
            fill="#204063"
          />
          <path
            d="M12.2559 22.2681C12.2736 22.2857 12.2559 22.2857 12.2559 22.2857C12.2559 22.2857 12.2382 22.2681 12.2559 22.2681Z"
            fill="#204063"
          />
          <path
            d="M11.9737 22.4268H11.9561C11.9737 22.4092 11.9914 22.4092 11.9737 22.4268Z"
            fill="#204063"
          />
          <path
            d="M12.1324 22.4093H12.1148C12.1148 22.4093 12.0971 22.4093 12.1148 22.3916C12.1148 22.3963 12.1166 22.4008 12.12 22.4041C12.1233 22.4074 12.1278 22.4093 12.1324 22.4093Z"
            fill="#204063"
          />
          <path
            d="M12.0088 22.4444C11.9911 22.4444 12.0264 22.4797 11.9911 22.4797C11.9558 22.4797 11.9734 22.4444 11.9911 22.4268L12.0088 22.4444Z"
            fill="#204063"
          />
          <path
            d="M11.6912 21.5791V21.6144C11.6912 21.5968 11.6912 21.5968 11.7088 21.5968C11.7179 21.6434 11.7179 21.6914 11.7088 21.738H11.6558C11.6735 21.7027 11.6382 21.6851 11.6382 21.6674H11.6558C11.655 21.6578 11.6562 21.6482 11.6592 21.6391C11.6623 21.63 11.6671 21.6216 11.6735 21.6144L11.6912 21.5791Z"
            fill="#204063"
          />
          <path
            d="M11.5319 21.738C11.4966 21.7557 11.4966 21.7027 11.4966 21.6851H11.5142C11.5319 21.6851 11.5496 21.7027 11.5319 21.738Z"
            fill="#204063"
          />
          <path
            d="M11.5318 21.7203H11.5142V21.7026V21.7203H11.5318Z"
            fill="white"
          />
          <path
            d="M11.6911 24.387H11.6734C11.6381 24.3516 11.6734 24.2987 11.6734 24.2633V24.228C11.6967 24.2776 11.703 24.3335 11.6911 24.387Z"
            fill="#204063"
          />
          <path
            d="M11.5322 21.9325H11.5145C11.5145 21.9501 11.4969 21.9325 11.4969 21.9325C11.4882 21.9227 11.4834 21.9102 11.4834 21.8971C11.4834 21.8841 11.4882 21.8715 11.4969 21.8618C11.4792 21.8618 11.4969 21.8618 11.4969 21.8795C11.4969 21.8971 11.4969 21.8618 11.4969 21.8618C11.4969 21.8618 11.5322 21.9148 11.5322 21.9325Z"
            fill="#204063"
          />
          <path
            d="M11.4967 22.0033C11.5108 22.024 11.517 22.049 11.5144 22.0739H11.4967C11.4791 22.0739 11.4614 22.0562 11.4614 22.0209C11.4614 21.9856 11.4791 22.0033 11.4791 21.9856C11.4791 21.9679 11.4791 22.0209 11.4967 22.0033Z"
            fill="#204063"
          />
          <path
            d="M10.9318 22.3914H10.9141C10.8965 22.3914 10.8965 22.3561 10.8965 22.3561C10.8965 22.3561 10.8965 22.3385 10.8965 22.3208C10.9075 22.329 10.9164 22.3397 10.9225 22.352C10.9286 22.3642 10.9318 22.3777 10.9318 22.3914Z"
            fill="#204063"
          />
          <path
            d="M13.1393 22.2503C13.104 22.2503 13.104 22.215 13.104 22.1973C13.104 22.1797 13.1217 22.1267 13.104 22.0737H13.1217C13.1217 22.1091 13.1746 22.1797 13.1393 22.2503Z"
            fill="#204063"
          />
          <path
            d="M11.4259 22.8507H11.4082V22.8154H11.4259C11.4259 22.7977 11.4259 22.833 11.4259 22.8507Z"
            fill="#204063"
          />
          <path
            d="M11.4615 23.151C11.4792 23.151 11.4615 23.1333 11.4615 23.1333L11.4968 23.1863C11.4968 23.2039 11.4968 23.2039 11.4792 23.2216H11.4438C11.4438 23.2039 11.4615 23.1863 11.4438 23.1863V23.151H11.4615Z"
            fill="#204063"
          />
          <path
            d="M12.7681 22.5505H12.7505V22.5151L12.7681 22.5505Z"
            fill="#204063"
          />
          <path
            d="M11.9557 22.9922C11.9557 23.0275 11.991 23.0628 11.9733 23.0981H11.938C11.9204 23.0628 11.938 23.0452 11.938 23.0098L11.9557 22.9922Z"
            fill="#204063"
          />
          <path
            d="M11.3909 23.3804C11.3909 23.398 11.3909 23.4157 11.3732 23.4157C11.3556 23.4157 11.3556 23.4157 11.3556 23.4157C11.3509 23.4157 11.3464 23.4138 11.3431 23.4105C11.3398 23.4072 11.3379 23.4027 11.3379 23.398C11.3379 23.3933 11.3398 23.3889 11.3431 23.3855C11.3464 23.3822 11.3509 23.3804 11.3556 23.3804H11.3909Z"
            fill="#204063"
          />
          <path
            d="M12.4152 23.0451C12.4152 23.0627 12.4152 23.0804 12.3975 23.0804C12.3929 23.0804 12.3884 23.0785 12.3851 23.0752C12.3817 23.0719 12.3799 23.0674 12.3799 23.0627V23.0274C12.3975 23.0097 12.3975 23.0451 12.4152 23.0451Z"
            fill="#204063"
          />
          <path
            d="M11.3022 23.4338H11.3199C11.3022 23.4338 11.3022 23.4161 11.3199 23.3984C11.3246 23.4008 11.3282 23.4049 11.3298 23.4099C11.3315 23.4148 11.3311 23.4202 11.3287 23.4249C11.3264 23.4296 11.3223 23.4332 11.3173 23.4348C11.3124 23.4365 11.3069 23.4361 11.3022 23.4338Z"
            fill="#204063"
          />
          <path
            d="M13.1213 22.9745C13.1213 22.9922 13.1213 23.0099 13.1037 23.0099C13.086 23.0099 13.0684 23.0275 13.0684 23.0099C13.0684 22.9922 13.1037 22.9569 13.1213 22.9745Z"
            fill="#204063"
          />
          <path
            d="M12.8033 23.0627H12.821C12.821 23.098 12.8386 23.1333 12.821 23.1686C12.821 23.1733 12.8191 23.1778 12.8158 23.1811C12.8125 23.1844 12.808 23.1863 12.8033 23.1863C12.7986 23.1863 12.7941 23.1844 12.7908 23.1811C12.7875 23.1778 12.7856 23.1733 12.7856 23.1686V23.098H12.8033C12.8029 23.0733 12.809 23.0489 12.821 23.0273L12.8033 23.0627Z"
            fill="#204063"
          />
          <path
            d="M12.2384 23.2041H12.256C12.2647 23.2138 12.2695 23.2264 12.2695 23.2394C12.2695 23.2525 12.2647 23.265 12.256 23.2747H12.2207V23.2218H12.2384V23.2041Z"
            fill="#204063"
          />
          <path
            d="M10.9139 23.6453C10.9092 23.6453 10.9047 23.6434 10.9014 23.6401C10.8981 23.6368 10.8962 23.6323 10.8962 23.6276C10.8786 23.6276 10.9139 23.5923 10.8962 23.5923C10.8786 23.5923 10.9315 23.6276 10.9139 23.6453Z"
            fill="#204063"
          />
          <path
            d="M11.2143 25.2525H11.232C11.232 25.2525 11.1967 25.2878 11.232 25.2878C11.2673 25.2878 11.2143 25.3584 11.179 25.3761H11.1967C11.1967 25.4114 11.2143 25.4291 11.179 25.4467H11.1614C11.126 25.4114 11.2143 25.3761 11.1437 25.3408C11.0731 25.3055 11.1437 25.2701 11.1437 25.2525H11.1967C11.1967 25.2348 11.1967 25.2525 11.2143 25.2525Z"
            fill="#204063"
          />
          <path
            d="M11.32 23.6279C11.32 23.6456 11.32 23.6632 11.3024 23.6632H11.2847C11.267 23.6456 11.2847 23.6456 11.2847 23.6456H11.32V23.6279Z"
            fill="#204063"
          />
          <path
            d="M12.715 23.2925V23.3455H12.6973C12.6797 23.3455 12.6797 23.3101 12.6973 23.2925H12.715Z"
            fill="#204063"
          />
          <path
            d="M11.1788 23.8042H11.1965V23.8395H11.1611V23.8042H11.1788Z"
            fill="#204063"
          />
          <path
            d="M11.1787 23.8042V23.8219V23.8042H11.1964H11.1787Z"
            fill="white"
          />
          <path
            d="M11.2316 24.0514C11.2493 24.0514 11.2669 24.0691 11.2493 24.0868H11.2316C11.1963 24.0868 11.2139 24.0514 11.1963 24.0514C11.2139 24.0338 11.2139 24.0338 11.2139 24.0161C11.2093 24.0185 11.2057 24.0226 11.204 24.0275C11.2024 24.0325 11.2028 24.0379 11.2051 24.0426C11.2075 24.0473 11.2116 24.0508 11.2165 24.0525C11.2215 24.0542 11.2269 24.0538 11.2316 24.0514Z"
            fill="#204063"
          />
          <path
            d="M10.7725 24.0869C10.7725 24.1046 10.7902 24.1222 10.7725 24.1576V24.1222C10.7549 24.1046 10.7725 24.1046 10.7725 24.0869Z"
            fill="#204063"
          />
          <path
            d="M12.821 23.5923C12.821 23.6099 12.8386 23.6453 12.821 23.6629V23.6982L12.7856 23.6629V23.6276C12.8033 23.6453 12.7856 23.5923 12.8033 23.6099C12.8033 23.6099 12.8033 23.6099 12.821 23.5923Z"
            fill="#204063"
          />
          <path
            d="M11.0906 24.1221H11.1083C11.0906 24.1397 11.1083 24.175 11.0906 24.1927C11.073 24.2104 11.0553 24.175 11.0376 24.1574C11.02 24.1397 11.0376 24.1397 11.0376 24.1397H11.0906V24.1221Z"
            fill="#204063"
          />
          <path
            d="M12.3976 23.7337C12.3929 23.7337 12.3884 23.7319 12.3851 23.7286C12.3818 23.7252 12.3799 23.7207 12.3799 23.7161V23.6807C12.3623 23.6631 12.3799 23.6807 12.3799 23.6984C12.3976 23.6807 12.3976 23.6807 12.3976 23.6631C12.3976 23.6807 12.4152 23.7161 12.3976 23.7337Z"
            fill="#204063"
          />
          <path
            d="M12.2031 24.5461H12.2208V24.5107C12.2245 24.5141 12.2276 24.5181 12.2296 24.5227C12.2317 24.5273 12.2327 24.5322 12.2327 24.5372C12.2327 24.5422 12.2317 24.5472 12.2296 24.5518C12.2276 24.5563 12.2245 24.5604 12.2208 24.5637C12.217 24.5604 12.214 24.5563 12.212 24.5518C12.2099 24.5472 12.2088 24.5422 12.2088 24.5372C12.2088 24.5322 12.2099 24.5273 12.212 24.5227C12.214 24.5181 12.217 24.5141 12.2208 24.5107L12.2031 24.5461Z"
            fill="#204063"
          />
          <path
            d="M11.32 24.9876H11.3023C11.2847 25.0052 11.2847 24.9875 11.2847 24.9699C11.3023 24.9522 11.2847 24.9522 11.3023 24.9346H11.32C11.32 24.9522 11.3376 24.9699 11.32 24.9876Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.7759C11.9382 24.7935 11.9558 24.8289 11.9205 24.8289C11.8852 24.8289 11.9029 24.8289 11.9029 24.8112V24.7759H11.9205C11.9232 24.7774 11.9262 24.7782 11.9293 24.7782C11.9324 24.7782 11.9355 24.7774 11.9382 24.7759Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.8112H11.9205C11.9158 24.8112 11.9113 24.8093 11.908 24.806C11.9047 24.8027 11.9028 24.7982 11.9028 24.7935C11.9028 24.7889 11.9047 24.7844 11.908 24.781C11.9113 24.7777 11.9158 24.7759 11.9205 24.7759C11.9205 24.7935 11.9382 24.7759 11.9382 24.8112Z"
            fill="white"
          />
          <path
            d="M11.2496 24.8464C11.2496 24.864 11.2496 24.8464 11.2319 24.8464V24.811H11.2496C11.2496 24.8287 11.2673 24.8464 11.2496 24.8464Z"
            fill="#204063"
          />
          <path
            d="M12.0264 24.9172V24.8818C12.0264 24.8818 12.044 24.8995 12.0264 24.9172Z"
            fill="#204063"
          />
          <path
            d="M10.7373 26.2769H10.7726C10.7726 26.2769 10.755 26.2769 10.7726 26.2946C10.7773 26.2946 10.7818 26.2927 10.7851 26.2894C10.7884 26.2861 10.7903 26.2816 10.7903 26.2769C10.7903 26.2723 10.7884 26.2678 10.7851 26.2645C10.7818 26.2611 10.7773 26.2593 10.7726 26.2593C10.7903 26.2769 10.7726 26.3123 10.7903 26.3123H10.8079C10.8079 26.3476 10.8256 26.3476 10.8256 26.3652C10.8264 26.3748 10.8253 26.3844 10.8222 26.3935C10.8192 26.4027 10.8143 26.4111 10.8079 26.4182C10.8433 26.4006 10.8079 26.4535 10.8256 26.4535C10.8209 26.4535 10.8164 26.4554 10.8131 26.4587C10.8098 26.462 10.8079 26.4665 10.8079 26.4712L10.7373 26.5065H10.6843C10.6667 26.5065 10.649 26.4889 10.6667 26.4712H10.649C10.6517 26.4463 10.6454 26.4213 10.6313 26.4006H10.6667V26.3652C10.6843 26.3652 10.6667 26.3476 10.6843 26.3299C10.702 26.3123 10.702 26.3476 10.7196 26.3299C10.7174 26.3203 10.7178 26.3103 10.7209 26.3009C10.7241 26.2916 10.7297 26.2832 10.7373 26.2769Z"
            fill="#204063"
          />
          <path
            d="M11.9205 25.0582V25.0935C11.9028 25.1112 11.9028 25.0758 11.9028 25.0758C11.9028 25.0758 11.9028 25.0582 11.9028 25.0405L11.9205 25.0582Z"
            fill="#204063"
          />
          <path
            d="M11.8501 25.27H11.7971C11.7971 25.2877 11.7794 25.2877 11.7618 25.2877C11.7557 25.2658 11.7559 25.2427 11.7621 25.2209C11.7683 25.1991 11.7804 25.1794 11.7971 25.1641H11.8147C11.8249 25.1676 11.8341 25.1735 11.8417 25.1812C11.8493 25.1888 11.855 25.1982 11.8584 25.2084C11.8618 25.2186 11.8628 25.2295 11.8614 25.2402C11.8599 25.2509 11.8561 25.2611 11.8501 25.27Z"
            fill="#204063"
          />
          <path
            d="M11.1966 27.4601H11.2143V27.4954H11.2319C11.2143 27.5308 11.2319 27.5484 11.2143 27.5661C11.1966 27.5837 11.1966 27.6014 11.1966 27.6191H11.126C11.1249 27.6055 11.1185 27.5928 11.1083 27.5837H11.0553C11.02 27.5837 11.0377 27.5484 11.02 27.5308V27.4954C11.0377 27.5131 11.0377 27.4778 11.0553 27.4601H11.126V27.4248H11.1613C11.1613 27.4248 11.179 27.4778 11.1966 27.4601Z"
            fill="#204063"
          />
          <path
            d="M11.0731 25.7114C11.0731 25.7291 11.1084 25.7467 11.1084 25.7821L11.0731 25.835L11.0024 25.7997C11.0201 25.7821 11.0024 25.7467 11.0024 25.7467H11.0201C11.0201 25.7291 11.0201 25.7114 11.0378 25.7114H11.0731Z"
            fill="#204063"
          />
          <path
            d="M11.6029 25.5703H11.6205C11.6382 25.6056 11.5675 25.6056 11.6029 25.6409C11.6382 25.6762 11.5852 25.6939 11.5675 25.6939C11.5499 25.6939 11.5322 25.6586 11.5322 25.6409C11.5499 25.6586 11.5499 25.6233 11.5499 25.6233H11.5852C11.5782 25.6209 11.5724 25.6159 11.5691 25.6093C11.5657 25.6026 11.5652 25.595 11.5675 25.5879C11.5699 25.5809 11.5749 25.5751 11.5815 25.5718C11.5882 25.5685 11.5958 25.5679 11.6029 25.5703Z"
            fill="#204063"
          />
          <path
            d="M11.4083 26.3652V26.4006C11.3907 26.4182 11.4437 26.4182 11.4083 26.4535C11.373 26.4889 11.3907 26.4712 11.3907 26.4889H11.32V26.4535C11.3377 26.4535 11.3024 26.4359 11.32 26.4359V26.4006H11.373C11.3907 26.3476 11.3907 26.3829 11.4083 26.3652Z"
            fill="#204063"
          />
          <path
            d="M10.7019 26.7008C10.7019 26.7184 10.7019 26.7184 10.7196 26.7184C10.7372 26.7184 10.7019 26.7714 10.6842 26.7537H10.6489C10.6666 26.7361 10.6489 26.7361 10.6489 26.7184C10.6536 26.7184 10.6581 26.7166 10.6614 26.7133C10.6647 26.7099 10.6666 26.7054 10.6666 26.7008C10.6666 26.6961 10.6684 26.6916 10.6718 26.6883C10.6751 26.685 10.6796 26.6831 10.6842 26.6831L10.7019 26.7008Z"
            fill="#204063"
          />
          <path
            d="M10.6842 26.7007V26.7183H10.6665L10.6842 26.7007Z"
            fill="white"
          />
          <path
            d="M9.99577 26.5592C9.99577 26.5768 9.97811 26.5945 9.96045 26.5768V26.5415C9.97811 26.5238 10.0134 26.5415 9.99577 26.5592Z"
            fill="#204063"
          />
          <path
            d="M10.8784 27.2481C10.8784 27.2481 10.8784 27.2304 10.8961 27.2481H10.8784Z"
            fill="#204063"
          />
          <path
            d="M10.4903 26.8066C10.508 26.8066 10.4903 26.8243 10.4903 26.8243H10.4727C10.4727 26.8243 10.4903 26.8066 10.4903 26.8243V26.8066Z"
            fill="#204063"
          />
          <path
            d="M10.1899 27.0186H10.2252C10.2075 27.0186 10.2252 27.0362 10.2252 27.0362C10.2252 27.0715 10.2252 27.1069 10.1722 27.1245L10.1192 27.0892C10.1016 27.0715 10.1192 27.0539 10.1016 27.0362H10.1192C10.1016 27.0186 10.1192 27.0362 10.1192 27.0186H10.1899Z"
            fill="#204063"
          />
          <path
            d="M10.6135 27.2481H10.6489V27.2834C10.6665 27.3011 10.6312 27.3011 10.6312 27.3364H10.5429C10.5429 27.3188 10.5076 27.3541 10.5076 27.3188C10.4722 27.3364 10.4899 27.3011 10.4722 27.3011H10.4546C10.4593 27.3011 10.4638 27.2992 10.4671 27.2959C10.4704 27.2926 10.4722 27.2881 10.4722 27.2834C10.4722 27.2788 10.4704 27.2743 10.4671 27.271C10.4638 27.2676 10.4593 27.2658 10.4546 27.2658C10.4546 27.2481 10.4899 27.2481 10.4722 27.2305C10.4546 27.2128 10.5076 27.2305 10.4899 27.1951C10.5076 27.1951 10.5076 27.2128 10.5076 27.1951C10.5076 27.1775 10.5076 27.1951 10.5076 27.1775C10.5076 27.1598 10.5252 27.2128 10.5429 27.1951H10.5959C10.5782 27.2305 10.6135 27.2305 10.6135 27.2481Z"
            fill="#204063"
          />
          <path
            d="M10.066 27.5835L10.1014 27.6188C10.0837 27.6365 10.119 27.6365 10.1014 27.6541C10.0837 27.6718 10.119 27.6718 10.1014 27.6718H10.119C10.1014 27.6895 10.1014 27.7248 10.066 27.7424H9.96008C9.94242 27.7248 9.96008 27.7071 9.94242 27.7071C9.92476 27.7071 9.94242 27.6895 9.94242 27.6718C9.9471 27.6718 9.9516 27.6699 9.95491 27.6666C9.95822 27.6633 9.96008 27.6588 9.96008 27.6541C9.96008 27.6495 9.95822 27.645 9.95491 27.6416C9.9516 27.6383 9.9471 27.6365 9.94242 27.6365H9.96008C9.96008 27.6365 9.94242 27.6188 9.96008 27.6188H10.0307L10.066 27.5835Z"
            fill="#204063"
          />
          <path
            d="M10.9137 27.778H10.8961C10.8914 27.778 10.8869 27.7761 10.8836 27.7728C10.8803 27.7695 10.8784 27.765 10.8784 27.7603C10.8784 27.7557 10.8803 27.7512 10.8836 27.7478C10.8869 27.7445 10.8914 27.7427 10.8961 27.7427C10.9137 27.7603 10.9137 27.7603 10.9137 27.778Z"
            fill="#204063"
          />
          <path
            d="M11.3199 28.131C11.3022 28.131 11.3022 28.1134 11.3022 28.0957H11.3199C11.3199 28.0957 11.3376 28.131 11.3199 28.131Z"
            fill="#204063"
          />
          <path
            d="M10.6136 28.043H10.6313V28.0959C10.5959 28.0959 10.5959 28.1136 10.5606 28.0959H10.543C10.543 28.0783 10.5606 28.0606 10.543 28.0606H10.5606C10.543 28.0606 10.5606 28.0606 10.5606 28.043C10.5606 28.0477 10.5625 28.0521 10.5658 28.0555C10.5691 28.0588 10.5736 28.0606 10.5783 28.0606H10.6136V28.043Z"
            fill="#204063"
          />
          <path
            d="M10.5075 28.0604H10.5252C10.5075 28.0604 10.5252 28.078 10.5252 28.078H10.5075L10.4722 28.1134H10.4192C10.4192 28.078 10.3839 28.0957 10.3662 28.0604H10.3839C10.3662 28.0427 10.3839 28.0251 10.3839 28.0074H10.4015C10.4015 27.9897 10.4192 27.9897 10.4015 27.9897C10.3839 27.9897 10.4369 28.0074 10.4369 27.9897H10.4545C10.4898 28.0074 10.4898 28.0604 10.5075 28.0604Z"
            fill="#204063"
          />
          <path
            d="M10.2076 28.2192H10.2606C10.2606 28.2369 10.2429 28.2546 10.2606 28.2546H10.2783C10.2783 28.2722 10.2606 28.2899 10.2783 28.2899H10.2959C10.2959 28.2899 10.3136 28.2899 10.2959 28.3075H10.3489C10.3313 28.3252 10.3489 28.3252 10.3489 28.3252H10.3313C10.3489 28.3252 10.3313 28.3252 10.3313 28.3429H10.137C10.137 28.3075 10.1017 28.3252 10.1017 28.3252H10.0663V28.2899H10.031C10.031 28.2899 10.0663 28.2899 10.0487 28.2722C10.0487 28.2369 9.99571 28.2369 10.0134 28.2016C10.031 28.1663 10.031 28.2016 10.031 28.2016C10.031 28.2016 10.0134 28.1663 10.031 28.1663L10.0663 28.1309C10.0663 28.1309 10.0487 28.1133 10.0663 28.1133C10.0663 28.118 10.0682 28.1225 10.0715 28.1258C10.0748 28.1291 10.0793 28.1309 10.084 28.1309H10.1193C10.1193 28.1309 10.1193 28.1486 10.137 28.1309H10.2253L10.2076 28.2192Z"
            fill="#204063"
          />
          <path
            d="M11.4791 26.9302C11.4615 26.9478 11.4791 26.9655 11.4438 26.9655C11.4085 26.9655 11.4085 26.9478 11.4262 26.9302H11.4791Z"
            fill="#204063"
          />
          <path
            d="M11.4082 27.0539V27.0362H11.4259L11.4082 27.0186H11.4259L11.4082 27.0539Z"
            fill="#204063"
          />
          <path
            d="M11.4261 27.1065H11.4437V27.1418C11.4614 27.1595 11.4437 27.1948 11.4437 27.2125C11.4437 27.2301 11.3908 27.2301 11.3908 27.2655H11.3378C11.3201 27.2301 11.3201 27.2301 11.3025 27.2301C11.3025 27.2125 11.3201 27.1948 11.3025 27.1772C11.2848 27.1595 11.3201 27.1418 11.3025 27.1418C11.2848 27.1418 11.3378 27.1595 11.3554 27.1595C11.3731 27.1595 11.3378 27.1418 11.3554 27.1418C11.3731 27.1418 11.3731 27.1595 11.3731 27.1595V27.1065C11.3908 27.0712 11.3908 27.1065 11.4261 27.1065Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M19.7262 23.8751L19.6909 23.8574H19.7262V23.8751Z"
            fill="white"
          />
          <path
            d="M19.797 23.8751L19.7617 23.8927V23.8574L19.797 23.8751Z"
            fill="white"
          />
          <path
            d="M19.8323 17.0583L19.8853 17.0229C19.8977 17.0339 19.9073 17.0476 19.9134 17.0629C19.9196 17.0782 19.922 17.0948 19.9206 17.1112C19.903 17.1466 19.8677 17.1466 19.8323 17.1289C19.8237 17.1192 19.8188 17.1066 19.8188 17.0936C19.8188 17.0806 19.8237 17.068 19.8323 17.0583Z"
            fill="#204063"
          />
          <path
            d="M19.9028 16.8286C19.9205 16.8286 19.9205 16.8462 19.9205 16.8639L19.8675 16.8992C19.8322 16.8816 19.8498 16.7933 19.9028 16.8286Z"
            fill="#204063"
          />
          <path
            d="M11.9557 21.1026C11.9557 21.1203 11.938 21.1556 11.9204 21.1379H11.9027C11.9018 21.1313 11.9027 21.1246 11.9054 21.1185C11.9082 21.1125 11.9125 21.1073 11.9181 21.1036C11.9236 21.0999 11.9301 21.0978 11.9367 21.0977C11.9434 21.0975 11.9499 21.0992 11.9557 21.1026Z"
            fill="#204063"
          />
          <path
            d="M17.4145 19.8689L17.397 19.8711L17.3981 19.8799L17.4156 19.8777L17.4145 19.8689Z"
            fill="#204063"
          />
          <path
            d="M17.7133 19.9367C17.6779 19.972 17.6249 19.9367 17.6073 19.9013C17.5896 19.866 17.6779 19.9013 17.7133 19.9367Z"
            fill="#204063"
          />
          <path
            d="M12.4325 21.1909C12.4501 21.2262 12.4501 21.2616 12.4148 21.2616C12.3795 21.2616 12.3618 21.2439 12.3618 21.2262C12.3618 21.2086 12.4148 21.1909 12.4325 21.1909Z"
            fill="#204063"
          />
          <path
            d="M10.8962 19.0538H10.8785C10.9096 19.0393 10.9439 19.0333 10.978 19.0364C11.0121 19.0395 11.0448 19.0516 11.0728 19.0714C11.0728 19.1067 11.0374 19.0891 11.0021 19.1067L10.8608 19.0714L10.8962 19.0538Z"
            fill="#204063"
          />
          <path
            d="M22.7108 18.5594H22.6755L22.7108 18.5241C22.6755 18.4711 22.7638 18.4711 22.7638 18.4358C22.8135 18.4305 22.8636 18.443 22.905 18.4711C22.9404 18.5241 22.9227 18.5241 22.9404 18.577C22.958 18.63 22.958 18.683 22.8697 18.683C22.7814 18.683 22.8167 18.6653 22.7638 18.7007C22.7108 18.736 22.7461 18.6653 22.7284 18.6653H22.7108C22.7284 18.63 22.7108 18.6124 22.6755 18.5947C22.6401 18.577 22.6931 18.577 22.7108 18.5594Z"
            fill="#204063"
          />
          <path
            d="M11.3554 19.1597L11.4084 19.195C11.3907 19.2303 11.3377 19.2126 11.3201 19.2126H11.2671L11.3554 19.1597Z"
            fill="#204063"
          />
          <path
            d="M11.5498 19.0011H11.5675C11.5321 19.0187 11.4792 18.9834 11.4438 18.9834L11.5498 19.0011Z"
            fill="#204063"
          />
          <path
            d="M14.3048 19.6895C14.3224 19.7071 14.3224 19.7071 14.3224 19.7248H14.2871C14.2871 19.7248 14.2695 19.6895 14.3048 19.6895Z"
            fill="#204063"
          />
          <path
            d="M14.6578 18.8066H14.6931L14.6578 18.8596C14.6401 18.8596 14.6401 18.8243 14.6578 18.8066Z"
            fill="#204063"
          />
          <path
            d="M14.6579 18.312C14.6756 18.3297 14.7286 18.3297 14.7109 18.365C14.6933 18.4003 14.7109 18.4356 14.6756 18.4356C14.6403 18.4356 14.6403 18.4003 14.605 18.4003C14.5696 18.4003 14.6403 18.3473 14.6579 18.312Z"
            fill="#204063"
          />
          <path
            d="M14.6931 18.7007C14.6931 18.7007 14.7107 18.6831 14.7107 18.7007V18.736C14.6754 18.736 14.6578 18.7007 14.6931 18.7007Z"
            fill="#204063"
          />
          <path
            d="M14.958 19.6016H14.9933C14.9757 19.6192 14.9933 19.6369 14.9757 19.6545C14.958 19.6722 14.905 19.6192 14.958 19.6016Z"
            fill="#204063"
          />
          <path
            d="M12.6799 19.8662L12.627 19.8839L12.6446 19.8662H12.6799Z"
            fill="#204063"
          />
          <path
            d="M12.9096 19.9193C12.9273 19.9369 12.9802 19.9369 12.9626 19.9722C12.9449 20.0076 12.839 20.0076 12.8036 20.0076H12.786C12.8036 19.9899 12.786 19.9899 12.786 19.9722C12.786 19.9546 12.7683 19.9193 12.7153 19.9369C12.7773 19.9138 12.8444 19.9077 12.9096 19.9193Z"
            fill="#204063"
          />
          <path
            d="M14.9932 18.7891C15.0109 18.7891 15.0109 18.8067 15.0109 18.8244C15.0109 18.842 14.9932 18.842 14.9756 18.8244L14.9932 18.7891Z"
            fill="#204063"
          />
          <path
            d="M15.2227 19.478C15.2404 19.478 15.2404 19.4956 15.2404 19.5133H15.2051C15.1874 19.4956 15.2051 19.4603 15.2227 19.478Z"
            fill="#204063"
          />
          <path
            d="M15.2232 19.1421C15.2409 19.1421 15.2585 19.1774 15.2409 19.1774C15.2232 19.1774 15.2056 19.1951 15.2056 19.1774L15.2232 19.1421Z"
            fill="#204063"
          />
          <path
            d="M15.2759 19.4248C15.2936 19.4425 15.3642 19.4071 15.3466 19.4601C15.3289 19.5131 15.2936 19.4954 15.2583 19.4601C15.223 19.4248 15.2583 19.4248 15.2759 19.4248Z"
            fill="#204063"
          />
          <path
            d="M13.3687 19.7957C13.4041 19.7957 13.4217 19.7957 13.4217 19.7604V19.7251C13.51 19.7428 13.6336 19.7074 13.7043 19.7957C13.7749 19.884 13.7043 19.8487 13.6866 19.8664H13.5983C13.563 19.8311 13.4924 19.9017 13.4394 19.8664H13.4747L13.3511 19.8134L13.3687 19.7957Z"
            fill="#204063"
          />
          <path
            d="M13.6337 20.2193C13.6514 20.3076 13.5454 20.2723 13.5101 20.2723L13.4395 20.2369C13.4674 20.2171 13.5001 20.2051 13.5342 20.202C13.5683 20.1989 13.6027 20.2048 13.6337 20.2193Z"
            fill="#204063"
          />
          <path
            d="M13.5808 20.2373L13.5632 20.255L13.5278 20.2373L13.5632 20.255L13.5808 20.2373Z"
            fill="white"
          />
          <path
            d="M19.5499 20.131H19.5676C19.5146 20.2193 19.3733 20.184 19.285 20.1486H19.2144C19.2649 20.1195 19.3217 20.1027 19.38 20.0996C19.4383 20.0966 19.4965 20.1073 19.5499 20.131Z"
            fill="#204063"
          />
          <path
            d="M13.8102 20.3077L13.7749 20.29H13.8102V20.3077Z"
            fill="#204063"
          />
          <path
            d="M14.0397 20.3253H14.0927L14.0574 20.3783C14.0097 20.3905 13.9593 20.3842 13.9161 20.3606C13.8984 20.3783 13.9338 20.3606 13.9338 20.343H13.8984C13.9183 20.3278 13.9419 20.3182 13.9667 20.3151C13.9915 20.312 14.0167 20.3155 14.0397 20.3253Z"
            fill="#204063"
          />
          <path
            d="M14.0047 20.3606H13.987C13.9693 20.3959 13.987 20.3606 13.9693 20.3783C13.9517 20.3959 13.9693 20.3253 14.0047 20.3606Z"
            fill="white"
          />
          <path
            d="M14.1812 20.4311C14.2038 20.4144 14.2304 20.404 14.2583 20.4009C14.2862 20.3978 14.3145 20.4021 14.3402 20.4135C14.3578 20.4135 14.3755 20.4312 14.3578 20.4665C14.3147 20.49 14.2642 20.4963 14.2166 20.4841C14.2166 20.4488 14.1636 20.4665 14.1459 20.4665C14.1283 20.4665 14.2166 20.4665 14.1812 20.4311Z"
            fill="#204063"
          />
          <path
            d="M14.2339 20.4136L14.2515 20.4312H14.2339V20.4136Z"
            fill="white"
          />
          <path
            d="M14.8519 21.8441C14.8696 21.8441 14.8519 21.8617 14.8519 21.8617C14.8519 21.8617 14.7813 21.8971 14.7459 21.8971C14.7106 21.8971 14.7106 21.9147 14.6753 21.8794C14.7287 21.8487 14.7907 21.8363 14.8519 21.8441Z"
            fill="#204063"
          />
          <path
            d="M15.0817 16.8286C15.117 16.8992 15.0287 16.8992 15.0111 16.9169C14.9934 16.9345 14.8521 16.8462 14.7815 16.8462H14.7285C14.8345 16.8462 14.9934 16.7226 15.0817 16.8286Z"
            fill="#204063"
          />
          <path
            d="M16.0527 20.8022C16.0704 20.8022 16.0881 20.8022 16.0881 20.8199C16.0881 20.8376 16.1057 20.8552 16.0704 20.8729H15.9468C15.9644 20.8022 16.0174 20.8022 16.0527 20.8022Z"
            fill="#204063"
          />
          <path
            d="M15.4172 20.873L15.3818 20.8907V20.873H15.4172Z"
            fill="white"
          />
          <path
            d="M16.7418 20.7668H16.7241C16.7594 20.7315 16.7948 20.7315 16.8477 20.7139C16.8631 20.7157 16.8778 20.7216 16.8902 20.7309C16.9026 20.7402 16.9123 20.7526 16.9184 20.7668C16.936 20.8022 16.9007 20.8022 16.8831 20.8375C16.8654 20.8728 16.8124 20.8022 16.7771 20.8375H16.7948L16.7241 20.8022L16.7418 20.7668Z"
            fill="#204063"
          />
          <path
            d="M15.5939 17.5704L15.5586 17.5527H15.5939V17.5704Z"
            fill="#204063"
          />
          <path
            d="M15.647 17.7471H15.6823C15.7 17.7647 15.7176 17.7647 15.7176 17.8001H15.647V17.7471Z"
            fill="#204063"
          />
          <path
            d="M16.4414 19.6544C16.512 19.6544 16.6003 19.5661 16.671 19.6368C16.6737 19.6437 16.675 19.6511 16.6747 19.6586C16.6743 19.666 16.6725 19.6733 16.6691 19.68C16.6658 19.6867 16.6611 19.6925 16.6553 19.6973C16.6496 19.702 16.6429 19.7054 16.6357 19.7074C16.565 19.7251 16.512 19.6721 16.4414 19.6544Z"
            fill="#204063"
          />
          <path
            d="M17.2891 20.9434C17.3245 20.9434 17.3774 20.9257 17.3951 20.961C17.4128 20.9964 17.3598 21.014 17.3598 21.0317H17.2715C17.2715 21.014 17.2891 20.9964 17.2715 20.9964C17.2538 20.9964 17.2715 20.9787 17.2891 20.9434Z"
            fill="#204063"
          />
          <path
            d="M16.6006 18.6124C16.6146 18.6106 16.6288 18.613 16.6414 18.6193C16.6539 18.6256 16.6644 18.6355 16.6713 18.6477C16.6713 18.6654 16.6536 18.683 16.636 18.7007H16.5477C16.53 18.6301 16.5653 18.6301 16.6006 18.6124Z"
            fill="#204063"
          />
          <path
            d="M17.4304 21.1203C17.4481 21.1026 17.4127 21.085 17.4304 21.085V21.1203Z"
            fill="#204063"
          />
          <path
            d="M16.4594 17.0229C16.4947 17.0053 16.5124 17.0229 16.5477 17.0406C16.583 17.0583 16.5477 17.1112 16.5124 17.1112C16.4771 17.1112 16.4241 17.0583 16.4594 17.0229Z"
            fill="#204063"
          />
          <path
            d="M16.6359 17.7296C16.6359 17.7119 16.6359 17.7119 16.6182 17.7119C16.6006 17.7119 16.6536 17.6942 16.6712 17.7119C16.6889 17.7296 16.8125 17.6413 16.8831 17.7119C16.9538 17.7825 16.8831 17.7649 16.8655 17.7825H16.7419C16.6901 17.7813 16.6404 17.7626 16.6006 17.7296H16.6359Z"
            fill="#204063"
          />
          <path
            d="M16.9005 19.0007C16.9005 19.0184 16.9181 19.0184 16.9181 19.0361C16.9214 19.0398 16.9255 19.0428 16.9301 19.0449C16.9347 19.0469 16.9396 19.048 16.9446 19.048C16.9496 19.048 16.9546 19.0469 16.9592 19.0449C16.9637 19.0428 16.9678 19.0398 16.9711 19.0361C16.9181 19.0361 16.9535 18.9831 16.9181 18.9654C16.8828 18.9478 17.0241 18.9301 17.0594 18.9831C17.0594 18.9968 17.0562 19.0103 17.0501 19.0226C17.044 19.0348 17.0351 19.0455 17.0241 19.0537C16.9888 19.0361 16.9711 19.0537 16.9358 19.0714H16.9005C16.9181 19.0537 16.9005 19.0537 16.9181 19.0361H16.8828C16.8828 19.0007 16.9005 19.0184 16.9005 19.0007Z"
            fill="#204063"
          />
          <path
            d="M17.9249 21.9856C17.9602 22.0033 17.9249 22.0386 17.9072 22.0386C17.8896 22.0386 17.8189 22.0209 17.7836 22.0563C17.7483 22.0916 17.8719 21.968 17.9249 21.9856Z"
            fill="#204063"
          />
          <path
            d="M16.9537 19.001C16.9714 19.001 16.936 19.0186 16.936 19.0186H16.9537V19.001Z"
            fill="white"
          />
          <path
            d="M16.9712 18.9831C16.9712 18.9654 16.9889 18.9654 16.9712 18.9478V18.9831Z"
            fill="white"
          />
          <path
            d="M21.7748 20.8197L21.7395 20.7843C21.7395 20.7667 21.8631 20.8197 21.8101 20.7314C21.7572 20.6431 22.0044 20.7314 22.075 20.802H22.0927L22.0574 20.7667C22.1104 20.7667 22.181 20.7137 22.234 20.7314C22.287 20.749 22.2693 20.7667 22.2516 20.7843C22.234 20.802 22.0221 20.749 21.9867 20.908C21.9514 21.0669 21.8455 20.9609 21.7925 20.9433L21.7395 20.9786C21.7925 20.9609 21.7395 20.9256 21.7395 20.908L21.6865 20.8726C21.7042 20.855 21.7572 20.855 21.7748 20.8197Z"
            fill="#204063"
          />
          <path
            d="M17.872 21.085C17.9073 21.1026 17.9603 21.0673 17.9779 21.1203C17.9956 21.1733 17.9249 21.1556 17.9073 21.1909C17.8896 21.2262 17.8896 21.1556 17.8543 21.1733H17.872C17.8543 21.1556 17.8366 21.085 17.872 21.085Z"
            fill="#204063"
          />
          <path
            d="M17.0951 17.9589C17.1304 17.9236 17.1481 17.9236 17.1834 17.9413C17.2187 17.9589 17.2187 17.9589 17.2011 17.9766C17.1834 17.9943 17.1304 17.9943 17.0951 17.9943C17.0598 17.9943 17.0774 17.9589 17.0951 17.9589Z"
            fill="#204063"
          />
          <path d="M17.13 17.959L17.0947 17.9766V17.959H17.13Z" fill="white" />
          <path
            d="M18.2959 21.4026C18.2783 21.4026 18.2959 21.3673 18.2959 21.3673C18.2959 21.3673 18.3489 21.3319 18.3666 21.3673C18.3842 21.4026 18.3489 21.4026 18.3489 21.4202L18.2959 21.4026Z"
            fill="#204063"
          />
          <path
            d="M18.3136 21.3848H18.3312V21.4025L18.2959 21.3848L18.3136 21.3672V21.3848Z"
            fill="white"
          />
          <path
            d="M18.8784 21.2261C18.8961 21.1908 18.9314 21.1555 18.9667 21.1732C18.9821 21.175 18.9968 21.1809 19.0092 21.1902C19.0216 21.1995 19.0313 21.2119 19.0374 21.2261C19.0374 21.2791 18.9667 21.2791 18.9314 21.2968C18.9138 21.2615 18.8961 21.2791 18.8608 21.2615C18.8255 21.2438 18.8784 21.2261 18.8784 21.2261Z"
            fill="#204063"
          />
          <path
            d="M19.0905 22.2856C19.0905 22.2809 19.0886 22.2764 19.0853 22.2731C19.082 22.2698 19.0775 22.2679 19.0728 22.2679H19.0552C19.1082 22.2502 19.1611 22.1973 19.2318 22.2326C19.3024 22.2679 19.2141 22.3032 19.1788 22.3032C19.1435 22.3032 19.0905 22.3032 19.0552 22.3032L19.0905 22.2856Z"
            fill="#204063"
          />
          <path
            d="M17.6954 17.7116L17.8014 17.6763C17.8367 17.6763 17.8543 17.6939 17.872 17.7292C17.8734 17.7457 17.8709 17.7623 17.8648 17.7776C17.8587 17.7929 17.849 17.8066 17.8367 17.8175C17.8014 17.8175 17.7837 17.7999 17.7484 17.8352C17.7131 17.8705 17.6777 17.8175 17.7131 17.7646H17.6777C17.6954 17.7646 17.6954 17.7292 17.6954 17.7116Z"
            fill="#204063"
          />
          <path
            d="M19.0905 21.5262C19.1435 21.5438 19.2141 21.4732 19.2494 21.5438C19.2848 21.6145 19.2141 21.6145 19.1788 21.6498C19.1435 21.6851 19.1435 21.6498 19.1258 21.6498H19.1435C19.0905 21.6498 19.1258 21.6321 19.0905 21.6321H19.0552C19.0905 21.5615 19.0552 21.5262 19.0905 21.5262Z"
            fill="#204063"
          />
          <path
            d="M18.0134 18.6652L17.9781 18.7005H17.9251C17.9251 18.7358 17.9605 18.7182 17.9605 18.7182V18.6829C17.9251 18.6475 17.9075 18.6829 17.8898 18.6829H17.8545C17.9075 18.6475 17.9781 18.6122 18.0134 18.6652Z"
            fill="#204063"
          />
          <path
            d="M19.6734 20.8023C19.6734 20.807 19.6752 20.8115 19.6785 20.8148C19.6819 20.8181 19.6864 20.82 19.691 20.82H19.6734V20.7847C19.6557 20.82 19.6734 20.8023 19.6734 20.8023Z"
            fill="#204063"
          />
          <path
            d="M19.7438 18.9125C19.7615 18.8949 19.7438 18.9125 19.7438 18.9302H19.7791C19.7968 18.9302 19.7791 18.9125 19.7791 18.8949L19.7262 18.9302C19.7398 18.9164 19.7565 18.906 19.7749 18.8999C19.7933 18.8938 19.8129 18.892 19.8321 18.8949V18.9302C19.816 18.9459 19.7954 18.956 19.7732 18.9592C19.751 18.9624 19.7283 18.9584 19.7085 18.9479L19.7438 18.9125Z"
            fill="#204063"
          />
          <path
            d="M19.797 18.9479L19.7793 18.9303L19.797 18.9126V18.9479Z"
            fill="white"
          />
          <path
            d="M21.0861 20.6963C21.1214 20.6963 21.1214 20.7316 21.1038 20.7669L21.0508 20.8022C21.0508 20.8022 21.0508 20.7493 21.0155 20.7669C20.9801 20.7846 21.0155 20.8022 20.9801 20.8199H20.9448C20.9752 20.7628 21.0255 20.7189 21.0861 20.6963Z"
            fill="#204063"
          />
          <path
            d="M20.3442 19.4249C20.3972 19.4249 20.4325 19.3896 20.4855 19.4249C20.486 19.4409 20.4811 19.4567 20.4714 19.4695C20.4618 19.4823 20.4481 19.4915 20.4325 19.4955H20.3619V19.4602H20.3442C20.3442 19.4602 20.3619 19.4425 20.3442 19.4249Z"
            fill="#204063"
          />
          <path
            d="M20.4153 19.4248H20.3976C20.4027 19.4266 20.4073 19.4295 20.4111 19.4334C20.4149 19.4372 20.4177 19.4419 20.4194 19.447C20.4211 19.4521 20.4217 19.4575 20.4209 19.4629C20.4202 19.4682 20.4183 19.4733 20.4153 19.4778C20.4153 19.5131 20.3623 19.4954 20.3623 19.4954C20.3623 19.4954 20.3623 19.4425 20.4153 19.4248Z"
            fill="white"
          />
          <path
            d="M20.8036 20.9259V20.9613L20.7329 20.9966L20.7682 20.9613V20.9259C20.7682 20.9436 20.7506 20.9613 20.7329 20.9436C20.742 20.9345 20.7533 20.9281 20.7658 20.925C20.7782 20.9218 20.7913 20.9222 20.8036 20.9259Z"
            fill="#204063"
          />
          <path
            d="M20.5918 19.1597H20.6095L20.5741 19.195H20.4858L20.5918 19.1597Z"
            fill="#204063"
          />
          <path
            d="M24.477 21.0673C24.477 21.0143 24.424 21.0496 24.4063 21.0496C24.3887 21.0496 24.4593 21.0496 24.4593 21.0143H24.3887C24.424 20.979 24.4946 20.9967 24.5123 20.9437C24.53 20.8907 24.477 20.926 24.4946 20.9084C24.5123 20.8907 24.5476 20.8554 24.6006 20.8377H24.7066C24.6712 20.7847 24.7772 20.8201 24.7595 20.7671C24.7419 20.7141 24.8302 20.8201 24.8478 20.7847C24.8655 20.7494 24.9715 20.8554 24.9715 20.926C24.9715 20.9967 24.9715 20.9613 24.9715 21.0143C24.9715 21.032 24.9538 21.0496 24.9715 21.0673C24.9891 21.085 24.9185 21.085 24.9185 21.1026C24.9185 21.1203 24.9008 21.1733 24.8832 21.1733C24.8655 21.1733 24.8655 21.1733 24.8655 21.1909H24.8478C24.7772 21.2262 24.7242 21.2262 24.6712 21.2969L24.6359 21.3499C24.6359 21.3145 24.6712 21.2969 24.6359 21.2616H24.6006C24.5829 21.2439 24.5476 21.2969 24.5123 21.2792C24.477 21.2616 24.5123 21.2086 24.477 21.1909H24.4063C24.4227 21.2003 24.4422 21.2028 24.4604 21.1978C24.4786 21.1928 24.4941 21.1808 24.5035 21.1644C24.5128 21.148 24.5153 21.1286 24.5103 21.1104C24.5054 21.0922 24.4934 21.0767 24.477 21.0673Z"
            fill="#204063"
          />
          <path
            d="M20.9623 19.3542C20.9446 19.3542 20.9446 19.3542 20.9446 19.3718H20.9976V19.3365C20.98 19.3188 20.9623 19.3542 20.9623 19.3365C20.9623 19.3188 21.0153 19.3188 21.0329 19.3188C21.0506 19.3188 21.0153 19.3718 20.98 19.3718C20.9446 19.3718 20.927 19.3542 20.9093 19.3542C20.8917 19.3542 20.9446 19.3365 20.9623 19.3542Z"
            fill="#204063"
          />
          <path
            d="M21.4393 19.3896C21.4746 19.4073 21.5099 19.4426 21.5099 19.4603C21.5099 19.4779 21.5099 19.4956 21.4923 19.4956C21.4746 19.4956 21.5806 19.5309 21.5629 19.5662C21.5453 19.6016 21.351 19.5662 21.2804 19.5486V19.5133H21.2627C21.2766 19.4775 21.3008 19.4467 21.3323 19.4247C21.3637 19.4027 21.4009 19.3905 21.4393 19.3896Z"
            fill="#204063"
          />
          <path
            d="M26.5431 18.948H26.5255C26.5608 18.9303 26.5608 18.9127 26.5785 18.895H26.5431C26.5431 18.8774 26.5961 18.8774 26.5608 18.8597C26.6314 18.8597 26.6314 18.8067 26.6844 18.8067C26.7374 18.8067 26.7904 18.7891 26.8257 18.7891C26.861 18.7891 26.861 18.8067 26.8787 18.8244V18.948L26.8257 19.0186C26.861 19.0363 26.914 19.054 26.9317 19.0893C26.9493 19.1246 26.8963 19.1599 26.8787 19.2129L26.7904 19.2482C26.808 19.1952 26.7197 19.2129 26.6844 19.2129H26.6668C26.6844 19.1952 26.7021 19.1952 26.7021 19.1776H26.6668C26.6668 19.1599 26.6844 19.1599 26.6844 19.1423H26.6668C26.6844 19.1599 26.6844 19.1423 26.6844 19.1246H26.7021C26.6668 19.1246 26.6491 19.1246 26.6491 19.0893H26.5608V19.054H26.5078C26.5255 18.9833 26.5961 18.9657 26.5431 18.948Z"
            fill="#204063"
          />
          <path
            d="M22.9054 20.855H22.8877C22.923 20.8197 22.9407 20.749 23.029 20.749C23.1173 20.749 23.0996 20.749 23.1526 20.7667C23.2056 20.7843 23.1526 20.8726 23.1173 20.9256C23.082 20.9786 23.029 20.9786 22.976 20.9786H22.8877C22.9054 20.908 22.8877 20.8726 22.9054 20.855Z"
            fill="#204063"
          />
          <path
            d="M21.9867 19.7603C21.9867 19.7427 21.969 19.725 21.9514 19.7427C21.9337 19.7603 21.9867 19.7427 21.9867 19.7603Z"
            fill="#204063"
          />
          <path
            d="M22.2515 19.7603H22.2339C22.2339 19.7603 22.2692 19.7427 22.2515 19.725C22.2339 19.7074 22.3752 19.8133 22.4281 19.725C22.4811 19.6367 22.5341 19.725 22.5694 19.778C22.5684 19.8004 22.5612 19.8221 22.5488 19.8408C22.5363 19.8594 22.5191 19.8744 22.4988 19.884L22.4281 19.9193C22.4281 19.9146 22.4263 19.9101 22.423 19.9068C22.4197 19.9035 22.4152 19.9016 22.4105 19.9016H22.3752C22.3928 19.8663 22.3398 19.9016 22.3222 19.8663C22.3222 19.831 22.2692 19.8486 22.2515 19.831H22.2339C22.2162 19.778 22.2339 19.778 22.2515 19.7603Z"
            fill="#204063"
          />
          <path
            d="M24.1059 19.6192C24.0883 19.6016 24.1413 19.6016 24.1059 19.5839C24.0706 19.5663 24.1413 19.5486 24.1589 19.5309H24.1413C24.1942 19.5486 24.1766 19.4426 24.2649 19.478C24.3532 19.5133 24.3355 19.5133 24.3532 19.4956C24.3708 19.478 24.4238 19.5663 24.4062 19.6192C24.3885 19.6722 24.3885 19.6369 24.3532 19.6899V19.7252C24.3355 19.6722 24.3179 19.7782 24.2825 19.7252L24.2296 19.7605V19.7252H24.1413V19.6899H24.1059C24.0883 19.6369 24.1589 19.6369 24.1059 19.6192Z"
            fill="#204063"
          />
          <path
            d="M24.2297 19.9194L24.1768 19.9371H24.2121L24.2297 19.9194Z"
            fill="white"
          />
          <path
            d="M25.5186 20.7491C25.5363 20.7491 25.5363 20.7314 25.5363 20.7137C25.5363 20.6961 25.6423 20.6961 25.6599 20.7314V20.802C25.6246 20.7844 25.6069 20.8197 25.5893 20.8374C25.5716 20.855 25.554 20.8374 25.554 20.8374H25.501C25.5186 20.7844 25.5363 20.7667 25.5186 20.7491Z"
            fill="#204063"
          />
          <path
            d="M25.5366 20.7847L25.5719 20.7671V20.7847H25.5366Z"
            fill="white"
          />
          <path
            d="M25.9602 22.3034C25.9955 22.2858 26.0485 22.3211 26.0132 22.3741C25.9778 22.427 25.9778 22.4094 25.9425 22.3917C25.9072 22.3741 25.8895 22.3034 25.9602 22.3034Z"
            fill="#204063"
          />
          <path
            d="M26.3311 19.9015V19.8662H26.4194C26.4371 19.8839 26.4371 19.9015 26.4194 19.9369H26.3841L26.3135 19.9015H26.3311Z"
            fill="#204063"
          />
          <path
            d="M26.4899 19.7778C26.4899 19.7955 26.4899 19.8132 26.4722 19.8132C26.4676 19.8132 26.4631 19.8113 26.4598 19.808C26.4564 19.8047 26.4546 19.8002 26.4546 19.7955L26.4899 19.7778Z"
            fill="#204063"
          />
          <path
            d="M25.9604 21.0495C25.9687 21.0385 25.9793 21.0296 25.9916 21.0235C26.0039 21.0174 26.0174 21.0142 26.0311 21.0142C26.0311 21.0318 26.0487 21.0318 26.0311 21.0495L25.9781 21.0848C25.9781 21.0848 25.9428 21.0671 25.9781 21.0495H25.9604Z"
            fill="#204063"
          />
          <path
            d="M25.9957 21.0494H26.0133C26.031 21.0317 25.978 21.0847 25.978 21.0494C25.978 21.0141 25.9957 21.0494 25.9957 21.0494Z"
            fill="white"
          />
          <path
            d="M26.8079 21.4029H26.7726C26.8079 21.4029 26.8079 21.3852 26.8256 21.3675C26.8433 21.3499 26.8256 21.3499 26.8079 21.3499C26.7903 21.3499 26.8433 21.3322 26.8609 21.3146H26.8433C26.9139 21.3146 27.0375 21.2439 27.1082 21.3499V21.4558H27.0905C27.0905 21.5088 27.0375 21.5265 27.0199 21.5618H26.9845C26.9669 21.5795 26.9669 21.5441 26.9492 21.5618L26.8962 21.5971V21.5618C26.8786 21.5441 26.8609 21.5618 26.8609 21.5795C26.8609 21.5971 26.8256 21.5265 26.7903 21.5088H26.7373C26.7726 21.4205 26.8256 21.4382 26.8079 21.4029Z"
            fill="#204063"
          />
          <path
            d="M26.7903 20.3254V20.29H26.7726C26.755 20.3077 26.7903 20.29 26.8079 20.3077C26.8256 20.3254 26.8079 20.2547 26.8433 20.2547C26.8786 20.2547 26.8256 20.2371 26.8079 20.2194C26.7903 20.2017 26.8609 20.2371 26.8962 20.2194C26.9316 20.2017 26.9845 20.2194 27.0199 20.1841H27.0728L27.1611 20.2547L27.1965 20.29C27.1965 20.29 27.1965 20.3077 27.2318 20.3254C27.2671 20.343 27.2848 20.3607 27.2318 20.3783C27.1788 20.396 27.2494 20.4137 27.2671 20.4137H27.2141C27.2671 20.449 27.1788 20.4666 27.2141 20.5196L27.1788 20.5549C27.1435 20.5373 27.1258 20.5903 27.1082 20.6079C27.0905 20.6256 27.0199 20.5549 27.0022 20.6256C26.9845 20.6962 26.9492 20.5549 26.9139 20.6079H26.8962C26.8786 20.5903 26.9316 20.5726 26.8962 20.5549C26.8609 20.5373 26.8786 20.5726 26.8609 20.5903C26.8433 20.6079 26.8962 20.5196 26.8433 20.5196H26.7903C26.8079 20.502 26.8079 20.4843 26.8079 20.449C26.8079 20.4137 26.7726 20.4843 26.7726 20.449C26.7726 20.4137 26.8079 20.4313 26.7903 20.4137H26.7373C26.7903 20.396 26.7726 20.343 26.7903 20.3254Z"
            fill="#204063"
          />
          <path
            d="M28.2384 20.9434C28.2384 20.9081 28.2737 20.8728 28.256 20.8375C28.2384 20.8022 28.2737 20.7492 28.3267 20.7668C28.3797 20.7845 28.3267 20.7139 28.3797 20.7315C28.4326 20.7315 28.4856 20.6962 28.5563 20.7315C28.6269 20.7668 28.5916 20.7845 28.6269 20.7668H28.6092C28.6269 20.7845 28.6799 20.8022 28.6622 20.8375V20.8728C28.6403 20.9039 28.628 20.9407 28.6269 20.9788C28.6092 20.9964 28.5739 20.9964 28.5916 21.0317C28.6092 21.0671 28.5563 21.0671 28.5386 21.0847H28.4856C28.4621 21.0847 28.4444 21.1024 28.4326 21.1377C28.4326 21.12 28.415 21.12 28.4326 21.1024C28.4503 21.0847 28.3973 21.12 28.3797 21.12H28.362C28.3443 21.1024 28.309 21.1377 28.2914 21.1377C28.2737 21.1377 28.309 21.1024 28.2914 21.0847H28.256V21.0317C28.2207 21.0141 28.2207 21.0671 28.2031 21.0494C28.1854 21.0317 28.2207 20.9788 28.2384 20.9434Z"
            fill="#204063"
          />
          <path
            d="M27.4967 19.1245C27.4967 19.1422 27.5144 19.1422 27.5144 19.1598C27.5144 19.1775 27.4614 19.1775 27.4614 19.1598C27.4614 19.1422 27.4614 19.1245 27.4967 19.1245Z"
            fill="#204063"
          />
          <path
            d="M27.638 17.8706H27.6733C27.691 17.8883 27.6557 17.9059 27.638 17.9236C27.6204 17.9412 27.638 17.9059 27.6027 17.8883C27.5674 17.8706 27.6204 17.8883 27.638 17.8706Z"
            fill="#204063"
          />
          <path
            d="M28.4681 20.3608H28.5211L28.4857 20.4138H28.4681C28.4504 20.3962 28.5034 20.3785 28.4681 20.3608V20.3962C28.4651 20.3846 28.4651 20.3724 28.4681 20.3608Z"
            fill="#204063"
          />
          <path
            d="M28.3796 19.3189C28.3788 19.3094 28.38 19.2997 28.383 19.2906C28.3861 19.2815 28.3909 19.2731 28.3973 19.2659C28.4091 19.249 28.425 19.2352 28.4435 19.2259C28.462 19.2167 28.4826 19.2122 28.5033 19.213C28.5562 19.2483 28.5916 19.2483 28.5916 19.3013C28.5916 19.3542 28.5562 19.3366 28.6092 19.3542C28.6622 19.3719 28.5562 19.3719 28.5739 19.4072C28.5916 19.4425 28.5386 19.4072 28.5209 19.4072H28.5033C28.4856 19.4425 28.4679 19.4072 28.4326 19.4249H28.4503C28.4503 19.4202 28.4484 19.4157 28.4451 19.4124C28.4418 19.4091 28.4373 19.4072 28.4326 19.4072C28.4279 19.4072 28.4235 19.4091 28.4201 19.4124C28.4168 19.4157 28.415 19.4202 28.415 19.4249L28.3796 19.3896V19.3189Z"
            fill="#204063"
          />
          <path
            d="M28.5562 19.478C28.5562 19.4603 28.6091 19.478 28.6091 19.4427H28.6445C28.6621 19.4427 28.6445 19.425 28.6621 19.4074H28.7328C28.7681 19.372 28.7857 19.4427 28.8211 19.4427C28.8564 19.4427 28.8387 19.4956 28.8917 19.4956C28.9447 19.4956 28.927 19.5839 28.874 19.6546H28.8564C28.8387 19.6722 28.8564 19.6899 28.8564 19.7076H28.8211C28.8211 19.7605 28.7504 19.7429 28.7328 19.7605C28.7151 19.7782 28.6974 19.7605 28.6974 19.7429H28.6798V19.6899C28.6621 19.7076 28.6445 19.6899 28.6445 19.7252C28.6445 19.7605 28.6268 19.6369 28.5915 19.6546C28.5962 19.6546 28.6006 19.6527 28.604 19.6494C28.6073 19.6461 28.6091 19.6416 28.6091 19.6369C28.6091 19.6322 28.6073 19.6278 28.604 19.6244C28.6006 19.6211 28.5962 19.6193 28.5915 19.6193C28.5208 19.5839 28.6091 19.5133 28.5562 19.478Z"
            fill="#204063"
          />
          <path
            d="M29.3158 19.7603C29.3334 19.7426 29.2981 19.725 29.2804 19.725C29.2628 19.725 29.2981 19.7073 29.2981 19.6897H29.2628C29.2628 19.672 29.3158 19.6897 29.2981 19.6543C29.3121 19.6543 29.3256 19.6487 29.3356 19.6388C29.3455 19.6289 29.3511 19.6154 29.3511 19.6014V19.5131C29.3864 19.5131 29.3334 19.4601 29.3864 19.4777C29.3773 19.437 29.3773 19.3948 29.3864 19.3541C29.4041 19.3541 29.3864 19.3365 29.4041 19.3188H29.4394C29.4217 19.2658 29.457 19.3188 29.457 19.2835C29.457 19.2482 29.51 19.3188 29.5453 19.3011C29.5807 19.2835 29.5807 19.3365 29.5807 19.3718C29.5807 19.4071 29.563 19.3188 29.5983 19.3011C29.6336 19.2835 29.5983 19.3718 29.6513 19.3718H29.669C29.6866 19.3718 29.6866 19.4248 29.7219 19.3894V19.4248H29.7396C29.7573 19.4424 29.7396 19.4601 29.7573 19.4601H29.7749L29.8102 19.5131H29.8279V19.566C29.8632 19.566 29.8279 19.619 29.8632 19.619C29.8985 19.619 29.8985 19.672 29.9162 19.672C29.9339 19.672 29.8809 19.672 29.8809 19.6897C29.8809 19.7073 29.9162 19.7073 29.9339 19.725H29.8985C29.8809 19.7426 29.8985 19.7603 29.9162 19.7779C29.9162 19.7956 29.8632 19.8309 29.9162 19.8309C29.9115 19.8309 29.907 19.8328 29.9037 19.8361C29.9004 19.8394 29.8985 19.8439 29.8985 19.8486C29.8985 19.8839 29.9162 19.8839 29.9339 19.9016C29.9515 19.9192 29.8632 19.8486 29.8632 19.9016V19.9722L29.8279 19.9192C29.7573 19.9545 29.8279 20.0605 29.7573 20.0782C29.7596 20.0688 29.7581 20.0589 29.7532 20.0506C29.7482 20.0423 29.7401 20.0364 29.7308 20.034C29.7214 20.0317 29.7115 20.0331 29.7032 20.0381C29.6949 20.0431 29.689 20.0511 29.6866 20.0605C29.6513 20.0605 29.6866 20.1135 29.6336 20.1135C29.5807 20.1135 29.563 20.0605 29.5277 20.0782C29.4924 20.0958 29.5277 20.1311 29.51 20.1311C29.4924 20.1311 29.5277 20.0782 29.4924 20.0605C29.51 20.0428 29.4924 20.0252 29.4747 20.0075H29.457C29.457 19.9899 29.4747 19.9722 29.4394 19.9722H29.4217C29.4041 19.9545 29.4394 19.9545 29.4217 19.9369C29.4041 19.9192 29.3864 19.9016 29.3687 19.9192C29.3511 19.9369 29.3864 19.8839 29.3511 19.8839H29.3334C29.3334 19.8662 29.3687 19.8662 29.3511 19.8309H29.2981V19.7956H29.2451C29.2804 19.7956 29.3158 19.7956 29.3158 19.7603Z"
            fill="#204063"
          />
          <path
            d="M25.2184 18.9302C25.236 18.9302 25.289 18.9125 25.3067 18.9479C25.3243 18.9832 25.3067 19.0715 25.2537 19.0538H25.236L25.183 19.0185C25.2184 18.9832 25.1477 18.9832 25.183 18.9479C25.2184 18.9125 25.2184 18.9655 25.2184 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5189 18.9302L25.4659 18.9655V18.9478L25.4482 18.9655V18.9478L25.5189 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5896 18.8595H25.5719C25.5719 18.8419 25.5896 18.8419 25.5896 18.8242H25.5543C25.5896 18.8066 25.5896 18.7889 25.6073 18.7712H25.5896C25.6424 18.7374 25.7035 18.7191 25.7662 18.7183C25.8015 18.7359 25.8368 18.7889 25.8898 18.7536C25.9428 18.7183 25.8545 18.7889 25.8898 18.7889L25.9428 18.8949C25.9075 18.9125 25.9251 18.9478 25.9251 18.9832C25.9251 19.0185 25.8722 19.0008 25.8898 19.0361H25.8722C25.8368 19.0538 25.8722 19.0715 25.8722 19.0891H25.8192C25.8192 19.1244 25.7485 19.1244 25.7309 19.1421C25.7132 19.1598 25.6602 19.1598 25.6426 19.1951C25.6249 19.2304 25.6779 19.1068 25.6249 19.0891C25.6249 19.0938 25.6231 19.0983 25.6197 19.1016C25.6164 19.1049 25.6119 19.1068 25.6073 19.1068C25.5719 19.0715 25.6426 19.0361 25.6073 19.0361L25.5366 19.0891C25.5719 18.9655 25.6249 18.9302 25.5896 18.8595Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M10.0308 24.2813L10.0484 24.2637V24.2813H10.0308Z"
            fill="white"
          />
          <path
            d="M10.0308 24.2989V24.2812H10.0484L10.0308 24.2989Z"
            fill="white"
          />
          <path
            d="M13.0154 24.7227V24.758C12.9977 24.7756 12.9977 24.7756 12.98 24.758C12.9624 24.7403 12.9624 24.7227 12.98 24.7227H13.0154Z"
            fill="#204063"
          />
          <path
            d="M13.1037 24.7755H13.086C13.0813 24.7755 13.0768 24.7736 13.0735 24.7703C13.0702 24.767 13.0684 24.7625 13.0684 24.7578C13.086 24.7401 13.1213 24.7578 13.1037 24.7755Z"
            fill="#204063"
          />
          <path
            d="M11.0201 21.1554C11.0201 21.1554 11.0024 21.1377 11.0201 21.1377V21.1554Z"
            fill="#204063"
          />
          <path
            d="M11.8324 23.575H11.8147C11.8139 23.5654 11.815 23.5558 11.8181 23.5466C11.8211 23.5375 11.826 23.5291 11.8324 23.522C11.8324 23.5396 11.85 23.5573 11.8324 23.575Z"
            fill="#204063"
          />
          <path
            d="M10.9845 21.3322C10.9845 21.3499 10.9669 21.3499 10.9492 21.3322V21.2969C10.9845 21.2969 10.9845 21.3145 10.9845 21.3322Z"
            fill="#204063"
          />
          <path
            d="M11.6382 20.3608C11.6558 20.3962 11.6912 20.4315 11.6735 20.4668C11.6558 20.5021 11.6558 20.4491 11.6558 20.4315C11.6558 20.4138 11.6558 20.3785 11.6382 20.3608Z"
            fill="#204063"
          />
          <path
            d="M12.044 25.9234H12.0616C12.097 25.9057 12.0793 25.9411 12.097 25.9411C12.097 25.9548 12.0938 25.9683 12.0876 25.9806C12.0815 25.9928 12.0726 26.0035 12.0616 26.0117H12.0087C12.0087 25.994 11.9557 26.0117 11.9733 25.9764V25.9234H12.0263H12.044Z"
            fill="#204063"
          />
          <path
            d="M11.6733 20.5904C11.6733 20.5904 11.691 20.6081 11.6733 20.6081V20.5727C11.6733 20.5551 11.6733 20.5727 11.6733 20.5904Z"
            fill="#204063"
          />
          <path
            d="M11.7791 20.6609C11.7728 20.6537 11.7679 20.6453 11.7649 20.6362C11.7618 20.6271 11.7607 20.6175 11.7615 20.6079L11.7791 20.6609Z"
            fill="#204063"
          />
          <path
            d="M11.7617 20.6431C11.7794 20.6431 11.7617 20.6431 11.7617 20.6255V20.6431Z"
            fill="white"
          />
          <path
            d="M12.4504 22.0912C12.4504 22.1089 12.4504 22.1265 12.4328 22.1265H12.3975C12.3986 22.1129 12.4049 22.1003 12.4151 22.0912C12.4328 22.0559 12.4328 22.0735 12.4504 22.0912Z"
            fill="#204063"
          />
          <path
            d="M12.2916 22.1265C12.2739 22.1441 12.2739 22.1441 12.2739 22.1265H12.2916Z"
            fill="#204063"
          />
          <path
            d="M11.9029 22.3033C11.8982 22.3033 11.8937 22.3014 11.8904 22.2981C11.8871 22.2948 11.8853 22.2903 11.8853 22.2856L11.9029 22.3033Z"
            fill="#204063"
          />
          <path
            d="M11.585 21.2789L11.5674 21.2612L11.585 21.2789Z"
            fill="#204063"
          />
          <path
            d="M11.5852 21.3851C11.5852 21.4028 11.5852 21.4204 11.5675 21.4204C11.5499 21.4204 11.5499 21.3674 11.5322 21.3498C11.5322 21.3498 11.5499 21.3321 11.5499 21.3498C11.5499 21.3674 11.5675 21.3321 11.5499 21.3145C11.5609 21.3227 11.5698 21.3333 11.5759 21.3456C11.582 21.3579 11.5852 21.3714 11.5852 21.3851Z"
            fill="#204063"
          />
          <path
            d="M12.2559 22.2681C12.2736 22.2857 12.2559 22.2857 12.2559 22.2857C12.2559 22.2857 12.2382 22.2681 12.2559 22.2681Z"
            fill="#204063"
          />
          <path
            d="M11.9737 22.4268H11.9561C11.9737 22.4092 11.9914 22.4092 11.9737 22.4268Z"
            fill="#204063"
          />
          <path
            d="M12.1324 22.4093H12.1148C12.1148 22.4093 12.0971 22.4093 12.1148 22.3916C12.1148 22.3963 12.1166 22.4008 12.12 22.4041C12.1233 22.4074 12.1278 22.4093 12.1324 22.4093Z"
            fill="#204063"
          />
          <path
            d="M12.0088 22.4444C11.9911 22.4444 12.0264 22.4797 11.9911 22.4797C11.9558 22.4797 11.9734 22.4444 11.9911 22.4268L12.0088 22.4444Z"
            fill="#204063"
          />
          <path
            d="M11.6912 21.5791V21.6144C11.6912 21.5968 11.6912 21.5968 11.7088 21.5968C11.7179 21.6434 11.7179 21.6914 11.7088 21.738H11.6558C11.6735 21.7027 11.6382 21.6851 11.6382 21.6674H11.6558C11.655 21.6578 11.6562 21.6482 11.6592 21.6391C11.6623 21.63 11.6671 21.6216 11.6735 21.6144L11.6912 21.5791Z"
            fill="#204063"
          />
          <path
            d="M11.5319 21.738C11.4966 21.7557 11.4966 21.7027 11.4966 21.6851H11.5142C11.5319 21.6851 11.5496 21.7027 11.5319 21.738Z"
            fill="#204063"
          />
          <path
            d="M11.5318 21.7203H11.5142V21.7026V21.7203H11.5318Z"
            fill="white"
          />
          <path
            d="M11.6911 24.387H11.6734C11.6381 24.3516 11.6734 24.2987 11.6734 24.2633V24.228C11.6967 24.2776 11.703 24.3335 11.6911 24.387Z"
            fill="#204063"
          />
          <path
            d="M11.5322 21.9325H11.5145C11.5145 21.9501 11.4969 21.9325 11.4969 21.9325C11.4882 21.9227 11.4834 21.9102 11.4834 21.8971C11.4834 21.8841 11.4882 21.8715 11.4969 21.8618C11.4792 21.8618 11.4969 21.8618 11.4969 21.8795C11.4969 21.8971 11.4969 21.8618 11.4969 21.8618C11.4969 21.8618 11.5322 21.9148 11.5322 21.9325Z"
            fill="#204063"
          />
          <path
            d="M11.4967 22.0033C11.5108 22.024 11.517 22.049 11.5144 22.0739H11.4967C11.4791 22.0739 11.4614 22.0562 11.4614 22.0209C11.4614 21.9856 11.4791 22.0033 11.4791 21.9856C11.4791 21.9679 11.4791 22.0209 11.4967 22.0033Z"
            fill="#204063"
          />
          <path
            d="M10.9318 22.3914H10.9141C10.8965 22.3914 10.8965 22.3561 10.8965 22.3561C10.8965 22.3561 10.8965 22.3385 10.8965 22.3208C10.9075 22.329 10.9164 22.3397 10.9225 22.352C10.9286 22.3642 10.9318 22.3777 10.9318 22.3914Z"
            fill="#204063"
          />
          <path
            d="M13.1393 22.2503C13.104 22.2503 13.104 22.215 13.104 22.1973C13.104 22.1797 13.1217 22.1267 13.104 22.0737H13.1217C13.1217 22.1091 13.1746 22.1797 13.1393 22.2503Z"
            fill="#204063"
          />
          <path
            d="M11.4259 22.8507H11.4082V22.8154H11.4259C11.4259 22.7977 11.4259 22.833 11.4259 22.8507Z"
            fill="#204063"
          />
          <path
            d="M11.4615 23.151C11.4792 23.151 11.4615 23.1333 11.4615 23.1333L11.4968 23.1863C11.4968 23.2039 11.4968 23.2039 11.4792 23.2216H11.4438C11.4438 23.2039 11.4615 23.1863 11.4438 23.1863V23.151H11.4615Z"
            fill="#204063"
          />
          <path
            d="M12.7681 22.5505H12.7505V22.5151L12.7681 22.5505Z"
            fill="#204063"
          />
          <path
            d="M11.9557 22.9922C11.9557 23.0275 11.991 23.0628 11.9733 23.0981H11.938C11.9204 23.0628 11.938 23.0452 11.938 23.0098L11.9557 22.9922Z"
            fill="#204063"
          />
          <path
            d="M11.3909 23.3804C11.3909 23.398 11.3909 23.4157 11.3732 23.4157C11.3556 23.4157 11.3556 23.4157 11.3556 23.4157C11.3509 23.4157 11.3464 23.4138 11.3431 23.4105C11.3398 23.4072 11.3379 23.4027 11.3379 23.398C11.3379 23.3933 11.3398 23.3889 11.3431 23.3855C11.3464 23.3822 11.3509 23.3804 11.3556 23.3804H11.3909Z"
            fill="#204063"
          />
          <path
            d="M12.4152 23.0451C12.4152 23.0627 12.4152 23.0804 12.3975 23.0804C12.3929 23.0804 12.3884 23.0785 12.3851 23.0752C12.3817 23.0719 12.3799 23.0674 12.3799 23.0627V23.0274C12.3975 23.0097 12.3975 23.0451 12.4152 23.0451Z"
            fill="#204063"
          />
          <path
            d="M11.3022 23.4338H11.3199C11.3022 23.4338 11.3022 23.4161 11.3199 23.3984C11.3246 23.4008 11.3282 23.4049 11.3298 23.4099C11.3315 23.4148 11.3311 23.4202 11.3287 23.4249C11.3264 23.4296 11.3223 23.4332 11.3173 23.4348C11.3124 23.4365 11.3069 23.4361 11.3022 23.4338Z"
            fill="#204063"
          />
          <path
            d="M13.1213 22.9745C13.1213 22.9922 13.1213 23.0099 13.1037 23.0099C13.086 23.0099 13.0684 23.0275 13.0684 23.0099C13.0684 22.9922 13.1037 22.9569 13.1213 22.9745Z"
            fill="#204063"
          />
          <path
            d="M12.8033 23.0627H12.821C12.821 23.098 12.8386 23.1333 12.821 23.1686C12.821 23.1733 12.8191 23.1778 12.8158 23.1811C12.8125 23.1844 12.808 23.1863 12.8033 23.1863C12.7986 23.1863 12.7941 23.1844 12.7908 23.1811C12.7875 23.1778 12.7856 23.1733 12.7856 23.1686V23.098H12.8033C12.8029 23.0733 12.809 23.0489 12.821 23.0273L12.8033 23.0627Z"
            fill="#204063"
          />
          <path
            d="M12.2384 23.2041H12.256C12.2647 23.2138 12.2695 23.2264 12.2695 23.2394C12.2695 23.2525 12.2647 23.265 12.256 23.2747H12.2207V23.2218H12.2384V23.2041Z"
            fill="#204063"
          />
          <path
            d="M10.9139 23.6453C10.9092 23.6453 10.9047 23.6434 10.9014 23.6401C10.8981 23.6368 10.8962 23.6323 10.8962 23.6276C10.8786 23.6276 10.9139 23.5923 10.8962 23.5923C10.8786 23.5923 10.9315 23.6276 10.9139 23.6453Z"
            fill="#204063"
          />
          <path
            d="M11.2143 25.2525H11.232C11.232 25.2525 11.1967 25.2878 11.232 25.2878C11.2673 25.2878 11.2143 25.3584 11.179 25.3761H11.1967C11.1967 25.4114 11.2143 25.4291 11.179 25.4467H11.1614C11.126 25.4114 11.2143 25.3761 11.1437 25.3408C11.0731 25.3055 11.1437 25.2701 11.1437 25.2525H11.1967C11.1967 25.2348 11.1967 25.2525 11.2143 25.2525Z"
            fill="#204063"
          />
          <path
            d="M11.32 23.6279C11.32 23.6456 11.32 23.6632 11.3024 23.6632H11.2847C11.267 23.6456 11.2847 23.6456 11.2847 23.6456H11.32V23.6279Z"
            fill="#204063"
          />
          <path
            d="M12.715 23.2925V23.3455H12.6973C12.6797 23.3455 12.6797 23.3101 12.6973 23.2925H12.715Z"
            fill="#204063"
          />
          <path
            d="M11.1788 23.8042H11.1965V23.8395H11.1611V23.8042H11.1788Z"
            fill="#204063"
          />
          <path
            d="M11.1787 23.8042V23.8219V23.8042H11.1964H11.1787Z"
            fill="white"
          />
          <path
            d="M11.2316 24.0514C11.2493 24.0514 11.2669 24.0691 11.2493 24.0868H11.2316C11.1963 24.0868 11.2139 24.0514 11.1963 24.0514C11.2139 24.0338 11.2139 24.0338 11.2139 24.0161C11.2093 24.0185 11.2057 24.0226 11.204 24.0275C11.2024 24.0325 11.2028 24.0379 11.2051 24.0426C11.2075 24.0473 11.2116 24.0508 11.2165 24.0525C11.2215 24.0542 11.2269 24.0538 11.2316 24.0514Z"
            fill="#204063"
          />
          <path
            d="M10.7725 24.0869C10.7725 24.1046 10.7902 24.1222 10.7725 24.1576V24.1222C10.7549 24.1046 10.7725 24.1046 10.7725 24.0869Z"
            fill="#204063"
          />
          <path
            d="M12.821 23.5923C12.821 23.6099 12.8386 23.6453 12.821 23.6629V23.6982L12.7856 23.6629V23.6276C12.8033 23.6453 12.7856 23.5923 12.8033 23.6099C12.8033 23.6099 12.8033 23.6099 12.821 23.5923Z"
            fill="#204063"
          />
          <path
            d="M11.0906 24.1221H11.1083C11.0906 24.1397 11.1083 24.175 11.0906 24.1927C11.073 24.2104 11.0553 24.175 11.0376 24.1574C11.02 24.1397 11.0376 24.1397 11.0376 24.1397H11.0906V24.1221Z"
            fill="#204063"
          />
          <path
            d="M12.3976 23.7337C12.3929 23.7337 12.3884 23.7319 12.3851 23.7286C12.3818 23.7252 12.3799 23.7207 12.3799 23.7161V23.6807C12.3623 23.6631 12.3799 23.6807 12.3799 23.6984C12.3976 23.6807 12.3976 23.6807 12.3976 23.6631C12.3976 23.6807 12.4152 23.7161 12.3976 23.7337Z"
            fill="#204063"
          />
          <path
            d="M12.2031 24.5461H12.2208V24.5107C12.2245 24.5141 12.2276 24.5181 12.2296 24.5227C12.2317 24.5273 12.2327 24.5322 12.2327 24.5372C12.2327 24.5422 12.2317 24.5472 12.2296 24.5518C12.2276 24.5563 12.2245 24.5604 12.2208 24.5637C12.217 24.5604 12.214 24.5563 12.212 24.5518C12.2099 24.5472 12.2088 24.5422 12.2088 24.5372C12.2088 24.5322 12.2099 24.5273 12.212 24.5227C12.214 24.5181 12.217 24.5141 12.2208 24.5107L12.2031 24.5461Z"
            fill="#204063"
          />
          <path
            d="M11.32 24.9876H11.3023C11.2847 25.0052 11.2847 24.9875 11.2847 24.9699C11.3023 24.9522 11.2847 24.9522 11.3023 24.9346H11.32C11.32 24.9522 11.3376 24.9699 11.32 24.9876Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.7759C11.9382 24.7935 11.9558 24.8289 11.9205 24.8289C11.8852 24.8289 11.9029 24.8289 11.9029 24.8112V24.7759H11.9205C11.9232 24.7774 11.9262 24.7782 11.9293 24.7782C11.9324 24.7782 11.9355 24.7774 11.9382 24.7759Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.8112H11.9205C11.9158 24.8112 11.9113 24.8093 11.908 24.806C11.9047 24.8027 11.9028 24.7982 11.9028 24.7935C11.9028 24.7889 11.9047 24.7844 11.908 24.781C11.9113 24.7777 11.9158 24.7759 11.9205 24.7759C11.9205 24.7935 11.9382 24.7759 11.9382 24.8112Z"
            fill="white"
          />
          <path
            d="M11.2496 24.8464C11.2496 24.864 11.2496 24.8464 11.2319 24.8464V24.811H11.2496C11.2496 24.8287 11.2673 24.8464 11.2496 24.8464Z"
            fill="#204063"
          />
          <path
            d="M12.0264 24.9172V24.8818C12.0264 24.8818 12.044 24.8995 12.0264 24.9172Z"
            fill="#204063"
          />
          <path
            d="M10.7373 26.2769H10.7726C10.7726 26.2769 10.755 26.2769 10.7726 26.2946C10.7773 26.2946 10.7818 26.2927 10.7851 26.2894C10.7884 26.2861 10.7903 26.2816 10.7903 26.2769C10.7903 26.2723 10.7884 26.2678 10.7851 26.2645C10.7818 26.2611 10.7773 26.2593 10.7726 26.2593C10.7903 26.2769 10.7726 26.3123 10.7903 26.3123H10.8079C10.8079 26.3476 10.8256 26.3476 10.8256 26.3652C10.8264 26.3748 10.8253 26.3844 10.8222 26.3935C10.8192 26.4027 10.8143 26.4111 10.8079 26.4182C10.8433 26.4006 10.8079 26.4535 10.8256 26.4535C10.8209 26.4535 10.8164 26.4554 10.8131 26.4587C10.8098 26.462 10.8079 26.4665 10.8079 26.4712L10.7373 26.5065H10.6843C10.6667 26.5065 10.649 26.4889 10.6667 26.4712H10.649C10.6517 26.4463 10.6454 26.4213 10.6313 26.4006H10.6667V26.3652C10.6843 26.3652 10.6667 26.3476 10.6843 26.3299C10.702 26.3123 10.702 26.3476 10.7196 26.3299C10.7174 26.3203 10.7178 26.3103 10.7209 26.3009C10.7241 26.2916 10.7297 26.2832 10.7373 26.2769Z"
            fill="#204063"
          />
          <path
            d="M11.9205 25.0582V25.0935C11.9028 25.1112 11.9028 25.0758 11.9028 25.0758C11.9028 25.0758 11.9028 25.0582 11.9028 25.0405L11.9205 25.0582Z"
            fill="#204063"
          />
          <path
            d="M11.8501 25.27H11.7971C11.7971 25.2877 11.7794 25.2877 11.7618 25.2877C11.7557 25.2658 11.7559 25.2427 11.7621 25.2209C11.7683 25.1991 11.7804 25.1794 11.7971 25.1641H11.8147C11.8249 25.1676 11.8341 25.1735 11.8417 25.1812C11.8493 25.1888 11.855 25.1982 11.8584 25.2084C11.8618 25.2186 11.8628 25.2295 11.8614 25.2402C11.8599 25.2509 11.8561 25.2611 11.8501 25.27Z"
            fill="#204063"
          />
          <path
            d="M11.1966 27.4601H11.2143V27.4954H11.2319C11.2143 27.5308 11.2319 27.5484 11.2143 27.5661C11.1966 27.5837 11.1966 27.6014 11.1966 27.6191H11.126C11.1249 27.6055 11.1185 27.5928 11.1083 27.5837H11.0553C11.02 27.5837 11.0377 27.5484 11.02 27.5308V27.4954C11.0377 27.5131 11.0377 27.4778 11.0553 27.4601H11.126V27.4248H11.1613C11.1613 27.4248 11.179 27.4778 11.1966 27.4601Z"
            fill="#204063"
          />
          <path
            d="M11.0731 25.7114C11.0731 25.7291 11.1084 25.7467 11.1084 25.7821L11.0731 25.835L11.0024 25.7997C11.0201 25.7821 11.0024 25.7467 11.0024 25.7467H11.0201C11.0201 25.7291 11.0201 25.7114 11.0378 25.7114H11.0731Z"
            fill="#204063"
          />
          <path
            d="M11.6029 25.5703H11.6205C11.6382 25.6056 11.5675 25.6056 11.6029 25.6409C11.6382 25.6762 11.5852 25.6939 11.5675 25.6939C11.5499 25.6939 11.5322 25.6586 11.5322 25.6409C11.5499 25.6586 11.5499 25.6233 11.5499 25.6233H11.5852C11.5782 25.6209 11.5724 25.6159 11.5691 25.6093C11.5657 25.6026 11.5652 25.595 11.5675 25.5879C11.5699 25.5809 11.5749 25.5751 11.5815 25.5718C11.5882 25.5685 11.5958 25.5679 11.6029 25.5703Z"
            fill="#204063"
          />
          <path
            d="M11.4083 26.3652V26.4006C11.3907 26.4182 11.4437 26.4182 11.4083 26.4535C11.373 26.4889 11.3907 26.4712 11.3907 26.4889H11.32V26.4535C11.3377 26.4535 11.3024 26.4359 11.32 26.4359V26.4006H11.373C11.3907 26.3476 11.3907 26.3829 11.4083 26.3652Z"
            fill="#204063"
          />
          <path
            d="M10.7019 26.7008C10.7019 26.7184 10.7019 26.7184 10.7196 26.7184C10.7372 26.7184 10.7019 26.7714 10.6842 26.7537H10.6489C10.6666 26.7361 10.6489 26.7361 10.6489 26.7184C10.6536 26.7184 10.6581 26.7166 10.6614 26.7133C10.6647 26.7099 10.6666 26.7054 10.6666 26.7008C10.6666 26.6961 10.6684 26.6916 10.6718 26.6883C10.6751 26.685 10.6796 26.6831 10.6842 26.6831L10.7019 26.7008Z"
            fill="#204063"
          />
          <path
            d="M10.6842 26.7007V26.7183H10.6665L10.6842 26.7007Z"
            fill="white"
          />
          <path
            d="M9.99577 26.5592C9.99577 26.5768 9.97811 26.5945 9.96045 26.5768V26.5415C9.97811 26.5238 10.0134 26.5415 9.99577 26.5592Z"
            fill="#204063"
          />
          <path
            d="M10.8784 27.2481C10.8784 27.2481 10.8784 27.2304 10.8961 27.2481H10.8784Z"
            fill="#204063"
          />
          <path
            d="M10.4903 26.8066C10.508 26.8066 10.4903 26.8243 10.4903 26.8243H10.4727C10.4727 26.8243 10.4903 26.8066 10.4903 26.8243V26.8066Z"
            fill="#204063"
          />
          <path
            d="M10.1899 27.0186H10.2252C10.2075 27.0186 10.2252 27.0362 10.2252 27.0362C10.2252 27.0715 10.2252 27.1069 10.1722 27.1245L10.1192 27.0892C10.1016 27.0715 10.1192 27.0539 10.1016 27.0362H10.1192C10.1016 27.0186 10.1192 27.0362 10.1192 27.0186H10.1899Z"
            fill="#204063"
          />
          <path
            d="M10.6135 27.2481H10.6489V27.2834C10.6665 27.3011 10.6312 27.3011 10.6312 27.3364H10.5429C10.5429 27.3188 10.5076 27.3541 10.5076 27.3188C10.4722 27.3364 10.4899 27.3011 10.4722 27.3011H10.4546C10.4593 27.3011 10.4638 27.2992 10.4671 27.2959C10.4704 27.2926 10.4722 27.2881 10.4722 27.2834C10.4722 27.2788 10.4704 27.2743 10.4671 27.271C10.4638 27.2676 10.4593 27.2658 10.4546 27.2658C10.4546 27.2481 10.4899 27.2481 10.4722 27.2305C10.4546 27.2128 10.5076 27.2305 10.4899 27.1951C10.5076 27.1951 10.5076 27.2128 10.5076 27.1951C10.5076 27.1775 10.5076 27.1951 10.5076 27.1775C10.5076 27.1598 10.5252 27.2128 10.5429 27.1951H10.5959C10.5782 27.2305 10.6135 27.2305 10.6135 27.2481Z"
            fill="#204063"
          />
          <path
            d="M10.066 27.5835L10.1014 27.6188C10.0837 27.6365 10.119 27.6365 10.1014 27.6541C10.0837 27.6718 10.119 27.6718 10.1014 27.6718H10.119C10.1014 27.6895 10.1014 27.7248 10.066 27.7424H9.96008C9.94242 27.7248 9.96008 27.7071 9.94242 27.7071C9.92476 27.7071 9.94242 27.6895 9.94242 27.6718C9.9471 27.6718 9.9516 27.6699 9.95491 27.6666C9.95822 27.6633 9.96008 27.6588 9.96008 27.6541C9.96008 27.6495 9.95822 27.645 9.95491 27.6416C9.9516 27.6383 9.9471 27.6365 9.94242 27.6365H9.96008C9.96008 27.6365 9.94242 27.6188 9.96008 27.6188H10.0307L10.066 27.5835Z"
            fill="#204063"
          />
          <path
            d="M10.9137 27.778H10.8961C10.8914 27.778 10.8869 27.7761 10.8836 27.7728C10.8803 27.7695 10.8784 27.765 10.8784 27.7603C10.8784 27.7557 10.8803 27.7512 10.8836 27.7478C10.8869 27.7445 10.8914 27.7427 10.8961 27.7427C10.9137 27.7603 10.9137 27.7603 10.9137 27.778Z"
            fill="#204063"
          />
          <path
            d="M11.3199 28.131C11.3022 28.131 11.3022 28.1134 11.3022 28.0957H11.3199C11.3199 28.0957 11.3376 28.131 11.3199 28.131Z"
            fill="#204063"
          />
          <path
            d="M10.6136 28.043H10.6313V28.0959C10.5959 28.0959 10.5959 28.1136 10.5606 28.0959H10.543C10.543 28.0783 10.5606 28.0606 10.543 28.0606H10.5606C10.543 28.0606 10.5606 28.0606 10.5606 28.043C10.5606 28.0477 10.5625 28.0521 10.5658 28.0555C10.5691 28.0588 10.5736 28.0606 10.5783 28.0606H10.6136V28.043Z"
            fill="#204063"
          />
          <path
            d="M10.5075 28.0604H10.5252C10.5075 28.0604 10.5252 28.078 10.5252 28.078H10.5075L10.4722 28.1134H10.4192C10.4192 28.078 10.3839 28.0957 10.3662 28.0604H10.3839C10.3662 28.0427 10.3839 28.0251 10.3839 28.0074H10.4015C10.4015 27.9897 10.4192 27.9897 10.4015 27.9897C10.3839 27.9897 10.4369 28.0074 10.4369 27.9897H10.4545C10.4898 28.0074 10.4898 28.0604 10.5075 28.0604Z"
            fill="#204063"
          />
          <path
            d="M10.2076 28.2192H10.2606C10.2606 28.2369 10.2429 28.2546 10.2606 28.2546H10.2783C10.2783 28.2722 10.2606 28.2899 10.2783 28.2899H10.2959C10.2959 28.2899 10.3136 28.2899 10.2959 28.3075H10.3489C10.3313 28.3252 10.3489 28.3252 10.3489 28.3252H10.3313C10.3489 28.3252 10.3313 28.3252 10.3313 28.3429H10.137C10.137 28.3075 10.1017 28.3252 10.1017 28.3252H10.0663V28.2899H10.031C10.031 28.2899 10.0663 28.2899 10.0487 28.2722C10.0487 28.2369 9.99571 28.2369 10.0134 28.2016C10.031 28.1663 10.031 28.2016 10.031 28.2016C10.031 28.2016 10.0134 28.1663 10.031 28.1663L10.0663 28.1309C10.0663 28.1309 10.0487 28.1133 10.0663 28.1133C10.0663 28.118 10.0682 28.1225 10.0715 28.1258C10.0748 28.1291 10.0793 28.1309 10.084 28.1309H10.1193C10.1193 28.1309 10.1193 28.1486 10.137 28.1309H10.2253L10.2076 28.2192Z"
            fill="#204063"
          />
          <path
            d="M11.4791 26.9302C11.4615 26.9478 11.4791 26.9655 11.4438 26.9655C11.4085 26.9655 11.4085 26.9478 11.4262 26.9302H11.4791Z"
            fill="#204063"
          />
          <path
            d="M11.4082 27.0539V27.0362H11.4259L11.4082 27.0186H11.4259L11.4082 27.0539Z"
            fill="#204063"
          />
          <path
            d="M11.4261 27.1065H11.4437V27.1418C11.4614 27.1595 11.4437 27.1948 11.4437 27.2125C11.4437 27.2301 11.3908 27.2301 11.3908 27.2655H11.3378C11.3201 27.2301 11.3201 27.2301 11.3025 27.2301C11.3025 27.2125 11.3201 27.1948 11.3025 27.1772C11.2848 27.1595 11.3201 27.1418 11.3025 27.1418C11.2848 27.1418 11.3378 27.1595 11.3554 27.1595C11.3731 27.1595 11.3378 27.1418 11.3554 27.1418C11.3731 27.1418 11.3731 27.1595 11.3731 27.1595V27.1065C11.3908 27.0712 11.3908 27.1065 11.4261 27.1065Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M19.7262 23.8751L19.6909 23.8574H19.7262V23.8751Z"
            fill="white"
          />
          <path
            d="M19.797 23.8751L19.7617 23.8927V23.8574L19.797 23.8751Z"
            fill="white"
          />
          <path
            d="M19.8323 17.0583L19.8853 17.0229C19.8977 17.0339 19.9073 17.0476 19.9134 17.0629C19.9196 17.0782 19.922 17.0948 19.9206 17.1112C19.903 17.1466 19.8677 17.1466 19.8323 17.1289C19.8237 17.1192 19.8188 17.1066 19.8188 17.0936C19.8188 17.0806 19.8237 17.068 19.8323 17.0583Z"
            fill="#204063"
          />
          <path
            d="M19.9028 16.8286C19.9205 16.8286 19.9205 16.8462 19.9205 16.8639L19.8675 16.8992C19.8322 16.8816 19.8498 16.7933 19.9028 16.8286Z"
            fill="#204063"
          />
          <path
            d="M11.9557 21.1026C11.9557 21.1203 11.938 21.1556 11.9204 21.1379H11.9027C11.9018 21.1313 11.9027 21.1246 11.9054 21.1185C11.9082 21.1125 11.9125 21.1073 11.9181 21.1036C11.9236 21.0999 11.9301 21.0978 11.9367 21.0977C11.9434 21.0975 11.9499 21.0992 11.9557 21.1026Z"
            fill="#204063"
          />
          <path
            d="M17.4145 19.8689L17.397 19.8711L17.3981 19.8799L17.4156 19.8777L17.4145 19.8689Z"
            fill="#204063"
          />
          <path
            d="M17.7133 19.9367C17.6779 19.972 17.6249 19.9367 17.6073 19.9013C17.5896 19.866 17.6779 19.9013 17.7133 19.9367Z"
            fill="#204063"
          />
          <path
            d="M12.4325 21.1909C12.4501 21.2262 12.4501 21.2616 12.4148 21.2616C12.3795 21.2616 12.3618 21.2439 12.3618 21.2262C12.3618 21.2086 12.4148 21.1909 12.4325 21.1909Z"
            fill="#204063"
          />
          <path
            d="M10.8962 19.0538H10.8785C10.9096 19.0393 10.9439 19.0333 10.978 19.0364C11.0121 19.0395 11.0448 19.0516 11.0728 19.0714C11.0728 19.1067 11.0374 19.0891 11.0021 19.1067L10.8608 19.0714L10.8962 19.0538Z"
            fill="#204063"
          />
          <path
            d="M22.7108 18.5594H22.6755L22.7108 18.5241C22.6755 18.4711 22.7638 18.4711 22.7638 18.4358C22.8135 18.4305 22.8636 18.443 22.905 18.4711C22.9404 18.5241 22.9227 18.5241 22.9404 18.577C22.958 18.63 22.958 18.683 22.8697 18.683C22.7814 18.683 22.8167 18.6653 22.7638 18.7007C22.7108 18.736 22.7461 18.6653 22.7284 18.6653H22.7108C22.7284 18.63 22.7108 18.6124 22.6755 18.5947C22.6401 18.577 22.6931 18.577 22.7108 18.5594Z"
            fill="#204063"
          />
          <path
            d="M11.3554 19.1597L11.4084 19.195C11.3907 19.2303 11.3377 19.2126 11.3201 19.2126H11.2671L11.3554 19.1597Z"
            fill="#204063"
          />
          <path
            d="M11.5498 19.0011H11.5675C11.5321 19.0187 11.4792 18.9834 11.4438 18.9834L11.5498 19.0011Z"
            fill="#204063"
          />
          <path
            d="M14.3048 19.6895C14.3224 19.7071 14.3224 19.7071 14.3224 19.7248H14.2871C14.2871 19.7248 14.2695 19.6895 14.3048 19.6895Z"
            fill="#204063"
          />
          <path
            d="M14.6578 18.8066H14.6931L14.6578 18.8596C14.6401 18.8596 14.6401 18.8243 14.6578 18.8066Z"
            fill="#204063"
          />
          <path
            d="M14.6579 18.312C14.6756 18.3297 14.7286 18.3297 14.7109 18.365C14.6933 18.4003 14.7109 18.4356 14.6756 18.4356C14.6403 18.4356 14.6403 18.4003 14.605 18.4003C14.5696 18.4003 14.6403 18.3473 14.6579 18.312Z"
            fill="#204063"
          />
          <path
            d="M14.6931 18.7007C14.6931 18.7007 14.7107 18.6831 14.7107 18.7007V18.736C14.6754 18.736 14.6578 18.7007 14.6931 18.7007Z"
            fill="#204063"
          />
          <path
            d="M14.958 19.6016H14.9933C14.9757 19.6192 14.9933 19.6369 14.9757 19.6545C14.958 19.6722 14.905 19.6192 14.958 19.6016Z"
            fill="#204063"
          />
          <path
            d="M12.6799 19.8662L12.627 19.8839L12.6446 19.8662H12.6799Z"
            fill="#204063"
          />
          <path
            d="M12.9096 19.9193C12.9273 19.9369 12.9802 19.9369 12.9626 19.9722C12.9449 20.0076 12.839 20.0076 12.8036 20.0076H12.786C12.8036 19.9899 12.786 19.9899 12.786 19.9722C12.786 19.9546 12.7683 19.9193 12.7153 19.9369C12.7773 19.9138 12.8444 19.9077 12.9096 19.9193Z"
            fill="#204063"
          />
          <path
            d="M14.9932 18.7891C15.0109 18.7891 15.0109 18.8067 15.0109 18.8244C15.0109 18.842 14.9932 18.842 14.9756 18.8244L14.9932 18.7891Z"
            fill="#204063"
          />
          <path
            d="M15.2227 19.478C15.2404 19.478 15.2404 19.4956 15.2404 19.5133H15.2051C15.1874 19.4956 15.2051 19.4603 15.2227 19.478Z"
            fill="#204063"
          />
          <path
            d="M15.2232 19.1421C15.2409 19.1421 15.2585 19.1774 15.2409 19.1774C15.2232 19.1774 15.2056 19.1951 15.2056 19.1774L15.2232 19.1421Z"
            fill="#204063"
          />
          <path
            d="M15.2759 19.4248C15.2936 19.4425 15.3642 19.4071 15.3466 19.4601C15.3289 19.5131 15.2936 19.4954 15.2583 19.4601C15.223 19.4248 15.2583 19.4248 15.2759 19.4248Z"
            fill="#204063"
          />
          <path
            d="M13.3687 19.7957C13.4041 19.7957 13.4217 19.7957 13.4217 19.7604V19.7251C13.51 19.7428 13.6336 19.7074 13.7043 19.7957C13.7749 19.884 13.7043 19.8487 13.6866 19.8664H13.5983C13.563 19.8311 13.4924 19.9017 13.4394 19.8664H13.4747L13.3511 19.8134L13.3687 19.7957Z"
            fill="#204063"
          />
          <path
            d="M13.6337 20.2193C13.6514 20.3076 13.5454 20.2723 13.5101 20.2723L13.4395 20.2369C13.4674 20.2171 13.5001 20.2051 13.5342 20.202C13.5683 20.1989 13.6027 20.2048 13.6337 20.2193Z"
            fill="#204063"
          />
          <path
            d="M13.5808 20.2373L13.5632 20.255L13.5278 20.2373L13.5632 20.255L13.5808 20.2373Z"
            fill="white"
          />
          <path
            d="M19.5499 20.131H19.5676C19.5146 20.2193 19.3733 20.184 19.285 20.1486H19.2144C19.2649 20.1195 19.3217 20.1027 19.38 20.0996C19.4383 20.0966 19.4965 20.1073 19.5499 20.131Z"
            fill="#204063"
          />
          <path
            d="M13.8102 20.3077L13.7749 20.29H13.8102V20.3077Z"
            fill="#204063"
          />
          <path
            d="M14.0397 20.3253H14.0927L14.0574 20.3783C14.0097 20.3905 13.9593 20.3842 13.9161 20.3606C13.8984 20.3783 13.9338 20.3606 13.9338 20.343H13.8984C13.9183 20.3278 13.9419 20.3182 13.9667 20.3151C13.9915 20.312 14.0167 20.3155 14.0397 20.3253Z"
            fill="#204063"
          />
          <path
            d="M14.0047 20.3606H13.987C13.9693 20.3959 13.987 20.3606 13.9693 20.3783C13.9517 20.3959 13.9693 20.3253 14.0047 20.3606Z"
            fill="white"
          />
          <path
            d="M14.1812 20.4311C14.2038 20.4144 14.2304 20.404 14.2583 20.4009C14.2862 20.3978 14.3145 20.4021 14.3402 20.4135C14.3578 20.4135 14.3755 20.4312 14.3578 20.4665C14.3147 20.49 14.2642 20.4963 14.2166 20.4841C14.2166 20.4488 14.1636 20.4665 14.1459 20.4665C14.1283 20.4665 14.2166 20.4665 14.1812 20.4311Z"
            fill="#204063"
          />
          <path
            d="M14.2339 20.4136L14.2515 20.4312H14.2339V20.4136Z"
            fill="white"
          />
          <path
            d="M14.8519 21.8441C14.8696 21.8441 14.8519 21.8617 14.8519 21.8617C14.8519 21.8617 14.7813 21.8971 14.7459 21.8971C14.7106 21.8971 14.7106 21.9147 14.6753 21.8794C14.7287 21.8487 14.7907 21.8363 14.8519 21.8441Z"
            fill="#204063"
          />
          <path
            d="M15.0817 16.8286C15.117 16.8992 15.0287 16.8992 15.0111 16.9169C14.9934 16.9345 14.8521 16.8462 14.7815 16.8462H14.7285C14.8345 16.8462 14.9934 16.7226 15.0817 16.8286Z"
            fill="#204063"
          />
          <path
            d="M16.0527 20.8022C16.0704 20.8022 16.0881 20.8022 16.0881 20.8199C16.0881 20.8376 16.1057 20.8552 16.0704 20.8729H15.9468C15.9644 20.8022 16.0174 20.8022 16.0527 20.8022Z"
            fill="#204063"
          />
          <path
            d="M15.4172 20.873L15.3818 20.8907V20.873H15.4172Z"
            fill="white"
          />
          <path
            d="M16.7418 20.7668H16.7241C16.7594 20.7315 16.7948 20.7315 16.8477 20.7139C16.8631 20.7157 16.8778 20.7216 16.8902 20.7309C16.9026 20.7402 16.9123 20.7526 16.9184 20.7668C16.936 20.8022 16.9007 20.8022 16.8831 20.8375C16.8654 20.8728 16.8124 20.8022 16.7771 20.8375H16.7948L16.7241 20.8022L16.7418 20.7668Z"
            fill="#204063"
          />
          <path
            d="M15.5939 17.5704L15.5586 17.5527H15.5939V17.5704Z"
            fill="#204063"
          />
          <path
            d="M15.647 17.7471H15.6823C15.7 17.7647 15.7176 17.7647 15.7176 17.8001H15.647V17.7471Z"
            fill="#204063"
          />
          <path
            d="M16.4414 19.6544C16.512 19.6544 16.6003 19.5661 16.671 19.6368C16.6737 19.6437 16.675 19.6511 16.6747 19.6586C16.6743 19.666 16.6725 19.6733 16.6691 19.68C16.6658 19.6867 16.6611 19.6925 16.6553 19.6973C16.6496 19.702 16.6429 19.7054 16.6357 19.7074C16.565 19.7251 16.512 19.6721 16.4414 19.6544Z"
            fill="#204063"
          />
          <path
            d="M17.2891 20.9434C17.3245 20.9434 17.3774 20.9257 17.3951 20.961C17.4128 20.9964 17.3598 21.014 17.3598 21.0317H17.2715C17.2715 21.014 17.2891 20.9964 17.2715 20.9964C17.2538 20.9964 17.2715 20.9787 17.2891 20.9434Z"
            fill="#204063"
          />
          <path
            d="M16.6006 18.6124C16.6146 18.6106 16.6288 18.613 16.6414 18.6193C16.6539 18.6256 16.6644 18.6355 16.6713 18.6477C16.6713 18.6654 16.6536 18.683 16.636 18.7007H16.5477C16.53 18.6301 16.5653 18.6301 16.6006 18.6124Z"
            fill="#204063"
          />
          <path
            d="M17.4304 21.1203C17.4481 21.1026 17.4127 21.085 17.4304 21.085V21.1203Z"
            fill="#204063"
          />
          <path
            d="M16.4594 17.0229C16.4947 17.0053 16.5124 17.0229 16.5477 17.0406C16.583 17.0583 16.5477 17.1112 16.5124 17.1112C16.4771 17.1112 16.4241 17.0583 16.4594 17.0229Z"
            fill="#204063"
          />
          <path
            d="M16.6359 17.7296C16.6359 17.7119 16.6359 17.7119 16.6182 17.7119C16.6006 17.7119 16.6536 17.6942 16.6712 17.7119C16.6889 17.7296 16.8125 17.6413 16.8831 17.7119C16.9538 17.7825 16.8831 17.7649 16.8655 17.7825H16.7419C16.6901 17.7813 16.6404 17.7626 16.6006 17.7296H16.6359Z"
            fill="#204063"
          />
          <path
            d="M16.9005 19.0007C16.9005 19.0184 16.9181 19.0184 16.9181 19.0361C16.9214 19.0398 16.9255 19.0428 16.9301 19.0449C16.9347 19.0469 16.9396 19.048 16.9446 19.048C16.9496 19.048 16.9546 19.0469 16.9592 19.0449C16.9637 19.0428 16.9678 19.0398 16.9711 19.0361C16.9181 19.0361 16.9535 18.9831 16.9181 18.9654C16.8828 18.9478 17.0241 18.9301 17.0594 18.9831C17.0594 18.9968 17.0562 19.0103 17.0501 19.0226C17.044 19.0348 17.0351 19.0455 17.0241 19.0537C16.9888 19.0361 16.9711 19.0537 16.9358 19.0714H16.9005C16.9181 19.0537 16.9005 19.0537 16.9181 19.0361H16.8828C16.8828 19.0007 16.9005 19.0184 16.9005 19.0007Z"
            fill="#204063"
          />
          <path
            d="M17.9249 21.9856C17.9602 22.0033 17.9249 22.0386 17.9072 22.0386C17.8896 22.0386 17.8189 22.0209 17.7836 22.0563C17.7483 22.0916 17.8719 21.968 17.9249 21.9856Z"
            fill="#204063"
          />
          <path
            d="M16.9537 19.001C16.9714 19.001 16.936 19.0186 16.936 19.0186H16.9537V19.001Z"
            fill="white"
          />
          <path
            d="M16.9712 18.9831C16.9712 18.9654 16.9889 18.9654 16.9712 18.9478V18.9831Z"
            fill="white"
          />
          <path
            d="M21.7748 20.8197L21.7395 20.7843C21.7395 20.7667 21.8631 20.8197 21.8101 20.7314C21.7572 20.6431 22.0044 20.7314 22.075 20.802H22.0927L22.0574 20.7667C22.1104 20.7667 22.181 20.7137 22.234 20.7314C22.287 20.749 22.2693 20.7667 22.2516 20.7843C22.234 20.802 22.0221 20.749 21.9867 20.908C21.9514 21.0669 21.8455 20.9609 21.7925 20.9433L21.7395 20.9786C21.7925 20.9609 21.7395 20.9256 21.7395 20.908L21.6865 20.8726C21.7042 20.855 21.7572 20.855 21.7748 20.8197Z"
            fill="#204063"
          />
          <path
            d="M17.872 21.085C17.9073 21.1026 17.9603 21.0673 17.9779 21.1203C17.9956 21.1733 17.9249 21.1556 17.9073 21.1909C17.8896 21.2262 17.8896 21.1556 17.8543 21.1733H17.872C17.8543 21.1556 17.8366 21.085 17.872 21.085Z"
            fill="#204063"
          />
          <path
            d="M17.0951 17.9589C17.1304 17.9236 17.1481 17.9236 17.1834 17.9413C17.2187 17.9589 17.2187 17.9589 17.2011 17.9766C17.1834 17.9943 17.1304 17.9943 17.0951 17.9943C17.0598 17.9943 17.0774 17.9589 17.0951 17.9589Z"
            fill="#204063"
          />
          <path d="M17.13 17.959L17.0947 17.9766V17.959H17.13Z" fill="white" />
          <path
            d="M18.2959 21.4026C18.2783 21.4026 18.2959 21.3673 18.2959 21.3673C18.2959 21.3673 18.3489 21.3319 18.3666 21.3673C18.3842 21.4026 18.3489 21.4026 18.3489 21.4202L18.2959 21.4026Z"
            fill="#204063"
          />
          <path
            d="M18.3136 21.3848H18.3312V21.4025L18.2959 21.3848L18.3136 21.3672V21.3848Z"
            fill="white"
          />
          <path
            d="M18.8784 21.2261C18.8961 21.1908 18.9314 21.1555 18.9667 21.1732C18.9821 21.175 18.9968 21.1809 19.0092 21.1902C19.0216 21.1995 19.0313 21.2119 19.0374 21.2261C19.0374 21.2791 18.9667 21.2791 18.9314 21.2968C18.9138 21.2615 18.8961 21.2791 18.8608 21.2615C18.8255 21.2438 18.8784 21.2261 18.8784 21.2261Z"
            fill="#204063"
          />
          <path
            d="M19.0905 22.2856C19.0905 22.2809 19.0886 22.2764 19.0853 22.2731C19.082 22.2698 19.0775 22.2679 19.0728 22.2679H19.0552C19.1082 22.2502 19.1611 22.1973 19.2318 22.2326C19.3024 22.2679 19.2141 22.3032 19.1788 22.3032C19.1435 22.3032 19.0905 22.3032 19.0552 22.3032L19.0905 22.2856Z"
            fill="#204063"
          />
          <path
            d="M17.6954 17.7116L17.8014 17.6763C17.8367 17.6763 17.8543 17.6939 17.872 17.7292C17.8734 17.7457 17.8709 17.7623 17.8648 17.7776C17.8587 17.7929 17.849 17.8066 17.8367 17.8175C17.8014 17.8175 17.7837 17.7999 17.7484 17.8352C17.7131 17.8705 17.6777 17.8175 17.7131 17.7646H17.6777C17.6954 17.7646 17.6954 17.7292 17.6954 17.7116Z"
            fill="#204063"
          />
          <path
            d="M19.0905 21.5262C19.1435 21.5438 19.2141 21.4732 19.2494 21.5438C19.2848 21.6145 19.2141 21.6145 19.1788 21.6498C19.1435 21.6851 19.1435 21.6498 19.1258 21.6498H19.1435C19.0905 21.6498 19.1258 21.6321 19.0905 21.6321H19.0552C19.0905 21.5615 19.0552 21.5262 19.0905 21.5262Z"
            fill="#204063"
          />
          <path
            d="M18.0134 18.6652L17.9781 18.7005H17.9251C17.9251 18.7358 17.9605 18.7182 17.9605 18.7182V18.6829C17.9251 18.6475 17.9075 18.6829 17.8898 18.6829H17.8545C17.9075 18.6475 17.9781 18.6122 18.0134 18.6652Z"
            fill="#204063"
          />
          <path
            d="M19.6734 20.8023C19.6734 20.807 19.6752 20.8115 19.6785 20.8148C19.6819 20.8181 19.6864 20.82 19.691 20.82H19.6734V20.7847C19.6557 20.82 19.6734 20.8023 19.6734 20.8023Z"
            fill="#204063"
          />
          <path
            d="M19.7438 18.9125C19.7615 18.8949 19.7438 18.9125 19.7438 18.9302H19.7791C19.7968 18.9302 19.7791 18.9125 19.7791 18.8949L19.7262 18.9302C19.7398 18.9164 19.7565 18.906 19.7749 18.8999C19.7933 18.8938 19.8129 18.892 19.8321 18.8949V18.9302C19.816 18.9459 19.7954 18.956 19.7732 18.9592C19.751 18.9624 19.7283 18.9584 19.7085 18.9479L19.7438 18.9125Z"
            fill="#204063"
          />
          <path
            d="M19.797 18.9479L19.7793 18.9303L19.797 18.9126V18.9479Z"
            fill="white"
          />
          <path
            d="M21.0861 20.6963C21.1214 20.6963 21.1214 20.7316 21.1038 20.7669L21.0508 20.8022C21.0508 20.8022 21.0508 20.7493 21.0155 20.7669C20.9801 20.7846 21.0155 20.8022 20.9801 20.8199H20.9448C20.9752 20.7628 21.0255 20.7189 21.0861 20.6963Z"
            fill="#204063"
          />
          <path
            d="M20.3442 19.4249C20.3972 19.4249 20.4325 19.3896 20.4855 19.4249C20.486 19.4409 20.4811 19.4567 20.4714 19.4695C20.4618 19.4823 20.4481 19.4915 20.4325 19.4955H20.3619V19.4602H20.3442C20.3442 19.4602 20.3619 19.4425 20.3442 19.4249Z"
            fill="#204063"
          />
          <path
            d="M20.4153 19.4248H20.3976C20.4027 19.4266 20.4073 19.4295 20.4111 19.4334C20.4149 19.4372 20.4177 19.4419 20.4194 19.447C20.4211 19.4521 20.4217 19.4575 20.4209 19.4629C20.4202 19.4682 20.4183 19.4733 20.4153 19.4778C20.4153 19.5131 20.3623 19.4954 20.3623 19.4954C20.3623 19.4954 20.3623 19.4425 20.4153 19.4248Z"
            fill="white"
          />
          <path
            d="M20.8036 20.9259V20.9613L20.7329 20.9966L20.7682 20.9613V20.9259C20.7682 20.9436 20.7506 20.9613 20.7329 20.9436C20.742 20.9345 20.7533 20.9281 20.7658 20.925C20.7782 20.9218 20.7913 20.9222 20.8036 20.9259Z"
            fill="#204063"
          />
          <path
            d="M20.5918 19.1597H20.6095L20.5741 19.195H20.4858L20.5918 19.1597Z"
            fill="#204063"
          />
          <path
            d="M24.477 21.0673C24.477 21.0143 24.424 21.0496 24.4063 21.0496C24.3887 21.0496 24.4593 21.0496 24.4593 21.0143H24.3887C24.424 20.979 24.4946 20.9967 24.5123 20.9437C24.53 20.8907 24.477 20.926 24.4946 20.9084C24.5123 20.8907 24.5476 20.8554 24.6006 20.8377H24.7066C24.6712 20.7847 24.7772 20.8201 24.7595 20.7671C24.7419 20.7141 24.8302 20.8201 24.8478 20.7847C24.8655 20.7494 24.9715 20.8554 24.9715 20.926C24.9715 20.9967 24.9715 20.9613 24.9715 21.0143C24.9715 21.032 24.9538 21.0496 24.9715 21.0673C24.9891 21.085 24.9185 21.085 24.9185 21.1026C24.9185 21.1203 24.9008 21.1733 24.8832 21.1733C24.8655 21.1733 24.8655 21.1733 24.8655 21.1909H24.8478C24.7772 21.2262 24.7242 21.2262 24.6712 21.2969L24.6359 21.3499C24.6359 21.3145 24.6712 21.2969 24.6359 21.2616H24.6006C24.5829 21.2439 24.5476 21.2969 24.5123 21.2792C24.477 21.2616 24.5123 21.2086 24.477 21.1909H24.4063C24.4227 21.2003 24.4422 21.2028 24.4604 21.1978C24.4786 21.1928 24.4941 21.1808 24.5035 21.1644C24.5128 21.148 24.5153 21.1286 24.5103 21.1104C24.5054 21.0922 24.4934 21.0767 24.477 21.0673Z"
            fill="#204063"
          />
          <path
            d="M20.9623 19.3542C20.9446 19.3542 20.9446 19.3542 20.9446 19.3718H20.9976V19.3365C20.98 19.3188 20.9623 19.3542 20.9623 19.3365C20.9623 19.3188 21.0153 19.3188 21.0329 19.3188C21.0506 19.3188 21.0153 19.3718 20.98 19.3718C20.9446 19.3718 20.927 19.3542 20.9093 19.3542C20.8917 19.3542 20.9446 19.3365 20.9623 19.3542Z"
            fill="#204063"
          />
          <path
            d="M21.4393 19.3896C21.4746 19.4073 21.5099 19.4426 21.5099 19.4603C21.5099 19.4779 21.5099 19.4956 21.4923 19.4956C21.4746 19.4956 21.5806 19.5309 21.5629 19.5662C21.5453 19.6016 21.351 19.5662 21.2804 19.5486V19.5133H21.2627C21.2766 19.4775 21.3008 19.4467 21.3323 19.4247C21.3637 19.4027 21.4009 19.3905 21.4393 19.3896Z"
            fill="#204063"
          />
          <path
            d="M26.5431 18.948H26.5255C26.5608 18.9303 26.5608 18.9127 26.5785 18.895H26.5431C26.5431 18.8774 26.5961 18.8774 26.5608 18.8597C26.6314 18.8597 26.6314 18.8067 26.6844 18.8067C26.7374 18.8067 26.7904 18.7891 26.8257 18.7891C26.861 18.7891 26.861 18.8067 26.8787 18.8244V18.948L26.8257 19.0186C26.861 19.0363 26.914 19.054 26.9317 19.0893C26.9493 19.1246 26.8963 19.1599 26.8787 19.2129L26.7904 19.2482C26.808 19.1952 26.7197 19.2129 26.6844 19.2129H26.6668C26.6844 19.1952 26.7021 19.1952 26.7021 19.1776H26.6668C26.6668 19.1599 26.6844 19.1599 26.6844 19.1423H26.6668C26.6844 19.1599 26.6844 19.1423 26.6844 19.1246H26.7021C26.6668 19.1246 26.6491 19.1246 26.6491 19.0893H26.5608V19.054H26.5078C26.5255 18.9833 26.5961 18.9657 26.5431 18.948Z"
            fill="#204063"
          />
          <path
            d="M22.9054 20.855H22.8877C22.923 20.8197 22.9407 20.749 23.029 20.749C23.1173 20.749 23.0996 20.749 23.1526 20.7667C23.2056 20.7843 23.1526 20.8726 23.1173 20.9256C23.082 20.9786 23.029 20.9786 22.976 20.9786H22.8877C22.9054 20.908 22.8877 20.8726 22.9054 20.855Z"
            fill="#204063"
          />
          <path
            d="M21.9867 19.7603C21.9867 19.7427 21.969 19.725 21.9514 19.7427C21.9337 19.7603 21.9867 19.7427 21.9867 19.7603Z"
            fill="#204063"
          />
          <path
            d="M22.2515 19.7603H22.2339C22.2339 19.7603 22.2692 19.7427 22.2515 19.725C22.2339 19.7074 22.3752 19.8133 22.4281 19.725C22.4811 19.6367 22.5341 19.725 22.5694 19.778C22.5684 19.8004 22.5612 19.8221 22.5488 19.8408C22.5363 19.8594 22.5191 19.8744 22.4988 19.884L22.4281 19.9193C22.4281 19.9146 22.4263 19.9101 22.423 19.9068C22.4197 19.9035 22.4152 19.9016 22.4105 19.9016H22.3752C22.3928 19.8663 22.3398 19.9016 22.3222 19.8663C22.3222 19.831 22.2692 19.8486 22.2515 19.831H22.2339C22.2162 19.778 22.2339 19.778 22.2515 19.7603Z"
            fill="#204063"
          />
          <path
            d="M24.1059 19.6192C24.0883 19.6016 24.1413 19.6016 24.1059 19.5839C24.0706 19.5663 24.1413 19.5486 24.1589 19.5309H24.1413C24.1942 19.5486 24.1766 19.4426 24.2649 19.478C24.3532 19.5133 24.3355 19.5133 24.3532 19.4956C24.3708 19.478 24.4238 19.5663 24.4062 19.6192C24.3885 19.6722 24.3885 19.6369 24.3532 19.6899V19.7252C24.3355 19.6722 24.3179 19.7782 24.2825 19.7252L24.2296 19.7605V19.7252H24.1413V19.6899H24.1059C24.0883 19.6369 24.1589 19.6369 24.1059 19.6192Z"
            fill="#204063"
          />
          <path
            d="M24.2297 19.9194L24.1768 19.9371H24.2121L24.2297 19.9194Z"
            fill="white"
          />
          <path
            d="M25.5186 20.7491C25.5363 20.7491 25.5363 20.7314 25.5363 20.7137C25.5363 20.6961 25.6423 20.6961 25.6599 20.7314V20.802C25.6246 20.7844 25.6069 20.8197 25.5893 20.8374C25.5716 20.855 25.554 20.8374 25.554 20.8374H25.501C25.5186 20.7844 25.5363 20.7667 25.5186 20.7491Z"
            fill="#204063"
          />
          <path
            d="M25.5366 20.7847L25.5719 20.7671V20.7847H25.5366Z"
            fill="white"
          />
          <path
            d="M25.9602 22.3034C25.9955 22.2858 26.0485 22.3211 26.0132 22.3741C25.9778 22.427 25.9778 22.4094 25.9425 22.3917C25.9072 22.3741 25.8895 22.3034 25.9602 22.3034Z"
            fill="#204063"
          />
          <path
            d="M26.3311 19.9015V19.8662H26.4194C26.4371 19.8839 26.4371 19.9015 26.4194 19.9369H26.3841L26.3135 19.9015H26.3311Z"
            fill="#204063"
          />
          <path
            d="M26.4899 19.7778C26.4899 19.7955 26.4899 19.8132 26.4722 19.8132C26.4676 19.8132 26.4631 19.8113 26.4598 19.808C26.4564 19.8047 26.4546 19.8002 26.4546 19.7955L26.4899 19.7778Z"
            fill="#204063"
          />
          <path
            d="M25.9604 21.0495C25.9687 21.0385 25.9793 21.0296 25.9916 21.0235C26.0039 21.0174 26.0174 21.0142 26.0311 21.0142C26.0311 21.0318 26.0487 21.0318 26.0311 21.0495L25.9781 21.0848C25.9781 21.0848 25.9428 21.0671 25.9781 21.0495H25.9604Z"
            fill="#204063"
          />
          <path
            d="M25.9957 21.0494H26.0133C26.031 21.0317 25.978 21.0847 25.978 21.0494C25.978 21.0141 25.9957 21.0494 25.9957 21.0494Z"
            fill="white"
          />
          <path
            d="M26.8079 21.4029H26.7726C26.8079 21.4029 26.8079 21.3852 26.8256 21.3675C26.8433 21.3499 26.8256 21.3499 26.8079 21.3499C26.7903 21.3499 26.8433 21.3322 26.8609 21.3146H26.8433C26.9139 21.3146 27.0375 21.2439 27.1082 21.3499V21.4558H27.0905C27.0905 21.5088 27.0375 21.5265 27.0199 21.5618H26.9845C26.9669 21.5795 26.9669 21.5441 26.9492 21.5618L26.8962 21.5971V21.5618C26.8786 21.5441 26.8609 21.5618 26.8609 21.5795C26.8609 21.5971 26.8256 21.5265 26.7903 21.5088H26.7373C26.7726 21.4205 26.8256 21.4382 26.8079 21.4029Z"
            fill="#204063"
          />
          <path
            d="M26.7903 20.3254V20.29H26.7726C26.755 20.3077 26.7903 20.29 26.8079 20.3077C26.8256 20.3254 26.8079 20.2547 26.8433 20.2547C26.8786 20.2547 26.8256 20.2371 26.8079 20.2194C26.7903 20.2017 26.8609 20.2371 26.8962 20.2194C26.9316 20.2017 26.9845 20.2194 27.0199 20.1841H27.0728L27.1611 20.2547L27.1965 20.29C27.1965 20.29 27.1965 20.3077 27.2318 20.3254C27.2671 20.343 27.2848 20.3607 27.2318 20.3783C27.1788 20.396 27.2494 20.4137 27.2671 20.4137H27.2141C27.2671 20.449 27.1788 20.4666 27.2141 20.5196L27.1788 20.5549C27.1435 20.5373 27.1258 20.5903 27.1082 20.6079C27.0905 20.6256 27.0199 20.5549 27.0022 20.6256C26.9845 20.6962 26.9492 20.5549 26.9139 20.6079H26.8962C26.8786 20.5903 26.9316 20.5726 26.8962 20.5549C26.8609 20.5373 26.8786 20.5726 26.8609 20.5903C26.8433 20.6079 26.8962 20.5196 26.8433 20.5196H26.7903C26.8079 20.502 26.8079 20.4843 26.8079 20.449C26.8079 20.4137 26.7726 20.4843 26.7726 20.449C26.7726 20.4137 26.8079 20.4313 26.7903 20.4137H26.7373C26.7903 20.396 26.7726 20.343 26.7903 20.3254Z"
            fill="#204063"
          />
          <path
            d="M28.2384 20.9434C28.2384 20.9081 28.2737 20.8728 28.256 20.8375C28.2384 20.8022 28.2737 20.7492 28.3267 20.7668C28.3797 20.7845 28.3267 20.7139 28.3797 20.7315C28.4326 20.7315 28.4856 20.6962 28.5563 20.7315C28.6269 20.7668 28.5916 20.7845 28.6269 20.7668H28.6092C28.6269 20.7845 28.6799 20.8022 28.6622 20.8375V20.8728C28.6403 20.9039 28.628 20.9407 28.6269 20.9788C28.6092 20.9964 28.5739 20.9964 28.5916 21.0317C28.6092 21.0671 28.5563 21.0671 28.5386 21.0847H28.4856C28.4621 21.0847 28.4444 21.1024 28.4326 21.1377C28.4326 21.12 28.415 21.12 28.4326 21.1024C28.4503 21.0847 28.3973 21.12 28.3797 21.12H28.362C28.3443 21.1024 28.309 21.1377 28.2914 21.1377C28.2737 21.1377 28.309 21.1024 28.2914 21.0847H28.256V21.0317C28.2207 21.0141 28.2207 21.0671 28.2031 21.0494C28.1854 21.0317 28.2207 20.9788 28.2384 20.9434Z"
            fill="#204063"
          />
          <path
            d="M27.4967 19.1245C27.4967 19.1422 27.5144 19.1422 27.5144 19.1598C27.5144 19.1775 27.4614 19.1775 27.4614 19.1598C27.4614 19.1422 27.4614 19.1245 27.4967 19.1245Z"
            fill="#204063"
          />
          <path
            d="M27.638 17.8706H27.6733C27.691 17.8883 27.6557 17.9059 27.638 17.9236C27.6204 17.9412 27.638 17.9059 27.6027 17.8883C27.5674 17.8706 27.6204 17.8883 27.638 17.8706Z"
            fill="#204063"
          />
          <path
            d="M28.4681 20.3608H28.5211L28.4857 20.4138H28.4681C28.4504 20.3962 28.5034 20.3785 28.4681 20.3608V20.3962C28.4651 20.3846 28.4651 20.3724 28.4681 20.3608Z"
            fill="#204063"
          />
          <path
            d="M28.3796 19.3189C28.3788 19.3094 28.38 19.2997 28.383 19.2906C28.3861 19.2815 28.3909 19.2731 28.3973 19.2659C28.4091 19.249 28.425 19.2352 28.4435 19.2259C28.462 19.2167 28.4826 19.2122 28.5033 19.213C28.5562 19.2483 28.5916 19.2483 28.5916 19.3013C28.5916 19.3542 28.5562 19.3366 28.6092 19.3542C28.6622 19.3719 28.5562 19.3719 28.5739 19.4072C28.5916 19.4425 28.5386 19.4072 28.5209 19.4072H28.5033C28.4856 19.4425 28.4679 19.4072 28.4326 19.4249H28.4503C28.4503 19.4202 28.4484 19.4157 28.4451 19.4124C28.4418 19.4091 28.4373 19.4072 28.4326 19.4072C28.4279 19.4072 28.4235 19.4091 28.4201 19.4124C28.4168 19.4157 28.415 19.4202 28.415 19.4249L28.3796 19.3896V19.3189Z"
            fill="#204063"
          />
          <path
            d="M28.5562 19.478C28.5562 19.4603 28.6091 19.478 28.6091 19.4427H28.6445C28.6621 19.4427 28.6445 19.425 28.6621 19.4074H28.7328C28.7681 19.372 28.7857 19.4427 28.8211 19.4427C28.8564 19.4427 28.8387 19.4956 28.8917 19.4956C28.9447 19.4956 28.927 19.5839 28.874 19.6546H28.8564C28.8387 19.6722 28.8564 19.6899 28.8564 19.7076H28.8211C28.8211 19.7605 28.7504 19.7429 28.7328 19.7605C28.7151 19.7782 28.6974 19.7605 28.6974 19.7429H28.6798V19.6899C28.6621 19.7076 28.6445 19.6899 28.6445 19.7252C28.6445 19.7605 28.6268 19.6369 28.5915 19.6546C28.5962 19.6546 28.6006 19.6527 28.604 19.6494C28.6073 19.6461 28.6091 19.6416 28.6091 19.6369C28.6091 19.6322 28.6073 19.6278 28.604 19.6244C28.6006 19.6211 28.5962 19.6193 28.5915 19.6193C28.5208 19.5839 28.6091 19.5133 28.5562 19.478Z"
            fill="#204063"
          />
          <path
            d="M29.3158 19.7603C29.3334 19.7426 29.2981 19.725 29.2804 19.725C29.2628 19.725 29.2981 19.7073 29.2981 19.6897H29.2628C29.2628 19.672 29.3158 19.6897 29.2981 19.6543C29.3121 19.6543 29.3256 19.6487 29.3356 19.6388C29.3455 19.6289 29.3511 19.6154 29.3511 19.6014V19.5131C29.3864 19.5131 29.3334 19.4601 29.3864 19.4777C29.3773 19.437 29.3773 19.3948 29.3864 19.3541C29.4041 19.3541 29.3864 19.3365 29.4041 19.3188H29.4394C29.4217 19.2658 29.457 19.3188 29.457 19.2835C29.457 19.2482 29.51 19.3188 29.5453 19.3011C29.5807 19.2835 29.5807 19.3365 29.5807 19.3718C29.5807 19.4071 29.563 19.3188 29.5983 19.3011C29.6336 19.2835 29.5983 19.3718 29.6513 19.3718H29.669C29.6866 19.3718 29.6866 19.4248 29.7219 19.3894V19.4248H29.7396C29.7573 19.4424 29.7396 19.4601 29.7573 19.4601H29.7749L29.8102 19.5131H29.8279V19.566C29.8632 19.566 29.8279 19.619 29.8632 19.619C29.8985 19.619 29.8985 19.672 29.9162 19.672C29.9339 19.672 29.8809 19.672 29.8809 19.6897C29.8809 19.7073 29.9162 19.7073 29.9339 19.725H29.8985C29.8809 19.7426 29.8985 19.7603 29.9162 19.7779C29.9162 19.7956 29.8632 19.8309 29.9162 19.8309C29.9115 19.8309 29.907 19.8328 29.9037 19.8361C29.9004 19.8394 29.8985 19.8439 29.8985 19.8486C29.8985 19.8839 29.9162 19.8839 29.9339 19.9016C29.9515 19.9192 29.8632 19.8486 29.8632 19.9016V19.9722L29.8279 19.9192C29.7573 19.9545 29.8279 20.0605 29.7573 20.0782C29.7596 20.0688 29.7581 20.0589 29.7532 20.0506C29.7482 20.0423 29.7401 20.0364 29.7308 20.034C29.7214 20.0317 29.7115 20.0331 29.7032 20.0381C29.6949 20.0431 29.689 20.0511 29.6866 20.0605C29.6513 20.0605 29.6866 20.1135 29.6336 20.1135C29.5807 20.1135 29.563 20.0605 29.5277 20.0782C29.4924 20.0958 29.5277 20.1311 29.51 20.1311C29.4924 20.1311 29.5277 20.0782 29.4924 20.0605C29.51 20.0428 29.4924 20.0252 29.4747 20.0075H29.457C29.457 19.9899 29.4747 19.9722 29.4394 19.9722H29.4217C29.4041 19.9545 29.4394 19.9545 29.4217 19.9369C29.4041 19.9192 29.3864 19.9016 29.3687 19.9192C29.3511 19.9369 29.3864 19.8839 29.3511 19.8839H29.3334C29.3334 19.8662 29.3687 19.8662 29.3511 19.8309H29.2981V19.7956H29.2451C29.2804 19.7956 29.3158 19.7956 29.3158 19.7603Z"
            fill="#204063"
          />
          <path
            d="M25.2184 18.9302C25.236 18.9302 25.289 18.9125 25.3067 18.9479C25.3243 18.9832 25.3067 19.0715 25.2537 19.0538H25.236L25.183 19.0185C25.2184 18.9832 25.1477 18.9832 25.183 18.9479C25.2184 18.9125 25.2184 18.9655 25.2184 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5189 18.9302L25.4659 18.9655V18.9478L25.4482 18.9655V18.9478L25.5189 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5896 18.8595H25.5719C25.5719 18.8419 25.5896 18.8419 25.5896 18.8242H25.5543C25.5896 18.8066 25.5896 18.7889 25.6073 18.7712H25.5896C25.6424 18.7374 25.7035 18.7191 25.7662 18.7183C25.8015 18.7359 25.8368 18.7889 25.8898 18.7536C25.9428 18.7183 25.8545 18.7889 25.8898 18.7889L25.9428 18.8949C25.9075 18.9125 25.9251 18.9478 25.9251 18.9832C25.9251 19.0185 25.8722 19.0008 25.8898 19.0361H25.8722C25.8368 19.0538 25.8722 19.0715 25.8722 19.0891H25.8192C25.8192 19.1244 25.7485 19.1244 25.7309 19.1421C25.7132 19.1598 25.6602 19.1598 25.6426 19.1951C25.6249 19.2304 25.6779 19.1068 25.6249 19.0891C25.6249 19.0938 25.6231 19.0983 25.6197 19.1016C25.6164 19.1049 25.6119 19.1068 25.6073 19.1068C25.5719 19.0715 25.6426 19.0361 25.6073 19.0361L25.5366 19.0891C25.5719 18.9655 25.6249 18.9302 25.5896 18.8595Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M10.0308 24.2813L10.0484 24.2637V24.2813H10.0308Z"
            fill="white"
          />
          <path
            d="M10.0308 24.2989V24.2812H10.0484L10.0308 24.2989Z"
            fill="white"
          />
          <path
            d="M13.0154 24.7227V24.758C12.9977 24.7756 12.9977 24.7756 12.98 24.758C12.9624 24.7403 12.9624 24.7227 12.98 24.7227H13.0154Z"
            fill="#204063"
          />
          <path
            d="M13.1037 24.7755H13.086C13.0813 24.7755 13.0768 24.7736 13.0735 24.7703C13.0702 24.767 13.0684 24.7625 13.0684 24.7578C13.086 24.7401 13.1213 24.7578 13.1037 24.7755Z"
            fill="#204063"
          />
          <path
            d="M11.0201 21.1554C11.0201 21.1554 11.0024 21.1377 11.0201 21.1377V21.1554Z"
            fill="#204063"
          />
          <path
            d="M11.8324 23.575H11.8147C11.8139 23.5654 11.815 23.5558 11.8181 23.5466C11.8211 23.5375 11.826 23.5291 11.8324 23.522C11.8324 23.5396 11.85 23.5573 11.8324 23.575Z"
            fill="#204063"
          />
          <path
            d="M10.9845 21.3322C10.9845 21.3499 10.9669 21.3499 10.9492 21.3322V21.2969C10.9845 21.2969 10.9845 21.3145 10.9845 21.3322Z"
            fill="#204063"
          />
          <path
            d="M11.6382 20.3608C11.6558 20.3962 11.6912 20.4315 11.6735 20.4668C11.6558 20.5021 11.6558 20.4491 11.6558 20.4315C11.6558 20.4138 11.6558 20.3785 11.6382 20.3608Z"
            fill="#204063"
          />
          <path
            d="M12.044 25.9234H12.0616C12.097 25.9057 12.0793 25.9411 12.097 25.9411C12.097 25.9548 12.0938 25.9683 12.0876 25.9806C12.0815 25.9928 12.0726 26.0035 12.0616 26.0117H12.0087C12.0087 25.994 11.9557 26.0117 11.9733 25.9764V25.9234H12.0263H12.044Z"
            fill="#204063"
          />
          <path
            d="M11.6733 20.5904C11.6733 20.5904 11.691 20.6081 11.6733 20.6081V20.5727C11.6733 20.5551 11.6733 20.5727 11.6733 20.5904Z"
            fill="#204063"
          />
          <path
            d="M11.7791 20.6609C11.7728 20.6537 11.7679 20.6453 11.7649 20.6362C11.7618 20.6271 11.7607 20.6175 11.7615 20.6079L11.7791 20.6609Z"
            fill="#204063"
          />
          <path
            d="M11.7617 20.6431C11.7794 20.6431 11.7617 20.6431 11.7617 20.6255V20.6431Z"
            fill="white"
          />
          <path
            d="M12.4504 22.0912C12.4504 22.1089 12.4504 22.1265 12.4328 22.1265H12.3975C12.3986 22.1129 12.4049 22.1003 12.4151 22.0912C12.4328 22.0559 12.4328 22.0735 12.4504 22.0912Z"
            fill="#204063"
          />
          <path
            d="M12.2916 22.1265C12.2739 22.1441 12.2739 22.1441 12.2739 22.1265H12.2916Z"
            fill="#204063"
          />
          <path
            d="M11.9029 22.3033C11.8982 22.3033 11.8937 22.3014 11.8904 22.2981C11.8871 22.2948 11.8853 22.2903 11.8853 22.2856L11.9029 22.3033Z"
            fill="#204063"
          />
          <path
            d="M11.585 21.2789L11.5674 21.2612L11.585 21.2789Z"
            fill="#204063"
          />
          <path
            d="M11.5852 21.3851C11.5852 21.4028 11.5852 21.4204 11.5675 21.4204C11.5499 21.4204 11.5499 21.3674 11.5322 21.3498C11.5322 21.3498 11.5499 21.3321 11.5499 21.3498C11.5499 21.3674 11.5675 21.3321 11.5499 21.3145C11.5609 21.3227 11.5698 21.3333 11.5759 21.3456C11.582 21.3579 11.5852 21.3714 11.5852 21.3851Z"
            fill="#204063"
          />
          <path
            d="M12.2559 22.2681C12.2736 22.2857 12.2559 22.2857 12.2559 22.2857C12.2559 22.2857 12.2382 22.2681 12.2559 22.2681Z"
            fill="#204063"
          />
          <path
            d="M11.9737 22.4268H11.9561C11.9737 22.4092 11.9914 22.4092 11.9737 22.4268Z"
            fill="#204063"
          />
          <path
            d="M12.1324 22.4093H12.1148C12.1148 22.4093 12.0971 22.4093 12.1148 22.3916C12.1148 22.3963 12.1166 22.4008 12.12 22.4041C12.1233 22.4074 12.1278 22.4093 12.1324 22.4093Z"
            fill="#204063"
          />
          <path
            d="M12.0088 22.4444C11.9911 22.4444 12.0264 22.4797 11.9911 22.4797C11.9558 22.4797 11.9734 22.4444 11.9911 22.4268L12.0088 22.4444Z"
            fill="#204063"
          />
          <path
            d="M11.6912 21.5791V21.6144C11.6912 21.5968 11.6912 21.5968 11.7088 21.5968C11.7179 21.6434 11.7179 21.6914 11.7088 21.738H11.6558C11.6735 21.7027 11.6382 21.6851 11.6382 21.6674H11.6558C11.655 21.6578 11.6562 21.6482 11.6592 21.6391C11.6623 21.63 11.6671 21.6216 11.6735 21.6144L11.6912 21.5791Z"
            fill="#204063"
          />
          <path
            d="M11.5319 21.738C11.4966 21.7557 11.4966 21.7027 11.4966 21.6851H11.5142C11.5319 21.6851 11.5496 21.7027 11.5319 21.738Z"
            fill="#204063"
          />
          <path
            d="M11.5318 21.7203H11.5142V21.7026V21.7203H11.5318Z"
            fill="white"
          />
          <path
            d="M11.6911 24.387H11.6734C11.6381 24.3516 11.6734 24.2987 11.6734 24.2633V24.228C11.6967 24.2776 11.703 24.3335 11.6911 24.387Z"
            fill="#204063"
          />
          <path
            d="M11.5322 21.9325H11.5145C11.5145 21.9501 11.4969 21.9325 11.4969 21.9325C11.4882 21.9227 11.4834 21.9102 11.4834 21.8971C11.4834 21.8841 11.4882 21.8715 11.4969 21.8618C11.4792 21.8618 11.4969 21.8618 11.4969 21.8795C11.4969 21.8971 11.4969 21.8618 11.4969 21.8618C11.4969 21.8618 11.5322 21.9148 11.5322 21.9325Z"
            fill="#204063"
          />
          <path
            d="M11.4967 22.0033C11.5108 22.024 11.517 22.049 11.5144 22.0739H11.4967C11.4791 22.0739 11.4614 22.0562 11.4614 22.0209C11.4614 21.9856 11.4791 22.0033 11.4791 21.9856C11.4791 21.9679 11.4791 22.0209 11.4967 22.0033Z"
            fill="#204063"
          />
          <path
            d="M10.9318 22.3914H10.9141C10.8965 22.3914 10.8965 22.3561 10.8965 22.3561C10.8965 22.3561 10.8965 22.3385 10.8965 22.3208C10.9075 22.329 10.9164 22.3397 10.9225 22.352C10.9286 22.3642 10.9318 22.3777 10.9318 22.3914Z"
            fill="#204063"
          />
          <path
            d="M13.1393 22.2503C13.104 22.2503 13.104 22.215 13.104 22.1973C13.104 22.1797 13.1217 22.1267 13.104 22.0737H13.1217C13.1217 22.1091 13.1746 22.1797 13.1393 22.2503Z"
            fill="#204063"
          />
          <path
            d="M11.4259 22.8507H11.4082V22.8154H11.4259C11.4259 22.7977 11.4259 22.833 11.4259 22.8507Z"
            fill="#204063"
          />
          <path
            d="M11.4615 23.151C11.4792 23.151 11.4615 23.1333 11.4615 23.1333L11.4968 23.1863C11.4968 23.2039 11.4968 23.2039 11.4792 23.2216H11.4438C11.4438 23.2039 11.4615 23.1863 11.4438 23.1863V23.151H11.4615Z"
            fill="#204063"
          />
          <path
            d="M12.7681 22.5505H12.7505V22.5151L12.7681 22.5505Z"
            fill="#204063"
          />
          <path
            d="M11.9557 22.9922C11.9557 23.0275 11.991 23.0628 11.9733 23.0981H11.938C11.9204 23.0628 11.938 23.0452 11.938 23.0098L11.9557 22.9922Z"
            fill="#204063"
          />
          <path
            d="M11.3909 23.3804C11.3909 23.398 11.3909 23.4157 11.3732 23.4157C11.3556 23.4157 11.3556 23.4157 11.3556 23.4157C11.3509 23.4157 11.3464 23.4138 11.3431 23.4105C11.3398 23.4072 11.3379 23.4027 11.3379 23.398C11.3379 23.3933 11.3398 23.3889 11.3431 23.3855C11.3464 23.3822 11.3509 23.3804 11.3556 23.3804H11.3909Z"
            fill="#204063"
          />
          <path
            d="M12.4152 23.0451C12.4152 23.0627 12.4152 23.0804 12.3975 23.0804C12.3929 23.0804 12.3884 23.0785 12.3851 23.0752C12.3817 23.0719 12.3799 23.0674 12.3799 23.0627V23.0274C12.3975 23.0097 12.3975 23.0451 12.4152 23.0451Z"
            fill="#204063"
          />
          <path
            d="M11.3022 23.4338H11.3199C11.3022 23.4338 11.3022 23.4161 11.3199 23.3984C11.3246 23.4008 11.3282 23.4049 11.3298 23.4099C11.3315 23.4148 11.3311 23.4202 11.3287 23.4249C11.3264 23.4296 11.3223 23.4332 11.3173 23.4348C11.3124 23.4365 11.3069 23.4361 11.3022 23.4338Z"
            fill="#204063"
          />
          <path
            d="M13.1213 22.9745C13.1213 22.9922 13.1213 23.0099 13.1037 23.0099C13.086 23.0099 13.0684 23.0275 13.0684 23.0099C13.0684 22.9922 13.1037 22.9569 13.1213 22.9745Z"
            fill="#204063"
          />
          <path
            d="M12.8033 23.0627H12.821C12.821 23.098 12.8386 23.1333 12.821 23.1686C12.821 23.1733 12.8191 23.1778 12.8158 23.1811C12.8125 23.1844 12.808 23.1863 12.8033 23.1863C12.7986 23.1863 12.7941 23.1844 12.7908 23.1811C12.7875 23.1778 12.7856 23.1733 12.7856 23.1686V23.098H12.8033C12.8029 23.0733 12.809 23.0489 12.821 23.0273L12.8033 23.0627Z"
            fill="#204063"
          />
          <path
            d="M12.2384 23.2041H12.256C12.2647 23.2138 12.2695 23.2264 12.2695 23.2394C12.2695 23.2525 12.2647 23.265 12.256 23.2747H12.2207V23.2218H12.2384V23.2041Z"
            fill="#204063"
          />
          <path
            d="M10.9139 23.6453C10.9092 23.6453 10.9047 23.6434 10.9014 23.6401C10.8981 23.6368 10.8962 23.6323 10.8962 23.6276C10.8786 23.6276 10.9139 23.5923 10.8962 23.5923C10.8786 23.5923 10.9315 23.6276 10.9139 23.6453Z"
            fill="#204063"
          />
          <path
            d="M11.2143 25.2525H11.232C11.232 25.2525 11.1967 25.2878 11.232 25.2878C11.2673 25.2878 11.2143 25.3584 11.179 25.3761H11.1967C11.1967 25.4114 11.2143 25.4291 11.179 25.4467H11.1614C11.126 25.4114 11.2143 25.3761 11.1437 25.3408C11.0731 25.3055 11.1437 25.2701 11.1437 25.2525H11.1967C11.1967 25.2348 11.1967 25.2525 11.2143 25.2525Z"
            fill="#204063"
          />
          <path
            d="M11.32 23.6279C11.32 23.6456 11.32 23.6632 11.3024 23.6632H11.2847C11.267 23.6456 11.2847 23.6456 11.2847 23.6456H11.32V23.6279Z"
            fill="#204063"
          />
          <path
            d="M12.715 23.2925V23.3455H12.6973C12.6797 23.3455 12.6797 23.3101 12.6973 23.2925H12.715Z"
            fill="#204063"
          />
          <path
            d="M11.1788 23.8042H11.1965V23.8395H11.1611V23.8042H11.1788Z"
            fill="#204063"
          />
          <path
            d="M11.1787 23.8042V23.8219V23.8042H11.1964H11.1787Z"
            fill="white"
          />
          <path
            d="M11.2316 24.0514C11.2493 24.0514 11.2669 24.0691 11.2493 24.0868H11.2316C11.1963 24.0868 11.2139 24.0514 11.1963 24.0514C11.2139 24.0338 11.2139 24.0338 11.2139 24.0161C11.2093 24.0185 11.2057 24.0226 11.204 24.0275C11.2024 24.0325 11.2028 24.0379 11.2051 24.0426C11.2075 24.0473 11.2116 24.0508 11.2165 24.0525C11.2215 24.0542 11.2269 24.0538 11.2316 24.0514Z"
            fill="#204063"
          />
          <path
            d="M10.7725 24.0869C10.7725 24.1046 10.7902 24.1222 10.7725 24.1576V24.1222C10.7549 24.1046 10.7725 24.1046 10.7725 24.0869Z"
            fill="#204063"
          />
          <path
            d="M12.821 23.5923C12.821 23.6099 12.8386 23.6453 12.821 23.6629V23.6982L12.7856 23.6629V23.6276C12.8033 23.6453 12.7856 23.5923 12.8033 23.6099C12.8033 23.6099 12.8033 23.6099 12.821 23.5923Z"
            fill="#204063"
          />
          <path
            d="M11.0906 24.1221H11.1083C11.0906 24.1397 11.1083 24.175 11.0906 24.1927C11.073 24.2104 11.0553 24.175 11.0376 24.1574C11.02 24.1397 11.0376 24.1397 11.0376 24.1397H11.0906V24.1221Z"
            fill="#204063"
          />
          <path
            d="M12.3976 23.7337C12.3929 23.7337 12.3884 23.7319 12.3851 23.7286C12.3818 23.7252 12.3799 23.7207 12.3799 23.7161V23.6807C12.3623 23.6631 12.3799 23.6807 12.3799 23.6984C12.3976 23.6807 12.3976 23.6807 12.3976 23.6631C12.3976 23.6807 12.4152 23.7161 12.3976 23.7337Z"
            fill="#204063"
          />
          <path
            d="M12.2031 24.5461H12.2208V24.5107C12.2245 24.5141 12.2276 24.5181 12.2296 24.5227C12.2317 24.5273 12.2327 24.5322 12.2327 24.5372C12.2327 24.5422 12.2317 24.5472 12.2296 24.5518C12.2276 24.5563 12.2245 24.5604 12.2208 24.5637C12.217 24.5604 12.214 24.5563 12.212 24.5518C12.2099 24.5472 12.2088 24.5422 12.2088 24.5372C12.2088 24.5322 12.2099 24.5273 12.212 24.5227C12.214 24.5181 12.217 24.5141 12.2208 24.5107L12.2031 24.5461Z"
            fill="#204063"
          />
          <path
            d="M11.32 24.9876H11.3023C11.2847 25.0052 11.2847 24.9875 11.2847 24.9699C11.3023 24.9522 11.2847 24.9522 11.3023 24.9346H11.32C11.32 24.9522 11.3376 24.9699 11.32 24.9876Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.7759C11.9382 24.7935 11.9558 24.8289 11.9205 24.8289C11.8852 24.8289 11.9029 24.8289 11.9029 24.8112V24.7759H11.9205C11.9232 24.7774 11.9262 24.7782 11.9293 24.7782C11.9324 24.7782 11.9355 24.7774 11.9382 24.7759Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.8112H11.9205C11.9158 24.8112 11.9113 24.8093 11.908 24.806C11.9047 24.8027 11.9028 24.7982 11.9028 24.7935C11.9028 24.7889 11.9047 24.7844 11.908 24.781C11.9113 24.7777 11.9158 24.7759 11.9205 24.7759C11.9205 24.7935 11.9382 24.7759 11.9382 24.8112Z"
            fill="white"
          />
          <path
            d="M11.2496 24.8464C11.2496 24.864 11.2496 24.8464 11.2319 24.8464V24.811H11.2496C11.2496 24.8287 11.2673 24.8464 11.2496 24.8464Z"
            fill="#204063"
          />
          <path
            d="M12.0264 24.9172V24.8818C12.0264 24.8818 12.044 24.8995 12.0264 24.9172Z"
            fill="#204063"
          />
          <path
            d="M10.7373 26.2769H10.7726C10.7726 26.2769 10.755 26.2769 10.7726 26.2946C10.7773 26.2946 10.7818 26.2927 10.7851 26.2894C10.7884 26.2861 10.7903 26.2816 10.7903 26.2769C10.7903 26.2723 10.7884 26.2678 10.7851 26.2645C10.7818 26.2611 10.7773 26.2593 10.7726 26.2593C10.7903 26.2769 10.7726 26.3123 10.7903 26.3123H10.8079C10.8079 26.3476 10.8256 26.3476 10.8256 26.3652C10.8264 26.3748 10.8253 26.3844 10.8222 26.3935C10.8192 26.4027 10.8143 26.4111 10.8079 26.4182C10.8433 26.4006 10.8079 26.4535 10.8256 26.4535C10.8209 26.4535 10.8164 26.4554 10.8131 26.4587C10.8098 26.462 10.8079 26.4665 10.8079 26.4712L10.7373 26.5065H10.6843C10.6667 26.5065 10.649 26.4889 10.6667 26.4712H10.649C10.6517 26.4463 10.6454 26.4213 10.6313 26.4006H10.6667V26.3652C10.6843 26.3652 10.6667 26.3476 10.6843 26.3299C10.702 26.3123 10.702 26.3476 10.7196 26.3299C10.7174 26.3203 10.7178 26.3103 10.7209 26.3009C10.7241 26.2916 10.7297 26.2832 10.7373 26.2769Z"
            fill="#204063"
          />
          <path
            d="M11.9205 25.0582V25.0935C11.9028 25.1112 11.9028 25.0758 11.9028 25.0758C11.9028 25.0758 11.9028 25.0582 11.9028 25.0405L11.9205 25.0582Z"
            fill="#204063"
          />
          <path
            d="M11.8501 25.27H11.7971C11.7971 25.2877 11.7794 25.2877 11.7618 25.2877C11.7557 25.2658 11.7559 25.2427 11.7621 25.2209C11.7683 25.1991 11.7804 25.1794 11.7971 25.1641H11.8147C11.8249 25.1676 11.8341 25.1735 11.8417 25.1812C11.8493 25.1888 11.855 25.1982 11.8584 25.2084C11.8618 25.2186 11.8628 25.2295 11.8614 25.2402C11.8599 25.2509 11.8561 25.2611 11.8501 25.27Z"
            fill="#204063"
          />
          <path
            d="M11.1966 27.4601H11.2143V27.4954H11.2319C11.2143 27.5308 11.2319 27.5484 11.2143 27.5661C11.1966 27.5837 11.1966 27.6014 11.1966 27.6191H11.126C11.1249 27.6055 11.1185 27.5928 11.1083 27.5837H11.0553C11.02 27.5837 11.0377 27.5484 11.02 27.5308V27.4954C11.0377 27.5131 11.0377 27.4778 11.0553 27.4601H11.126V27.4248H11.1613C11.1613 27.4248 11.179 27.4778 11.1966 27.4601Z"
            fill="#204063"
          />
          <path
            d="M11.0731 25.7114C11.0731 25.7291 11.1084 25.7467 11.1084 25.7821L11.0731 25.835L11.0024 25.7997C11.0201 25.7821 11.0024 25.7467 11.0024 25.7467H11.0201C11.0201 25.7291 11.0201 25.7114 11.0378 25.7114H11.0731Z"
            fill="#204063"
          />
          <path
            d="M11.6029 25.5703H11.6205C11.6382 25.6056 11.5675 25.6056 11.6029 25.6409C11.6382 25.6762 11.5852 25.6939 11.5675 25.6939C11.5499 25.6939 11.5322 25.6586 11.5322 25.6409C11.5499 25.6586 11.5499 25.6233 11.5499 25.6233H11.5852C11.5782 25.6209 11.5724 25.6159 11.5691 25.6093C11.5657 25.6026 11.5652 25.595 11.5675 25.5879C11.5699 25.5809 11.5749 25.5751 11.5815 25.5718C11.5882 25.5685 11.5958 25.5679 11.6029 25.5703Z"
            fill="#204063"
          />
          <path
            d="M11.4083 26.3652V26.4006C11.3907 26.4182 11.4437 26.4182 11.4083 26.4535C11.373 26.4889 11.3907 26.4712 11.3907 26.4889H11.32V26.4535C11.3377 26.4535 11.3024 26.4359 11.32 26.4359V26.4006H11.373C11.3907 26.3476 11.3907 26.3829 11.4083 26.3652Z"
            fill="#204063"
          />
          <path
            d="M10.7019 26.7008C10.7019 26.7184 10.7019 26.7184 10.7196 26.7184C10.7372 26.7184 10.7019 26.7714 10.6842 26.7537H10.6489C10.6666 26.7361 10.6489 26.7361 10.6489 26.7184C10.6536 26.7184 10.6581 26.7166 10.6614 26.7133C10.6647 26.7099 10.6666 26.7054 10.6666 26.7008C10.6666 26.6961 10.6684 26.6916 10.6718 26.6883C10.6751 26.685 10.6796 26.6831 10.6842 26.6831L10.7019 26.7008Z"
            fill="#204063"
          />
          <path
            d="M10.6842 26.7007V26.7183H10.6665L10.6842 26.7007Z"
            fill="white"
          />
          <path
            d="M9.99577 26.5592C9.99577 26.5768 9.97811 26.5945 9.96045 26.5768V26.5415C9.97811 26.5238 10.0134 26.5415 9.99577 26.5592Z"
            fill="#204063"
          />
          <path
            d="M10.8784 27.2481C10.8784 27.2481 10.8784 27.2304 10.8961 27.2481H10.8784Z"
            fill="#204063"
          />
          <path
            d="M10.4903 26.8066C10.508 26.8066 10.4903 26.8243 10.4903 26.8243H10.4727C10.4727 26.8243 10.4903 26.8066 10.4903 26.8243V26.8066Z"
            fill="#204063"
          />
          <path
            d="M10.1899 27.0186H10.2252C10.2075 27.0186 10.2252 27.0362 10.2252 27.0362C10.2252 27.0715 10.2252 27.1069 10.1722 27.1245L10.1192 27.0892C10.1016 27.0715 10.1192 27.0539 10.1016 27.0362H10.1192C10.1016 27.0186 10.1192 27.0362 10.1192 27.0186H10.1899Z"
            fill="#204063"
          />
          <path
            d="M10.6135 27.2481H10.6489V27.2834C10.6665 27.3011 10.6312 27.3011 10.6312 27.3364H10.5429C10.5429 27.3188 10.5076 27.3541 10.5076 27.3188C10.4722 27.3364 10.4899 27.3011 10.4722 27.3011H10.4546C10.4593 27.3011 10.4638 27.2992 10.4671 27.2959C10.4704 27.2926 10.4722 27.2881 10.4722 27.2834C10.4722 27.2788 10.4704 27.2743 10.4671 27.271C10.4638 27.2676 10.4593 27.2658 10.4546 27.2658C10.4546 27.2481 10.4899 27.2481 10.4722 27.2305C10.4546 27.2128 10.5076 27.2305 10.4899 27.1951C10.5076 27.1951 10.5076 27.2128 10.5076 27.1951C10.5076 27.1775 10.5076 27.1951 10.5076 27.1775C10.5076 27.1598 10.5252 27.2128 10.5429 27.1951H10.5959C10.5782 27.2305 10.6135 27.2305 10.6135 27.2481Z"
            fill="#204063"
          />
          <path
            d="M10.066 27.5835L10.1014 27.6188C10.0837 27.6365 10.119 27.6365 10.1014 27.6541C10.0837 27.6718 10.119 27.6718 10.1014 27.6718H10.119C10.1014 27.6895 10.1014 27.7248 10.066 27.7424H9.96008C9.94242 27.7248 9.96008 27.7071 9.94242 27.7071C9.92476 27.7071 9.94242 27.6895 9.94242 27.6718C9.9471 27.6718 9.9516 27.6699 9.95491 27.6666C9.95822 27.6633 9.96008 27.6588 9.96008 27.6541C9.96008 27.6495 9.95822 27.645 9.95491 27.6416C9.9516 27.6383 9.9471 27.6365 9.94242 27.6365H9.96008C9.96008 27.6365 9.94242 27.6188 9.96008 27.6188H10.0307L10.066 27.5835Z"
            fill="#204063"
          />
          <path
            d="M10.9137 27.778H10.8961C10.8914 27.778 10.8869 27.7761 10.8836 27.7728C10.8803 27.7695 10.8784 27.765 10.8784 27.7603C10.8784 27.7557 10.8803 27.7512 10.8836 27.7478C10.8869 27.7445 10.8914 27.7427 10.8961 27.7427C10.9137 27.7603 10.9137 27.7603 10.9137 27.778Z"
            fill="#204063"
          />
          <path
            d="M11.3199 28.131C11.3022 28.131 11.3022 28.1134 11.3022 28.0957H11.3199C11.3199 28.0957 11.3376 28.131 11.3199 28.131Z"
            fill="#204063"
          />
          <path
            d="M10.6136 28.043H10.6313V28.0959C10.5959 28.0959 10.5959 28.1136 10.5606 28.0959H10.543C10.543 28.0783 10.5606 28.0606 10.543 28.0606H10.5606C10.543 28.0606 10.5606 28.0606 10.5606 28.043C10.5606 28.0477 10.5625 28.0521 10.5658 28.0555C10.5691 28.0588 10.5736 28.0606 10.5783 28.0606H10.6136V28.043Z"
            fill="#204063"
          />
          <path
            d="M10.5075 28.0604H10.5252C10.5075 28.0604 10.5252 28.078 10.5252 28.078H10.5075L10.4722 28.1134H10.4192C10.4192 28.078 10.3839 28.0957 10.3662 28.0604H10.3839C10.3662 28.0427 10.3839 28.0251 10.3839 28.0074H10.4015C10.4015 27.9897 10.4192 27.9897 10.4015 27.9897C10.3839 27.9897 10.4369 28.0074 10.4369 27.9897H10.4545C10.4898 28.0074 10.4898 28.0604 10.5075 28.0604Z"
            fill="#204063"
          />
          <path
            d="M10.2076 28.2192H10.2606C10.2606 28.2369 10.2429 28.2546 10.2606 28.2546H10.2783C10.2783 28.2722 10.2606 28.2899 10.2783 28.2899H10.2959C10.2959 28.2899 10.3136 28.2899 10.2959 28.3075H10.3489C10.3313 28.3252 10.3489 28.3252 10.3489 28.3252H10.3313C10.3489 28.3252 10.3313 28.3252 10.3313 28.3429H10.137C10.137 28.3075 10.1017 28.3252 10.1017 28.3252H10.0663V28.2899H10.031C10.031 28.2899 10.0663 28.2899 10.0487 28.2722C10.0487 28.2369 9.99571 28.2369 10.0134 28.2016C10.031 28.1663 10.031 28.2016 10.031 28.2016C10.031 28.2016 10.0134 28.1663 10.031 28.1663L10.0663 28.1309C10.0663 28.1309 10.0487 28.1133 10.0663 28.1133C10.0663 28.118 10.0682 28.1225 10.0715 28.1258C10.0748 28.1291 10.0793 28.1309 10.084 28.1309H10.1193C10.1193 28.1309 10.1193 28.1486 10.137 28.1309H10.2253L10.2076 28.2192Z"
            fill="#204063"
          />
          <path
            d="M11.4791 26.9302C11.4615 26.9478 11.4791 26.9655 11.4438 26.9655C11.4085 26.9655 11.4085 26.9478 11.4262 26.9302H11.4791Z"
            fill="#204063"
          />
          <path
            d="M11.4082 27.0539V27.0362H11.4259L11.4082 27.0186H11.4259L11.4082 27.0539Z"
            fill="#204063"
          />
          <path
            d="M11.4261 27.1065H11.4437V27.1418C11.4614 27.1595 11.4437 27.1948 11.4437 27.2125C11.4437 27.2301 11.3908 27.2301 11.3908 27.2655H11.3378C11.3201 27.2301 11.3201 27.2301 11.3025 27.2301C11.3025 27.2125 11.3201 27.1948 11.3025 27.1772C11.2848 27.1595 11.3201 27.1418 11.3025 27.1418C11.2848 27.1418 11.3378 27.1595 11.3554 27.1595C11.3731 27.1595 11.3378 27.1418 11.3554 27.1418C11.3731 27.1418 11.3731 27.1595 11.3731 27.1595V27.1065C11.3908 27.0712 11.3908 27.1065 11.4261 27.1065Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M19.7262 23.8751L19.6909 23.8574H19.7262V23.8751Z"
            fill="white"
          />
          <path
            d="M19.797 23.8751L19.7617 23.8927V23.8574L19.797 23.8751Z"
            fill="white"
          />
          <path
            d="M19.8323 17.0583L19.8853 17.0229C19.8977 17.0339 19.9073 17.0476 19.9134 17.0629C19.9196 17.0782 19.922 17.0948 19.9206 17.1112C19.903 17.1466 19.8677 17.1466 19.8323 17.1289C19.8237 17.1192 19.8188 17.1066 19.8188 17.0936C19.8188 17.0806 19.8237 17.068 19.8323 17.0583Z"
            fill="#204063"
          />
          <path
            d="M19.9028 16.8286C19.9205 16.8286 19.9205 16.8462 19.9205 16.8639L19.8675 16.8992C19.8322 16.8816 19.8498 16.7933 19.9028 16.8286Z"
            fill="#204063"
          />
          <path
            d="M11.9557 21.1026C11.9557 21.1203 11.938 21.1556 11.9204 21.1379H11.9027C11.9018 21.1313 11.9027 21.1246 11.9054 21.1185C11.9082 21.1125 11.9125 21.1073 11.9181 21.1036C11.9236 21.0999 11.9301 21.0978 11.9367 21.0977C11.9434 21.0975 11.9499 21.0992 11.9557 21.1026Z"
            fill="#204063"
          />
          <path
            d="M17.4145 19.8689L17.397 19.8711L17.3981 19.8799L17.4156 19.8777L17.4145 19.8689Z"
            fill="#204063"
          />
          <path
            d="M17.7133 19.9367C17.6779 19.972 17.6249 19.9367 17.6073 19.9013C17.5896 19.866 17.6779 19.9013 17.7133 19.9367Z"
            fill="#204063"
          />
          <path
            d="M12.4325 21.1909C12.4501 21.2262 12.4501 21.2616 12.4148 21.2616C12.3795 21.2616 12.3618 21.2439 12.3618 21.2262C12.3618 21.2086 12.4148 21.1909 12.4325 21.1909Z"
            fill="#204063"
          />
          <path
            d="M10.8962 19.0538H10.8785C10.9096 19.0393 10.9439 19.0333 10.978 19.0364C11.0121 19.0395 11.0448 19.0516 11.0728 19.0714C11.0728 19.1067 11.0374 19.0891 11.0021 19.1067L10.8608 19.0714L10.8962 19.0538Z"
            fill="#204063"
          />
          <path
            d="M22.7108 18.5594H22.6755L22.7108 18.5241C22.6755 18.4711 22.7638 18.4711 22.7638 18.4358C22.8135 18.4305 22.8636 18.443 22.905 18.4711C22.9404 18.5241 22.9227 18.5241 22.9404 18.577C22.958 18.63 22.958 18.683 22.8697 18.683C22.7814 18.683 22.8167 18.6653 22.7638 18.7007C22.7108 18.736 22.7461 18.6653 22.7284 18.6653H22.7108C22.7284 18.63 22.7108 18.6124 22.6755 18.5947C22.6401 18.577 22.6931 18.577 22.7108 18.5594Z"
            fill="#204063"
          />
          <path
            d="M11.3554 19.1597L11.4084 19.195C11.3907 19.2303 11.3377 19.2126 11.3201 19.2126H11.2671L11.3554 19.1597Z"
            fill="#204063"
          />
          <path
            d="M11.5498 19.0011H11.5675C11.5321 19.0187 11.4792 18.9834 11.4438 18.9834L11.5498 19.0011Z"
            fill="#204063"
          />
          <path
            d="M14.3048 19.6895C14.3224 19.7071 14.3224 19.7071 14.3224 19.7248H14.2871C14.2871 19.7248 14.2695 19.6895 14.3048 19.6895Z"
            fill="#204063"
          />
          <path
            d="M14.6578 18.8066H14.6931L14.6578 18.8596C14.6401 18.8596 14.6401 18.8243 14.6578 18.8066Z"
            fill="#204063"
          />
          <path
            d="M14.6579 18.312C14.6756 18.3297 14.7286 18.3297 14.7109 18.365C14.6933 18.4003 14.7109 18.4356 14.6756 18.4356C14.6403 18.4356 14.6403 18.4003 14.605 18.4003C14.5696 18.4003 14.6403 18.3473 14.6579 18.312Z"
            fill="#204063"
          />
          <path
            d="M14.6931 18.7007C14.6931 18.7007 14.7107 18.6831 14.7107 18.7007V18.736C14.6754 18.736 14.6578 18.7007 14.6931 18.7007Z"
            fill="#204063"
          />
          <path
            d="M14.958 19.6016H14.9933C14.9757 19.6192 14.9933 19.6369 14.9757 19.6545C14.958 19.6722 14.905 19.6192 14.958 19.6016Z"
            fill="#204063"
          />
          <path
            d="M12.6799 19.8662L12.627 19.8839L12.6446 19.8662H12.6799Z"
            fill="#204063"
          />
          <path
            d="M12.9096 19.9193C12.9273 19.9369 12.9802 19.9369 12.9626 19.9722C12.9449 20.0076 12.839 20.0076 12.8036 20.0076H12.786C12.8036 19.9899 12.786 19.9899 12.786 19.9722C12.786 19.9546 12.7683 19.9193 12.7153 19.9369C12.7773 19.9138 12.8444 19.9077 12.9096 19.9193Z"
            fill="#204063"
          />
          <path
            d="M14.9932 18.7891C15.0109 18.7891 15.0109 18.8067 15.0109 18.8244C15.0109 18.842 14.9932 18.842 14.9756 18.8244L14.9932 18.7891Z"
            fill="#204063"
          />
          <path
            d="M15.2227 19.478C15.2404 19.478 15.2404 19.4956 15.2404 19.5133H15.2051C15.1874 19.4956 15.2051 19.4603 15.2227 19.478Z"
            fill="#204063"
          />
          <path
            d="M15.2232 19.1421C15.2409 19.1421 15.2585 19.1774 15.2409 19.1774C15.2232 19.1774 15.2056 19.1951 15.2056 19.1774L15.2232 19.1421Z"
            fill="#204063"
          />
          <path
            d="M15.2759 19.4248C15.2936 19.4425 15.3642 19.4071 15.3466 19.4601C15.3289 19.5131 15.2936 19.4954 15.2583 19.4601C15.223 19.4248 15.2583 19.4248 15.2759 19.4248Z"
            fill="#204063"
          />
          <path
            d="M13.3687 19.7957C13.4041 19.7957 13.4217 19.7957 13.4217 19.7604V19.7251C13.51 19.7428 13.6336 19.7074 13.7043 19.7957C13.7749 19.884 13.7043 19.8487 13.6866 19.8664H13.5983C13.563 19.8311 13.4924 19.9017 13.4394 19.8664H13.4747L13.3511 19.8134L13.3687 19.7957Z"
            fill="#204063"
          />
          <path
            d="M13.6337 20.2193C13.6514 20.3076 13.5454 20.2723 13.5101 20.2723L13.4395 20.2369C13.4674 20.2171 13.5001 20.2051 13.5342 20.202C13.5683 20.1989 13.6027 20.2048 13.6337 20.2193Z"
            fill="#204063"
          />
          <path
            d="M13.5808 20.2373L13.5632 20.255L13.5278 20.2373L13.5632 20.255L13.5808 20.2373Z"
            fill="white"
          />
          <path
            d="M19.5499 20.131H19.5676C19.5146 20.2193 19.3733 20.184 19.285 20.1486H19.2144C19.2649 20.1195 19.3217 20.1027 19.38 20.0996C19.4383 20.0966 19.4965 20.1073 19.5499 20.131Z"
            fill="#204063"
          />
          <path
            d="M13.8102 20.3077L13.7749 20.29H13.8102V20.3077Z"
            fill="#204063"
          />
          <path
            d="M14.0397 20.3253H14.0927L14.0574 20.3783C14.0097 20.3905 13.9593 20.3842 13.9161 20.3606C13.8984 20.3783 13.9338 20.3606 13.9338 20.343H13.8984C13.9183 20.3278 13.9419 20.3182 13.9667 20.3151C13.9915 20.312 14.0167 20.3155 14.0397 20.3253Z"
            fill="#204063"
          />
          <path
            d="M14.0047 20.3606H13.987C13.9693 20.3959 13.987 20.3606 13.9693 20.3783C13.9517 20.3959 13.9693 20.3253 14.0047 20.3606Z"
            fill="white"
          />
          <path
            d="M14.1812 20.4311C14.2038 20.4144 14.2304 20.404 14.2583 20.4009C14.2862 20.3978 14.3145 20.4021 14.3402 20.4135C14.3578 20.4135 14.3755 20.4312 14.3578 20.4665C14.3147 20.49 14.2642 20.4963 14.2166 20.4841C14.2166 20.4488 14.1636 20.4665 14.1459 20.4665C14.1283 20.4665 14.2166 20.4665 14.1812 20.4311Z"
            fill="#204063"
          />
          <path
            d="M14.2339 20.4136L14.2515 20.4312H14.2339V20.4136Z"
            fill="white"
          />
          <path
            d="M14.8519 21.8441C14.8696 21.8441 14.8519 21.8617 14.8519 21.8617C14.8519 21.8617 14.7813 21.8971 14.7459 21.8971C14.7106 21.8971 14.7106 21.9147 14.6753 21.8794C14.7287 21.8487 14.7907 21.8363 14.8519 21.8441Z"
            fill="#204063"
          />
          <path
            d="M15.0817 16.8286C15.117 16.8992 15.0287 16.8992 15.0111 16.9169C14.9934 16.9345 14.8521 16.8462 14.7815 16.8462H14.7285C14.8345 16.8462 14.9934 16.7226 15.0817 16.8286Z"
            fill="#204063"
          />
          <path
            d="M16.0527 20.8022C16.0704 20.8022 16.0881 20.8022 16.0881 20.8199C16.0881 20.8376 16.1057 20.8552 16.0704 20.8729H15.9468C15.9644 20.8022 16.0174 20.8022 16.0527 20.8022Z"
            fill="#204063"
          />
          <path
            d="M15.4172 20.873L15.3818 20.8907V20.873H15.4172Z"
            fill="white"
          />
          <path
            d="M16.7418 20.7668H16.7241C16.7594 20.7315 16.7948 20.7315 16.8477 20.7139C16.8631 20.7157 16.8778 20.7216 16.8902 20.7309C16.9026 20.7402 16.9123 20.7526 16.9184 20.7668C16.936 20.8022 16.9007 20.8022 16.8831 20.8375C16.8654 20.8728 16.8124 20.8022 16.7771 20.8375H16.7948L16.7241 20.8022L16.7418 20.7668Z"
            fill="#204063"
          />
          <path
            d="M15.5939 17.5704L15.5586 17.5527H15.5939V17.5704Z"
            fill="#204063"
          />
          <path
            d="M15.647 17.7471H15.6823C15.7 17.7647 15.7176 17.7647 15.7176 17.8001H15.647V17.7471Z"
            fill="#204063"
          />
          <path
            d="M16.4414 19.6544C16.512 19.6544 16.6003 19.5661 16.671 19.6368C16.6737 19.6437 16.675 19.6511 16.6747 19.6586C16.6743 19.666 16.6725 19.6733 16.6691 19.68C16.6658 19.6867 16.6611 19.6925 16.6553 19.6973C16.6496 19.702 16.6429 19.7054 16.6357 19.7074C16.565 19.7251 16.512 19.6721 16.4414 19.6544Z"
            fill="#204063"
          />
          <path
            d="M17.2891 20.9434C17.3245 20.9434 17.3774 20.9257 17.3951 20.961C17.4128 20.9964 17.3598 21.014 17.3598 21.0317H17.2715C17.2715 21.014 17.2891 20.9964 17.2715 20.9964C17.2538 20.9964 17.2715 20.9787 17.2891 20.9434Z"
            fill="#204063"
          />
          <path
            d="M16.6006 18.6124C16.6146 18.6106 16.6288 18.613 16.6414 18.6193C16.6539 18.6256 16.6644 18.6355 16.6713 18.6477C16.6713 18.6654 16.6536 18.683 16.636 18.7007H16.5477C16.53 18.6301 16.5653 18.6301 16.6006 18.6124Z"
            fill="#204063"
          />
          <path
            d="M17.4304 21.1203C17.4481 21.1026 17.4127 21.085 17.4304 21.085V21.1203Z"
            fill="#204063"
          />
          <path
            d="M16.4594 17.0229C16.4947 17.0053 16.5124 17.0229 16.5477 17.0406C16.583 17.0583 16.5477 17.1112 16.5124 17.1112C16.4771 17.1112 16.4241 17.0583 16.4594 17.0229Z"
            fill="#204063"
          />
          <path
            d="M16.6359 17.7296C16.6359 17.7119 16.6359 17.7119 16.6182 17.7119C16.6006 17.7119 16.6536 17.6942 16.6712 17.7119C16.6889 17.7296 16.8125 17.6413 16.8831 17.7119C16.9538 17.7825 16.8831 17.7649 16.8655 17.7825H16.7419C16.6901 17.7813 16.6404 17.7626 16.6006 17.7296H16.6359Z"
            fill="#204063"
          />
          <path
            d="M16.9005 19.0007C16.9005 19.0184 16.9181 19.0184 16.9181 19.0361C16.9214 19.0398 16.9255 19.0428 16.9301 19.0449C16.9347 19.0469 16.9396 19.048 16.9446 19.048C16.9496 19.048 16.9546 19.0469 16.9592 19.0449C16.9637 19.0428 16.9678 19.0398 16.9711 19.0361C16.9181 19.0361 16.9535 18.9831 16.9181 18.9654C16.8828 18.9478 17.0241 18.9301 17.0594 18.9831C17.0594 18.9968 17.0562 19.0103 17.0501 19.0226C17.044 19.0348 17.0351 19.0455 17.0241 19.0537C16.9888 19.0361 16.9711 19.0537 16.9358 19.0714H16.9005C16.9181 19.0537 16.9005 19.0537 16.9181 19.0361H16.8828C16.8828 19.0007 16.9005 19.0184 16.9005 19.0007Z"
            fill="#204063"
          />
          <path
            d="M17.9249 21.9856C17.9602 22.0033 17.9249 22.0386 17.9072 22.0386C17.8896 22.0386 17.8189 22.0209 17.7836 22.0563C17.7483 22.0916 17.8719 21.968 17.9249 21.9856Z"
            fill="#204063"
          />
          <path
            d="M16.9537 19.001C16.9714 19.001 16.936 19.0186 16.936 19.0186H16.9537V19.001Z"
            fill="white"
          />
          <path
            d="M16.9712 18.9831C16.9712 18.9654 16.9889 18.9654 16.9712 18.9478V18.9831Z"
            fill="white"
          />
          <path
            d="M21.7748 20.8197L21.7395 20.7843C21.7395 20.7667 21.8631 20.8197 21.8101 20.7314C21.7572 20.6431 22.0044 20.7314 22.075 20.802H22.0927L22.0574 20.7667C22.1104 20.7667 22.181 20.7137 22.234 20.7314C22.287 20.749 22.2693 20.7667 22.2516 20.7843C22.234 20.802 22.0221 20.749 21.9867 20.908C21.9514 21.0669 21.8455 20.9609 21.7925 20.9433L21.7395 20.9786C21.7925 20.9609 21.7395 20.9256 21.7395 20.908L21.6865 20.8726C21.7042 20.855 21.7572 20.855 21.7748 20.8197Z"
            fill="#204063"
          />
          <path
            d="M17.872 21.085C17.9073 21.1026 17.9603 21.0673 17.9779 21.1203C17.9956 21.1733 17.9249 21.1556 17.9073 21.1909C17.8896 21.2262 17.8896 21.1556 17.8543 21.1733H17.872C17.8543 21.1556 17.8366 21.085 17.872 21.085Z"
            fill="#204063"
          />
          <path
            d="M17.0951 17.9589C17.1304 17.9236 17.1481 17.9236 17.1834 17.9413C17.2187 17.9589 17.2187 17.9589 17.2011 17.9766C17.1834 17.9943 17.1304 17.9943 17.0951 17.9943C17.0598 17.9943 17.0774 17.9589 17.0951 17.9589Z"
            fill="#204063"
          />
          <path d="M17.13 17.959L17.0947 17.9766V17.959H17.13Z" fill="white" />
          <path
            d="M18.2959 21.4026C18.2783 21.4026 18.2959 21.3673 18.2959 21.3673C18.2959 21.3673 18.3489 21.3319 18.3666 21.3673C18.3842 21.4026 18.3489 21.4026 18.3489 21.4202L18.2959 21.4026Z"
            fill="#204063"
          />
          <path
            d="M18.3136 21.3848H18.3312V21.4025L18.2959 21.3848L18.3136 21.3672V21.3848Z"
            fill="white"
          />
          <path
            d="M18.8784 21.2261C18.8961 21.1908 18.9314 21.1555 18.9667 21.1732C18.9821 21.175 18.9968 21.1809 19.0092 21.1902C19.0216 21.1995 19.0313 21.2119 19.0374 21.2261C19.0374 21.2791 18.9667 21.2791 18.9314 21.2968C18.9138 21.2615 18.8961 21.2791 18.8608 21.2615C18.8255 21.2438 18.8784 21.2261 18.8784 21.2261Z"
            fill="#204063"
          />
          <path
            d="M19.0905 22.2856C19.0905 22.2809 19.0886 22.2764 19.0853 22.2731C19.082 22.2698 19.0775 22.2679 19.0728 22.2679H19.0552C19.1082 22.2502 19.1611 22.1973 19.2318 22.2326C19.3024 22.2679 19.2141 22.3032 19.1788 22.3032C19.1435 22.3032 19.0905 22.3032 19.0552 22.3032L19.0905 22.2856Z"
            fill="#204063"
          />
          <path
            d="M17.6954 17.7116L17.8014 17.6763C17.8367 17.6763 17.8543 17.6939 17.872 17.7292C17.8734 17.7457 17.8709 17.7623 17.8648 17.7776C17.8587 17.7929 17.849 17.8066 17.8367 17.8175C17.8014 17.8175 17.7837 17.7999 17.7484 17.8352C17.7131 17.8705 17.6777 17.8175 17.7131 17.7646H17.6777C17.6954 17.7646 17.6954 17.7292 17.6954 17.7116Z"
            fill="#204063"
          />
          <path
            d="M19.0905 21.5262C19.1435 21.5438 19.2141 21.4732 19.2494 21.5438C19.2848 21.6145 19.2141 21.6145 19.1788 21.6498C19.1435 21.6851 19.1435 21.6498 19.1258 21.6498H19.1435C19.0905 21.6498 19.1258 21.6321 19.0905 21.6321H19.0552C19.0905 21.5615 19.0552 21.5262 19.0905 21.5262Z"
            fill="#204063"
          />
          <path
            d="M18.0134 18.6652L17.9781 18.7005H17.9251C17.9251 18.7358 17.9605 18.7182 17.9605 18.7182V18.6829C17.9251 18.6475 17.9075 18.6829 17.8898 18.6829H17.8545C17.9075 18.6475 17.9781 18.6122 18.0134 18.6652Z"
            fill="#204063"
          />
          <path
            d="M19.6734 20.8023C19.6734 20.807 19.6752 20.8115 19.6785 20.8148C19.6819 20.8181 19.6864 20.82 19.691 20.82H19.6734V20.7847C19.6557 20.82 19.6734 20.8023 19.6734 20.8023Z"
            fill="#204063"
          />
          <path
            d="M19.7438 18.9125C19.7615 18.8949 19.7438 18.9125 19.7438 18.9302H19.7791C19.7968 18.9302 19.7791 18.9125 19.7791 18.8949L19.7262 18.9302C19.7398 18.9164 19.7565 18.906 19.7749 18.8999C19.7933 18.8938 19.8129 18.892 19.8321 18.8949V18.9302C19.816 18.9459 19.7954 18.956 19.7732 18.9592C19.751 18.9624 19.7283 18.9584 19.7085 18.9479L19.7438 18.9125Z"
            fill="#204063"
          />
          <path
            d="M19.797 18.9479L19.7793 18.9303L19.797 18.9126V18.9479Z"
            fill="white"
          />
          <path
            d="M21.0861 20.6963C21.1214 20.6963 21.1214 20.7316 21.1038 20.7669L21.0508 20.8022C21.0508 20.8022 21.0508 20.7493 21.0155 20.7669C20.9801 20.7846 21.0155 20.8022 20.9801 20.8199H20.9448C20.9752 20.7628 21.0255 20.7189 21.0861 20.6963Z"
            fill="#204063"
          />
          <path
            d="M20.3442 19.4249C20.3972 19.4249 20.4325 19.3896 20.4855 19.4249C20.486 19.4409 20.4811 19.4567 20.4714 19.4695C20.4618 19.4823 20.4481 19.4915 20.4325 19.4955H20.3619V19.4602H20.3442C20.3442 19.4602 20.3619 19.4425 20.3442 19.4249Z"
            fill="#204063"
          />
          <path
            d="M20.4153 19.4248H20.3976C20.4027 19.4266 20.4073 19.4295 20.4111 19.4334C20.4149 19.4372 20.4177 19.4419 20.4194 19.447C20.4211 19.4521 20.4217 19.4575 20.4209 19.4629C20.4202 19.4682 20.4183 19.4733 20.4153 19.4778C20.4153 19.5131 20.3623 19.4954 20.3623 19.4954C20.3623 19.4954 20.3623 19.4425 20.4153 19.4248Z"
            fill="white"
          />
          <path
            d="M20.8036 20.9259V20.9613L20.7329 20.9966L20.7682 20.9613V20.9259C20.7682 20.9436 20.7506 20.9613 20.7329 20.9436C20.742 20.9345 20.7533 20.9281 20.7658 20.925C20.7782 20.9218 20.7913 20.9222 20.8036 20.9259Z"
            fill="#204063"
          />
          <path
            d="M20.5918 19.1597H20.6095L20.5741 19.195H20.4858L20.5918 19.1597Z"
            fill="#204063"
          />
          <path
            d="M24.477 21.0673C24.477 21.0143 24.424 21.0496 24.4063 21.0496C24.3887 21.0496 24.4593 21.0496 24.4593 21.0143H24.3887C24.424 20.979 24.4946 20.9967 24.5123 20.9437C24.53 20.8907 24.477 20.926 24.4946 20.9084C24.5123 20.8907 24.5476 20.8554 24.6006 20.8377H24.7066C24.6712 20.7847 24.7772 20.8201 24.7595 20.7671C24.7419 20.7141 24.8302 20.8201 24.8478 20.7847C24.8655 20.7494 24.9715 20.8554 24.9715 20.926C24.9715 20.9967 24.9715 20.9613 24.9715 21.0143C24.9715 21.032 24.9538 21.0496 24.9715 21.0673C24.9891 21.085 24.9185 21.085 24.9185 21.1026C24.9185 21.1203 24.9008 21.1733 24.8832 21.1733C24.8655 21.1733 24.8655 21.1733 24.8655 21.1909H24.8478C24.7772 21.2262 24.7242 21.2262 24.6712 21.2969L24.6359 21.3499C24.6359 21.3145 24.6712 21.2969 24.6359 21.2616H24.6006C24.5829 21.2439 24.5476 21.2969 24.5123 21.2792C24.477 21.2616 24.5123 21.2086 24.477 21.1909H24.4063C24.4227 21.2003 24.4422 21.2028 24.4604 21.1978C24.4786 21.1928 24.4941 21.1808 24.5035 21.1644C24.5128 21.148 24.5153 21.1286 24.5103 21.1104C24.5054 21.0922 24.4934 21.0767 24.477 21.0673Z"
            fill="#204063"
          />
          <path
            d="M20.9623 19.3542C20.9446 19.3542 20.9446 19.3542 20.9446 19.3718H20.9976V19.3365C20.98 19.3188 20.9623 19.3542 20.9623 19.3365C20.9623 19.3188 21.0153 19.3188 21.0329 19.3188C21.0506 19.3188 21.0153 19.3718 20.98 19.3718C20.9446 19.3718 20.927 19.3542 20.9093 19.3542C20.8917 19.3542 20.9446 19.3365 20.9623 19.3542Z"
            fill="#204063"
          />
          <path
            d="M21.4393 19.3896C21.4746 19.4073 21.5099 19.4426 21.5099 19.4603C21.5099 19.4779 21.5099 19.4956 21.4923 19.4956C21.4746 19.4956 21.5806 19.5309 21.5629 19.5662C21.5453 19.6016 21.351 19.5662 21.2804 19.5486V19.5133H21.2627C21.2766 19.4775 21.3008 19.4467 21.3323 19.4247C21.3637 19.4027 21.4009 19.3905 21.4393 19.3896Z"
            fill="#204063"
          />
          <path
            d="M26.5431 18.948H26.5255C26.5608 18.9303 26.5608 18.9127 26.5785 18.895H26.5431C26.5431 18.8774 26.5961 18.8774 26.5608 18.8597C26.6314 18.8597 26.6314 18.8067 26.6844 18.8067C26.7374 18.8067 26.7904 18.7891 26.8257 18.7891C26.861 18.7891 26.861 18.8067 26.8787 18.8244V18.948L26.8257 19.0186C26.861 19.0363 26.914 19.054 26.9317 19.0893C26.9493 19.1246 26.8963 19.1599 26.8787 19.2129L26.7904 19.2482C26.808 19.1952 26.7197 19.2129 26.6844 19.2129H26.6668C26.6844 19.1952 26.7021 19.1952 26.7021 19.1776H26.6668C26.6668 19.1599 26.6844 19.1599 26.6844 19.1423H26.6668C26.6844 19.1599 26.6844 19.1423 26.6844 19.1246H26.7021C26.6668 19.1246 26.6491 19.1246 26.6491 19.0893H26.5608V19.054H26.5078C26.5255 18.9833 26.5961 18.9657 26.5431 18.948Z"
            fill="#204063"
          />
          <path
            d="M22.9054 20.855H22.8877C22.923 20.8197 22.9407 20.749 23.029 20.749C23.1173 20.749 23.0996 20.749 23.1526 20.7667C23.2056 20.7843 23.1526 20.8726 23.1173 20.9256C23.082 20.9786 23.029 20.9786 22.976 20.9786H22.8877C22.9054 20.908 22.8877 20.8726 22.9054 20.855Z"
            fill="#204063"
          />
          <path
            d="M21.9867 19.7603C21.9867 19.7427 21.969 19.725 21.9514 19.7427C21.9337 19.7603 21.9867 19.7427 21.9867 19.7603Z"
            fill="#204063"
          />
          <path
            d="M22.2515 19.7603H22.2339C22.2339 19.7603 22.2692 19.7427 22.2515 19.725C22.2339 19.7074 22.3752 19.8133 22.4281 19.725C22.4811 19.6367 22.5341 19.725 22.5694 19.778C22.5684 19.8004 22.5612 19.8221 22.5488 19.8408C22.5363 19.8594 22.5191 19.8744 22.4988 19.884L22.4281 19.9193C22.4281 19.9146 22.4263 19.9101 22.423 19.9068C22.4197 19.9035 22.4152 19.9016 22.4105 19.9016H22.3752C22.3928 19.8663 22.3398 19.9016 22.3222 19.8663C22.3222 19.831 22.2692 19.8486 22.2515 19.831H22.2339C22.2162 19.778 22.2339 19.778 22.2515 19.7603Z"
            fill="#204063"
          />
          <path
            d="M24.1059 19.6192C24.0883 19.6016 24.1413 19.6016 24.1059 19.5839C24.0706 19.5663 24.1413 19.5486 24.1589 19.5309H24.1413C24.1942 19.5486 24.1766 19.4426 24.2649 19.478C24.3532 19.5133 24.3355 19.5133 24.3532 19.4956C24.3708 19.478 24.4238 19.5663 24.4062 19.6192C24.3885 19.6722 24.3885 19.6369 24.3532 19.6899V19.7252C24.3355 19.6722 24.3179 19.7782 24.2825 19.7252L24.2296 19.7605V19.7252H24.1413V19.6899H24.1059C24.0883 19.6369 24.1589 19.6369 24.1059 19.6192Z"
            fill="#204063"
          />
          <path
            d="M24.2297 19.9194L24.1768 19.9371H24.2121L24.2297 19.9194Z"
            fill="white"
          />
          <path
            d="M25.5186 20.7491C25.5363 20.7491 25.5363 20.7314 25.5363 20.7137C25.5363 20.6961 25.6423 20.6961 25.6599 20.7314V20.802C25.6246 20.7844 25.6069 20.8197 25.5893 20.8374C25.5716 20.855 25.554 20.8374 25.554 20.8374H25.501C25.5186 20.7844 25.5363 20.7667 25.5186 20.7491Z"
            fill="#204063"
          />
          <path
            d="M25.5366 20.7847L25.5719 20.7671V20.7847H25.5366Z"
            fill="white"
          />
          <path
            d="M25.9602 22.3034C25.9955 22.2858 26.0485 22.3211 26.0132 22.3741C25.9778 22.427 25.9778 22.4094 25.9425 22.3917C25.9072 22.3741 25.8895 22.3034 25.9602 22.3034Z"
            fill="#204063"
          />
          <path
            d="M26.3311 19.9015V19.8662H26.4194C26.4371 19.8839 26.4371 19.9015 26.4194 19.9369H26.3841L26.3135 19.9015H26.3311Z"
            fill="#204063"
          />
          <path
            d="M26.4899 19.7778C26.4899 19.7955 26.4899 19.8132 26.4722 19.8132C26.4676 19.8132 26.4631 19.8113 26.4598 19.808C26.4564 19.8047 26.4546 19.8002 26.4546 19.7955L26.4899 19.7778Z"
            fill="#204063"
          />
          <path
            d="M25.9604 21.0495C25.9687 21.0385 25.9793 21.0296 25.9916 21.0235C26.0039 21.0174 26.0174 21.0142 26.0311 21.0142C26.0311 21.0318 26.0487 21.0318 26.0311 21.0495L25.9781 21.0848C25.9781 21.0848 25.9428 21.0671 25.9781 21.0495H25.9604Z"
            fill="#204063"
          />
          <path
            d="M25.9957 21.0494H26.0133C26.031 21.0317 25.978 21.0847 25.978 21.0494C25.978 21.0141 25.9957 21.0494 25.9957 21.0494Z"
            fill="white"
          />
          <path
            d="M26.8079 21.4029H26.7726C26.8079 21.4029 26.8079 21.3852 26.8256 21.3675C26.8433 21.3499 26.8256 21.3499 26.8079 21.3499C26.7903 21.3499 26.8433 21.3322 26.8609 21.3146H26.8433C26.9139 21.3146 27.0375 21.2439 27.1082 21.3499V21.4558H27.0905C27.0905 21.5088 27.0375 21.5265 27.0199 21.5618H26.9845C26.9669 21.5795 26.9669 21.5441 26.9492 21.5618L26.8962 21.5971V21.5618C26.8786 21.5441 26.8609 21.5618 26.8609 21.5795C26.8609 21.5971 26.8256 21.5265 26.7903 21.5088H26.7373C26.7726 21.4205 26.8256 21.4382 26.8079 21.4029Z"
            fill="#204063"
          />
          <path
            d="M26.7903 20.3254V20.29H26.7726C26.755 20.3077 26.7903 20.29 26.8079 20.3077C26.8256 20.3254 26.8079 20.2547 26.8433 20.2547C26.8786 20.2547 26.8256 20.2371 26.8079 20.2194C26.7903 20.2017 26.8609 20.2371 26.8962 20.2194C26.9316 20.2017 26.9845 20.2194 27.0199 20.1841H27.0728L27.1611 20.2547L27.1965 20.29C27.1965 20.29 27.1965 20.3077 27.2318 20.3254C27.2671 20.343 27.2848 20.3607 27.2318 20.3783C27.1788 20.396 27.2494 20.4137 27.2671 20.4137H27.2141C27.2671 20.449 27.1788 20.4666 27.2141 20.5196L27.1788 20.5549C27.1435 20.5373 27.1258 20.5903 27.1082 20.6079C27.0905 20.6256 27.0199 20.5549 27.0022 20.6256C26.9845 20.6962 26.9492 20.5549 26.9139 20.6079H26.8962C26.8786 20.5903 26.9316 20.5726 26.8962 20.5549C26.8609 20.5373 26.8786 20.5726 26.8609 20.5903C26.8433 20.6079 26.8962 20.5196 26.8433 20.5196H26.7903C26.8079 20.502 26.8079 20.4843 26.8079 20.449C26.8079 20.4137 26.7726 20.4843 26.7726 20.449C26.7726 20.4137 26.8079 20.4313 26.7903 20.4137H26.7373C26.7903 20.396 26.7726 20.343 26.7903 20.3254Z"
            fill="#204063"
          />
          <path
            d="M28.2384 20.9434C28.2384 20.9081 28.2737 20.8728 28.256 20.8375C28.2384 20.8022 28.2737 20.7492 28.3267 20.7668C28.3797 20.7845 28.3267 20.7139 28.3797 20.7315C28.4326 20.7315 28.4856 20.6962 28.5563 20.7315C28.6269 20.7668 28.5916 20.7845 28.6269 20.7668H28.6092C28.6269 20.7845 28.6799 20.8022 28.6622 20.8375V20.8728C28.6403 20.9039 28.628 20.9407 28.6269 20.9788C28.6092 20.9964 28.5739 20.9964 28.5916 21.0317C28.6092 21.0671 28.5563 21.0671 28.5386 21.0847H28.4856C28.4621 21.0847 28.4444 21.1024 28.4326 21.1377C28.4326 21.12 28.415 21.12 28.4326 21.1024C28.4503 21.0847 28.3973 21.12 28.3797 21.12H28.362C28.3443 21.1024 28.309 21.1377 28.2914 21.1377C28.2737 21.1377 28.309 21.1024 28.2914 21.0847H28.256V21.0317C28.2207 21.0141 28.2207 21.0671 28.2031 21.0494C28.1854 21.0317 28.2207 20.9788 28.2384 20.9434Z"
            fill="#204063"
          />
          <path
            d="M27.4967 19.1245C27.4967 19.1422 27.5144 19.1422 27.5144 19.1598C27.5144 19.1775 27.4614 19.1775 27.4614 19.1598C27.4614 19.1422 27.4614 19.1245 27.4967 19.1245Z"
            fill="#204063"
          />
          <path
            d="M27.638 17.8706H27.6733C27.691 17.8883 27.6557 17.9059 27.638 17.9236C27.6204 17.9412 27.638 17.9059 27.6027 17.8883C27.5674 17.8706 27.6204 17.8883 27.638 17.8706Z"
            fill="#204063"
          />
          <path
            d="M28.4681 20.3608H28.5211L28.4857 20.4138H28.4681C28.4504 20.3962 28.5034 20.3785 28.4681 20.3608V20.3962C28.4651 20.3846 28.4651 20.3724 28.4681 20.3608Z"
            fill="#204063"
          />
          <path
            d="M28.3796 19.3189C28.3788 19.3094 28.38 19.2997 28.383 19.2906C28.3861 19.2815 28.3909 19.2731 28.3973 19.2659C28.4091 19.249 28.425 19.2352 28.4435 19.2259C28.462 19.2167 28.4826 19.2122 28.5033 19.213C28.5562 19.2483 28.5916 19.2483 28.5916 19.3013C28.5916 19.3542 28.5562 19.3366 28.6092 19.3542C28.6622 19.3719 28.5562 19.3719 28.5739 19.4072C28.5916 19.4425 28.5386 19.4072 28.5209 19.4072H28.5033C28.4856 19.4425 28.4679 19.4072 28.4326 19.4249H28.4503C28.4503 19.4202 28.4484 19.4157 28.4451 19.4124C28.4418 19.4091 28.4373 19.4072 28.4326 19.4072C28.4279 19.4072 28.4235 19.4091 28.4201 19.4124C28.4168 19.4157 28.415 19.4202 28.415 19.4249L28.3796 19.3896V19.3189Z"
            fill="#204063"
          />
          <path
            d="M28.5562 19.478C28.5562 19.4603 28.6091 19.478 28.6091 19.4427H28.6445C28.6621 19.4427 28.6445 19.425 28.6621 19.4074H28.7328C28.7681 19.372 28.7857 19.4427 28.8211 19.4427C28.8564 19.4427 28.8387 19.4956 28.8917 19.4956C28.9447 19.4956 28.927 19.5839 28.874 19.6546H28.8564C28.8387 19.6722 28.8564 19.6899 28.8564 19.7076H28.8211C28.8211 19.7605 28.7504 19.7429 28.7328 19.7605C28.7151 19.7782 28.6974 19.7605 28.6974 19.7429H28.6798V19.6899C28.6621 19.7076 28.6445 19.6899 28.6445 19.7252C28.6445 19.7605 28.6268 19.6369 28.5915 19.6546C28.5962 19.6546 28.6006 19.6527 28.604 19.6494C28.6073 19.6461 28.6091 19.6416 28.6091 19.6369C28.6091 19.6322 28.6073 19.6278 28.604 19.6244C28.6006 19.6211 28.5962 19.6193 28.5915 19.6193C28.5208 19.5839 28.6091 19.5133 28.5562 19.478Z"
            fill="#204063"
          />
          <path
            d="M29.3158 19.7603C29.3334 19.7426 29.2981 19.725 29.2804 19.725C29.2628 19.725 29.2981 19.7073 29.2981 19.6897H29.2628C29.2628 19.672 29.3158 19.6897 29.2981 19.6543C29.3121 19.6543 29.3256 19.6487 29.3356 19.6388C29.3455 19.6289 29.3511 19.6154 29.3511 19.6014V19.5131C29.3864 19.5131 29.3334 19.4601 29.3864 19.4777C29.3773 19.437 29.3773 19.3948 29.3864 19.3541C29.4041 19.3541 29.3864 19.3365 29.4041 19.3188H29.4394C29.4217 19.2658 29.457 19.3188 29.457 19.2835C29.457 19.2482 29.51 19.3188 29.5453 19.3011C29.5807 19.2835 29.5807 19.3365 29.5807 19.3718C29.5807 19.4071 29.563 19.3188 29.5983 19.3011C29.6336 19.2835 29.5983 19.3718 29.6513 19.3718H29.669C29.6866 19.3718 29.6866 19.4248 29.7219 19.3894V19.4248H29.7396C29.7573 19.4424 29.7396 19.4601 29.7573 19.4601H29.7749L29.8102 19.5131H29.8279V19.566C29.8632 19.566 29.8279 19.619 29.8632 19.619C29.8985 19.619 29.8985 19.672 29.9162 19.672C29.9339 19.672 29.8809 19.672 29.8809 19.6897C29.8809 19.7073 29.9162 19.7073 29.9339 19.725H29.8985C29.8809 19.7426 29.8985 19.7603 29.9162 19.7779C29.9162 19.7956 29.8632 19.8309 29.9162 19.8309C29.9115 19.8309 29.907 19.8328 29.9037 19.8361C29.9004 19.8394 29.8985 19.8439 29.8985 19.8486C29.8985 19.8839 29.9162 19.8839 29.9339 19.9016C29.9515 19.9192 29.8632 19.8486 29.8632 19.9016V19.9722L29.8279 19.9192C29.7573 19.9545 29.8279 20.0605 29.7573 20.0782C29.7596 20.0688 29.7581 20.0589 29.7532 20.0506C29.7482 20.0423 29.7401 20.0364 29.7308 20.034C29.7214 20.0317 29.7115 20.0331 29.7032 20.0381C29.6949 20.0431 29.689 20.0511 29.6866 20.0605C29.6513 20.0605 29.6866 20.1135 29.6336 20.1135C29.5807 20.1135 29.563 20.0605 29.5277 20.0782C29.4924 20.0958 29.5277 20.1311 29.51 20.1311C29.4924 20.1311 29.5277 20.0782 29.4924 20.0605C29.51 20.0428 29.4924 20.0252 29.4747 20.0075H29.457C29.457 19.9899 29.4747 19.9722 29.4394 19.9722H29.4217C29.4041 19.9545 29.4394 19.9545 29.4217 19.9369C29.4041 19.9192 29.3864 19.9016 29.3687 19.9192C29.3511 19.9369 29.3864 19.8839 29.3511 19.8839H29.3334C29.3334 19.8662 29.3687 19.8662 29.3511 19.8309H29.2981V19.7956H29.2451C29.2804 19.7956 29.3158 19.7956 29.3158 19.7603Z"
            fill="#204063"
          />
          <path
            d="M25.2184 18.9302C25.236 18.9302 25.289 18.9125 25.3067 18.9479C25.3243 18.9832 25.3067 19.0715 25.2537 19.0538H25.236L25.183 19.0185C25.2184 18.9832 25.1477 18.9832 25.183 18.9479C25.2184 18.9125 25.2184 18.9655 25.2184 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5189 18.9302L25.4659 18.9655V18.9478L25.4482 18.9655V18.9478L25.5189 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5896 18.8595H25.5719C25.5719 18.8419 25.5896 18.8419 25.5896 18.8242H25.5543C25.5896 18.8066 25.5896 18.7889 25.6073 18.7712H25.5896C25.6424 18.7374 25.7035 18.7191 25.7662 18.7183C25.8015 18.7359 25.8368 18.7889 25.8898 18.7536C25.9428 18.7183 25.8545 18.7889 25.8898 18.7889L25.9428 18.8949C25.9075 18.9125 25.9251 18.9478 25.9251 18.9832C25.9251 19.0185 25.8722 19.0008 25.8898 19.0361H25.8722C25.8368 19.0538 25.8722 19.0715 25.8722 19.0891H25.8192C25.8192 19.1244 25.7485 19.1244 25.7309 19.1421C25.7132 19.1598 25.6602 19.1598 25.6426 19.1951C25.6249 19.2304 25.6779 19.1068 25.6249 19.0891C25.6249 19.0938 25.6231 19.0983 25.6197 19.1016C25.6164 19.1049 25.6119 19.1068 25.6073 19.1068C25.5719 19.0715 25.6426 19.0361 25.6073 19.0361L25.5366 19.0891C25.5719 18.9655 25.6249 18.9302 25.5896 18.8595Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M10.0308 24.2813L10.0484 24.2637V24.2813H10.0308Z"
            fill="white"
          />
          <path
            d="M10.0308 24.2989V24.2812H10.0484L10.0308 24.2989Z"
            fill="white"
          />
          <path
            d="M13.0154 24.7227V24.758C12.9977 24.7756 12.9977 24.7756 12.98 24.758C12.9624 24.7403 12.9624 24.7227 12.98 24.7227H13.0154Z"
            fill="#204063"
          />
          <path
            d="M13.1037 24.7755H13.086C13.0813 24.7755 13.0768 24.7736 13.0735 24.7703C13.0702 24.767 13.0684 24.7625 13.0684 24.7578C13.086 24.7401 13.1213 24.7578 13.1037 24.7755Z"
            fill="#204063"
          />
          <path
            d="M11.0201 21.1554C11.0201 21.1554 11.0024 21.1377 11.0201 21.1377V21.1554Z"
            fill="#204063"
          />
          <path
            d="M11.8324 23.575H11.8147C11.8139 23.5654 11.815 23.5558 11.8181 23.5466C11.8211 23.5375 11.826 23.5291 11.8324 23.522C11.8324 23.5396 11.85 23.5573 11.8324 23.575Z"
            fill="#204063"
          />
          <path
            d="M10.9845 21.3322C10.9845 21.3499 10.9669 21.3499 10.9492 21.3322V21.2969C10.9845 21.2969 10.9845 21.3145 10.9845 21.3322Z"
            fill="#204063"
          />
          <path
            d="M11.6382 20.3608C11.6558 20.3962 11.6912 20.4315 11.6735 20.4668C11.6558 20.5021 11.6558 20.4491 11.6558 20.4315C11.6558 20.4138 11.6558 20.3785 11.6382 20.3608Z"
            fill="#204063"
          />
          <path
            d="M12.044 25.9234H12.0616C12.097 25.9057 12.0793 25.9411 12.097 25.9411C12.097 25.9548 12.0938 25.9683 12.0876 25.9806C12.0815 25.9928 12.0726 26.0035 12.0616 26.0117H12.0087C12.0087 25.994 11.9557 26.0117 11.9733 25.9764V25.9234H12.0263H12.044Z"
            fill="#204063"
          />
          <path
            d="M11.6733 20.5904C11.6733 20.5904 11.691 20.6081 11.6733 20.6081V20.5727C11.6733 20.5551 11.6733 20.5727 11.6733 20.5904Z"
            fill="#204063"
          />
          <path
            d="M11.7791 20.6609C11.7728 20.6537 11.7679 20.6453 11.7649 20.6362C11.7618 20.6271 11.7607 20.6175 11.7615 20.6079L11.7791 20.6609Z"
            fill="#204063"
          />
          <path
            d="M11.7617 20.6431C11.7794 20.6431 11.7617 20.6431 11.7617 20.6255V20.6431Z"
            fill="white"
          />
          <path
            d="M12.4504 22.0912C12.4504 22.1089 12.4504 22.1265 12.4328 22.1265H12.3975C12.3986 22.1129 12.4049 22.1003 12.4151 22.0912C12.4328 22.0559 12.4328 22.0735 12.4504 22.0912Z"
            fill="#204063"
          />
          <path
            d="M12.2916 22.1265C12.2739 22.1441 12.2739 22.1441 12.2739 22.1265H12.2916Z"
            fill="#204063"
          />
          <path
            d="M11.9029 22.3033C11.8982 22.3033 11.8937 22.3014 11.8904 22.2981C11.8871 22.2948 11.8853 22.2903 11.8853 22.2856L11.9029 22.3033Z"
            fill="#204063"
          />
          <path
            d="M11.585 21.2789L11.5674 21.2612L11.585 21.2789Z"
            fill="#204063"
          />
          <path
            d="M11.5852 21.3851C11.5852 21.4028 11.5852 21.4204 11.5675 21.4204C11.5499 21.4204 11.5499 21.3674 11.5322 21.3498C11.5322 21.3498 11.5499 21.3321 11.5499 21.3498C11.5499 21.3674 11.5675 21.3321 11.5499 21.3145C11.5609 21.3227 11.5698 21.3333 11.5759 21.3456C11.582 21.3579 11.5852 21.3714 11.5852 21.3851Z"
            fill="#204063"
          />
          <path
            d="M12.2559 22.2681C12.2736 22.2857 12.2559 22.2857 12.2559 22.2857C12.2559 22.2857 12.2382 22.2681 12.2559 22.2681Z"
            fill="#204063"
          />
          <path
            d="M11.9737 22.4268H11.9561C11.9737 22.4092 11.9914 22.4092 11.9737 22.4268Z"
            fill="#204063"
          />
          <path
            d="M12.1324 22.4093H12.1148C12.1148 22.4093 12.0971 22.4093 12.1148 22.3916C12.1148 22.3963 12.1166 22.4008 12.12 22.4041C12.1233 22.4074 12.1278 22.4093 12.1324 22.4093Z"
            fill="#204063"
          />
          <path
            d="M12.0088 22.4444C11.9911 22.4444 12.0264 22.4797 11.9911 22.4797C11.9558 22.4797 11.9734 22.4444 11.9911 22.4268L12.0088 22.4444Z"
            fill="#204063"
          />
          <path
            d="M11.6912 21.5791V21.6144C11.6912 21.5968 11.6912 21.5968 11.7088 21.5968C11.7179 21.6434 11.7179 21.6914 11.7088 21.738H11.6558C11.6735 21.7027 11.6382 21.6851 11.6382 21.6674H11.6558C11.655 21.6578 11.6562 21.6482 11.6592 21.6391C11.6623 21.63 11.6671 21.6216 11.6735 21.6144L11.6912 21.5791Z"
            fill="#204063"
          />
          <path
            d="M11.5319 21.738C11.4966 21.7557 11.4966 21.7027 11.4966 21.6851H11.5142C11.5319 21.6851 11.5496 21.7027 11.5319 21.738Z"
            fill="#204063"
          />
          <path
            d="M11.5318 21.7203H11.5142V21.7026V21.7203H11.5318Z"
            fill="white"
          />
          <path
            d="M11.6911 24.387H11.6734C11.6381 24.3516 11.6734 24.2987 11.6734 24.2633V24.228C11.6967 24.2776 11.703 24.3335 11.6911 24.387Z"
            fill="#204063"
          />
          <path
            d="M11.5322 21.9325H11.5145C11.5145 21.9501 11.4969 21.9325 11.4969 21.9325C11.4882 21.9227 11.4834 21.9102 11.4834 21.8971C11.4834 21.8841 11.4882 21.8715 11.4969 21.8618C11.4792 21.8618 11.4969 21.8618 11.4969 21.8795C11.4969 21.8971 11.4969 21.8618 11.4969 21.8618C11.4969 21.8618 11.5322 21.9148 11.5322 21.9325Z"
            fill="#204063"
          />
          <path
            d="M11.4967 22.0033C11.5108 22.024 11.517 22.049 11.5144 22.0739H11.4967C11.4791 22.0739 11.4614 22.0562 11.4614 22.0209C11.4614 21.9856 11.4791 22.0033 11.4791 21.9856C11.4791 21.9679 11.4791 22.0209 11.4967 22.0033Z"
            fill="#204063"
          />
          <path
            d="M10.9318 22.3914H10.9141C10.8965 22.3914 10.8965 22.3561 10.8965 22.3561C10.8965 22.3561 10.8965 22.3385 10.8965 22.3208C10.9075 22.329 10.9164 22.3397 10.9225 22.352C10.9286 22.3642 10.9318 22.3777 10.9318 22.3914Z"
            fill="#204063"
          />
          <path
            d="M13.1393 22.2503C13.104 22.2503 13.104 22.215 13.104 22.1973C13.104 22.1797 13.1217 22.1267 13.104 22.0737H13.1217C13.1217 22.1091 13.1746 22.1797 13.1393 22.2503Z"
            fill="#204063"
          />
          <path
            d="M11.4259 22.8507H11.4082V22.8154H11.4259C11.4259 22.7977 11.4259 22.833 11.4259 22.8507Z"
            fill="#204063"
          />
          <path
            d="M11.4615 23.151C11.4792 23.151 11.4615 23.1333 11.4615 23.1333L11.4968 23.1863C11.4968 23.2039 11.4968 23.2039 11.4792 23.2216H11.4438C11.4438 23.2039 11.4615 23.1863 11.4438 23.1863V23.151H11.4615Z"
            fill="#204063"
          />
          <path
            d="M12.7681 22.5505H12.7505V22.5151L12.7681 22.5505Z"
            fill="#204063"
          />
          <path
            d="M11.9557 22.9922C11.9557 23.0275 11.991 23.0628 11.9733 23.0981H11.938C11.9204 23.0628 11.938 23.0452 11.938 23.0098L11.9557 22.9922Z"
            fill="#204063"
          />
          <path
            d="M11.3909 23.3804C11.3909 23.398 11.3909 23.4157 11.3732 23.4157C11.3556 23.4157 11.3556 23.4157 11.3556 23.4157C11.3509 23.4157 11.3464 23.4138 11.3431 23.4105C11.3398 23.4072 11.3379 23.4027 11.3379 23.398C11.3379 23.3933 11.3398 23.3889 11.3431 23.3855C11.3464 23.3822 11.3509 23.3804 11.3556 23.3804H11.3909Z"
            fill="#204063"
          />
          <path
            d="M12.4152 23.0451C12.4152 23.0627 12.4152 23.0804 12.3975 23.0804C12.3929 23.0804 12.3884 23.0785 12.3851 23.0752C12.3817 23.0719 12.3799 23.0674 12.3799 23.0627V23.0274C12.3975 23.0097 12.3975 23.0451 12.4152 23.0451Z"
            fill="#204063"
          />
          <path
            d="M11.3022 23.4338H11.3199C11.3022 23.4338 11.3022 23.4161 11.3199 23.3984C11.3246 23.4008 11.3282 23.4049 11.3298 23.4099C11.3315 23.4148 11.3311 23.4202 11.3287 23.4249C11.3264 23.4296 11.3223 23.4332 11.3173 23.4348C11.3124 23.4365 11.3069 23.4361 11.3022 23.4338Z"
            fill="#204063"
          />
          <path
            d="M13.1213 22.9745C13.1213 22.9922 13.1213 23.0099 13.1037 23.0099C13.086 23.0099 13.0684 23.0275 13.0684 23.0099C13.0684 22.9922 13.1037 22.9569 13.1213 22.9745Z"
            fill="#204063"
          />
          <path
            d="M12.8033 23.0627H12.821C12.821 23.098 12.8386 23.1333 12.821 23.1686C12.821 23.1733 12.8191 23.1778 12.8158 23.1811C12.8125 23.1844 12.808 23.1863 12.8033 23.1863C12.7986 23.1863 12.7941 23.1844 12.7908 23.1811C12.7875 23.1778 12.7856 23.1733 12.7856 23.1686V23.098H12.8033C12.8029 23.0733 12.809 23.0489 12.821 23.0273L12.8033 23.0627Z"
            fill="#204063"
          />
          <path
            d="M12.2384 23.2041H12.256C12.2647 23.2138 12.2695 23.2264 12.2695 23.2394C12.2695 23.2525 12.2647 23.265 12.256 23.2747H12.2207V23.2218H12.2384V23.2041Z"
            fill="#204063"
          />
          <path
            d="M10.9139 23.6453C10.9092 23.6453 10.9047 23.6434 10.9014 23.6401C10.8981 23.6368 10.8962 23.6323 10.8962 23.6276C10.8786 23.6276 10.9139 23.5923 10.8962 23.5923C10.8786 23.5923 10.9315 23.6276 10.9139 23.6453Z"
            fill="#204063"
          />
          <path
            d="M11.2143 25.2525H11.232C11.232 25.2525 11.1967 25.2878 11.232 25.2878C11.2673 25.2878 11.2143 25.3584 11.179 25.3761H11.1967C11.1967 25.4114 11.2143 25.4291 11.179 25.4467H11.1614C11.126 25.4114 11.2143 25.3761 11.1437 25.3408C11.0731 25.3055 11.1437 25.2701 11.1437 25.2525H11.1967C11.1967 25.2348 11.1967 25.2525 11.2143 25.2525Z"
            fill="#204063"
          />
          <path
            d="M11.32 23.6279C11.32 23.6456 11.32 23.6632 11.3024 23.6632H11.2847C11.267 23.6456 11.2847 23.6456 11.2847 23.6456H11.32V23.6279Z"
            fill="#204063"
          />
          <path
            d="M12.715 23.2925V23.3455H12.6973C12.6797 23.3455 12.6797 23.3101 12.6973 23.2925H12.715Z"
            fill="#204063"
          />
          <path
            d="M11.1788 23.8042H11.1965V23.8395H11.1611V23.8042H11.1788Z"
            fill="#204063"
          />
          <path
            d="M11.1787 23.8042V23.8219V23.8042H11.1964H11.1787Z"
            fill="white"
          />
          <path
            d="M11.2316 24.0514C11.2493 24.0514 11.2669 24.0691 11.2493 24.0868H11.2316C11.1963 24.0868 11.2139 24.0514 11.1963 24.0514C11.2139 24.0338 11.2139 24.0338 11.2139 24.0161C11.2093 24.0185 11.2057 24.0226 11.204 24.0275C11.2024 24.0325 11.2028 24.0379 11.2051 24.0426C11.2075 24.0473 11.2116 24.0508 11.2165 24.0525C11.2215 24.0542 11.2269 24.0538 11.2316 24.0514Z"
            fill="#204063"
          />
          <path
            d="M10.7725 24.0869C10.7725 24.1046 10.7902 24.1222 10.7725 24.1576V24.1222C10.7549 24.1046 10.7725 24.1046 10.7725 24.0869Z"
            fill="#204063"
          />
          <path
            d="M12.821 23.5923C12.821 23.6099 12.8386 23.6453 12.821 23.6629V23.6982L12.7856 23.6629V23.6276C12.8033 23.6453 12.7856 23.5923 12.8033 23.6099C12.8033 23.6099 12.8033 23.6099 12.821 23.5923Z"
            fill="#204063"
          />
          <path
            d="M11.0906 24.1221H11.1083C11.0906 24.1397 11.1083 24.175 11.0906 24.1927C11.073 24.2104 11.0553 24.175 11.0376 24.1574C11.02 24.1397 11.0376 24.1397 11.0376 24.1397H11.0906V24.1221Z"
            fill="#204063"
          />
          <path
            d="M12.3976 23.7337C12.3929 23.7337 12.3884 23.7319 12.3851 23.7286C12.3818 23.7252 12.3799 23.7207 12.3799 23.7161V23.6807C12.3623 23.6631 12.3799 23.6807 12.3799 23.6984C12.3976 23.6807 12.3976 23.6807 12.3976 23.6631C12.3976 23.6807 12.4152 23.7161 12.3976 23.7337Z"
            fill="#204063"
          />
          <path
            d="M12.2031 24.5461H12.2208V24.5107C12.2245 24.5141 12.2276 24.5181 12.2296 24.5227C12.2317 24.5273 12.2327 24.5322 12.2327 24.5372C12.2327 24.5422 12.2317 24.5472 12.2296 24.5518C12.2276 24.5563 12.2245 24.5604 12.2208 24.5637C12.217 24.5604 12.214 24.5563 12.212 24.5518C12.2099 24.5472 12.2088 24.5422 12.2088 24.5372C12.2088 24.5322 12.2099 24.5273 12.212 24.5227C12.214 24.5181 12.217 24.5141 12.2208 24.5107L12.2031 24.5461Z"
            fill="#204063"
          />
          <path
            d="M11.32 24.9876H11.3023C11.2847 25.0052 11.2847 24.9875 11.2847 24.9699C11.3023 24.9522 11.2847 24.9522 11.3023 24.9346H11.32C11.32 24.9522 11.3376 24.9699 11.32 24.9876Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.7759C11.9382 24.7935 11.9558 24.8289 11.9205 24.8289C11.8852 24.8289 11.9029 24.8289 11.9029 24.8112V24.7759H11.9205C11.9232 24.7774 11.9262 24.7782 11.9293 24.7782C11.9324 24.7782 11.9355 24.7774 11.9382 24.7759Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.8112H11.9205C11.9158 24.8112 11.9113 24.8093 11.908 24.806C11.9047 24.8027 11.9028 24.7982 11.9028 24.7935C11.9028 24.7889 11.9047 24.7844 11.908 24.781C11.9113 24.7777 11.9158 24.7759 11.9205 24.7759C11.9205 24.7935 11.9382 24.7759 11.9382 24.8112Z"
            fill="white"
          />
          <path
            d="M11.2496 24.8464C11.2496 24.864 11.2496 24.8464 11.2319 24.8464V24.811H11.2496C11.2496 24.8287 11.2673 24.8464 11.2496 24.8464Z"
            fill="#204063"
          />
          <path
            d="M12.0264 24.9172V24.8818C12.0264 24.8818 12.044 24.8995 12.0264 24.9172Z"
            fill="#204063"
          />
          <path
            d="M10.7373 26.2769H10.7726C10.7726 26.2769 10.755 26.2769 10.7726 26.2946C10.7773 26.2946 10.7818 26.2927 10.7851 26.2894C10.7884 26.2861 10.7903 26.2816 10.7903 26.2769C10.7903 26.2723 10.7884 26.2678 10.7851 26.2645C10.7818 26.2611 10.7773 26.2593 10.7726 26.2593C10.7903 26.2769 10.7726 26.3123 10.7903 26.3123H10.8079C10.8079 26.3476 10.8256 26.3476 10.8256 26.3652C10.8264 26.3748 10.8253 26.3844 10.8222 26.3935C10.8192 26.4027 10.8143 26.4111 10.8079 26.4182C10.8433 26.4006 10.8079 26.4535 10.8256 26.4535C10.8209 26.4535 10.8164 26.4554 10.8131 26.4587C10.8098 26.462 10.8079 26.4665 10.8079 26.4712L10.7373 26.5065H10.6843C10.6667 26.5065 10.649 26.4889 10.6667 26.4712H10.649C10.6517 26.4463 10.6454 26.4213 10.6313 26.4006H10.6667V26.3652C10.6843 26.3652 10.6667 26.3476 10.6843 26.3299C10.702 26.3123 10.702 26.3476 10.7196 26.3299C10.7174 26.3203 10.7178 26.3103 10.7209 26.3009C10.7241 26.2916 10.7297 26.2832 10.7373 26.2769Z"
            fill="#204063"
          />
          <path
            d="M11.9205 25.0582V25.0935C11.9028 25.1112 11.9028 25.0758 11.9028 25.0758C11.9028 25.0758 11.9028 25.0582 11.9028 25.0405L11.9205 25.0582Z"
            fill="#204063"
          />
          <path
            d="M11.8501 25.27H11.7971C11.7971 25.2877 11.7794 25.2877 11.7618 25.2877C11.7557 25.2658 11.7559 25.2427 11.7621 25.2209C11.7683 25.1991 11.7804 25.1794 11.7971 25.1641H11.8147C11.8249 25.1676 11.8341 25.1735 11.8417 25.1812C11.8493 25.1888 11.855 25.1982 11.8584 25.2084C11.8618 25.2186 11.8628 25.2295 11.8614 25.2402C11.8599 25.2509 11.8561 25.2611 11.8501 25.27Z"
            fill="#204063"
          />
          <path
            d="M11.1966 27.4601H11.2143V27.4954H11.2319C11.2143 27.5308 11.2319 27.5484 11.2143 27.5661C11.1966 27.5837 11.1966 27.6014 11.1966 27.6191H11.126C11.1249 27.6055 11.1185 27.5928 11.1083 27.5837H11.0553C11.02 27.5837 11.0377 27.5484 11.02 27.5308V27.4954C11.0377 27.5131 11.0377 27.4778 11.0553 27.4601H11.126V27.4248H11.1613C11.1613 27.4248 11.179 27.4778 11.1966 27.4601Z"
            fill="#204063"
          />
          <path
            d="M11.0731 25.7114C11.0731 25.7291 11.1084 25.7467 11.1084 25.7821L11.0731 25.835L11.0024 25.7997C11.0201 25.7821 11.0024 25.7467 11.0024 25.7467H11.0201C11.0201 25.7291 11.0201 25.7114 11.0378 25.7114H11.0731Z"
            fill="#204063"
          />
          <path
            d="M11.6029 25.5703H11.6205C11.6382 25.6056 11.5675 25.6056 11.6029 25.6409C11.6382 25.6762 11.5852 25.6939 11.5675 25.6939C11.5499 25.6939 11.5322 25.6586 11.5322 25.6409C11.5499 25.6586 11.5499 25.6233 11.5499 25.6233H11.5852C11.5782 25.6209 11.5724 25.6159 11.5691 25.6093C11.5657 25.6026 11.5652 25.595 11.5675 25.5879C11.5699 25.5809 11.5749 25.5751 11.5815 25.5718C11.5882 25.5685 11.5958 25.5679 11.6029 25.5703Z"
            fill="#204063"
          />
          <path
            d="M11.4083 26.3652V26.4006C11.3907 26.4182 11.4437 26.4182 11.4083 26.4535C11.373 26.4889 11.3907 26.4712 11.3907 26.4889H11.32V26.4535C11.3377 26.4535 11.3024 26.4359 11.32 26.4359V26.4006H11.373C11.3907 26.3476 11.3907 26.3829 11.4083 26.3652Z"
            fill="#204063"
          />
          <path
            d="M10.7019 26.7008C10.7019 26.7184 10.7019 26.7184 10.7196 26.7184C10.7372 26.7184 10.7019 26.7714 10.6842 26.7537H10.6489C10.6666 26.7361 10.6489 26.7361 10.6489 26.7184C10.6536 26.7184 10.6581 26.7166 10.6614 26.7133C10.6647 26.7099 10.6666 26.7054 10.6666 26.7008C10.6666 26.6961 10.6684 26.6916 10.6718 26.6883C10.6751 26.685 10.6796 26.6831 10.6842 26.6831L10.7019 26.7008Z"
            fill="#204063"
          />
          <path
            d="M10.6842 26.7007V26.7183H10.6665L10.6842 26.7007Z"
            fill="white"
          />
          <path
            d="M9.99577 26.5592C9.99577 26.5768 9.97811 26.5945 9.96045 26.5768V26.5415C9.97811 26.5238 10.0134 26.5415 9.99577 26.5592Z"
            fill="#204063"
          />
          <path
            d="M10.8784 27.2481C10.8784 27.2481 10.8784 27.2304 10.8961 27.2481H10.8784Z"
            fill="#204063"
          />
          <path
            d="M10.4903 26.8066C10.508 26.8066 10.4903 26.8243 10.4903 26.8243H10.4727C10.4727 26.8243 10.4903 26.8066 10.4903 26.8243V26.8066Z"
            fill="#204063"
          />
          <path
            d="M10.1899 27.0186H10.2252C10.2075 27.0186 10.2252 27.0362 10.2252 27.0362C10.2252 27.0715 10.2252 27.1069 10.1722 27.1245L10.1192 27.0892C10.1016 27.0715 10.1192 27.0539 10.1016 27.0362H10.1192C10.1016 27.0186 10.1192 27.0362 10.1192 27.0186H10.1899Z"
            fill="#204063"
          />
          <path
            d="M10.6135 27.2481H10.6489V27.2834C10.6665 27.3011 10.6312 27.3011 10.6312 27.3364H10.5429C10.5429 27.3188 10.5076 27.3541 10.5076 27.3188C10.4722 27.3364 10.4899 27.3011 10.4722 27.3011H10.4546C10.4593 27.3011 10.4638 27.2992 10.4671 27.2959C10.4704 27.2926 10.4722 27.2881 10.4722 27.2834C10.4722 27.2788 10.4704 27.2743 10.4671 27.271C10.4638 27.2676 10.4593 27.2658 10.4546 27.2658C10.4546 27.2481 10.4899 27.2481 10.4722 27.2305C10.4546 27.2128 10.5076 27.2305 10.4899 27.1951C10.5076 27.1951 10.5076 27.2128 10.5076 27.1951C10.5076 27.1775 10.5076 27.1951 10.5076 27.1775C10.5076 27.1598 10.5252 27.2128 10.5429 27.1951H10.5959C10.5782 27.2305 10.6135 27.2305 10.6135 27.2481Z"
            fill="#204063"
          />
          <path
            d="M10.066 27.5835L10.1014 27.6188C10.0837 27.6365 10.119 27.6365 10.1014 27.6541C10.0837 27.6718 10.119 27.6718 10.1014 27.6718H10.119C10.1014 27.6895 10.1014 27.7248 10.066 27.7424H9.96008C9.94242 27.7248 9.96008 27.7071 9.94242 27.7071C9.92476 27.7071 9.94242 27.6895 9.94242 27.6718C9.9471 27.6718 9.9516 27.6699 9.95491 27.6666C9.95822 27.6633 9.96008 27.6588 9.96008 27.6541C9.96008 27.6495 9.95822 27.645 9.95491 27.6416C9.9516 27.6383 9.9471 27.6365 9.94242 27.6365H9.96008C9.96008 27.6365 9.94242 27.6188 9.96008 27.6188H10.0307L10.066 27.5835Z"
            fill="#204063"
          />
          <path
            d="M10.9137 27.778H10.8961C10.8914 27.778 10.8869 27.7761 10.8836 27.7728C10.8803 27.7695 10.8784 27.765 10.8784 27.7603C10.8784 27.7557 10.8803 27.7512 10.8836 27.7478C10.8869 27.7445 10.8914 27.7427 10.8961 27.7427C10.9137 27.7603 10.9137 27.7603 10.9137 27.778Z"
            fill="#204063"
          />
          <path
            d="M11.3199 28.131C11.3022 28.131 11.3022 28.1134 11.3022 28.0957H11.3199C11.3199 28.0957 11.3376 28.131 11.3199 28.131Z"
            fill="#204063"
          />
          <path
            d="M10.6136 28.043H10.6313V28.0959C10.5959 28.0959 10.5959 28.1136 10.5606 28.0959H10.543C10.543 28.0783 10.5606 28.0606 10.543 28.0606H10.5606C10.543 28.0606 10.5606 28.0606 10.5606 28.043C10.5606 28.0477 10.5625 28.0521 10.5658 28.0555C10.5691 28.0588 10.5736 28.0606 10.5783 28.0606H10.6136V28.043Z"
            fill="#204063"
          />
          <path
            d="M10.5075 28.0604H10.5252C10.5075 28.0604 10.5252 28.078 10.5252 28.078H10.5075L10.4722 28.1134H10.4192C10.4192 28.078 10.3839 28.0957 10.3662 28.0604H10.3839C10.3662 28.0427 10.3839 28.0251 10.3839 28.0074H10.4015C10.4015 27.9897 10.4192 27.9897 10.4015 27.9897C10.3839 27.9897 10.4369 28.0074 10.4369 27.9897H10.4545C10.4898 28.0074 10.4898 28.0604 10.5075 28.0604Z"
            fill="#204063"
          />
          <path
            d="M10.2076 28.2192H10.2606C10.2606 28.2369 10.2429 28.2546 10.2606 28.2546H10.2783C10.2783 28.2722 10.2606 28.2899 10.2783 28.2899H10.2959C10.2959 28.2899 10.3136 28.2899 10.2959 28.3075H10.3489C10.3313 28.3252 10.3489 28.3252 10.3489 28.3252H10.3313C10.3489 28.3252 10.3313 28.3252 10.3313 28.3429H10.137C10.137 28.3075 10.1017 28.3252 10.1017 28.3252H10.0663V28.2899H10.031C10.031 28.2899 10.0663 28.2899 10.0487 28.2722C10.0487 28.2369 9.99571 28.2369 10.0134 28.2016C10.031 28.1663 10.031 28.2016 10.031 28.2016C10.031 28.2016 10.0134 28.1663 10.031 28.1663L10.0663 28.1309C10.0663 28.1309 10.0487 28.1133 10.0663 28.1133C10.0663 28.118 10.0682 28.1225 10.0715 28.1258C10.0748 28.1291 10.0793 28.1309 10.084 28.1309H10.1193C10.1193 28.1309 10.1193 28.1486 10.137 28.1309H10.2253L10.2076 28.2192Z"
            fill="#204063"
          />
          <path
            d="M11.4791 26.9302C11.4615 26.9478 11.4791 26.9655 11.4438 26.9655C11.4085 26.9655 11.4085 26.9478 11.4262 26.9302H11.4791Z"
            fill="#204063"
          />
          <path
            d="M11.4082 27.0539V27.0362H11.4259L11.4082 27.0186H11.4259L11.4082 27.0539Z"
            fill="#204063"
          />
          <path
            d="M11.4261 27.1065H11.4437V27.1418C11.4614 27.1595 11.4437 27.1948 11.4437 27.2125C11.4437 27.2301 11.3908 27.2301 11.3908 27.2655H11.3378C11.3201 27.2301 11.3201 27.2301 11.3025 27.2301C11.3025 27.2125 11.3201 27.1948 11.3025 27.1772C11.2848 27.1595 11.3201 27.1418 11.3025 27.1418C11.2848 27.1418 11.3378 27.1595 11.3554 27.1595C11.3731 27.1595 11.3378 27.1418 11.3554 27.1418C11.3731 27.1418 11.3731 27.1595 11.3731 27.1595V27.1065C11.3908 27.0712 11.3908 27.1065 11.4261 27.1065Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M19.7262 23.8751L19.6909 23.8574H19.7262V23.8751Z"
            fill="white"
          />
          <path
            d="M19.797 23.8751L19.7617 23.8927V23.8574L19.797 23.8751Z"
            fill="white"
          />
          <path
            d="M19.8323 17.0583L19.8853 17.0229C19.8977 17.0339 19.9073 17.0476 19.9134 17.0629C19.9196 17.0782 19.922 17.0948 19.9206 17.1112C19.903 17.1466 19.8677 17.1466 19.8323 17.1289C19.8237 17.1192 19.8188 17.1066 19.8188 17.0936C19.8188 17.0806 19.8237 17.068 19.8323 17.0583Z"
            fill="#204063"
          />
          <path
            d="M19.9028 16.8286C19.9205 16.8286 19.9205 16.8462 19.9205 16.8639L19.8675 16.8992C19.8322 16.8816 19.8498 16.7933 19.9028 16.8286Z"
            fill="#204063"
          />
          <path
            d="M11.9557 21.1026C11.9557 21.1203 11.938 21.1556 11.9204 21.1379H11.9027C11.9018 21.1313 11.9027 21.1246 11.9054 21.1185C11.9082 21.1125 11.9125 21.1073 11.9181 21.1036C11.9236 21.0999 11.9301 21.0978 11.9367 21.0977C11.9434 21.0975 11.9499 21.0992 11.9557 21.1026Z"
            fill="#204063"
          />
          <path
            d="M17.4145 19.8689L17.397 19.8711L17.3981 19.8799L17.4156 19.8777L17.4145 19.8689Z"
            fill="#204063"
          />
          <path
            d="M17.7133 19.9367C17.6779 19.972 17.6249 19.9367 17.6073 19.9013C17.5896 19.866 17.6779 19.9013 17.7133 19.9367Z"
            fill="#204063"
          />
          <path
            d="M12.4325 21.1909C12.4501 21.2262 12.4501 21.2616 12.4148 21.2616C12.3795 21.2616 12.3618 21.2439 12.3618 21.2262C12.3618 21.2086 12.4148 21.1909 12.4325 21.1909Z"
            fill="#204063"
          />
          <path
            d="M10.8962 19.0538H10.8785C10.9096 19.0393 10.9439 19.0333 10.978 19.0364C11.0121 19.0395 11.0448 19.0516 11.0728 19.0714C11.0728 19.1067 11.0374 19.0891 11.0021 19.1067L10.8608 19.0714L10.8962 19.0538Z"
            fill="#204063"
          />
          <path
            d="M22.7108 18.5594H22.6755L22.7108 18.5241C22.6755 18.4711 22.7638 18.4711 22.7638 18.4358C22.8135 18.4305 22.8636 18.443 22.905 18.4711C22.9404 18.5241 22.9227 18.5241 22.9404 18.577C22.958 18.63 22.958 18.683 22.8697 18.683C22.7814 18.683 22.8167 18.6653 22.7638 18.7007C22.7108 18.736 22.7461 18.6653 22.7284 18.6653H22.7108C22.7284 18.63 22.7108 18.6124 22.6755 18.5947C22.6401 18.577 22.6931 18.577 22.7108 18.5594Z"
            fill="#204063"
          />
          <path
            d="M11.3554 19.1597L11.4084 19.195C11.3907 19.2303 11.3377 19.2126 11.3201 19.2126H11.2671L11.3554 19.1597Z"
            fill="#204063"
          />
          <path
            d="M11.5498 19.0011H11.5675C11.5321 19.0187 11.4792 18.9834 11.4438 18.9834L11.5498 19.0011Z"
            fill="#204063"
          />
          <path
            d="M14.3048 19.6895C14.3224 19.7071 14.3224 19.7071 14.3224 19.7248H14.2871C14.2871 19.7248 14.2695 19.6895 14.3048 19.6895Z"
            fill="#204063"
          />
          <path
            d="M14.6578 18.8066H14.6931L14.6578 18.8596C14.6401 18.8596 14.6401 18.8243 14.6578 18.8066Z"
            fill="#204063"
          />
          <path
            d="M14.6579 18.312C14.6756 18.3297 14.7286 18.3297 14.7109 18.365C14.6933 18.4003 14.7109 18.4356 14.6756 18.4356C14.6403 18.4356 14.6403 18.4003 14.605 18.4003C14.5696 18.4003 14.6403 18.3473 14.6579 18.312Z"
            fill="#204063"
          />
          <path
            d="M14.6931 18.7007C14.6931 18.7007 14.7107 18.6831 14.7107 18.7007V18.736C14.6754 18.736 14.6578 18.7007 14.6931 18.7007Z"
            fill="#204063"
          />
          <path
            d="M14.958 19.6016H14.9933C14.9757 19.6192 14.9933 19.6369 14.9757 19.6545C14.958 19.6722 14.905 19.6192 14.958 19.6016Z"
            fill="#204063"
          />
          <path
            d="M12.6799 19.8662L12.627 19.8839L12.6446 19.8662H12.6799Z"
            fill="#204063"
          />
          <path
            d="M12.9096 19.9193C12.9273 19.9369 12.9802 19.9369 12.9626 19.9722C12.9449 20.0076 12.839 20.0076 12.8036 20.0076H12.786C12.8036 19.9899 12.786 19.9899 12.786 19.9722C12.786 19.9546 12.7683 19.9193 12.7153 19.9369C12.7773 19.9138 12.8444 19.9077 12.9096 19.9193Z"
            fill="#204063"
          />
          <path
            d="M14.9932 18.7891C15.0109 18.7891 15.0109 18.8067 15.0109 18.8244C15.0109 18.842 14.9932 18.842 14.9756 18.8244L14.9932 18.7891Z"
            fill="#204063"
          />
          <path
            d="M15.2227 19.478C15.2404 19.478 15.2404 19.4956 15.2404 19.5133H15.2051C15.1874 19.4956 15.2051 19.4603 15.2227 19.478Z"
            fill="#204063"
          />
          <path
            d="M15.2232 19.1421C15.2409 19.1421 15.2585 19.1774 15.2409 19.1774C15.2232 19.1774 15.2056 19.1951 15.2056 19.1774L15.2232 19.1421Z"
            fill="#204063"
          />
          <path
            d="M15.2759 19.4248C15.2936 19.4425 15.3642 19.4071 15.3466 19.4601C15.3289 19.5131 15.2936 19.4954 15.2583 19.4601C15.223 19.4248 15.2583 19.4248 15.2759 19.4248Z"
            fill="#204063"
          />
          <path
            d="M13.3687 19.7957C13.4041 19.7957 13.4217 19.7957 13.4217 19.7604V19.7251C13.51 19.7428 13.6336 19.7074 13.7043 19.7957C13.7749 19.884 13.7043 19.8487 13.6866 19.8664H13.5983C13.563 19.8311 13.4924 19.9017 13.4394 19.8664H13.4747L13.3511 19.8134L13.3687 19.7957Z"
            fill="#204063"
          />
          <path
            d="M13.6337 20.2193C13.6514 20.3076 13.5454 20.2723 13.5101 20.2723L13.4395 20.2369C13.4674 20.2171 13.5001 20.2051 13.5342 20.202C13.5683 20.1989 13.6027 20.2048 13.6337 20.2193Z"
            fill="#204063"
          />
          <path
            d="M13.5808 20.2373L13.5632 20.255L13.5278 20.2373L13.5632 20.255L13.5808 20.2373Z"
            fill="white"
          />
          <path
            d="M19.5499 20.131H19.5676C19.5146 20.2193 19.3733 20.184 19.285 20.1486H19.2144C19.2649 20.1195 19.3217 20.1027 19.38 20.0996C19.4383 20.0966 19.4965 20.1073 19.5499 20.131Z"
            fill="#204063"
          />
          <path
            d="M13.8102 20.3077L13.7749 20.29H13.8102V20.3077Z"
            fill="#204063"
          />
          <path
            d="M14.0397 20.3253H14.0927L14.0574 20.3783C14.0097 20.3905 13.9593 20.3842 13.9161 20.3606C13.8984 20.3783 13.9338 20.3606 13.9338 20.343H13.8984C13.9183 20.3278 13.9419 20.3182 13.9667 20.3151C13.9915 20.312 14.0167 20.3155 14.0397 20.3253Z"
            fill="#204063"
          />
          <path
            d="M14.0047 20.3606H13.987C13.9693 20.3959 13.987 20.3606 13.9693 20.3783C13.9517 20.3959 13.9693 20.3253 14.0047 20.3606Z"
            fill="white"
          />
          <path
            d="M14.1812 20.4311C14.2038 20.4144 14.2304 20.404 14.2583 20.4009C14.2862 20.3978 14.3145 20.4021 14.3402 20.4135C14.3578 20.4135 14.3755 20.4312 14.3578 20.4665C14.3147 20.49 14.2642 20.4963 14.2166 20.4841C14.2166 20.4488 14.1636 20.4665 14.1459 20.4665C14.1283 20.4665 14.2166 20.4665 14.1812 20.4311Z"
            fill="#204063"
          />
          <path
            d="M14.2339 20.4136L14.2515 20.4312H14.2339V20.4136Z"
            fill="white"
          />
          <path
            d="M14.8519 21.8441C14.8696 21.8441 14.8519 21.8617 14.8519 21.8617C14.8519 21.8617 14.7813 21.8971 14.7459 21.8971C14.7106 21.8971 14.7106 21.9147 14.6753 21.8794C14.7287 21.8487 14.7907 21.8363 14.8519 21.8441Z"
            fill="#204063"
          />
          <path
            d="M15.0817 16.8286C15.117 16.8992 15.0287 16.8992 15.0111 16.9169C14.9934 16.9345 14.8521 16.8462 14.7815 16.8462H14.7285C14.8345 16.8462 14.9934 16.7226 15.0817 16.8286Z"
            fill="#204063"
          />
          <path
            d="M16.0527 20.8022C16.0704 20.8022 16.0881 20.8022 16.0881 20.8199C16.0881 20.8376 16.1057 20.8552 16.0704 20.8729H15.9468C15.9644 20.8022 16.0174 20.8022 16.0527 20.8022Z"
            fill="#204063"
          />
          <path
            d="M15.4172 20.873L15.3818 20.8907V20.873H15.4172Z"
            fill="white"
          />
          <path
            d="M16.7418 20.7668H16.7241C16.7594 20.7315 16.7948 20.7315 16.8477 20.7139C16.8631 20.7157 16.8778 20.7216 16.8902 20.7309C16.9026 20.7402 16.9123 20.7526 16.9184 20.7668C16.936 20.8022 16.9007 20.8022 16.8831 20.8375C16.8654 20.8728 16.8124 20.8022 16.7771 20.8375H16.7948L16.7241 20.8022L16.7418 20.7668Z"
            fill="#204063"
          />
          <path
            d="M15.5939 17.5704L15.5586 17.5527H15.5939V17.5704Z"
            fill="#204063"
          />
          <path
            d="M15.647 17.7471H15.6823C15.7 17.7647 15.7176 17.7647 15.7176 17.8001H15.647V17.7471Z"
            fill="#204063"
          />
          <path
            d="M16.4414 19.6544C16.512 19.6544 16.6003 19.5661 16.671 19.6368C16.6737 19.6437 16.675 19.6511 16.6747 19.6586C16.6743 19.666 16.6725 19.6733 16.6691 19.68C16.6658 19.6867 16.6611 19.6925 16.6553 19.6973C16.6496 19.702 16.6429 19.7054 16.6357 19.7074C16.565 19.7251 16.512 19.6721 16.4414 19.6544Z"
            fill="#204063"
          />
          <path
            d="M17.2891 20.9434C17.3245 20.9434 17.3774 20.9257 17.3951 20.961C17.4128 20.9964 17.3598 21.014 17.3598 21.0317H17.2715C17.2715 21.014 17.2891 20.9964 17.2715 20.9964C17.2538 20.9964 17.2715 20.9787 17.2891 20.9434Z"
            fill="#204063"
          />
          <path
            d="M16.6006 18.6124C16.6146 18.6106 16.6288 18.613 16.6414 18.6193C16.6539 18.6256 16.6644 18.6355 16.6713 18.6477C16.6713 18.6654 16.6536 18.683 16.636 18.7007H16.5477C16.53 18.6301 16.5653 18.6301 16.6006 18.6124Z"
            fill="#204063"
          />
          <path
            d="M17.4304 21.1203C17.4481 21.1026 17.4127 21.085 17.4304 21.085V21.1203Z"
            fill="#204063"
          />
          <path
            d="M16.4594 17.0229C16.4947 17.0053 16.5124 17.0229 16.5477 17.0406C16.583 17.0583 16.5477 17.1112 16.5124 17.1112C16.4771 17.1112 16.4241 17.0583 16.4594 17.0229Z"
            fill="#204063"
          />
          <path
            d="M16.6359 17.7296C16.6359 17.7119 16.6359 17.7119 16.6182 17.7119C16.6006 17.7119 16.6536 17.6942 16.6712 17.7119C16.6889 17.7296 16.8125 17.6413 16.8831 17.7119C16.9538 17.7825 16.8831 17.7649 16.8655 17.7825H16.7419C16.6901 17.7813 16.6404 17.7626 16.6006 17.7296H16.6359Z"
            fill="#204063"
          />
          <path
            d="M16.9005 19.0007C16.9005 19.0184 16.9181 19.0184 16.9181 19.0361C16.9214 19.0398 16.9255 19.0428 16.9301 19.0449C16.9347 19.0469 16.9396 19.048 16.9446 19.048C16.9496 19.048 16.9546 19.0469 16.9592 19.0449C16.9637 19.0428 16.9678 19.0398 16.9711 19.0361C16.9181 19.0361 16.9535 18.9831 16.9181 18.9654C16.8828 18.9478 17.0241 18.9301 17.0594 18.9831C17.0594 18.9968 17.0562 19.0103 17.0501 19.0226C17.044 19.0348 17.0351 19.0455 17.0241 19.0537C16.9888 19.0361 16.9711 19.0537 16.9358 19.0714H16.9005C16.9181 19.0537 16.9005 19.0537 16.9181 19.0361H16.8828C16.8828 19.0007 16.9005 19.0184 16.9005 19.0007Z"
            fill="#204063"
          />
          <path
            d="M17.9249 21.9856C17.9602 22.0033 17.9249 22.0386 17.9072 22.0386C17.8896 22.0386 17.8189 22.0209 17.7836 22.0563C17.7483 22.0916 17.8719 21.968 17.9249 21.9856Z"
            fill="#204063"
          />
          <path
            d="M16.9537 19.001C16.9714 19.001 16.936 19.0186 16.936 19.0186H16.9537V19.001Z"
            fill="white"
          />
          <path
            d="M16.9712 18.9831C16.9712 18.9654 16.9889 18.9654 16.9712 18.9478V18.9831Z"
            fill="white"
          />
          <path
            d="M21.7748 20.8197L21.7395 20.7843C21.7395 20.7667 21.8631 20.8197 21.8101 20.7314C21.7572 20.6431 22.0044 20.7314 22.075 20.802H22.0927L22.0574 20.7667C22.1104 20.7667 22.181 20.7137 22.234 20.7314C22.287 20.749 22.2693 20.7667 22.2516 20.7843C22.234 20.802 22.0221 20.749 21.9867 20.908C21.9514 21.0669 21.8455 20.9609 21.7925 20.9433L21.7395 20.9786C21.7925 20.9609 21.7395 20.9256 21.7395 20.908L21.6865 20.8726C21.7042 20.855 21.7572 20.855 21.7748 20.8197Z"
            fill="#204063"
          />
          <path
            d="M17.872 21.085C17.9073 21.1026 17.9603 21.0673 17.9779 21.1203C17.9956 21.1733 17.9249 21.1556 17.9073 21.1909C17.8896 21.2262 17.8896 21.1556 17.8543 21.1733H17.872C17.8543 21.1556 17.8366 21.085 17.872 21.085Z"
            fill="#204063"
          />
          <path
            d="M17.0951 17.9589C17.1304 17.9236 17.1481 17.9236 17.1834 17.9413C17.2187 17.9589 17.2187 17.9589 17.2011 17.9766C17.1834 17.9943 17.1304 17.9943 17.0951 17.9943C17.0598 17.9943 17.0774 17.9589 17.0951 17.9589Z"
            fill="#204063"
          />
          <path d="M17.13 17.959L17.0947 17.9766V17.959H17.13Z" fill="white" />
          <path
            d="M18.2959 21.4026C18.2783 21.4026 18.2959 21.3673 18.2959 21.3673C18.2959 21.3673 18.3489 21.3319 18.3666 21.3673C18.3842 21.4026 18.3489 21.4026 18.3489 21.4202L18.2959 21.4026Z"
            fill="#204063"
          />
          <path
            d="M18.3136 21.3848H18.3312V21.4025L18.2959 21.3848L18.3136 21.3672V21.3848Z"
            fill="white"
          />
          <path
            d="M18.8784 21.2261C18.8961 21.1908 18.9314 21.1555 18.9667 21.1732C18.9821 21.175 18.9968 21.1809 19.0092 21.1902C19.0216 21.1995 19.0313 21.2119 19.0374 21.2261C19.0374 21.2791 18.9667 21.2791 18.9314 21.2968C18.9138 21.2615 18.8961 21.2791 18.8608 21.2615C18.8255 21.2438 18.8784 21.2261 18.8784 21.2261Z"
            fill="#204063"
          />
          <path
            d="M19.0905 22.2856C19.0905 22.2809 19.0886 22.2764 19.0853 22.2731C19.082 22.2698 19.0775 22.2679 19.0728 22.2679H19.0552C19.1082 22.2502 19.1611 22.1973 19.2318 22.2326C19.3024 22.2679 19.2141 22.3032 19.1788 22.3032C19.1435 22.3032 19.0905 22.3032 19.0552 22.3032L19.0905 22.2856Z"
            fill="#204063"
          />
          <path
            d="M17.6954 17.7116L17.8014 17.6763C17.8367 17.6763 17.8543 17.6939 17.872 17.7292C17.8734 17.7457 17.8709 17.7623 17.8648 17.7776C17.8587 17.7929 17.849 17.8066 17.8367 17.8175C17.8014 17.8175 17.7837 17.7999 17.7484 17.8352C17.7131 17.8705 17.6777 17.8175 17.7131 17.7646H17.6777C17.6954 17.7646 17.6954 17.7292 17.6954 17.7116Z"
            fill="#204063"
          />
          <path
            d="M19.0905 21.5262C19.1435 21.5438 19.2141 21.4732 19.2494 21.5438C19.2848 21.6145 19.2141 21.6145 19.1788 21.6498C19.1435 21.6851 19.1435 21.6498 19.1258 21.6498H19.1435C19.0905 21.6498 19.1258 21.6321 19.0905 21.6321H19.0552C19.0905 21.5615 19.0552 21.5262 19.0905 21.5262Z"
            fill="#204063"
          />
          <path
            d="M18.0134 18.6652L17.9781 18.7005H17.9251C17.9251 18.7358 17.9605 18.7182 17.9605 18.7182V18.6829C17.9251 18.6475 17.9075 18.6829 17.8898 18.6829H17.8545C17.9075 18.6475 17.9781 18.6122 18.0134 18.6652Z"
            fill="#204063"
          />
          <path
            d="M19.6734 20.8023C19.6734 20.807 19.6752 20.8115 19.6785 20.8148C19.6819 20.8181 19.6864 20.82 19.691 20.82H19.6734V20.7847C19.6557 20.82 19.6734 20.8023 19.6734 20.8023Z"
            fill="#204063"
          />
          <path
            d="M19.7438 18.9125C19.7615 18.8949 19.7438 18.9125 19.7438 18.9302H19.7791C19.7968 18.9302 19.7791 18.9125 19.7791 18.8949L19.7262 18.9302C19.7398 18.9164 19.7565 18.906 19.7749 18.8999C19.7933 18.8938 19.8129 18.892 19.8321 18.8949V18.9302C19.816 18.9459 19.7954 18.956 19.7732 18.9592C19.751 18.9624 19.7283 18.9584 19.7085 18.9479L19.7438 18.9125Z"
            fill="#204063"
          />
          <path
            d="M19.797 18.9479L19.7793 18.9303L19.797 18.9126V18.9479Z"
            fill="white"
          />
          <path
            d="M21.0861 20.6963C21.1214 20.6963 21.1214 20.7316 21.1038 20.7669L21.0508 20.8022C21.0508 20.8022 21.0508 20.7493 21.0155 20.7669C20.9801 20.7846 21.0155 20.8022 20.9801 20.8199H20.9448C20.9752 20.7628 21.0255 20.7189 21.0861 20.6963Z"
            fill="#204063"
          />
          <path
            d="M20.3442 19.4249C20.3972 19.4249 20.4325 19.3896 20.4855 19.4249C20.486 19.4409 20.4811 19.4567 20.4714 19.4695C20.4618 19.4823 20.4481 19.4915 20.4325 19.4955H20.3619V19.4602H20.3442C20.3442 19.4602 20.3619 19.4425 20.3442 19.4249Z"
            fill="#204063"
          />
          <path
            d="M20.4153 19.4248H20.3976C20.4027 19.4266 20.4073 19.4295 20.4111 19.4334C20.4149 19.4372 20.4177 19.4419 20.4194 19.447C20.4211 19.4521 20.4217 19.4575 20.4209 19.4629C20.4202 19.4682 20.4183 19.4733 20.4153 19.4778C20.4153 19.5131 20.3623 19.4954 20.3623 19.4954C20.3623 19.4954 20.3623 19.4425 20.4153 19.4248Z"
            fill="white"
          />
          <path
            d="M20.8036 20.9259V20.9613L20.7329 20.9966L20.7682 20.9613V20.9259C20.7682 20.9436 20.7506 20.9613 20.7329 20.9436C20.742 20.9345 20.7533 20.9281 20.7658 20.925C20.7782 20.9218 20.7913 20.9222 20.8036 20.9259Z"
            fill="#204063"
          />
          <path
            d="M20.5918 19.1597H20.6095L20.5741 19.195H20.4858L20.5918 19.1597Z"
            fill="#204063"
          />
          <path
            d="M24.477 21.0673C24.477 21.0143 24.424 21.0496 24.4063 21.0496C24.3887 21.0496 24.4593 21.0496 24.4593 21.0143H24.3887C24.424 20.979 24.4946 20.9967 24.5123 20.9437C24.53 20.8907 24.477 20.926 24.4946 20.9084C24.5123 20.8907 24.5476 20.8554 24.6006 20.8377H24.7066C24.6712 20.7847 24.7772 20.8201 24.7595 20.7671C24.7419 20.7141 24.8302 20.8201 24.8478 20.7847C24.8655 20.7494 24.9715 20.8554 24.9715 20.926C24.9715 20.9967 24.9715 20.9613 24.9715 21.0143C24.9715 21.032 24.9538 21.0496 24.9715 21.0673C24.9891 21.085 24.9185 21.085 24.9185 21.1026C24.9185 21.1203 24.9008 21.1733 24.8832 21.1733C24.8655 21.1733 24.8655 21.1733 24.8655 21.1909H24.8478C24.7772 21.2262 24.7242 21.2262 24.6712 21.2969L24.6359 21.3499C24.6359 21.3145 24.6712 21.2969 24.6359 21.2616H24.6006C24.5829 21.2439 24.5476 21.2969 24.5123 21.2792C24.477 21.2616 24.5123 21.2086 24.477 21.1909H24.4063C24.4227 21.2003 24.4422 21.2028 24.4604 21.1978C24.4786 21.1928 24.4941 21.1808 24.5035 21.1644C24.5128 21.148 24.5153 21.1286 24.5103 21.1104C24.5054 21.0922 24.4934 21.0767 24.477 21.0673Z"
            fill="#204063"
          />
          <path
            d="M20.9623 19.3542C20.9446 19.3542 20.9446 19.3542 20.9446 19.3718H20.9976V19.3365C20.98 19.3188 20.9623 19.3542 20.9623 19.3365C20.9623 19.3188 21.0153 19.3188 21.0329 19.3188C21.0506 19.3188 21.0153 19.3718 20.98 19.3718C20.9446 19.3718 20.927 19.3542 20.9093 19.3542C20.8917 19.3542 20.9446 19.3365 20.9623 19.3542Z"
            fill="#204063"
          />
          <path
            d="M21.4393 19.3896C21.4746 19.4073 21.5099 19.4426 21.5099 19.4603C21.5099 19.4779 21.5099 19.4956 21.4923 19.4956C21.4746 19.4956 21.5806 19.5309 21.5629 19.5662C21.5453 19.6016 21.351 19.5662 21.2804 19.5486V19.5133H21.2627C21.2766 19.4775 21.3008 19.4467 21.3323 19.4247C21.3637 19.4027 21.4009 19.3905 21.4393 19.3896Z"
            fill="#204063"
          />
          <path
            d="M26.5431 18.948H26.5255C26.5608 18.9303 26.5608 18.9127 26.5785 18.895H26.5431C26.5431 18.8774 26.5961 18.8774 26.5608 18.8597C26.6314 18.8597 26.6314 18.8067 26.6844 18.8067C26.7374 18.8067 26.7904 18.7891 26.8257 18.7891C26.861 18.7891 26.861 18.8067 26.8787 18.8244V18.948L26.8257 19.0186C26.861 19.0363 26.914 19.054 26.9317 19.0893C26.9493 19.1246 26.8963 19.1599 26.8787 19.2129L26.7904 19.2482C26.808 19.1952 26.7197 19.2129 26.6844 19.2129H26.6668C26.6844 19.1952 26.7021 19.1952 26.7021 19.1776H26.6668C26.6668 19.1599 26.6844 19.1599 26.6844 19.1423H26.6668C26.6844 19.1599 26.6844 19.1423 26.6844 19.1246H26.7021C26.6668 19.1246 26.6491 19.1246 26.6491 19.0893H26.5608V19.054H26.5078C26.5255 18.9833 26.5961 18.9657 26.5431 18.948Z"
            fill="#204063"
          />
          <path
            d="M22.9054 20.855H22.8877C22.923 20.8197 22.9407 20.749 23.029 20.749C23.1173 20.749 23.0996 20.749 23.1526 20.7667C23.2056 20.7843 23.1526 20.8726 23.1173 20.9256C23.082 20.9786 23.029 20.9786 22.976 20.9786H22.8877C22.9054 20.908 22.8877 20.8726 22.9054 20.855Z"
            fill="#204063"
          />
          <path
            d="M21.9867 19.7603C21.9867 19.7427 21.969 19.725 21.9514 19.7427C21.9337 19.7603 21.9867 19.7427 21.9867 19.7603Z"
            fill="#204063"
          />
          <path
            d="M22.2515 19.7603H22.2339C22.2339 19.7603 22.2692 19.7427 22.2515 19.725C22.2339 19.7074 22.3752 19.8133 22.4281 19.725C22.4811 19.6367 22.5341 19.725 22.5694 19.778C22.5684 19.8004 22.5612 19.8221 22.5488 19.8408C22.5363 19.8594 22.5191 19.8744 22.4988 19.884L22.4281 19.9193C22.4281 19.9146 22.4263 19.9101 22.423 19.9068C22.4197 19.9035 22.4152 19.9016 22.4105 19.9016H22.3752C22.3928 19.8663 22.3398 19.9016 22.3222 19.8663C22.3222 19.831 22.2692 19.8486 22.2515 19.831H22.2339C22.2162 19.778 22.2339 19.778 22.2515 19.7603Z"
            fill="#204063"
          />
          <path
            d="M24.1059 19.6192C24.0883 19.6016 24.1413 19.6016 24.1059 19.5839C24.0706 19.5663 24.1413 19.5486 24.1589 19.5309H24.1413C24.1942 19.5486 24.1766 19.4426 24.2649 19.478C24.3532 19.5133 24.3355 19.5133 24.3532 19.4956C24.3708 19.478 24.4238 19.5663 24.4062 19.6192C24.3885 19.6722 24.3885 19.6369 24.3532 19.6899V19.7252C24.3355 19.6722 24.3179 19.7782 24.2825 19.7252L24.2296 19.7605V19.7252H24.1413V19.6899H24.1059C24.0883 19.6369 24.1589 19.6369 24.1059 19.6192Z"
            fill="#204063"
          />
          <path
            d="M24.2297 19.9194L24.1768 19.9371H24.2121L24.2297 19.9194Z"
            fill="white"
          />
          <path
            d="M25.5186 20.7491C25.5363 20.7491 25.5363 20.7314 25.5363 20.7137C25.5363 20.6961 25.6423 20.6961 25.6599 20.7314V20.802C25.6246 20.7844 25.6069 20.8197 25.5893 20.8374C25.5716 20.855 25.554 20.8374 25.554 20.8374H25.501C25.5186 20.7844 25.5363 20.7667 25.5186 20.7491Z"
            fill="#204063"
          />
          <path
            d="M25.5366 20.7847L25.5719 20.7671V20.7847H25.5366Z"
            fill="white"
          />
          <path
            d="M25.9602 22.3034C25.9955 22.2858 26.0485 22.3211 26.0132 22.3741C25.9778 22.427 25.9778 22.4094 25.9425 22.3917C25.9072 22.3741 25.8895 22.3034 25.9602 22.3034Z"
            fill="#204063"
          />
          <path
            d="M26.3311 19.9015V19.8662H26.4194C26.4371 19.8839 26.4371 19.9015 26.4194 19.9369H26.3841L26.3135 19.9015H26.3311Z"
            fill="#204063"
          />
          <path
            d="M26.4899 19.7778C26.4899 19.7955 26.4899 19.8132 26.4722 19.8132C26.4676 19.8132 26.4631 19.8113 26.4598 19.808C26.4564 19.8047 26.4546 19.8002 26.4546 19.7955L26.4899 19.7778Z"
            fill="#204063"
          />
          <path
            d="M25.9604 21.0495C25.9687 21.0385 25.9793 21.0296 25.9916 21.0235C26.0039 21.0174 26.0174 21.0142 26.0311 21.0142C26.0311 21.0318 26.0487 21.0318 26.0311 21.0495L25.9781 21.0848C25.9781 21.0848 25.9428 21.0671 25.9781 21.0495H25.9604Z"
            fill="#204063"
          />
          <path
            d="M25.9957 21.0494H26.0133C26.031 21.0317 25.978 21.0847 25.978 21.0494C25.978 21.0141 25.9957 21.0494 25.9957 21.0494Z"
            fill="white"
          />
          <path
            d="M26.8079 21.4029H26.7726C26.8079 21.4029 26.8079 21.3852 26.8256 21.3675C26.8433 21.3499 26.8256 21.3499 26.8079 21.3499C26.7903 21.3499 26.8433 21.3322 26.8609 21.3146H26.8433C26.9139 21.3146 27.0375 21.2439 27.1082 21.3499V21.4558H27.0905C27.0905 21.5088 27.0375 21.5265 27.0199 21.5618H26.9845C26.9669 21.5795 26.9669 21.5441 26.9492 21.5618L26.8962 21.5971V21.5618C26.8786 21.5441 26.8609 21.5618 26.8609 21.5795C26.8609 21.5971 26.8256 21.5265 26.7903 21.5088H26.7373C26.7726 21.4205 26.8256 21.4382 26.8079 21.4029Z"
            fill="#204063"
          />
          <path
            d="M26.7903 20.3254V20.29H26.7726C26.755 20.3077 26.7903 20.29 26.8079 20.3077C26.8256 20.3254 26.8079 20.2547 26.8433 20.2547C26.8786 20.2547 26.8256 20.2371 26.8079 20.2194C26.7903 20.2017 26.8609 20.2371 26.8962 20.2194C26.9316 20.2017 26.9845 20.2194 27.0199 20.1841H27.0728L27.1611 20.2547L27.1965 20.29C27.1965 20.29 27.1965 20.3077 27.2318 20.3254C27.2671 20.343 27.2848 20.3607 27.2318 20.3783C27.1788 20.396 27.2494 20.4137 27.2671 20.4137H27.2141C27.2671 20.449 27.1788 20.4666 27.2141 20.5196L27.1788 20.5549C27.1435 20.5373 27.1258 20.5903 27.1082 20.6079C27.0905 20.6256 27.0199 20.5549 27.0022 20.6256C26.9845 20.6962 26.9492 20.5549 26.9139 20.6079H26.8962C26.8786 20.5903 26.9316 20.5726 26.8962 20.5549C26.8609 20.5373 26.8786 20.5726 26.8609 20.5903C26.8433 20.6079 26.8962 20.5196 26.8433 20.5196H26.7903C26.8079 20.502 26.8079 20.4843 26.8079 20.449C26.8079 20.4137 26.7726 20.4843 26.7726 20.449C26.7726 20.4137 26.8079 20.4313 26.7903 20.4137H26.7373C26.7903 20.396 26.7726 20.343 26.7903 20.3254Z"
            fill="#204063"
          />
          <path
            d="M28.2384 20.9434C28.2384 20.9081 28.2737 20.8728 28.256 20.8375C28.2384 20.8022 28.2737 20.7492 28.3267 20.7668C28.3797 20.7845 28.3267 20.7139 28.3797 20.7315C28.4326 20.7315 28.4856 20.6962 28.5563 20.7315C28.6269 20.7668 28.5916 20.7845 28.6269 20.7668H28.6092C28.6269 20.7845 28.6799 20.8022 28.6622 20.8375V20.8728C28.6403 20.9039 28.628 20.9407 28.6269 20.9788C28.6092 20.9964 28.5739 20.9964 28.5916 21.0317C28.6092 21.0671 28.5563 21.0671 28.5386 21.0847H28.4856C28.4621 21.0847 28.4444 21.1024 28.4326 21.1377C28.4326 21.12 28.415 21.12 28.4326 21.1024C28.4503 21.0847 28.3973 21.12 28.3797 21.12H28.362C28.3443 21.1024 28.309 21.1377 28.2914 21.1377C28.2737 21.1377 28.309 21.1024 28.2914 21.0847H28.256V21.0317C28.2207 21.0141 28.2207 21.0671 28.2031 21.0494C28.1854 21.0317 28.2207 20.9788 28.2384 20.9434Z"
            fill="#204063"
          />
          <path
            d="M27.4967 19.1245C27.4967 19.1422 27.5144 19.1422 27.5144 19.1598C27.5144 19.1775 27.4614 19.1775 27.4614 19.1598C27.4614 19.1422 27.4614 19.1245 27.4967 19.1245Z"
            fill="#204063"
          />
          <path
            d="M27.638 17.8706H27.6733C27.691 17.8883 27.6557 17.9059 27.638 17.9236C27.6204 17.9412 27.638 17.9059 27.6027 17.8883C27.5674 17.8706 27.6204 17.8883 27.638 17.8706Z"
            fill="#204063"
          />
          <path
            d="M28.4681 20.3608H28.5211L28.4857 20.4138H28.4681C28.4504 20.3962 28.5034 20.3785 28.4681 20.3608V20.3962C28.4651 20.3846 28.4651 20.3724 28.4681 20.3608Z"
            fill="#204063"
          />
          <path
            d="M28.3796 19.3189C28.3788 19.3094 28.38 19.2997 28.383 19.2906C28.3861 19.2815 28.3909 19.2731 28.3973 19.2659C28.4091 19.249 28.425 19.2352 28.4435 19.2259C28.462 19.2167 28.4826 19.2122 28.5033 19.213C28.5562 19.2483 28.5916 19.2483 28.5916 19.3013C28.5916 19.3542 28.5562 19.3366 28.6092 19.3542C28.6622 19.3719 28.5562 19.3719 28.5739 19.4072C28.5916 19.4425 28.5386 19.4072 28.5209 19.4072H28.5033C28.4856 19.4425 28.4679 19.4072 28.4326 19.4249H28.4503C28.4503 19.4202 28.4484 19.4157 28.4451 19.4124C28.4418 19.4091 28.4373 19.4072 28.4326 19.4072C28.4279 19.4072 28.4235 19.4091 28.4201 19.4124C28.4168 19.4157 28.415 19.4202 28.415 19.4249L28.3796 19.3896V19.3189Z"
            fill="#204063"
          />
          <path
            d="M28.5562 19.478C28.5562 19.4603 28.6091 19.478 28.6091 19.4427H28.6445C28.6621 19.4427 28.6445 19.425 28.6621 19.4074H28.7328C28.7681 19.372 28.7857 19.4427 28.8211 19.4427C28.8564 19.4427 28.8387 19.4956 28.8917 19.4956C28.9447 19.4956 28.927 19.5839 28.874 19.6546H28.8564C28.8387 19.6722 28.8564 19.6899 28.8564 19.7076H28.8211C28.8211 19.7605 28.7504 19.7429 28.7328 19.7605C28.7151 19.7782 28.6974 19.7605 28.6974 19.7429H28.6798V19.6899C28.6621 19.7076 28.6445 19.6899 28.6445 19.7252C28.6445 19.7605 28.6268 19.6369 28.5915 19.6546C28.5962 19.6546 28.6006 19.6527 28.604 19.6494C28.6073 19.6461 28.6091 19.6416 28.6091 19.6369C28.6091 19.6322 28.6073 19.6278 28.604 19.6244C28.6006 19.6211 28.5962 19.6193 28.5915 19.6193C28.5208 19.5839 28.6091 19.5133 28.5562 19.478Z"
            fill="#204063"
          />
          <path
            d="M29.3158 19.7603C29.3334 19.7426 29.2981 19.725 29.2804 19.725C29.2628 19.725 29.2981 19.7073 29.2981 19.6897H29.2628C29.2628 19.672 29.3158 19.6897 29.2981 19.6543C29.3121 19.6543 29.3256 19.6487 29.3356 19.6388C29.3455 19.6289 29.3511 19.6154 29.3511 19.6014V19.5131C29.3864 19.5131 29.3334 19.4601 29.3864 19.4777C29.3773 19.437 29.3773 19.3948 29.3864 19.3541C29.4041 19.3541 29.3864 19.3365 29.4041 19.3188H29.4394C29.4217 19.2658 29.457 19.3188 29.457 19.2835C29.457 19.2482 29.51 19.3188 29.5453 19.3011C29.5807 19.2835 29.5807 19.3365 29.5807 19.3718C29.5807 19.4071 29.563 19.3188 29.5983 19.3011C29.6336 19.2835 29.5983 19.3718 29.6513 19.3718H29.669C29.6866 19.3718 29.6866 19.4248 29.7219 19.3894V19.4248H29.7396C29.7573 19.4424 29.7396 19.4601 29.7573 19.4601H29.7749L29.8102 19.5131H29.8279V19.566C29.8632 19.566 29.8279 19.619 29.8632 19.619C29.8985 19.619 29.8985 19.672 29.9162 19.672C29.9339 19.672 29.8809 19.672 29.8809 19.6897C29.8809 19.7073 29.9162 19.7073 29.9339 19.725H29.8985C29.8809 19.7426 29.8985 19.7603 29.9162 19.7779C29.9162 19.7956 29.8632 19.8309 29.9162 19.8309C29.9115 19.8309 29.907 19.8328 29.9037 19.8361C29.9004 19.8394 29.8985 19.8439 29.8985 19.8486C29.8985 19.8839 29.9162 19.8839 29.9339 19.9016C29.9515 19.9192 29.8632 19.8486 29.8632 19.9016V19.9722L29.8279 19.9192C29.7573 19.9545 29.8279 20.0605 29.7573 20.0782C29.7596 20.0688 29.7581 20.0589 29.7532 20.0506C29.7482 20.0423 29.7401 20.0364 29.7308 20.034C29.7214 20.0317 29.7115 20.0331 29.7032 20.0381C29.6949 20.0431 29.689 20.0511 29.6866 20.0605C29.6513 20.0605 29.6866 20.1135 29.6336 20.1135C29.5807 20.1135 29.563 20.0605 29.5277 20.0782C29.4924 20.0958 29.5277 20.1311 29.51 20.1311C29.4924 20.1311 29.5277 20.0782 29.4924 20.0605C29.51 20.0428 29.4924 20.0252 29.4747 20.0075H29.457C29.457 19.9899 29.4747 19.9722 29.4394 19.9722H29.4217C29.4041 19.9545 29.4394 19.9545 29.4217 19.9369C29.4041 19.9192 29.3864 19.9016 29.3687 19.9192C29.3511 19.9369 29.3864 19.8839 29.3511 19.8839H29.3334C29.3334 19.8662 29.3687 19.8662 29.3511 19.8309H29.2981V19.7956H29.2451C29.2804 19.7956 29.3158 19.7956 29.3158 19.7603Z"
            fill="#204063"
          />
          <path
            d="M25.2184 18.9302C25.236 18.9302 25.289 18.9125 25.3067 18.9479C25.3243 18.9832 25.3067 19.0715 25.2537 19.0538H25.236L25.183 19.0185C25.2184 18.9832 25.1477 18.9832 25.183 18.9479C25.2184 18.9125 25.2184 18.9655 25.2184 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5189 18.9302L25.4659 18.9655V18.9478L25.4482 18.9655V18.9478L25.5189 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5896 18.8595H25.5719C25.5719 18.8419 25.5896 18.8419 25.5896 18.8242H25.5543C25.5896 18.8066 25.5896 18.7889 25.6073 18.7712H25.5896C25.6424 18.7374 25.7035 18.7191 25.7662 18.7183C25.8015 18.7359 25.8368 18.7889 25.8898 18.7536C25.9428 18.7183 25.8545 18.7889 25.8898 18.7889L25.9428 18.8949C25.9075 18.9125 25.9251 18.9478 25.9251 18.9832C25.9251 19.0185 25.8722 19.0008 25.8898 19.0361H25.8722C25.8368 19.0538 25.8722 19.0715 25.8722 19.0891H25.8192C25.8192 19.1244 25.7485 19.1244 25.7309 19.1421C25.7132 19.1598 25.6602 19.1598 25.6426 19.1951C25.6249 19.2304 25.6779 19.1068 25.6249 19.0891C25.6249 19.0938 25.6231 19.0983 25.6197 19.1016C25.6164 19.1049 25.6119 19.1068 25.6073 19.1068C25.5719 19.0715 25.6426 19.0361 25.6073 19.0361L25.5366 19.0891C25.5719 18.9655 25.6249 18.9302 25.5896 18.8595Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M10.0308 24.2813L10.0484 24.2637V24.2813H10.0308Z"
            fill="white"
          />
          <path
            d="M10.0308 24.2989V24.2812H10.0484L10.0308 24.2989Z"
            fill="white"
          />
          <path
            d="M13.0154 24.7227V24.758C12.9977 24.7756 12.9977 24.7756 12.98 24.758C12.9624 24.7403 12.9624 24.7227 12.98 24.7227H13.0154Z"
            fill="#204063"
          />
          <path
            d="M13.1037 24.7755H13.086C13.0813 24.7755 13.0768 24.7736 13.0735 24.7703C13.0702 24.767 13.0684 24.7625 13.0684 24.7578C13.086 24.7401 13.1213 24.7578 13.1037 24.7755Z"
            fill="#204063"
          />
          <path
            d="M11.0201 21.1554C11.0201 21.1554 11.0024 21.1377 11.0201 21.1377V21.1554Z"
            fill="#204063"
          />
          <path
            d="M11.8324 23.575H11.8147C11.8139 23.5654 11.815 23.5558 11.8181 23.5466C11.8211 23.5375 11.826 23.5291 11.8324 23.522C11.8324 23.5396 11.85 23.5573 11.8324 23.575Z"
            fill="#204063"
          />
          <path
            d="M10.9845 21.3322C10.9845 21.3499 10.9669 21.3499 10.9492 21.3322V21.2969C10.9845 21.2969 10.9845 21.3145 10.9845 21.3322Z"
            fill="#204063"
          />
          <path
            d="M11.6382 20.3608C11.6558 20.3962 11.6912 20.4315 11.6735 20.4668C11.6558 20.5021 11.6558 20.4491 11.6558 20.4315C11.6558 20.4138 11.6558 20.3785 11.6382 20.3608Z"
            fill="#204063"
          />
          <path
            d="M12.044 25.9234H12.0616C12.097 25.9057 12.0793 25.9411 12.097 25.9411C12.097 25.9548 12.0938 25.9683 12.0876 25.9806C12.0815 25.9928 12.0726 26.0035 12.0616 26.0117H12.0087C12.0087 25.994 11.9557 26.0117 11.9733 25.9764V25.9234H12.0263H12.044Z"
            fill="#204063"
          />
          <path
            d="M11.6733 20.5904C11.6733 20.5904 11.691 20.6081 11.6733 20.6081V20.5727C11.6733 20.5551 11.6733 20.5727 11.6733 20.5904Z"
            fill="#204063"
          />
          <path
            d="M11.7791 20.6609C11.7728 20.6537 11.7679 20.6453 11.7649 20.6362C11.7618 20.6271 11.7607 20.6175 11.7615 20.6079L11.7791 20.6609Z"
            fill="#204063"
          />
          <path
            d="M11.7617 20.6431C11.7794 20.6431 11.7617 20.6431 11.7617 20.6255V20.6431Z"
            fill="white"
          />
          <path
            d="M12.4504 22.0912C12.4504 22.1089 12.4504 22.1265 12.4328 22.1265H12.3975C12.3986 22.1129 12.4049 22.1003 12.4151 22.0912C12.4328 22.0559 12.4328 22.0735 12.4504 22.0912Z"
            fill="#204063"
          />
          <path
            d="M12.2916 22.1265C12.2739 22.1441 12.2739 22.1441 12.2739 22.1265H12.2916Z"
            fill="#204063"
          />
          <path
            d="M11.9029 22.3033C11.8982 22.3033 11.8937 22.3014 11.8904 22.2981C11.8871 22.2948 11.8853 22.2903 11.8853 22.2856L11.9029 22.3033Z"
            fill="#204063"
          />
          <path
            d="M11.585 21.2789L11.5674 21.2612L11.585 21.2789Z"
            fill="#204063"
          />
          <path
            d="M11.5852 21.3851C11.5852 21.4028 11.5852 21.4204 11.5675 21.4204C11.5499 21.4204 11.5499 21.3674 11.5322 21.3498C11.5322 21.3498 11.5499 21.3321 11.5499 21.3498C11.5499 21.3674 11.5675 21.3321 11.5499 21.3145C11.5609 21.3227 11.5698 21.3333 11.5759 21.3456C11.582 21.3579 11.5852 21.3714 11.5852 21.3851Z"
            fill="#204063"
          />
          <path
            d="M12.2559 22.2681C12.2736 22.2857 12.2559 22.2857 12.2559 22.2857C12.2559 22.2857 12.2382 22.2681 12.2559 22.2681Z"
            fill="#204063"
          />
          <path
            d="M11.9737 22.4268H11.9561C11.9737 22.4092 11.9914 22.4092 11.9737 22.4268Z"
            fill="#204063"
          />
          <path
            d="M12.1324 22.4093H12.1148C12.1148 22.4093 12.0971 22.4093 12.1148 22.3916C12.1148 22.3963 12.1166 22.4008 12.12 22.4041C12.1233 22.4074 12.1278 22.4093 12.1324 22.4093Z"
            fill="#204063"
          />
          <path
            d="M12.0088 22.4444C11.9911 22.4444 12.0264 22.4797 11.9911 22.4797C11.9558 22.4797 11.9734 22.4444 11.9911 22.4268L12.0088 22.4444Z"
            fill="#204063"
          />
          <path
            d="M11.6912 21.5791V21.6144C11.6912 21.5968 11.6912 21.5968 11.7088 21.5968C11.7179 21.6434 11.7179 21.6914 11.7088 21.738H11.6558C11.6735 21.7027 11.6382 21.6851 11.6382 21.6674H11.6558C11.655 21.6578 11.6562 21.6482 11.6592 21.6391C11.6623 21.63 11.6671 21.6216 11.6735 21.6144L11.6912 21.5791Z"
            fill="#204063"
          />
          <path
            d="M11.5319 21.738C11.4966 21.7557 11.4966 21.7027 11.4966 21.6851H11.5142C11.5319 21.6851 11.5496 21.7027 11.5319 21.738Z"
            fill="#204063"
          />
          <path
            d="M11.5318 21.7203H11.5142V21.7026V21.7203H11.5318Z"
            fill="white"
          />
          <path
            d="M11.6911 24.387H11.6734C11.6381 24.3516 11.6734 24.2987 11.6734 24.2633V24.228C11.6967 24.2776 11.703 24.3335 11.6911 24.387Z"
            fill="#204063"
          />
          <path
            d="M11.5322 21.9325H11.5145C11.5145 21.9501 11.4969 21.9325 11.4969 21.9325C11.4882 21.9227 11.4834 21.9102 11.4834 21.8971C11.4834 21.8841 11.4882 21.8715 11.4969 21.8618C11.4792 21.8618 11.4969 21.8618 11.4969 21.8795C11.4969 21.8971 11.4969 21.8618 11.4969 21.8618C11.4969 21.8618 11.5322 21.9148 11.5322 21.9325Z"
            fill="#204063"
          />
          <path
            d="M11.4967 22.0033C11.5108 22.024 11.517 22.049 11.5144 22.0739H11.4967C11.4791 22.0739 11.4614 22.0562 11.4614 22.0209C11.4614 21.9856 11.4791 22.0033 11.4791 21.9856C11.4791 21.9679 11.4791 22.0209 11.4967 22.0033Z"
            fill="#204063"
          />
          <path
            d="M10.9318 22.3914H10.9141C10.8965 22.3914 10.8965 22.3561 10.8965 22.3561C10.8965 22.3561 10.8965 22.3385 10.8965 22.3208C10.9075 22.329 10.9164 22.3397 10.9225 22.352C10.9286 22.3642 10.9318 22.3777 10.9318 22.3914Z"
            fill="#204063"
          />
          <path
            d="M13.1393 22.2503C13.104 22.2503 13.104 22.215 13.104 22.1973C13.104 22.1797 13.1217 22.1267 13.104 22.0737H13.1217C13.1217 22.1091 13.1746 22.1797 13.1393 22.2503Z"
            fill="#204063"
          />
          <path
            d="M11.4259 22.8507H11.4082V22.8154H11.4259C11.4259 22.7977 11.4259 22.833 11.4259 22.8507Z"
            fill="#204063"
          />
          <path
            d="M11.4615 23.151C11.4792 23.151 11.4615 23.1333 11.4615 23.1333L11.4968 23.1863C11.4968 23.2039 11.4968 23.2039 11.4792 23.2216H11.4438C11.4438 23.2039 11.4615 23.1863 11.4438 23.1863V23.151H11.4615Z"
            fill="#204063"
          />
          <path
            d="M12.7681 22.5505H12.7505V22.5151L12.7681 22.5505Z"
            fill="#204063"
          />
          <path
            d="M11.9557 22.9922C11.9557 23.0275 11.991 23.0628 11.9733 23.0981H11.938C11.9204 23.0628 11.938 23.0452 11.938 23.0098L11.9557 22.9922Z"
            fill="#204063"
          />
          <path
            d="M11.3909 23.3804C11.3909 23.398 11.3909 23.4157 11.3732 23.4157C11.3556 23.4157 11.3556 23.4157 11.3556 23.4157C11.3509 23.4157 11.3464 23.4138 11.3431 23.4105C11.3398 23.4072 11.3379 23.4027 11.3379 23.398C11.3379 23.3933 11.3398 23.3889 11.3431 23.3855C11.3464 23.3822 11.3509 23.3804 11.3556 23.3804H11.3909Z"
            fill="#204063"
          />
          <path
            d="M12.4152 23.0451C12.4152 23.0627 12.4152 23.0804 12.3975 23.0804C12.3929 23.0804 12.3884 23.0785 12.3851 23.0752C12.3817 23.0719 12.3799 23.0674 12.3799 23.0627V23.0274C12.3975 23.0097 12.3975 23.0451 12.4152 23.0451Z"
            fill="#204063"
          />
          <path
            d="M11.3022 23.4338H11.3199C11.3022 23.4338 11.3022 23.4161 11.3199 23.3984C11.3246 23.4008 11.3282 23.4049 11.3298 23.4099C11.3315 23.4148 11.3311 23.4202 11.3287 23.4249C11.3264 23.4296 11.3223 23.4332 11.3173 23.4348C11.3124 23.4365 11.3069 23.4361 11.3022 23.4338Z"
            fill="#204063"
          />
          <path
            d="M13.1213 22.9745C13.1213 22.9922 13.1213 23.0099 13.1037 23.0099C13.086 23.0099 13.0684 23.0275 13.0684 23.0099C13.0684 22.9922 13.1037 22.9569 13.1213 22.9745Z"
            fill="#204063"
          />
          <path
            d="M12.8033 23.0627H12.821C12.821 23.098 12.8386 23.1333 12.821 23.1686C12.821 23.1733 12.8191 23.1778 12.8158 23.1811C12.8125 23.1844 12.808 23.1863 12.8033 23.1863C12.7986 23.1863 12.7941 23.1844 12.7908 23.1811C12.7875 23.1778 12.7856 23.1733 12.7856 23.1686V23.098H12.8033C12.8029 23.0733 12.809 23.0489 12.821 23.0273L12.8033 23.0627Z"
            fill="#204063"
          />
          <path
            d="M12.2384 23.2041H12.256C12.2647 23.2138 12.2695 23.2264 12.2695 23.2394C12.2695 23.2525 12.2647 23.265 12.256 23.2747H12.2207V23.2218H12.2384V23.2041Z"
            fill="#204063"
          />
          <path
            d="M10.9139 23.6453C10.9092 23.6453 10.9047 23.6434 10.9014 23.6401C10.8981 23.6368 10.8962 23.6323 10.8962 23.6276C10.8786 23.6276 10.9139 23.5923 10.8962 23.5923C10.8786 23.5923 10.9315 23.6276 10.9139 23.6453Z"
            fill="#204063"
          />
          <path
            d="M11.2143 25.2525H11.232C11.232 25.2525 11.1967 25.2878 11.232 25.2878C11.2673 25.2878 11.2143 25.3584 11.179 25.3761H11.1967C11.1967 25.4114 11.2143 25.4291 11.179 25.4467H11.1614C11.126 25.4114 11.2143 25.3761 11.1437 25.3408C11.0731 25.3055 11.1437 25.2701 11.1437 25.2525H11.1967C11.1967 25.2348 11.1967 25.2525 11.2143 25.2525Z"
            fill="#204063"
          />
          <path
            d="M11.32 23.6279C11.32 23.6456 11.32 23.6632 11.3024 23.6632H11.2847C11.267 23.6456 11.2847 23.6456 11.2847 23.6456H11.32V23.6279Z"
            fill="#204063"
          />
          <path
            d="M12.715 23.2925V23.3455H12.6973C12.6797 23.3455 12.6797 23.3101 12.6973 23.2925H12.715Z"
            fill="#204063"
          />
          <path
            d="M11.1788 23.8042H11.1965V23.8395H11.1611V23.8042H11.1788Z"
            fill="#204063"
          />
          <path
            d="M11.1787 23.8042V23.8219V23.8042H11.1964H11.1787Z"
            fill="white"
          />
          <path
            d="M11.2316 24.0514C11.2493 24.0514 11.2669 24.0691 11.2493 24.0868H11.2316C11.1963 24.0868 11.2139 24.0514 11.1963 24.0514C11.2139 24.0338 11.2139 24.0338 11.2139 24.0161C11.2093 24.0185 11.2057 24.0226 11.204 24.0275C11.2024 24.0325 11.2028 24.0379 11.2051 24.0426C11.2075 24.0473 11.2116 24.0508 11.2165 24.0525C11.2215 24.0542 11.2269 24.0538 11.2316 24.0514Z"
            fill="#204063"
          />
          <path
            d="M10.7725 24.0869C10.7725 24.1046 10.7902 24.1222 10.7725 24.1576V24.1222C10.7549 24.1046 10.7725 24.1046 10.7725 24.0869Z"
            fill="#204063"
          />
          <path
            d="M12.821 23.5923C12.821 23.6099 12.8386 23.6453 12.821 23.6629V23.6982L12.7856 23.6629V23.6276C12.8033 23.6453 12.7856 23.5923 12.8033 23.6099C12.8033 23.6099 12.8033 23.6099 12.821 23.5923Z"
            fill="#204063"
          />
          <path
            d="M11.0906 24.1221H11.1083C11.0906 24.1397 11.1083 24.175 11.0906 24.1927C11.073 24.2104 11.0553 24.175 11.0376 24.1574C11.02 24.1397 11.0376 24.1397 11.0376 24.1397H11.0906V24.1221Z"
            fill="#204063"
          />
          <path
            d="M12.3976 23.7337C12.3929 23.7337 12.3884 23.7319 12.3851 23.7286C12.3818 23.7252 12.3799 23.7207 12.3799 23.7161V23.6807C12.3623 23.6631 12.3799 23.6807 12.3799 23.6984C12.3976 23.6807 12.3976 23.6807 12.3976 23.6631C12.3976 23.6807 12.4152 23.7161 12.3976 23.7337Z"
            fill="#204063"
          />
          <path
            d="M12.2031 24.5461H12.2208V24.5107C12.2245 24.5141 12.2276 24.5181 12.2296 24.5227C12.2317 24.5273 12.2327 24.5322 12.2327 24.5372C12.2327 24.5422 12.2317 24.5472 12.2296 24.5518C12.2276 24.5563 12.2245 24.5604 12.2208 24.5637C12.217 24.5604 12.214 24.5563 12.212 24.5518C12.2099 24.5472 12.2088 24.5422 12.2088 24.5372C12.2088 24.5322 12.2099 24.5273 12.212 24.5227C12.214 24.5181 12.217 24.5141 12.2208 24.5107L12.2031 24.5461Z"
            fill="#204063"
          />
          <path
            d="M11.32 24.9876H11.3023C11.2847 25.0052 11.2847 24.9875 11.2847 24.9699C11.3023 24.9522 11.2847 24.9522 11.3023 24.9346H11.32C11.32 24.9522 11.3376 24.9699 11.32 24.9876Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.7759C11.9382 24.7935 11.9558 24.8289 11.9205 24.8289C11.8852 24.8289 11.9029 24.8289 11.9029 24.8112V24.7759H11.9205C11.9232 24.7774 11.9262 24.7782 11.9293 24.7782C11.9324 24.7782 11.9355 24.7774 11.9382 24.7759Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.8112H11.9205C11.9158 24.8112 11.9113 24.8093 11.908 24.806C11.9047 24.8027 11.9028 24.7982 11.9028 24.7935C11.9028 24.7889 11.9047 24.7844 11.908 24.781C11.9113 24.7777 11.9158 24.7759 11.9205 24.7759C11.9205 24.7935 11.9382 24.7759 11.9382 24.8112Z"
            fill="white"
          />
          <path
            d="M11.2496 24.8464C11.2496 24.864 11.2496 24.8464 11.2319 24.8464V24.811H11.2496C11.2496 24.8287 11.2673 24.8464 11.2496 24.8464Z"
            fill="#204063"
          />
          <path
            d="M12.0264 24.9172V24.8818C12.0264 24.8818 12.044 24.8995 12.0264 24.9172Z"
            fill="#204063"
          />
          <path
            d="M10.7373 26.2769H10.7726C10.7726 26.2769 10.755 26.2769 10.7726 26.2946C10.7773 26.2946 10.7818 26.2927 10.7851 26.2894C10.7884 26.2861 10.7903 26.2816 10.7903 26.2769C10.7903 26.2723 10.7884 26.2678 10.7851 26.2645C10.7818 26.2611 10.7773 26.2593 10.7726 26.2593C10.7903 26.2769 10.7726 26.3123 10.7903 26.3123H10.8079C10.8079 26.3476 10.8256 26.3476 10.8256 26.3652C10.8264 26.3748 10.8253 26.3844 10.8222 26.3935C10.8192 26.4027 10.8143 26.4111 10.8079 26.4182C10.8433 26.4006 10.8079 26.4535 10.8256 26.4535C10.8209 26.4535 10.8164 26.4554 10.8131 26.4587C10.8098 26.462 10.8079 26.4665 10.8079 26.4712L10.7373 26.5065H10.6843C10.6667 26.5065 10.649 26.4889 10.6667 26.4712H10.649C10.6517 26.4463 10.6454 26.4213 10.6313 26.4006H10.6667V26.3652C10.6843 26.3652 10.6667 26.3476 10.6843 26.3299C10.702 26.3123 10.702 26.3476 10.7196 26.3299C10.7174 26.3203 10.7178 26.3103 10.7209 26.3009C10.7241 26.2916 10.7297 26.2832 10.7373 26.2769Z"
            fill="#204063"
          />
          <path
            d="M11.9205 25.0582V25.0935C11.9028 25.1112 11.9028 25.0758 11.9028 25.0758C11.9028 25.0758 11.9028 25.0582 11.9028 25.0405L11.9205 25.0582Z"
            fill="#204063"
          />
          <path
            d="M11.8501 25.27H11.7971C11.7971 25.2877 11.7794 25.2877 11.7618 25.2877C11.7557 25.2658 11.7559 25.2427 11.7621 25.2209C11.7683 25.1991 11.7804 25.1794 11.7971 25.1641H11.8147C11.8249 25.1676 11.8341 25.1735 11.8417 25.1812C11.8493 25.1888 11.855 25.1982 11.8584 25.2084C11.8618 25.2186 11.8628 25.2295 11.8614 25.2402C11.8599 25.2509 11.8561 25.2611 11.8501 25.27Z"
            fill="#204063"
          />
          <path
            d="M11.1966 27.4601H11.2143V27.4954H11.2319C11.2143 27.5308 11.2319 27.5484 11.2143 27.5661C11.1966 27.5837 11.1966 27.6014 11.1966 27.6191H11.126C11.1249 27.6055 11.1185 27.5928 11.1083 27.5837H11.0553C11.02 27.5837 11.0377 27.5484 11.02 27.5308V27.4954C11.0377 27.5131 11.0377 27.4778 11.0553 27.4601H11.126V27.4248H11.1613C11.1613 27.4248 11.179 27.4778 11.1966 27.4601Z"
            fill="#204063"
          />
          <path
            d="M11.0731 25.7114C11.0731 25.7291 11.1084 25.7467 11.1084 25.7821L11.0731 25.835L11.0024 25.7997C11.0201 25.7821 11.0024 25.7467 11.0024 25.7467H11.0201C11.0201 25.7291 11.0201 25.7114 11.0378 25.7114H11.0731Z"
            fill="#204063"
          />
          <path
            d="M11.6029 25.5703H11.6205C11.6382 25.6056 11.5675 25.6056 11.6029 25.6409C11.6382 25.6762 11.5852 25.6939 11.5675 25.6939C11.5499 25.6939 11.5322 25.6586 11.5322 25.6409C11.5499 25.6586 11.5499 25.6233 11.5499 25.6233H11.5852C11.5782 25.6209 11.5724 25.6159 11.5691 25.6093C11.5657 25.6026 11.5652 25.595 11.5675 25.5879C11.5699 25.5809 11.5749 25.5751 11.5815 25.5718C11.5882 25.5685 11.5958 25.5679 11.6029 25.5703Z"
            fill="#204063"
          />
          <path
            d="M11.4083 26.3652V26.4006C11.3907 26.4182 11.4437 26.4182 11.4083 26.4535C11.373 26.4889 11.3907 26.4712 11.3907 26.4889H11.32V26.4535C11.3377 26.4535 11.3024 26.4359 11.32 26.4359V26.4006H11.373C11.3907 26.3476 11.3907 26.3829 11.4083 26.3652Z"
            fill="#204063"
          />
          <path
            d="M10.7019 26.7008C10.7019 26.7184 10.7019 26.7184 10.7196 26.7184C10.7372 26.7184 10.7019 26.7714 10.6842 26.7537H10.6489C10.6666 26.7361 10.6489 26.7361 10.6489 26.7184C10.6536 26.7184 10.6581 26.7166 10.6614 26.7133C10.6647 26.7099 10.6666 26.7054 10.6666 26.7008C10.6666 26.6961 10.6684 26.6916 10.6718 26.6883C10.6751 26.685 10.6796 26.6831 10.6842 26.6831L10.7019 26.7008Z"
            fill="#204063"
          />
          <path
            d="M10.6842 26.7007V26.7183H10.6665L10.6842 26.7007Z"
            fill="white"
          />
          <path
            d="M9.99577 26.5592C9.99577 26.5768 9.97811 26.5945 9.96045 26.5768V26.5415C9.97811 26.5238 10.0134 26.5415 9.99577 26.5592Z"
            fill="#204063"
          />
          <path
            d="M10.8784 27.2481C10.8784 27.2481 10.8784 27.2304 10.8961 27.2481H10.8784Z"
            fill="#204063"
          />
          <path
            d="M10.4903 26.8066C10.508 26.8066 10.4903 26.8243 10.4903 26.8243H10.4727C10.4727 26.8243 10.4903 26.8066 10.4903 26.8243V26.8066Z"
            fill="#204063"
          />
          <path
            d="M10.1899 27.0186H10.2252C10.2075 27.0186 10.2252 27.0362 10.2252 27.0362C10.2252 27.0715 10.2252 27.1069 10.1722 27.1245L10.1192 27.0892C10.1016 27.0715 10.1192 27.0539 10.1016 27.0362H10.1192C10.1016 27.0186 10.1192 27.0362 10.1192 27.0186H10.1899Z"
            fill="#204063"
          />
          <path
            d="M10.6135 27.2481H10.6489V27.2834C10.6665 27.3011 10.6312 27.3011 10.6312 27.3364H10.5429C10.5429 27.3188 10.5076 27.3541 10.5076 27.3188C10.4722 27.3364 10.4899 27.3011 10.4722 27.3011H10.4546C10.4593 27.3011 10.4638 27.2992 10.4671 27.2959C10.4704 27.2926 10.4722 27.2881 10.4722 27.2834C10.4722 27.2788 10.4704 27.2743 10.4671 27.271C10.4638 27.2676 10.4593 27.2658 10.4546 27.2658C10.4546 27.2481 10.4899 27.2481 10.4722 27.2305C10.4546 27.2128 10.5076 27.2305 10.4899 27.1951C10.5076 27.1951 10.5076 27.2128 10.5076 27.1951C10.5076 27.1775 10.5076 27.1951 10.5076 27.1775C10.5076 27.1598 10.5252 27.2128 10.5429 27.1951H10.5959C10.5782 27.2305 10.6135 27.2305 10.6135 27.2481Z"
            fill="#204063"
          />
          <path
            d="M10.066 27.5835L10.1014 27.6188C10.0837 27.6365 10.119 27.6365 10.1014 27.6541C10.0837 27.6718 10.119 27.6718 10.1014 27.6718H10.119C10.1014 27.6895 10.1014 27.7248 10.066 27.7424H9.96008C9.94242 27.7248 9.96008 27.7071 9.94242 27.7071C9.92476 27.7071 9.94242 27.6895 9.94242 27.6718C9.9471 27.6718 9.9516 27.6699 9.95491 27.6666C9.95822 27.6633 9.96008 27.6588 9.96008 27.6541C9.96008 27.6495 9.95822 27.645 9.95491 27.6416C9.9516 27.6383 9.9471 27.6365 9.94242 27.6365H9.96008C9.96008 27.6365 9.94242 27.6188 9.96008 27.6188H10.0307L10.066 27.5835Z"
            fill="#204063"
          />
          <path
            d="M10.9137 27.778H10.8961C10.8914 27.778 10.8869 27.7761 10.8836 27.7728C10.8803 27.7695 10.8784 27.765 10.8784 27.7603C10.8784 27.7557 10.8803 27.7512 10.8836 27.7478C10.8869 27.7445 10.8914 27.7427 10.8961 27.7427C10.9137 27.7603 10.9137 27.7603 10.9137 27.778Z"
            fill="#204063"
          />
          <path
            d="M11.3199 28.131C11.3022 28.131 11.3022 28.1134 11.3022 28.0957H11.3199C11.3199 28.0957 11.3376 28.131 11.3199 28.131Z"
            fill="#204063"
          />
          <path
            d="M10.6136 28.043H10.6313V28.0959C10.5959 28.0959 10.5959 28.1136 10.5606 28.0959H10.543C10.543 28.0783 10.5606 28.0606 10.543 28.0606H10.5606C10.543 28.0606 10.5606 28.0606 10.5606 28.043C10.5606 28.0477 10.5625 28.0521 10.5658 28.0555C10.5691 28.0588 10.5736 28.0606 10.5783 28.0606H10.6136V28.043Z"
            fill="#204063"
          />
          <path
            d="M10.5075 28.0604H10.5252C10.5075 28.0604 10.5252 28.078 10.5252 28.078H10.5075L10.4722 28.1134H10.4192C10.4192 28.078 10.3839 28.0957 10.3662 28.0604H10.3839C10.3662 28.0427 10.3839 28.0251 10.3839 28.0074H10.4015C10.4015 27.9897 10.4192 27.9897 10.4015 27.9897C10.3839 27.9897 10.4369 28.0074 10.4369 27.9897H10.4545C10.4898 28.0074 10.4898 28.0604 10.5075 28.0604Z"
            fill="#204063"
          />
          <path
            d="M10.2076 28.2192H10.2606C10.2606 28.2369 10.2429 28.2546 10.2606 28.2546H10.2783C10.2783 28.2722 10.2606 28.2899 10.2783 28.2899H10.2959C10.2959 28.2899 10.3136 28.2899 10.2959 28.3075H10.3489C10.3313 28.3252 10.3489 28.3252 10.3489 28.3252H10.3313C10.3489 28.3252 10.3313 28.3252 10.3313 28.3429H10.137C10.137 28.3075 10.1017 28.3252 10.1017 28.3252H10.0663V28.2899H10.031C10.031 28.2899 10.0663 28.2899 10.0487 28.2722C10.0487 28.2369 9.99571 28.2369 10.0134 28.2016C10.031 28.1663 10.031 28.2016 10.031 28.2016C10.031 28.2016 10.0134 28.1663 10.031 28.1663L10.0663 28.1309C10.0663 28.1309 10.0487 28.1133 10.0663 28.1133C10.0663 28.118 10.0682 28.1225 10.0715 28.1258C10.0748 28.1291 10.0793 28.1309 10.084 28.1309H10.1193C10.1193 28.1309 10.1193 28.1486 10.137 28.1309H10.2253L10.2076 28.2192Z"
            fill="#204063"
          />
          <path
            d="M11.4791 26.9302C11.4615 26.9478 11.4791 26.9655 11.4438 26.9655C11.4085 26.9655 11.4085 26.9478 11.4262 26.9302H11.4791Z"
            fill="#204063"
          />
          <path
            d="M11.4082 27.0539V27.0362H11.4259L11.4082 27.0186H11.4259L11.4082 27.0539Z"
            fill="#204063"
          />
          <path
            d="M11.4261 27.1065H11.4437V27.1418C11.4614 27.1595 11.4437 27.1948 11.4437 27.2125C11.4437 27.2301 11.3908 27.2301 11.3908 27.2655H11.3378C11.3201 27.2301 11.3201 27.2301 11.3025 27.2301C11.3025 27.2125 11.3201 27.1948 11.3025 27.1772C11.2848 27.1595 11.3201 27.1418 11.3025 27.1418C11.2848 27.1418 11.3378 27.1595 11.3554 27.1595C11.3731 27.1595 11.3378 27.1418 11.3554 27.1418C11.3731 27.1418 11.3731 27.1595 11.3731 27.1595V27.1065C11.3908 27.0712 11.3908 27.1065 11.4261 27.1065Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M19.7262 23.8751L19.6909 23.8574H19.7262V23.8751Z"
            fill="white"
          />
          <path
            d="M19.797 23.8751L19.7617 23.8927V23.8574L19.797 23.8751Z"
            fill="white"
          />
          <path
            d="M19.8323 17.0583L19.8853 17.0229C19.8977 17.0339 19.9073 17.0476 19.9134 17.0629C19.9196 17.0782 19.922 17.0948 19.9206 17.1112C19.903 17.1466 19.8677 17.1466 19.8323 17.1289C19.8237 17.1192 19.8188 17.1066 19.8188 17.0936C19.8188 17.0806 19.8237 17.068 19.8323 17.0583Z"
            fill="#204063"
          />
          <path
            d="M19.9028 16.8286C19.9205 16.8286 19.9205 16.8462 19.9205 16.8639L19.8675 16.8992C19.8322 16.8816 19.8498 16.7933 19.9028 16.8286Z"
            fill="#204063"
          />
          <path
            d="M11.9557 21.1026C11.9557 21.1203 11.938 21.1556 11.9204 21.1379H11.9027C11.9018 21.1313 11.9027 21.1246 11.9054 21.1185C11.9082 21.1125 11.9125 21.1073 11.9181 21.1036C11.9236 21.0999 11.9301 21.0978 11.9367 21.0977C11.9434 21.0975 11.9499 21.0992 11.9557 21.1026Z"
            fill="#204063"
          />
          <path
            d="M17.4145 19.8689L17.397 19.8711L17.3981 19.8799L17.4156 19.8777L17.4145 19.8689Z"
            fill="#204063"
          />
          <path
            d="M17.7133 19.9367C17.6779 19.972 17.6249 19.9367 17.6073 19.9013C17.5896 19.866 17.6779 19.9013 17.7133 19.9367Z"
            fill="#204063"
          />
          <path
            d="M12.4325 21.1909C12.4501 21.2262 12.4501 21.2616 12.4148 21.2616C12.3795 21.2616 12.3618 21.2439 12.3618 21.2262C12.3618 21.2086 12.4148 21.1909 12.4325 21.1909Z"
            fill="#204063"
          />
          <path
            d="M10.8962 19.0538H10.8785C10.9096 19.0393 10.9439 19.0333 10.978 19.0364C11.0121 19.0395 11.0448 19.0516 11.0728 19.0714C11.0728 19.1067 11.0374 19.0891 11.0021 19.1067L10.8608 19.0714L10.8962 19.0538Z"
            fill="#204063"
          />
          <path
            d="M22.7108 18.5594H22.6755L22.7108 18.5241C22.6755 18.4711 22.7638 18.4711 22.7638 18.4358C22.8135 18.4305 22.8636 18.443 22.905 18.4711C22.9404 18.5241 22.9227 18.5241 22.9404 18.577C22.958 18.63 22.958 18.683 22.8697 18.683C22.7814 18.683 22.8167 18.6653 22.7638 18.7007C22.7108 18.736 22.7461 18.6653 22.7284 18.6653H22.7108C22.7284 18.63 22.7108 18.6124 22.6755 18.5947C22.6401 18.577 22.6931 18.577 22.7108 18.5594Z"
            fill="#204063"
          />
          <path
            d="M11.3554 19.1597L11.4084 19.195C11.3907 19.2303 11.3377 19.2126 11.3201 19.2126H11.2671L11.3554 19.1597Z"
            fill="#204063"
          />
          <path
            d="M11.5498 19.0011H11.5675C11.5321 19.0187 11.4792 18.9834 11.4438 18.9834L11.5498 19.0011Z"
            fill="#204063"
          />
          <path
            d="M14.3048 19.6895C14.3224 19.7071 14.3224 19.7071 14.3224 19.7248H14.2871C14.2871 19.7248 14.2695 19.6895 14.3048 19.6895Z"
            fill="#204063"
          />
          <path
            d="M14.6578 18.8066H14.6931L14.6578 18.8596C14.6401 18.8596 14.6401 18.8243 14.6578 18.8066Z"
            fill="#204063"
          />
          <path
            d="M14.6579 18.312C14.6756 18.3297 14.7286 18.3297 14.7109 18.365C14.6933 18.4003 14.7109 18.4356 14.6756 18.4356C14.6403 18.4356 14.6403 18.4003 14.605 18.4003C14.5696 18.4003 14.6403 18.3473 14.6579 18.312Z"
            fill="#204063"
          />
          <path
            d="M14.6931 18.7007C14.6931 18.7007 14.7107 18.6831 14.7107 18.7007V18.736C14.6754 18.736 14.6578 18.7007 14.6931 18.7007Z"
            fill="#204063"
          />
          <path
            d="M14.958 19.6016H14.9933C14.9757 19.6192 14.9933 19.6369 14.9757 19.6545C14.958 19.6722 14.905 19.6192 14.958 19.6016Z"
            fill="#204063"
          />
          <path
            d="M12.6799 19.8662L12.627 19.8839L12.6446 19.8662H12.6799Z"
            fill="#204063"
          />
          <path
            d="M12.9096 19.9193C12.9273 19.9369 12.9802 19.9369 12.9626 19.9722C12.9449 20.0076 12.839 20.0076 12.8036 20.0076H12.786C12.8036 19.9899 12.786 19.9899 12.786 19.9722C12.786 19.9546 12.7683 19.9193 12.7153 19.9369C12.7773 19.9138 12.8444 19.9077 12.9096 19.9193Z"
            fill="#204063"
          />
          <path
            d="M14.9932 18.7891C15.0109 18.7891 15.0109 18.8067 15.0109 18.8244C15.0109 18.842 14.9932 18.842 14.9756 18.8244L14.9932 18.7891Z"
            fill="#204063"
          />
          <path
            d="M15.2227 19.478C15.2404 19.478 15.2404 19.4956 15.2404 19.5133H15.2051C15.1874 19.4956 15.2051 19.4603 15.2227 19.478Z"
            fill="#204063"
          />
          <path
            d="M15.2232 19.1421C15.2409 19.1421 15.2585 19.1774 15.2409 19.1774C15.2232 19.1774 15.2056 19.1951 15.2056 19.1774L15.2232 19.1421Z"
            fill="#204063"
          />
          <path
            d="M15.2759 19.4248C15.2936 19.4425 15.3642 19.4071 15.3466 19.4601C15.3289 19.5131 15.2936 19.4954 15.2583 19.4601C15.223 19.4248 15.2583 19.4248 15.2759 19.4248Z"
            fill="#204063"
          />
          <path
            d="M13.3687 19.7957C13.4041 19.7957 13.4217 19.7957 13.4217 19.7604V19.7251C13.51 19.7428 13.6336 19.7074 13.7043 19.7957C13.7749 19.884 13.7043 19.8487 13.6866 19.8664H13.5983C13.563 19.8311 13.4924 19.9017 13.4394 19.8664H13.4747L13.3511 19.8134L13.3687 19.7957Z"
            fill="#204063"
          />
          <path
            d="M13.6337 20.2193C13.6514 20.3076 13.5454 20.2723 13.5101 20.2723L13.4395 20.2369C13.4674 20.2171 13.5001 20.2051 13.5342 20.202C13.5683 20.1989 13.6027 20.2048 13.6337 20.2193Z"
            fill="#204063"
          />
          <path
            d="M13.5808 20.2373L13.5632 20.255L13.5278 20.2373L13.5632 20.255L13.5808 20.2373Z"
            fill="white"
          />
          <path
            d="M19.5499 20.131H19.5676C19.5146 20.2193 19.3733 20.184 19.285 20.1486H19.2144C19.2649 20.1195 19.3217 20.1027 19.38 20.0996C19.4383 20.0966 19.4965 20.1073 19.5499 20.131Z"
            fill="#204063"
          />
          <path
            d="M13.8102 20.3077L13.7749 20.29H13.8102V20.3077Z"
            fill="#204063"
          />
          <path
            d="M14.0397 20.3253H14.0927L14.0574 20.3783C14.0097 20.3905 13.9593 20.3842 13.9161 20.3606C13.8984 20.3783 13.9338 20.3606 13.9338 20.343H13.8984C13.9183 20.3278 13.9419 20.3182 13.9667 20.3151C13.9915 20.312 14.0167 20.3155 14.0397 20.3253Z"
            fill="#204063"
          />
          <path
            d="M14.0047 20.3606H13.987C13.9693 20.3959 13.987 20.3606 13.9693 20.3783C13.9517 20.3959 13.9693 20.3253 14.0047 20.3606Z"
            fill="white"
          />
          <path
            d="M14.1812 20.4311C14.2038 20.4144 14.2304 20.404 14.2583 20.4009C14.2862 20.3978 14.3145 20.4021 14.3402 20.4135C14.3578 20.4135 14.3755 20.4312 14.3578 20.4665C14.3147 20.49 14.2642 20.4963 14.2166 20.4841C14.2166 20.4488 14.1636 20.4665 14.1459 20.4665C14.1283 20.4665 14.2166 20.4665 14.1812 20.4311Z"
            fill="#204063"
          />
          <path
            d="M14.2339 20.4136L14.2515 20.4312H14.2339V20.4136Z"
            fill="white"
          />
          <path
            d="M14.8519 21.8441C14.8696 21.8441 14.8519 21.8617 14.8519 21.8617C14.8519 21.8617 14.7813 21.8971 14.7459 21.8971C14.7106 21.8971 14.7106 21.9147 14.6753 21.8794C14.7287 21.8487 14.7907 21.8363 14.8519 21.8441Z"
            fill="#204063"
          />
          <path
            d="M15.0817 16.8286C15.117 16.8992 15.0287 16.8992 15.0111 16.9169C14.9934 16.9345 14.8521 16.8462 14.7815 16.8462H14.7285C14.8345 16.8462 14.9934 16.7226 15.0817 16.8286Z"
            fill="#204063"
          />
          <path
            d="M16.0527 20.8022C16.0704 20.8022 16.0881 20.8022 16.0881 20.8199C16.0881 20.8376 16.1057 20.8552 16.0704 20.8729H15.9468C15.9644 20.8022 16.0174 20.8022 16.0527 20.8022Z"
            fill="#204063"
          />
          <path
            d="M15.4172 20.873L15.3818 20.8907V20.873H15.4172Z"
            fill="white"
          />
          <path
            d="M16.7418 20.7668H16.7241C16.7594 20.7315 16.7948 20.7315 16.8477 20.7139C16.8631 20.7157 16.8778 20.7216 16.8902 20.7309C16.9026 20.7402 16.9123 20.7526 16.9184 20.7668C16.936 20.8022 16.9007 20.8022 16.8831 20.8375C16.8654 20.8728 16.8124 20.8022 16.7771 20.8375H16.7948L16.7241 20.8022L16.7418 20.7668Z"
            fill="#204063"
          />
          <path
            d="M15.5939 17.5704L15.5586 17.5527H15.5939V17.5704Z"
            fill="#204063"
          />
          <path
            d="M15.647 17.7471H15.6823C15.7 17.7647 15.7176 17.7647 15.7176 17.8001H15.647V17.7471Z"
            fill="#204063"
          />
          <path
            d="M16.4414 19.6544C16.512 19.6544 16.6003 19.5661 16.671 19.6368C16.6737 19.6437 16.675 19.6511 16.6747 19.6586C16.6743 19.666 16.6725 19.6733 16.6691 19.68C16.6658 19.6867 16.6611 19.6925 16.6553 19.6973C16.6496 19.702 16.6429 19.7054 16.6357 19.7074C16.565 19.7251 16.512 19.6721 16.4414 19.6544Z"
            fill="#204063"
          />
          <path
            d="M17.2891 20.9434C17.3245 20.9434 17.3774 20.9257 17.3951 20.961C17.4128 20.9964 17.3598 21.014 17.3598 21.0317H17.2715C17.2715 21.014 17.2891 20.9964 17.2715 20.9964C17.2538 20.9964 17.2715 20.9787 17.2891 20.9434Z"
            fill="#204063"
          />
          <path
            d="M16.6006 18.6124C16.6146 18.6106 16.6288 18.613 16.6414 18.6193C16.6539 18.6256 16.6644 18.6355 16.6713 18.6477C16.6713 18.6654 16.6536 18.683 16.636 18.7007H16.5477C16.53 18.6301 16.5653 18.6301 16.6006 18.6124Z"
            fill="#204063"
          />
          <path
            d="M17.4304 21.1203C17.4481 21.1026 17.4127 21.085 17.4304 21.085V21.1203Z"
            fill="#204063"
          />
          <path
            d="M16.4594 17.0229C16.4947 17.0053 16.5124 17.0229 16.5477 17.0406C16.583 17.0583 16.5477 17.1112 16.5124 17.1112C16.4771 17.1112 16.4241 17.0583 16.4594 17.0229Z"
            fill="#204063"
          />
          <path
            d="M16.6359 17.7296C16.6359 17.7119 16.6359 17.7119 16.6182 17.7119C16.6006 17.7119 16.6536 17.6942 16.6712 17.7119C16.6889 17.7296 16.8125 17.6413 16.8831 17.7119C16.9538 17.7825 16.8831 17.7649 16.8655 17.7825H16.7419C16.6901 17.7813 16.6404 17.7626 16.6006 17.7296H16.6359Z"
            fill="#204063"
          />
          <path
            d="M16.9005 19.0007C16.9005 19.0184 16.9181 19.0184 16.9181 19.0361C16.9214 19.0398 16.9255 19.0428 16.9301 19.0449C16.9347 19.0469 16.9396 19.048 16.9446 19.048C16.9496 19.048 16.9546 19.0469 16.9592 19.0449C16.9637 19.0428 16.9678 19.0398 16.9711 19.0361C16.9181 19.0361 16.9535 18.9831 16.9181 18.9654C16.8828 18.9478 17.0241 18.9301 17.0594 18.9831C17.0594 18.9968 17.0562 19.0103 17.0501 19.0226C17.044 19.0348 17.0351 19.0455 17.0241 19.0537C16.9888 19.0361 16.9711 19.0537 16.9358 19.0714H16.9005C16.9181 19.0537 16.9005 19.0537 16.9181 19.0361H16.8828C16.8828 19.0007 16.9005 19.0184 16.9005 19.0007Z"
            fill="#204063"
          />
          <path
            d="M17.9249 21.9856C17.9602 22.0033 17.9249 22.0386 17.9072 22.0386C17.8896 22.0386 17.8189 22.0209 17.7836 22.0563C17.7483 22.0916 17.8719 21.968 17.9249 21.9856Z"
            fill="#204063"
          />
          <path
            d="M16.9537 19.001C16.9714 19.001 16.936 19.0186 16.936 19.0186H16.9537V19.001Z"
            fill="white"
          />
          <path
            d="M16.9712 18.9831C16.9712 18.9654 16.9889 18.9654 16.9712 18.9478V18.9831Z"
            fill="white"
          />
          <path
            d="M21.7748 20.8197L21.7395 20.7843C21.7395 20.7667 21.8631 20.8197 21.8101 20.7314C21.7572 20.6431 22.0044 20.7314 22.075 20.802H22.0927L22.0574 20.7667C22.1104 20.7667 22.181 20.7137 22.234 20.7314C22.287 20.749 22.2693 20.7667 22.2516 20.7843C22.234 20.802 22.0221 20.749 21.9867 20.908C21.9514 21.0669 21.8455 20.9609 21.7925 20.9433L21.7395 20.9786C21.7925 20.9609 21.7395 20.9256 21.7395 20.908L21.6865 20.8726C21.7042 20.855 21.7572 20.855 21.7748 20.8197Z"
            fill="#204063"
          />
          <path
            d="M17.872 21.085C17.9073 21.1026 17.9603 21.0673 17.9779 21.1203C17.9956 21.1733 17.9249 21.1556 17.9073 21.1909C17.8896 21.2262 17.8896 21.1556 17.8543 21.1733H17.872C17.8543 21.1556 17.8366 21.085 17.872 21.085Z"
            fill="#204063"
          />
          <path
            d="M17.0951 17.9589C17.1304 17.9236 17.1481 17.9236 17.1834 17.9413C17.2187 17.9589 17.2187 17.9589 17.2011 17.9766C17.1834 17.9943 17.1304 17.9943 17.0951 17.9943C17.0598 17.9943 17.0774 17.9589 17.0951 17.9589Z"
            fill="#204063"
          />
          <path d="M17.13 17.959L17.0947 17.9766V17.959H17.13Z" fill="white" />
          <path
            d="M18.2959 21.4026C18.2783 21.4026 18.2959 21.3673 18.2959 21.3673C18.2959 21.3673 18.3489 21.3319 18.3666 21.3673C18.3842 21.4026 18.3489 21.4026 18.3489 21.4202L18.2959 21.4026Z"
            fill="#204063"
          />
          <path
            d="M18.3136 21.3848H18.3312V21.4025L18.2959 21.3848L18.3136 21.3672V21.3848Z"
            fill="white"
          />
          <path
            d="M18.8784 21.2261C18.8961 21.1908 18.9314 21.1555 18.9667 21.1732C18.9821 21.175 18.9968 21.1809 19.0092 21.1902C19.0216 21.1995 19.0313 21.2119 19.0374 21.2261C19.0374 21.2791 18.9667 21.2791 18.9314 21.2968C18.9138 21.2615 18.8961 21.2791 18.8608 21.2615C18.8255 21.2438 18.8784 21.2261 18.8784 21.2261Z"
            fill="#204063"
          />
          <path
            d="M19.0905 22.2856C19.0905 22.2809 19.0886 22.2764 19.0853 22.2731C19.082 22.2698 19.0775 22.2679 19.0728 22.2679H19.0552C19.1082 22.2502 19.1611 22.1973 19.2318 22.2326C19.3024 22.2679 19.2141 22.3032 19.1788 22.3032C19.1435 22.3032 19.0905 22.3032 19.0552 22.3032L19.0905 22.2856Z"
            fill="#204063"
          />
          <path
            d="M17.6954 17.7116L17.8014 17.6763C17.8367 17.6763 17.8543 17.6939 17.872 17.7292C17.8734 17.7457 17.8709 17.7623 17.8648 17.7776C17.8587 17.7929 17.849 17.8066 17.8367 17.8175C17.8014 17.8175 17.7837 17.7999 17.7484 17.8352C17.7131 17.8705 17.6777 17.8175 17.7131 17.7646H17.6777C17.6954 17.7646 17.6954 17.7292 17.6954 17.7116Z"
            fill="#204063"
          />
          <path
            d="M19.0905 21.5262C19.1435 21.5438 19.2141 21.4732 19.2494 21.5438C19.2848 21.6145 19.2141 21.6145 19.1788 21.6498C19.1435 21.6851 19.1435 21.6498 19.1258 21.6498H19.1435C19.0905 21.6498 19.1258 21.6321 19.0905 21.6321H19.0552C19.0905 21.5615 19.0552 21.5262 19.0905 21.5262Z"
            fill="#204063"
          />
          <path
            d="M18.0134 18.6652L17.9781 18.7005H17.9251C17.9251 18.7358 17.9605 18.7182 17.9605 18.7182V18.6829C17.9251 18.6475 17.9075 18.6829 17.8898 18.6829H17.8545C17.9075 18.6475 17.9781 18.6122 18.0134 18.6652Z"
            fill="#204063"
          />
          <path
            d="M19.6734 20.8023C19.6734 20.807 19.6752 20.8115 19.6785 20.8148C19.6819 20.8181 19.6864 20.82 19.691 20.82H19.6734V20.7847C19.6557 20.82 19.6734 20.8023 19.6734 20.8023Z"
            fill="#204063"
          />
          <path
            d="M19.7438 18.9125C19.7615 18.8949 19.7438 18.9125 19.7438 18.9302H19.7791C19.7968 18.9302 19.7791 18.9125 19.7791 18.8949L19.7262 18.9302C19.7398 18.9164 19.7565 18.906 19.7749 18.8999C19.7933 18.8938 19.8129 18.892 19.8321 18.8949V18.9302C19.816 18.9459 19.7954 18.956 19.7732 18.9592C19.751 18.9624 19.7283 18.9584 19.7085 18.9479L19.7438 18.9125Z"
            fill="#204063"
          />
          <path
            d="M19.797 18.9479L19.7793 18.9303L19.797 18.9126V18.9479Z"
            fill="white"
          />
          <path
            d="M21.0861 20.6963C21.1214 20.6963 21.1214 20.7316 21.1038 20.7669L21.0508 20.8022C21.0508 20.8022 21.0508 20.7493 21.0155 20.7669C20.9801 20.7846 21.0155 20.8022 20.9801 20.8199H20.9448C20.9752 20.7628 21.0255 20.7189 21.0861 20.6963Z"
            fill="#204063"
          />
          <path
            d="M20.3442 19.4249C20.3972 19.4249 20.4325 19.3896 20.4855 19.4249C20.486 19.4409 20.4811 19.4567 20.4714 19.4695C20.4618 19.4823 20.4481 19.4915 20.4325 19.4955H20.3619V19.4602H20.3442C20.3442 19.4602 20.3619 19.4425 20.3442 19.4249Z"
            fill="#204063"
          />
          <path
            d="M20.4153 19.4248H20.3976C20.4027 19.4266 20.4073 19.4295 20.4111 19.4334C20.4149 19.4372 20.4177 19.4419 20.4194 19.447C20.4211 19.4521 20.4217 19.4575 20.4209 19.4629C20.4202 19.4682 20.4183 19.4733 20.4153 19.4778C20.4153 19.5131 20.3623 19.4954 20.3623 19.4954C20.3623 19.4954 20.3623 19.4425 20.4153 19.4248Z"
            fill="white"
          />
          <path
            d="M20.8036 20.9259V20.9613L20.7329 20.9966L20.7682 20.9613V20.9259C20.7682 20.9436 20.7506 20.9613 20.7329 20.9436C20.742 20.9345 20.7533 20.9281 20.7658 20.925C20.7782 20.9218 20.7913 20.9222 20.8036 20.9259Z"
            fill="#204063"
          />
          <path
            d="M20.5918 19.1597H20.6095L20.5741 19.195H20.4858L20.5918 19.1597Z"
            fill="#204063"
          />
          <path
            d="M24.477 21.0673C24.477 21.0143 24.424 21.0496 24.4063 21.0496C24.3887 21.0496 24.4593 21.0496 24.4593 21.0143H24.3887C24.424 20.979 24.4946 20.9967 24.5123 20.9437C24.53 20.8907 24.477 20.926 24.4946 20.9084C24.5123 20.8907 24.5476 20.8554 24.6006 20.8377H24.7066C24.6712 20.7847 24.7772 20.8201 24.7595 20.7671C24.7419 20.7141 24.8302 20.8201 24.8478 20.7847C24.8655 20.7494 24.9715 20.8554 24.9715 20.926C24.9715 20.9967 24.9715 20.9613 24.9715 21.0143C24.9715 21.032 24.9538 21.0496 24.9715 21.0673C24.9891 21.085 24.9185 21.085 24.9185 21.1026C24.9185 21.1203 24.9008 21.1733 24.8832 21.1733C24.8655 21.1733 24.8655 21.1733 24.8655 21.1909H24.8478C24.7772 21.2262 24.7242 21.2262 24.6712 21.2969L24.6359 21.3499C24.6359 21.3145 24.6712 21.2969 24.6359 21.2616H24.6006C24.5829 21.2439 24.5476 21.2969 24.5123 21.2792C24.477 21.2616 24.5123 21.2086 24.477 21.1909H24.4063C24.4227 21.2003 24.4422 21.2028 24.4604 21.1978C24.4786 21.1928 24.4941 21.1808 24.5035 21.1644C24.5128 21.148 24.5153 21.1286 24.5103 21.1104C24.5054 21.0922 24.4934 21.0767 24.477 21.0673Z"
            fill="#204063"
          />
          <path
            d="M20.9623 19.3542C20.9446 19.3542 20.9446 19.3542 20.9446 19.3718H20.9976V19.3365C20.98 19.3188 20.9623 19.3542 20.9623 19.3365C20.9623 19.3188 21.0153 19.3188 21.0329 19.3188C21.0506 19.3188 21.0153 19.3718 20.98 19.3718C20.9446 19.3718 20.927 19.3542 20.9093 19.3542C20.8917 19.3542 20.9446 19.3365 20.9623 19.3542Z"
            fill="#204063"
          />
          <path
            d="M21.4393 19.3896C21.4746 19.4073 21.5099 19.4426 21.5099 19.4603C21.5099 19.4779 21.5099 19.4956 21.4923 19.4956C21.4746 19.4956 21.5806 19.5309 21.5629 19.5662C21.5453 19.6016 21.351 19.5662 21.2804 19.5486V19.5133H21.2627C21.2766 19.4775 21.3008 19.4467 21.3323 19.4247C21.3637 19.4027 21.4009 19.3905 21.4393 19.3896Z"
            fill="#204063"
          />
          <path
            d="M26.5431 18.948H26.5255C26.5608 18.9303 26.5608 18.9127 26.5785 18.895H26.5431C26.5431 18.8774 26.5961 18.8774 26.5608 18.8597C26.6314 18.8597 26.6314 18.8067 26.6844 18.8067C26.7374 18.8067 26.7904 18.7891 26.8257 18.7891C26.861 18.7891 26.861 18.8067 26.8787 18.8244V18.948L26.8257 19.0186C26.861 19.0363 26.914 19.054 26.9317 19.0893C26.9493 19.1246 26.8963 19.1599 26.8787 19.2129L26.7904 19.2482C26.808 19.1952 26.7197 19.2129 26.6844 19.2129H26.6668C26.6844 19.1952 26.7021 19.1952 26.7021 19.1776H26.6668C26.6668 19.1599 26.6844 19.1599 26.6844 19.1423H26.6668C26.6844 19.1599 26.6844 19.1423 26.6844 19.1246H26.7021C26.6668 19.1246 26.6491 19.1246 26.6491 19.0893H26.5608V19.054H26.5078C26.5255 18.9833 26.5961 18.9657 26.5431 18.948Z"
            fill="#204063"
          />
          <path
            d="M22.9054 20.855H22.8877C22.923 20.8197 22.9407 20.749 23.029 20.749C23.1173 20.749 23.0996 20.749 23.1526 20.7667C23.2056 20.7843 23.1526 20.8726 23.1173 20.9256C23.082 20.9786 23.029 20.9786 22.976 20.9786H22.8877C22.9054 20.908 22.8877 20.8726 22.9054 20.855Z"
            fill="#204063"
          />
          <path
            d="M21.9867 19.7603C21.9867 19.7427 21.969 19.725 21.9514 19.7427C21.9337 19.7603 21.9867 19.7427 21.9867 19.7603Z"
            fill="#204063"
          />
          <path
            d="M22.2515 19.7603H22.2339C22.2339 19.7603 22.2692 19.7427 22.2515 19.725C22.2339 19.7074 22.3752 19.8133 22.4281 19.725C22.4811 19.6367 22.5341 19.725 22.5694 19.778C22.5684 19.8004 22.5612 19.8221 22.5488 19.8408C22.5363 19.8594 22.5191 19.8744 22.4988 19.884L22.4281 19.9193C22.4281 19.9146 22.4263 19.9101 22.423 19.9068C22.4197 19.9035 22.4152 19.9016 22.4105 19.9016H22.3752C22.3928 19.8663 22.3398 19.9016 22.3222 19.8663C22.3222 19.831 22.2692 19.8486 22.2515 19.831H22.2339C22.2162 19.778 22.2339 19.778 22.2515 19.7603Z"
            fill="#204063"
          />
          <path
            d="M24.1059 19.6192C24.0883 19.6016 24.1413 19.6016 24.1059 19.5839C24.0706 19.5663 24.1413 19.5486 24.1589 19.5309H24.1413C24.1942 19.5486 24.1766 19.4426 24.2649 19.478C24.3532 19.5133 24.3355 19.5133 24.3532 19.4956C24.3708 19.478 24.4238 19.5663 24.4062 19.6192C24.3885 19.6722 24.3885 19.6369 24.3532 19.6899V19.7252C24.3355 19.6722 24.3179 19.7782 24.2825 19.7252L24.2296 19.7605V19.7252H24.1413V19.6899H24.1059C24.0883 19.6369 24.1589 19.6369 24.1059 19.6192Z"
            fill="#204063"
          />
          <path
            d="M24.2297 19.9194L24.1768 19.9371H24.2121L24.2297 19.9194Z"
            fill="white"
          />
          <path
            d="M25.5186 20.7491C25.5363 20.7491 25.5363 20.7314 25.5363 20.7137C25.5363 20.6961 25.6423 20.6961 25.6599 20.7314V20.802C25.6246 20.7844 25.6069 20.8197 25.5893 20.8374C25.5716 20.855 25.554 20.8374 25.554 20.8374H25.501C25.5186 20.7844 25.5363 20.7667 25.5186 20.7491Z"
            fill="#204063"
          />
          <path
            d="M25.5366 20.7847L25.5719 20.7671V20.7847H25.5366Z"
            fill="white"
          />
          <path
            d="M25.9602 22.3034C25.9955 22.2858 26.0485 22.3211 26.0132 22.3741C25.9778 22.427 25.9778 22.4094 25.9425 22.3917C25.9072 22.3741 25.8895 22.3034 25.9602 22.3034Z"
            fill="#204063"
          />
          <path
            d="M26.3311 19.9015V19.8662H26.4194C26.4371 19.8839 26.4371 19.9015 26.4194 19.9369H26.3841L26.3135 19.9015H26.3311Z"
            fill="#204063"
          />
          <path
            d="M26.4899 19.7778C26.4899 19.7955 26.4899 19.8132 26.4722 19.8132C26.4676 19.8132 26.4631 19.8113 26.4598 19.808C26.4564 19.8047 26.4546 19.8002 26.4546 19.7955L26.4899 19.7778Z"
            fill="#204063"
          />
          <path
            d="M25.9604 21.0495C25.9687 21.0385 25.9793 21.0296 25.9916 21.0235C26.0039 21.0174 26.0174 21.0142 26.0311 21.0142C26.0311 21.0318 26.0487 21.0318 26.0311 21.0495L25.9781 21.0848C25.9781 21.0848 25.9428 21.0671 25.9781 21.0495H25.9604Z"
            fill="#204063"
          />
          <path
            d="M25.9957 21.0494H26.0133C26.031 21.0317 25.978 21.0847 25.978 21.0494C25.978 21.0141 25.9957 21.0494 25.9957 21.0494Z"
            fill="white"
          />
          <path
            d="M26.8079 21.4029H26.7726C26.8079 21.4029 26.8079 21.3852 26.8256 21.3675C26.8433 21.3499 26.8256 21.3499 26.8079 21.3499C26.7903 21.3499 26.8433 21.3322 26.8609 21.3146H26.8433C26.9139 21.3146 27.0375 21.2439 27.1082 21.3499V21.4558H27.0905C27.0905 21.5088 27.0375 21.5265 27.0199 21.5618H26.9845C26.9669 21.5795 26.9669 21.5441 26.9492 21.5618L26.8962 21.5971V21.5618C26.8786 21.5441 26.8609 21.5618 26.8609 21.5795C26.8609 21.5971 26.8256 21.5265 26.7903 21.5088H26.7373C26.7726 21.4205 26.8256 21.4382 26.8079 21.4029Z"
            fill="#204063"
          />
          <path
            d="M26.7903 20.3254V20.29H26.7726C26.755 20.3077 26.7903 20.29 26.8079 20.3077C26.8256 20.3254 26.8079 20.2547 26.8433 20.2547C26.8786 20.2547 26.8256 20.2371 26.8079 20.2194C26.7903 20.2017 26.8609 20.2371 26.8962 20.2194C26.9316 20.2017 26.9845 20.2194 27.0199 20.1841H27.0728L27.1611 20.2547L27.1965 20.29C27.1965 20.29 27.1965 20.3077 27.2318 20.3254C27.2671 20.343 27.2848 20.3607 27.2318 20.3783C27.1788 20.396 27.2494 20.4137 27.2671 20.4137H27.2141C27.2671 20.449 27.1788 20.4666 27.2141 20.5196L27.1788 20.5549C27.1435 20.5373 27.1258 20.5903 27.1082 20.6079C27.0905 20.6256 27.0199 20.5549 27.0022 20.6256C26.9845 20.6962 26.9492 20.5549 26.9139 20.6079H26.8962C26.8786 20.5903 26.9316 20.5726 26.8962 20.5549C26.8609 20.5373 26.8786 20.5726 26.8609 20.5903C26.8433 20.6079 26.8962 20.5196 26.8433 20.5196H26.7903C26.8079 20.502 26.8079 20.4843 26.8079 20.449C26.8079 20.4137 26.7726 20.4843 26.7726 20.449C26.7726 20.4137 26.8079 20.4313 26.7903 20.4137H26.7373C26.7903 20.396 26.7726 20.343 26.7903 20.3254Z"
            fill="#204063"
          />
          <path
            d="M28.2384 20.9434C28.2384 20.9081 28.2737 20.8728 28.256 20.8375C28.2384 20.8022 28.2737 20.7492 28.3267 20.7668C28.3797 20.7845 28.3267 20.7139 28.3797 20.7315C28.4326 20.7315 28.4856 20.6962 28.5563 20.7315C28.6269 20.7668 28.5916 20.7845 28.6269 20.7668H28.6092C28.6269 20.7845 28.6799 20.8022 28.6622 20.8375V20.8728C28.6403 20.9039 28.628 20.9407 28.6269 20.9788C28.6092 20.9964 28.5739 20.9964 28.5916 21.0317C28.6092 21.0671 28.5563 21.0671 28.5386 21.0847H28.4856C28.4621 21.0847 28.4444 21.1024 28.4326 21.1377C28.4326 21.12 28.415 21.12 28.4326 21.1024C28.4503 21.0847 28.3973 21.12 28.3797 21.12H28.362C28.3443 21.1024 28.309 21.1377 28.2914 21.1377C28.2737 21.1377 28.309 21.1024 28.2914 21.0847H28.256V21.0317C28.2207 21.0141 28.2207 21.0671 28.2031 21.0494C28.1854 21.0317 28.2207 20.9788 28.2384 20.9434Z"
            fill="#204063"
          />
          <path
            d="M27.4967 19.1245C27.4967 19.1422 27.5144 19.1422 27.5144 19.1598C27.5144 19.1775 27.4614 19.1775 27.4614 19.1598C27.4614 19.1422 27.4614 19.1245 27.4967 19.1245Z"
            fill="#204063"
          />
          <path
            d="M27.638 17.8706H27.6733C27.691 17.8883 27.6557 17.9059 27.638 17.9236C27.6204 17.9412 27.638 17.9059 27.6027 17.8883C27.5674 17.8706 27.6204 17.8883 27.638 17.8706Z"
            fill="#204063"
          />
          <path
            d="M28.4681 20.3608H28.5211L28.4857 20.4138H28.4681C28.4504 20.3962 28.5034 20.3785 28.4681 20.3608V20.3962C28.4651 20.3846 28.4651 20.3724 28.4681 20.3608Z"
            fill="#204063"
          />
          <path
            d="M28.3796 19.3189C28.3788 19.3094 28.38 19.2997 28.383 19.2906C28.3861 19.2815 28.3909 19.2731 28.3973 19.2659C28.4091 19.249 28.425 19.2352 28.4435 19.2259C28.462 19.2167 28.4826 19.2122 28.5033 19.213C28.5562 19.2483 28.5916 19.2483 28.5916 19.3013C28.5916 19.3542 28.5562 19.3366 28.6092 19.3542C28.6622 19.3719 28.5562 19.3719 28.5739 19.4072C28.5916 19.4425 28.5386 19.4072 28.5209 19.4072H28.5033C28.4856 19.4425 28.4679 19.4072 28.4326 19.4249H28.4503C28.4503 19.4202 28.4484 19.4157 28.4451 19.4124C28.4418 19.4091 28.4373 19.4072 28.4326 19.4072C28.4279 19.4072 28.4235 19.4091 28.4201 19.4124C28.4168 19.4157 28.415 19.4202 28.415 19.4249L28.3796 19.3896V19.3189Z"
            fill="#204063"
          />
          <path
            d="M28.5562 19.478C28.5562 19.4603 28.6091 19.478 28.6091 19.4427H28.6445C28.6621 19.4427 28.6445 19.425 28.6621 19.4074H28.7328C28.7681 19.372 28.7857 19.4427 28.8211 19.4427C28.8564 19.4427 28.8387 19.4956 28.8917 19.4956C28.9447 19.4956 28.927 19.5839 28.874 19.6546H28.8564C28.8387 19.6722 28.8564 19.6899 28.8564 19.7076H28.8211C28.8211 19.7605 28.7504 19.7429 28.7328 19.7605C28.7151 19.7782 28.6974 19.7605 28.6974 19.7429H28.6798V19.6899C28.6621 19.7076 28.6445 19.6899 28.6445 19.7252C28.6445 19.7605 28.6268 19.6369 28.5915 19.6546C28.5962 19.6546 28.6006 19.6527 28.604 19.6494C28.6073 19.6461 28.6091 19.6416 28.6091 19.6369C28.6091 19.6322 28.6073 19.6278 28.604 19.6244C28.6006 19.6211 28.5962 19.6193 28.5915 19.6193C28.5208 19.5839 28.6091 19.5133 28.5562 19.478Z"
            fill="#204063"
          />
          <path
            d="M29.3158 19.7603C29.3334 19.7426 29.2981 19.725 29.2804 19.725C29.2628 19.725 29.2981 19.7073 29.2981 19.6897H29.2628C29.2628 19.672 29.3158 19.6897 29.2981 19.6543C29.3121 19.6543 29.3256 19.6487 29.3356 19.6388C29.3455 19.6289 29.3511 19.6154 29.3511 19.6014V19.5131C29.3864 19.5131 29.3334 19.4601 29.3864 19.4777C29.3773 19.437 29.3773 19.3948 29.3864 19.3541C29.4041 19.3541 29.3864 19.3365 29.4041 19.3188H29.4394C29.4217 19.2658 29.457 19.3188 29.457 19.2835C29.457 19.2482 29.51 19.3188 29.5453 19.3011C29.5807 19.2835 29.5807 19.3365 29.5807 19.3718C29.5807 19.4071 29.563 19.3188 29.5983 19.3011C29.6336 19.2835 29.5983 19.3718 29.6513 19.3718H29.669C29.6866 19.3718 29.6866 19.4248 29.7219 19.3894V19.4248H29.7396C29.7573 19.4424 29.7396 19.4601 29.7573 19.4601H29.7749L29.8102 19.5131H29.8279V19.566C29.8632 19.566 29.8279 19.619 29.8632 19.619C29.8985 19.619 29.8985 19.672 29.9162 19.672C29.9339 19.672 29.8809 19.672 29.8809 19.6897C29.8809 19.7073 29.9162 19.7073 29.9339 19.725H29.8985C29.8809 19.7426 29.8985 19.7603 29.9162 19.7779C29.9162 19.7956 29.8632 19.8309 29.9162 19.8309C29.9115 19.8309 29.907 19.8328 29.9037 19.8361C29.9004 19.8394 29.8985 19.8439 29.8985 19.8486C29.8985 19.8839 29.9162 19.8839 29.9339 19.9016C29.9515 19.9192 29.8632 19.8486 29.8632 19.9016V19.9722L29.8279 19.9192C29.7573 19.9545 29.8279 20.0605 29.7573 20.0782C29.7596 20.0688 29.7581 20.0589 29.7532 20.0506C29.7482 20.0423 29.7401 20.0364 29.7308 20.034C29.7214 20.0317 29.7115 20.0331 29.7032 20.0381C29.6949 20.0431 29.689 20.0511 29.6866 20.0605C29.6513 20.0605 29.6866 20.1135 29.6336 20.1135C29.5807 20.1135 29.563 20.0605 29.5277 20.0782C29.4924 20.0958 29.5277 20.1311 29.51 20.1311C29.4924 20.1311 29.5277 20.0782 29.4924 20.0605C29.51 20.0428 29.4924 20.0252 29.4747 20.0075H29.457C29.457 19.9899 29.4747 19.9722 29.4394 19.9722H29.4217C29.4041 19.9545 29.4394 19.9545 29.4217 19.9369C29.4041 19.9192 29.3864 19.9016 29.3687 19.9192C29.3511 19.9369 29.3864 19.8839 29.3511 19.8839H29.3334C29.3334 19.8662 29.3687 19.8662 29.3511 19.8309H29.2981V19.7956H29.2451C29.2804 19.7956 29.3158 19.7956 29.3158 19.7603Z"
            fill="#204063"
          />
          <path
            d="M25.2184 18.9302C25.236 18.9302 25.289 18.9125 25.3067 18.9479C25.3243 18.9832 25.3067 19.0715 25.2537 19.0538H25.236L25.183 19.0185C25.2184 18.9832 25.1477 18.9832 25.183 18.9479C25.2184 18.9125 25.2184 18.9655 25.2184 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5189 18.9302L25.4659 18.9655V18.9478L25.4482 18.9655V18.9478L25.5189 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5896 18.8595H25.5719C25.5719 18.8419 25.5896 18.8419 25.5896 18.8242H25.5543C25.5896 18.8066 25.5896 18.7889 25.6073 18.7712H25.5896C25.6424 18.7374 25.7035 18.7191 25.7662 18.7183C25.8015 18.7359 25.8368 18.7889 25.8898 18.7536C25.9428 18.7183 25.8545 18.7889 25.8898 18.7889L25.9428 18.8949C25.9075 18.9125 25.9251 18.9478 25.9251 18.9832C25.9251 19.0185 25.8722 19.0008 25.8898 19.0361H25.8722C25.8368 19.0538 25.8722 19.0715 25.8722 19.0891H25.8192C25.8192 19.1244 25.7485 19.1244 25.7309 19.1421C25.7132 19.1598 25.6602 19.1598 25.6426 19.1951C25.6249 19.2304 25.6779 19.1068 25.6249 19.0891C25.6249 19.0938 25.6231 19.0983 25.6197 19.1016C25.6164 19.1049 25.6119 19.1068 25.6073 19.1068C25.5719 19.0715 25.6426 19.0361 25.6073 19.0361L25.5366 19.0891C25.5719 18.9655 25.6249 18.9302 25.5896 18.8595Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M10.0308 24.2813L10.0484 24.2637V24.2813H10.0308Z"
            fill="white"
          />
          <path
            d="M10.0308 24.2989V24.2812H10.0484L10.0308 24.2989Z"
            fill="white"
          />
          <path
            d="M13.0154 24.7227V24.758C12.9977 24.7756 12.9977 24.7756 12.98 24.758C12.9624 24.7403 12.9624 24.7227 12.98 24.7227H13.0154Z"
            fill="#204063"
          />
          <path
            d="M13.1037 24.7755H13.086C13.0813 24.7755 13.0768 24.7736 13.0735 24.7703C13.0702 24.767 13.0684 24.7625 13.0684 24.7578C13.086 24.7401 13.1213 24.7578 13.1037 24.7755Z"
            fill="#204063"
          />
          <path
            d="M11.0201 21.1554C11.0201 21.1554 11.0024 21.1377 11.0201 21.1377V21.1554Z"
            fill="#204063"
          />
          <path
            d="M11.8324 23.575H11.8147C11.8139 23.5654 11.815 23.5558 11.8181 23.5466C11.8211 23.5375 11.826 23.5291 11.8324 23.522C11.8324 23.5396 11.85 23.5573 11.8324 23.575Z"
            fill="#204063"
          />
          <path
            d="M10.9845 21.3322C10.9845 21.3499 10.9669 21.3499 10.9492 21.3322V21.2969C10.9845 21.2969 10.9845 21.3145 10.9845 21.3322Z"
            fill="#204063"
          />
          <path
            d="M11.6382 20.3608C11.6558 20.3962 11.6912 20.4315 11.6735 20.4668C11.6558 20.5021 11.6558 20.4491 11.6558 20.4315C11.6558 20.4138 11.6558 20.3785 11.6382 20.3608Z"
            fill="#204063"
          />
          <path
            d="M12.044 25.9234H12.0616C12.097 25.9057 12.0793 25.9411 12.097 25.9411C12.097 25.9548 12.0938 25.9683 12.0876 25.9806C12.0815 25.9928 12.0726 26.0035 12.0616 26.0117H12.0087C12.0087 25.994 11.9557 26.0117 11.9733 25.9764V25.9234H12.0263H12.044Z"
            fill="#204063"
          />
          <path
            d="M11.6733 20.5904C11.6733 20.5904 11.691 20.6081 11.6733 20.6081V20.5727C11.6733 20.5551 11.6733 20.5727 11.6733 20.5904Z"
            fill="#204063"
          />
          <path
            d="M11.7791 20.6609C11.7728 20.6537 11.7679 20.6453 11.7649 20.6362C11.7618 20.6271 11.7607 20.6175 11.7615 20.6079L11.7791 20.6609Z"
            fill="#204063"
          />
          <path
            d="M11.7617 20.6431C11.7794 20.6431 11.7617 20.6431 11.7617 20.6255V20.6431Z"
            fill="white"
          />
          <path
            d="M12.4504 22.0912C12.4504 22.1089 12.4504 22.1265 12.4328 22.1265H12.3975C12.3986 22.1129 12.4049 22.1003 12.4151 22.0912C12.4328 22.0559 12.4328 22.0735 12.4504 22.0912Z"
            fill="#204063"
          />
          <path
            d="M12.2916 22.1265C12.2739 22.1441 12.2739 22.1441 12.2739 22.1265H12.2916Z"
            fill="#204063"
          />
          <path
            d="M11.9029 22.3033C11.8982 22.3033 11.8937 22.3014 11.8904 22.2981C11.8871 22.2948 11.8853 22.2903 11.8853 22.2856L11.9029 22.3033Z"
            fill="#204063"
          />
          <path
            d="M11.585 21.2789L11.5674 21.2612L11.585 21.2789Z"
            fill="#204063"
          />
          <path
            d="M11.5852 21.3851C11.5852 21.4028 11.5852 21.4204 11.5675 21.4204C11.5499 21.4204 11.5499 21.3674 11.5322 21.3498C11.5322 21.3498 11.5499 21.3321 11.5499 21.3498C11.5499 21.3674 11.5675 21.3321 11.5499 21.3145C11.5609 21.3227 11.5698 21.3333 11.5759 21.3456C11.582 21.3579 11.5852 21.3714 11.5852 21.3851Z"
            fill="#204063"
          />
          <path
            d="M12.2559 22.2681C12.2736 22.2857 12.2559 22.2857 12.2559 22.2857C12.2559 22.2857 12.2382 22.2681 12.2559 22.2681Z"
            fill="#204063"
          />
          <path
            d="M11.9737 22.4268H11.9561C11.9737 22.4092 11.9914 22.4092 11.9737 22.4268Z"
            fill="#204063"
          />
          <path
            d="M12.1324 22.4093H12.1148C12.1148 22.4093 12.0971 22.4093 12.1148 22.3916C12.1148 22.3963 12.1166 22.4008 12.12 22.4041C12.1233 22.4074 12.1278 22.4093 12.1324 22.4093Z"
            fill="#204063"
          />
          <path
            d="M12.0088 22.4444C11.9911 22.4444 12.0264 22.4797 11.9911 22.4797C11.9558 22.4797 11.9734 22.4444 11.9911 22.4268L12.0088 22.4444Z"
            fill="#204063"
          />
          <path
            d="M11.6912 21.5791V21.6144C11.6912 21.5968 11.6912 21.5968 11.7088 21.5968C11.7179 21.6434 11.7179 21.6914 11.7088 21.738H11.6558C11.6735 21.7027 11.6382 21.6851 11.6382 21.6674H11.6558C11.655 21.6578 11.6562 21.6482 11.6592 21.6391C11.6623 21.63 11.6671 21.6216 11.6735 21.6144L11.6912 21.5791Z"
            fill="#204063"
          />
          <path
            d="M11.5319 21.738C11.4966 21.7557 11.4966 21.7027 11.4966 21.6851H11.5142C11.5319 21.6851 11.5496 21.7027 11.5319 21.738Z"
            fill="#204063"
          />
          <path
            d="M11.5318 21.7203H11.5142V21.7026V21.7203H11.5318Z"
            fill="white"
          />
          <path
            d="M11.6911 24.387H11.6734C11.6381 24.3516 11.6734 24.2987 11.6734 24.2633V24.228C11.6967 24.2776 11.703 24.3335 11.6911 24.387Z"
            fill="#204063"
          />
          <path
            d="M11.5322 21.9325H11.5145C11.5145 21.9501 11.4969 21.9325 11.4969 21.9325C11.4882 21.9227 11.4834 21.9102 11.4834 21.8971C11.4834 21.8841 11.4882 21.8715 11.4969 21.8618C11.4792 21.8618 11.4969 21.8618 11.4969 21.8795C11.4969 21.8971 11.4969 21.8618 11.4969 21.8618C11.4969 21.8618 11.5322 21.9148 11.5322 21.9325Z"
            fill="#204063"
          />
          <path
            d="M11.4967 22.0033C11.5108 22.024 11.517 22.049 11.5144 22.0739H11.4967C11.4791 22.0739 11.4614 22.0562 11.4614 22.0209C11.4614 21.9856 11.4791 22.0033 11.4791 21.9856C11.4791 21.9679 11.4791 22.0209 11.4967 22.0033Z"
            fill="#204063"
          />
          <path
            d="M10.9318 22.3914H10.9141C10.8965 22.3914 10.8965 22.3561 10.8965 22.3561C10.8965 22.3561 10.8965 22.3385 10.8965 22.3208C10.9075 22.329 10.9164 22.3397 10.9225 22.352C10.9286 22.3642 10.9318 22.3777 10.9318 22.3914Z"
            fill="#204063"
          />
          <path
            d="M13.1393 22.2503C13.104 22.2503 13.104 22.215 13.104 22.1973C13.104 22.1797 13.1217 22.1267 13.104 22.0737H13.1217C13.1217 22.1091 13.1746 22.1797 13.1393 22.2503Z"
            fill="#204063"
          />
          <path
            d="M11.4259 22.8507H11.4082V22.8154H11.4259C11.4259 22.7977 11.4259 22.833 11.4259 22.8507Z"
            fill="#204063"
          />
          <path
            d="M11.4615 23.151C11.4792 23.151 11.4615 23.1333 11.4615 23.1333L11.4968 23.1863C11.4968 23.2039 11.4968 23.2039 11.4792 23.2216H11.4438C11.4438 23.2039 11.4615 23.1863 11.4438 23.1863V23.151H11.4615Z"
            fill="#204063"
          />
          <path
            d="M12.7681 22.5505H12.7505V22.5151L12.7681 22.5505Z"
            fill="#204063"
          />
          <path
            d="M11.9557 22.9922C11.9557 23.0275 11.991 23.0628 11.9733 23.0981H11.938C11.9204 23.0628 11.938 23.0452 11.938 23.0098L11.9557 22.9922Z"
            fill="#204063"
          />
          <path
            d="M11.3909 23.3804C11.3909 23.398 11.3909 23.4157 11.3732 23.4157C11.3556 23.4157 11.3556 23.4157 11.3556 23.4157C11.3509 23.4157 11.3464 23.4138 11.3431 23.4105C11.3398 23.4072 11.3379 23.4027 11.3379 23.398C11.3379 23.3933 11.3398 23.3889 11.3431 23.3855C11.3464 23.3822 11.3509 23.3804 11.3556 23.3804H11.3909Z"
            fill="#204063"
          />
          <path
            d="M12.4152 23.0451C12.4152 23.0627 12.4152 23.0804 12.3975 23.0804C12.3929 23.0804 12.3884 23.0785 12.3851 23.0752C12.3817 23.0719 12.3799 23.0674 12.3799 23.0627V23.0274C12.3975 23.0097 12.3975 23.0451 12.4152 23.0451Z"
            fill="#204063"
          />
          <path
            d="M11.3022 23.4338H11.3199C11.3022 23.4338 11.3022 23.4161 11.3199 23.3984C11.3246 23.4008 11.3282 23.4049 11.3298 23.4099C11.3315 23.4148 11.3311 23.4202 11.3287 23.4249C11.3264 23.4296 11.3223 23.4332 11.3173 23.4348C11.3124 23.4365 11.3069 23.4361 11.3022 23.4338Z"
            fill="#204063"
          />
          <path
            d="M13.1213 22.9745C13.1213 22.9922 13.1213 23.0099 13.1037 23.0099C13.086 23.0099 13.0684 23.0275 13.0684 23.0099C13.0684 22.9922 13.1037 22.9569 13.1213 22.9745Z"
            fill="#204063"
          />
          <path
            d="M12.8033 23.0627H12.821C12.821 23.098 12.8386 23.1333 12.821 23.1686C12.821 23.1733 12.8191 23.1778 12.8158 23.1811C12.8125 23.1844 12.808 23.1863 12.8033 23.1863C12.7986 23.1863 12.7941 23.1844 12.7908 23.1811C12.7875 23.1778 12.7856 23.1733 12.7856 23.1686V23.098H12.8033C12.8029 23.0733 12.809 23.0489 12.821 23.0273L12.8033 23.0627Z"
            fill="#204063"
          />
          <path
            d="M12.2384 23.2041H12.256C12.2647 23.2138 12.2695 23.2264 12.2695 23.2394C12.2695 23.2525 12.2647 23.265 12.256 23.2747H12.2207V23.2218H12.2384V23.2041Z"
            fill="#204063"
          />
          <path
            d="M10.9139 23.6453C10.9092 23.6453 10.9047 23.6434 10.9014 23.6401C10.8981 23.6368 10.8962 23.6323 10.8962 23.6276C10.8786 23.6276 10.9139 23.5923 10.8962 23.5923C10.8786 23.5923 10.9315 23.6276 10.9139 23.6453Z"
            fill="#204063"
          />
          <path
            d="M11.2143 25.2525H11.232C11.232 25.2525 11.1967 25.2878 11.232 25.2878C11.2673 25.2878 11.2143 25.3584 11.179 25.3761H11.1967C11.1967 25.4114 11.2143 25.4291 11.179 25.4467H11.1614C11.126 25.4114 11.2143 25.3761 11.1437 25.3408C11.0731 25.3055 11.1437 25.2701 11.1437 25.2525H11.1967C11.1967 25.2348 11.1967 25.2525 11.2143 25.2525Z"
            fill="#204063"
          />
          <path
            d="M11.32 23.6279C11.32 23.6456 11.32 23.6632 11.3024 23.6632H11.2847C11.267 23.6456 11.2847 23.6456 11.2847 23.6456H11.32V23.6279Z"
            fill="#204063"
          />
          <path
            d="M12.715 23.2925V23.3455H12.6973C12.6797 23.3455 12.6797 23.3101 12.6973 23.2925H12.715Z"
            fill="#204063"
          />
          <path
            d="M11.1788 23.8042H11.1965V23.8395H11.1611V23.8042H11.1788Z"
            fill="#204063"
          />
          <path
            d="M11.1787 23.8042V23.8219V23.8042H11.1964H11.1787Z"
            fill="white"
          />
          <path
            d="M11.2316 24.0514C11.2493 24.0514 11.2669 24.0691 11.2493 24.0868H11.2316C11.1963 24.0868 11.2139 24.0514 11.1963 24.0514C11.2139 24.0338 11.2139 24.0338 11.2139 24.0161C11.2093 24.0185 11.2057 24.0226 11.204 24.0275C11.2024 24.0325 11.2028 24.0379 11.2051 24.0426C11.2075 24.0473 11.2116 24.0508 11.2165 24.0525C11.2215 24.0542 11.2269 24.0538 11.2316 24.0514Z"
            fill="#204063"
          />
          <path
            d="M10.7725 24.0869C10.7725 24.1046 10.7902 24.1222 10.7725 24.1576V24.1222C10.7549 24.1046 10.7725 24.1046 10.7725 24.0869Z"
            fill="#204063"
          />
          <path
            d="M12.821 23.5923C12.821 23.6099 12.8386 23.6453 12.821 23.6629V23.6982L12.7856 23.6629V23.6276C12.8033 23.6453 12.7856 23.5923 12.8033 23.6099C12.8033 23.6099 12.8033 23.6099 12.821 23.5923Z"
            fill="#204063"
          />
          <path
            d="M11.0906 24.1221H11.1083C11.0906 24.1397 11.1083 24.175 11.0906 24.1927C11.073 24.2104 11.0553 24.175 11.0376 24.1574C11.02 24.1397 11.0376 24.1397 11.0376 24.1397H11.0906V24.1221Z"
            fill="#204063"
          />
          <path
            d="M12.3976 23.7337C12.3929 23.7337 12.3884 23.7319 12.3851 23.7286C12.3818 23.7252 12.3799 23.7207 12.3799 23.7161V23.6807C12.3623 23.6631 12.3799 23.6807 12.3799 23.6984C12.3976 23.6807 12.3976 23.6807 12.3976 23.6631C12.3976 23.6807 12.4152 23.7161 12.3976 23.7337Z"
            fill="#204063"
          />
          <path
            d="M12.2031 24.5461H12.2208V24.5107C12.2245 24.5141 12.2276 24.5181 12.2296 24.5227C12.2317 24.5273 12.2327 24.5322 12.2327 24.5372C12.2327 24.5422 12.2317 24.5472 12.2296 24.5518C12.2276 24.5563 12.2245 24.5604 12.2208 24.5637C12.217 24.5604 12.214 24.5563 12.212 24.5518C12.2099 24.5472 12.2088 24.5422 12.2088 24.5372C12.2088 24.5322 12.2099 24.5273 12.212 24.5227C12.214 24.5181 12.217 24.5141 12.2208 24.5107L12.2031 24.5461Z"
            fill="#204063"
          />
          <path
            d="M11.32 24.9876H11.3023C11.2847 25.0052 11.2847 24.9875 11.2847 24.9699C11.3023 24.9522 11.2847 24.9522 11.3023 24.9346H11.32C11.32 24.9522 11.3376 24.9699 11.32 24.9876Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.7759C11.9382 24.7935 11.9558 24.8289 11.9205 24.8289C11.8852 24.8289 11.9029 24.8289 11.9029 24.8112V24.7759H11.9205C11.9232 24.7774 11.9262 24.7782 11.9293 24.7782C11.9324 24.7782 11.9355 24.7774 11.9382 24.7759Z"
            fill="#204063"
          />
          <path
            d="M11.9382 24.8112H11.9205C11.9158 24.8112 11.9113 24.8093 11.908 24.806C11.9047 24.8027 11.9028 24.7982 11.9028 24.7935C11.9028 24.7889 11.9047 24.7844 11.908 24.781C11.9113 24.7777 11.9158 24.7759 11.9205 24.7759C11.9205 24.7935 11.9382 24.7759 11.9382 24.8112Z"
            fill="white"
          />
          <path
            d="M11.2496 24.8464C11.2496 24.864 11.2496 24.8464 11.2319 24.8464V24.811H11.2496C11.2496 24.8287 11.2673 24.8464 11.2496 24.8464Z"
            fill="#204063"
          />
          <path
            d="M12.0264 24.9172V24.8818C12.0264 24.8818 12.044 24.8995 12.0264 24.9172Z"
            fill="#204063"
          />
          <path
            d="M10.7373 26.2769H10.7726C10.7726 26.2769 10.755 26.2769 10.7726 26.2946C10.7773 26.2946 10.7818 26.2927 10.7851 26.2894C10.7884 26.2861 10.7903 26.2816 10.7903 26.2769C10.7903 26.2723 10.7884 26.2678 10.7851 26.2645C10.7818 26.2611 10.7773 26.2593 10.7726 26.2593C10.7903 26.2769 10.7726 26.3123 10.7903 26.3123H10.8079C10.8079 26.3476 10.8256 26.3476 10.8256 26.3652C10.8264 26.3748 10.8253 26.3844 10.8222 26.3935C10.8192 26.4027 10.8143 26.4111 10.8079 26.4182C10.8433 26.4006 10.8079 26.4535 10.8256 26.4535C10.8209 26.4535 10.8164 26.4554 10.8131 26.4587C10.8098 26.462 10.8079 26.4665 10.8079 26.4712L10.7373 26.5065H10.6843C10.6667 26.5065 10.649 26.4889 10.6667 26.4712H10.649C10.6517 26.4463 10.6454 26.4213 10.6313 26.4006H10.6667V26.3652C10.6843 26.3652 10.6667 26.3476 10.6843 26.3299C10.702 26.3123 10.702 26.3476 10.7196 26.3299C10.7174 26.3203 10.7178 26.3103 10.7209 26.3009C10.7241 26.2916 10.7297 26.2832 10.7373 26.2769Z"
            fill="#204063"
          />
          <path
            d="M11.9205 25.0582V25.0935C11.9028 25.1112 11.9028 25.0758 11.9028 25.0758C11.9028 25.0758 11.9028 25.0582 11.9028 25.0405L11.9205 25.0582Z"
            fill="#204063"
          />
          <path
            d="M11.8501 25.27H11.7971C11.7971 25.2877 11.7794 25.2877 11.7618 25.2877C11.7557 25.2658 11.7559 25.2427 11.7621 25.2209C11.7683 25.1991 11.7804 25.1794 11.7971 25.1641H11.8147C11.8249 25.1676 11.8341 25.1735 11.8417 25.1812C11.8493 25.1888 11.855 25.1982 11.8584 25.2084C11.8618 25.2186 11.8628 25.2295 11.8614 25.2402C11.8599 25.2509 11.8561 25.2611 11.8501 25.27Z"
            fill="#204063"
          />
          <path
            d="M11.1966 27.4601H11.2143V27.4954H11.2319C11.2143 27.5308 11.2319 27.5484 11.2143 27.5661C11.1966 27.5837 11.1966 27.6014 11.1966 27.6191H11.126C11.1249 27.6055 11.1185 27.5928 11.1083 27.5837H11.0553C11.02 27.5837 11.0377 27.5484 11.02 27.5308V27.4954C11.0377 27.5131 11.0377 27.4778 11.0553 27.4601H11.126V27.4248H11.1613C11.1613 27.4248 11.179 27.4778 11.1966 27.4601Z"
            fill="#204063"
          />
          <path
            d="M11.0731 25.7114C11.0731 25.7291 11.1084 25.7467 11.1084 25.7821L11.0731 25.835L11.0024 25.7997C11.0201 25.7821 11.0024 25.7467 11.0024 25.7467H11.0201C11.0201 25.7291 11.0201 25.7114 11.0378 25.7114H11.0731Z"
            fill="#204063"
          />
          <path
            d="M11.6029 25.5703H11.6205C11.6382 25.6056 11.5675 25.6056 11.6029 25.6409C11.6382 25.6762 11.5852 25.6939 11.5675 25.6939C11.5499 25.6939 11.5322 25.6586 11.5322 25.6409C11.5499 25.6586 11.5499 25.6233 11.5499 25.6233H11.5852C11.5782 25.6209 11.5724 25.6159 11.5691 25.6093C11.5657 25.6026 11.5652 25.595 11.5675 25.5879C11.5699 25.5809 11.5749 25.5751 11.5815 25.5718C11.5882 25.5685 11.5958 25.5679 11.6029 25.5703Z"
            fill="#204063"
          />
          <path
            d="M11.4083 26.3652V26.4006C11.3907 26.4182 11.4437 26.4182 11.4083 26.4535C11.373 26.4889 11.3907 26.4712 11.3907 26.4889H11.32V26.4535C11.3377 26.4535 11.3024 26.4359 11.32 26.4359V26.4006H11.373C11.3907 26.3476 11.3907 26.3829 11.4083 26.3652Z"
            fill="#204063"
          />
          <path
            d="M10.7019 26.7008C10.7019 26.7184 10.7019 26.7184 10.7196 26.7184C10.7372 26.7184 10.7019 26.7714 10.6842 26.7537H10.6489C10.6666 26.7361 10.6489 26.7361 10.6489 26.7184C10.6536 26.7184 10.6581 26.7166 10.6614 26.7133C10.6647 26.7099 10.6666 26.7054 10.6666 26.7008C10.6666 26.6961 10.6684 26.6916 10.6718 26.6883C10.6751 26.685 10.6796 26.6831 10.6842 26.6831L10.7019 26.7008Z"
            fill="#204063"
          />
          <path
            d="M10.6842 26.7007V26.7183H10.6665L10.6842 26.7007Z"
            fill="white"
          />
          <path
            d="M9.99577 26.5592C9.99577 26.5768 9.97811 26.5945 9.96045 26.5768V26.5415C9.97811 26.5238 10.0134 26.5415 9.99577 26.5592Z"
            fill="#204063"
          />
          <path
            d="M10.8784 27.2481C10.8784 27.2481 10.8784 27.2304 10.8961 27.2481H10.8784Z"
            fill="#204063"
          />
          <path
            d="M10.4903 26.8066C10.508 26.8066 10.4903 26.8243 10.4903 26.8243H10.4727C10.4727 26.8243 10.4903 26.8066 10.4903 26.8243V26.8066Z"
            fill="#204063"
          />
          <path
            d="M10.1899 27.0186H10.2252C10.2075 27.0186 10.2252 27.0362 10.2252 27.0362C10.2252 27.0715 10.2252 27.1069 10.1722 27.1245L10.1192 27.0892C10.1016 27.0715 10.1192 27.0539 10.1016 27.0362H10.1192C10.1016 27.0186 10.1192 27.0362 10.1192 27.0186H10.1899Z"
            fill="#204063"
          />
          <path
            d="M10.6135 27.2481H10.6489V27.2834C10.6665 27.3011 10.6312 27.3011 10.6312 27.3364H10.5429C10.5429 27.3188 10.5076 27.3541 10.5076 27.3188C10.4722 27.3364 10.4899 27.3011 10.4722 27.3011H10.4546C10.4593 27.3011 10.4638 27.2992 10.4671 27.2959C10.4704 27.2926 10.4722 27.2881 10.4722 27.2834C10.4722 27.2788 10.4704 27.2743 10.4671 27.271C10.4638 27.2676 10.4593 27.2658 10.4546 27.2658C10.4546 27.2481 10.4899 27.2481 10.4722 27.2305C10.4546 27.2128 10.5076 27.2305 10.4899 27.1951C10.5076 27.1951 10.5076 27.2128 10.5076 27.1951C10.5076 27.1775 10.5076 27.1951 10.5076 27.1775C10.5076 27.1598 10.5252 27.2128 10.5429 27.1951H10.5959C10.5782 27.2305 10.6135 27.2305 10.6135 27.2481Z"
            fill="#204063"
          />
          <path
            d="M10.066 27.5835L10.1014 27.6188C10.0837 27.6365 10.119 27.6365 10.1014 27.6541C10.0837 27.6718 10.119 27.6718 10.1014 27.6718H10.119C10.1014 27.6895 10.1014 27.7248 10.066 27.7424H9.96008C9.94242 27.7248 9.96008 27.7071 9.94242 27.7071C9.92476 27.7071 9.94242 27.6895 9.94242 27.6718C9.9471 27.6718 9.9516 27.6699 9.95491 27.6666C9.95822 27.6633 9.96008 27.6588 9.96008 27.6541C9.96008 27.6495 9.95822 27.645 9.95491 27.6416C9.9516 27.6383 9.9471 27.6365 9.94242 27.6365H9.96008C9.96008 27.6365 9.94242 27.6188 9.96008 27.6188H10.0307L10.066 27.5835Z"
            fill="#204063"
          />
          <path
            d="M10.9137 27.778H10.8961C10.8914 27.778 10.8869 27.7761 10.8836 27.7728C10.8803 27.7695 10.8784 27.765 10.8784 27.7603C10.8784 27.7557 10.8803 27.7512 10.8836 27.7478C10.8869 27.7445 10.8914 27.7427 10.8961 27.7427C10.9137 27.7603 10.9137 27.7603 10.9137 27.778Z"
            fill="#204063"
          />
          <path
            d="M11.3199 28.131C11.3022 28.131 11.3022 28.1134 11.3022 28.0957H11.3199C11.3199 28.0957 11.3376 28.131 11.3199 28.131Z"
            fill="#204063"
          />
          <path
            d="M10.6136 28.043H10.6313V28.0959C10.5959 28.0959 10.5959 28.1136 10.5606 28.0959H10.543C10.543 28.0783 10.5606 28.0606 10.543 28.0606H10.5606C10.543 28.0606 10.5606 28.0606 10.5606 28.043C10.5606 28.0477 10.5625 28.0521 10.5658 28.0555C10.5691 28.0588 10.5736 28.0606 10.5783 28.0606H10.6136V28.043Z"
            fill="#204063"
          />
          <path
            d="M10.5075 28.0604H10.5252C10.5075 28.0604 10.5252 28.078 10.5252 28.078H10.5075L10.4722 28.1134H10.4192C10.4192 28.078 10.3839 28.0957 10.3662 28.0604H10.3839C10.3662 28.0427 10.3839 28.0251 10.3839 28.0074H10.4015C10.4015 27.9897 10.4192 27.9897 10.4015 27.9897C10.3839 27.9897 10.4369 28.0074 10.4369 27.9897H10.4545C10.4898 28.0074 10.4898 28.0604 10.5075 28.0604Z"
            fill="#204063"
          />
          <path
            d="M10.2076 28.2192H10.2606C10.2606 28.2369 10.2429 28.2546 10.2606 28.2546H10.2783C10.2783 28.2722 10.2606 28.2899 10.2783 28.2899H10.2959C10.2959 28.2899 10.3136 28.2899 10.2959 28.3075H10.3489C10.3313 28.3252 10.3489 28.3252 10.3489 28.3252H10.3313C10.3489 28.3252 10.3313 28.3252 10.3313 28.3429H10.137C10.137 28.3075 10.1017 28.3252 10.1017 28.3252H10.0663V28.2899H10.031C10.031 28.2899 10.0663 28.2899 10.0487 28.2722C10.0487 28.2369 9.99571 28.2369 10.0134 28.2016C10.031 28.1663 10.031 28.2016 10.031 28.2016C10.031 28.2016 10.0134 28.1663 10.031 28.1663L10.0663 28.1309C10.0663 28.1309 10.0487 28.1133 10.0663 28.1133C10.0663 28.118 10.0682 28.1225 10.0715 28.1258C10.0748 28.1291 10.0793 28.1309 10.084 28.1309H10.1193C10.1193 28.1309 10.1193 28.1486 10.137 28.1309H10.2253L10.2076 28.2192Z"
            fill="#204063"
          />
          <path
            d="M11.4791 26.9302C11.4615 26.9478 11.4791 26.9655 11.4438 26.9655C11.4085 26.9655 11.4085 26.9478 11.4262 26.9302H11.4791Z"
            fill="#204063"
          />
          <path
            d="M11.4082 27.0539V27.0362H11.4259L11.4082 27.0186H11.4259L11.4082 27.0539Z"
            fill="#204063"
          />
          <path
            d="M11.4261 27.1065H11.4437V27.1418C11.4614 27.1595 11.4437 27.1948 11.4437 27.2125C11.4437 27.2301 11.3908 27.2301 11.3908 27.2655H11.3378C11.3201 27.2301 11.3201 27.2301 11.3025 27.2301C11.3025 27.2125 11.3201 27.1948 11.3025 27.1772C11.2848 27.1595 11.3201 27.1418 11.3025 27.1418C11.2848 27.1418 11.3378 27.1595 11.3554 27.1595C11.3731 27.1595 11.3378 27.1418 11.3554 27.1418C11.3731 27.1418 11.3731 27.1595 11.3731 27.1595V27.1065C11.3908 27.0712 11.3908 27.1065 11.4261 27.1065Z"
            fill="#204063"
          />
        </g>
        <g opacity="0.7">
          <path
            d="M19.7262 23.8751L19.6909 23.8574H19.7262V23.8751Z"
            fill="white"
          />
          <path
            d="M19.797 23.8751L19.7617 23.8927V23.8574L19.797 23.8751Z"
            fill="white"
          />
          <path
            d="M19.8323 17.0583L19.8853 17.0229C19.8977 17.0339 19.9073 17.0476 19.9134 17.0629C19.9196 17.0782 19.922 17.0948 19.9206 17.1112C19.903 17.1466 19.8677 17.1466 19.8323 17.1289C19.8237 17.1192 19.8188 17.1066 19.8188 17.0936C19.8188 17.0806 19.8237 17.068 19.8323 17.0583Z"
            fill="#204063"
          />
          <path
            d="M19.9028 16.8286C19.9205 16.8286 19.9205 16.8462 19.9205 16.8639L19.8675 16.8992C19.8322 16.8816 19.8498 16.7933 19.9028 16.8286Z"
            fill="#204063"
          />
          <path
            d="M11.9557 21.1026C11.9557 21.1203 11.938 21.1556 11.9204 21.1379H11.9027C11.9018 21.1313 11.9027 21.1246 11.9054 21.1185C11.9082 21.1125 11.9125 21.1073 11.9181 21.1036C11.9236 21.0999 11.9301 21.0978 11.9367 21.0977C11.9434 21.0975 11.9499 21.0992 11.9557 21.1026Z"
            fill="#204063"
          />
          <path
            d="M17.4145 19.8689L17.397 19.8711L17.3981 19.8799L17.4156 19.8777L17.4145 19.8689Z"
            fill="#204063"
          />
          <path
            d="M17.7133 19.9367C17.6779 19.972 17.6249 19.9367 17.6073 19.9013C17.5896 19.866 17.6779 19.9013 17.7133 19.9367Z"
            fill="#204063"
          />
          <path
            d="M12.4325 21.1909C12.4501 21.2262 12.4501 21.2616 12.4148 21.2616C12.3795 21.2616 12.3618 21.2439 12.3618 21.2262C12.3618 21.2086 12.4148 21.1909 12.4325 21.1909Z"
            fill="#204063"
          />
          <path
            d="M10.8962 19.0538H10.8785C10.9096 19.0393 10.9439 19.0333 10.978 19.0364C11.0121 19.0395 11.0448 19.0516 11.0728 19.0714C11.0728 19.1067 11.0374 19.0891 11.0021 19.1067L10.8608 19.0714L10.8962 19.0538Z"
            fill="#204063"
          />
          <path
            d="M22.7108 18.5594H22.6755L22.7108 18.5241C22.6755 18.4711 22.7638 18.4711 22.7638 18.4358C22.8135 18.4305 22.8636 18.443 22.905 18.4711C22.9404 18.5241 22.9227 18.5241 22.9404 18.577C22.958 18.63 22.958 18.683 22.8697 18.683C22.7814 18.683 22.8167 18.6653 22.7638 18.7007C22.7108 18.736 22.7461 18.6653 22.7284 18.6653H22.7108C22.7284 18.63 22.7108 18.6124 22.6755 18.5947C22.6401 18.577 22.6931 18.577 22.7108 18.5594Z"
            fill="#204063"
          />
          <path
            d="M11.3554 19.1597L11.4084 19.195C11.3907 19.2303 11.3377 19.2126 11.3201 19.2126H11.2671L11.3554 19.1597Z"
            fill="#204063"
          />
          <path
            d="M11.5498 19.0011H11.5675C11.5321 19.0187 11.4792 18.9834 11.4438 18.9834L11.5498 19.0011Z"
            fill="#204063"
          />
          <path
            d="M14.3048 19.6895C14.3224 19.7071 14.3224 19.7071 14.3224 19.7248H14.2871C14.2871 19.7248 14.2695 19.6895 14.3048 19.6895Z"
            fill="#204063"
          />
          <path
            d="M14.6578 18.8066H14.6931L14.6578 18.8596C14.6401 18.8596 14.6401 18.8243 14.6578 18.8066Z"
            fill="#204063"
          />
          <path
            d="M14.6579 18.312C14.6756 18.3297 14.7286 18.3297 14.7109 18.365C14.6933 18.4003 14.7109 18.4356 14.6756 18.4356C14.6403 18.4356 14.6403 18.4003 14.605 18.4003C14.5696 18.4003 14.6403 18.3473 14.6579 18.312Z"
            fill="#204063"
          />
          <path
            d="M14.6931 18.7007C14.6931 18.7007 14.7107 18.6831 14.7107 18.7007V18.736C14.6754 18.736 14.6578 18.7007 14.6931 18.7007Z"
            fill="#204063"
          />
          <path
            d="M14.958 19.6016H14.9933C14.9757 19.6192 14.9933 19.6369 14.9757 19.6545C14.958 19.6722 14.905 19.6192 14.958 19.6016Z"
            fill="#204063"
          />
          <path
            d="M12.6799 19.8662L12.627 19.8839L12.6446 19.8662H12.6799Z"
            fill="#204063"
          />
          <path
            d="M12.9096 19.9193C12.9273 19.9369 12.9802 19.9369 12.9626 19.9722C12.9449 20.0076 12.839 20.0076 12.8036 20.0076H12.786C12.8036 19.9899 12.786 19.9899 12.786 19.9722C12.786 19.9546 12.7683 19.9193 12.7153 19.9369C12.7773 19.9138 12.8444 19.9077 12.9096 19.9193Z"
            fill="#204063"
          />
          <path
            d="M14.9932 18.7891C15.0109 18.7891 15.0109 18.8067 15.0109 18.8244C15.0109 18.842 14.9932 18.842 14.9756 18.8244L14.9932 18.7891Z"
            fill="#204063"
          />
          <path
            d="M15.2227 19.478C15.2404 19.478 15.2404 19.4956 15.2404 19.5133H15.2051C15.1874 19.4956 15.2051 19.4603 15.2227 19.478Z"
            fill="#204063"
          />
          <path
            d="M15.2232 19.1421C15.2409 19.1421 15.2585 19.1774 15.2409 19.1774C15.2232 19.1774 15.2056 19.1951 15.2056 19.1774L15.2232 19.1421Z"
            fill="#204063"
          />
          <path
            d="M15.2759 19.4248C15.2936 19.4425 15.3642 19.4071 15.3466 19.4601C15.3289 19.5131 15.2936 19.4954 15.2583 19.4601C15.223 19.4248 15.2583 19.4248 15.2759 19.4248Z"
            fill="#204063"
          />
          <path
            d="M13.3687 19.7957C13.4041 19.7957 13.4217 19.7957 13.4217 19.7604V19.7251C13.51 19.7428 13.6336 19.7074 13.7043 19.7957C13.7749 19.884 13.7043 19.8487 13.6866 19.8664H13.5983C13.563 19.8311 13.4924 19.9017 13.4394 19.8664H13.4747L13.3511 19.8134L13.3687 19.7957Z"
            fill="#204063"
          />
          <path
            d="M13.6337 20.2193C13.6514 20.3076 13.5454 20.2723 13.5101 20.2723L13.4395 20.2369C13.4674 20.2171 13.5001 20.2051 13.5342 20.202C13.5683 20.1989 13.6027 20.2048 13.6337 20.2193Z"
            fill="#204063"
          />
          <path
            d="M13.5808 20.2373L13.5632 20.255L13.5278 20.2373L13.5632 20.255L13.5808 20.2373Z"
            fill="white"
          />
          <path
            d="M19.5499 20.131H19.5676C19.5146 20.2193 19.3733 20.184 19.285 20.1486H19.2144C19.2649 20.1195 19.3217 20.1027 19.38 20.0996C19.4383 20.0966 19.4965 20.1073 19.5499 20.131Z"
            fill="#204063"
          />
          <path
            d="M13.8102 20.3077L13.7749 20.29H13.8102V20.3077Z"
            fill="#204063"
          />
          <path
            d="M14.0397 20.3253H14.0927L14.0574 20.3783C14.0097 20.3905 13.9593 20.3842 13.9161 20.3606C13.8984 20.3783 13.9338 20.3606 13.9338 20.343H13.8984C13.9183 20.3278 13.9419 20.3182 13.9667 20.3151C13.9915 20.312 14.0167 20.3155 14.0397 20.3253Z"
            fill="#204063"
          />
          <path
            d="M14.0047 20.3606H13.987C13.9693 20.3959 13.987 20.3606 13.9693 20.3783C13.9517 20.3959 13.9693 20.3253 14.0047 20.3606Z"
            fill="white"
          />
          <path
            d="M14.1812 20.4311C14.2038 20.4144 14.2304 20.404 14.2583 20.4009C14.2862 20.3978 14.3145 20.4021 14.3402 20.4135C14.3578 20.4135 14.3755 20.4312 14.3578 20.4665C14.3147 20.49 14.2642 20.4963 14.2166 20.4841C14.2166 20.4488 14.1636 20.4665 14.1459 20.4665C14.1283 20.4665 14.2166 20.4665 14.1812 20.4311Z"
            fill="#204063"
          />
          <path
            d="M14.2339 20.4136L14.2515 20.4312H14.2339V20.4136Z"
            fill="white"
          />
          <path
            d="M14.8519 21.8441C14.8696 21.8441 14.8519 21.8617 14.8519 21.8617C14.8519 21.8617 14.7813 21.8971 14.7459 21.8971C14.7106 21.8971 14.7106 21.9147 14.6753 21.8794C14.7287 21.8487 14.7907 21.8363 14.8519 21.8441Z"
            fill="#204063"
          />
          <path
            d="M15.0817 16.8286C15.117 16.8992 15.0287 16.8992 15.0111 16.9169C14.9934 16.9345 14.8521 16.8462 14.7815 16.8462H14.7285C14.8345 16.8462 14.9934 16.7226 15.0817 16.8286Z"
            fill="#204063"
          />
          <path
            d="M16.0527 20.8022C16.0704 20.8022 16.0881 20.8022 16.0881 20.8199C16.0881 20.8376 16.1057 20.8552 16.0704 20.8729H15.9468C15.9644 20.8022 16.0174 20.8022 16.0527 20.8022Z"
            fill="#204063"
          />
          <path
            d="M15.4172 20.873L15.3818 20.8907V20.873H15.4172Z"
            fill="white"
          />
          <path
            d="M16.7418 20.7668H16.7241C16.7594 20.7315 16.7948 20.7315 16.8477 20.7139C16.8631 20.7157 16.8778 20.7216 16.8902 20.7309C16.9026 20.7402 16.9123 20.7526 16.9184 20.7668C16.936 20.8022 16.9007 20.8022 16.8831 20.8375C16.8654 20.8728 16.8124 20.8022 16.7771 20.8375H16.7948L16.7241 20.8022L16.7418 20.7668Z"
            fill="#204063"
          />
          <path
            d="M15.5939 17.5704L15.5586 17.5527H15.5939V17.5704Z"
            fill="#204063"
          />
          <path
            d="M15.647 17.7471H15.6823C15.7 17.7647 15.7176 17.7647 15.7176 17.8001H15.647V17.7471Z"
            fill="#204063"
          />
          <path
            d="M16.4414 19.6544C16.512 19.6544 16.6003 19.5661 16.671 19.6368C16.6737 19.6437 16.675 19.6511 16.6747 19.6586C16.6743 19.666 16.6725 19.6733 16.6691 19.68C16.6658 19.6867 16.6611 19.6925 16.6553 19.6973C16.6496 19.702 16.6429 19.7054 16.6357 19.7074C16.565 19.7251 16.512 19.6721 16.4414 19.6544Z"
            fill="#204063"
          />
          <path
            d="M17.2891 20.9434C17.3245 20.9434 17.3774 20.9257 17.3951 20.961C17.4128 20.9964 17.3598 21.014 17.3598 21.0317H17.2715C17.2715 21.014 17.2891 20.9964 17.2715 20.9964C17.2538 20.9964 17.2715 20.9787 17.2891 20.9434Z"
            fill="#204063"
          />
          <path
            d="M16.6006 18.6124C16.6146 18.6106 16.6288 18.613 16.6414 18.6193C16.6539 18.6256 16.6644 18.6355 16.6713 18.6477C16.6713 18.6654 16.6536 18.683 16.636 18.7007H16.5477C16.53 18.6301 16.5653 18.6301 16.6006 18.6124Z"
            fill="#204063"
          />
          <path
            d="M17.4304 21.1203C17.4481 21.1026 17.4127 21.085 17.4304 21.085V21.1203Z"
            fill="#204063"
          />
          <path
            d="M16.4594 17.0229C16.4947 17.0053 16.5124 17.0229 16.5477 17.0406C16.583 17.0583 16.5477 17.1112 16.5124 17.1112C16.4771 17.1112 16.4241 17.0583 16.4594 17.0229Z"
            fill="#204063"
          />
          <path
            d="M16.6359 17.7296C16.6359 17.7119 16.6359 17.7119 16.6182 17.7119C16.6006 17.7119 16.6536 17.6942 16.6712 17.7119C16.6889 17.7296 16.8125 17.6413 16.8831 17.7119C16.9538 17.7825 16.8831 17.7649 16.8655 17.7825H16.7419C16.6901 17.7813 16.6404 17.7626 16.6006 17.7296H16.6359Z"
            fill="#204063"
          />
          <path
            d="M16.9005 19.0007C16.9005 19.0184 16.9181 19.0184 16.9181 19.0361C16.9214 19.0398 16.9255 19.0428 16.9301 19.0449C16.9347 19.0469 16.9396 19.048 16.9446 19.048C16.9496 19.048 16.9546 19.0469 16.9592 19.0449C16.9637 19.0428 16.9678 19.0398 16.9711 19.0361C16.9181 19.0361 16.9535 18.9831 16.9181 18.9654C16.8828 18.9478 17.0241 18.9301 17.0594 18.9831C17.0594 18.9968 17.0562 19.0103 17.0501 19.0226C17.044 19.0348 17.0351 19.0455 17.0241 19.0537C16.9888 19.0361 16.9711 19.0537 16.9358 19.0714H16.9005C16.9181 19.0537 16.9005 19.0537 16.9181 19.0361H16.8828C16.8828 19.0007 16.9005 19.0184 16.9005 19.0007Z"
            fill="#204063"
          />
          <path
            d="M17.9249 21.9856C17.9602 22.0033 17.9249 22.0386 17.9072 22.0386C17.8896 22.0386 17.8189 22.0209 17.7836 22.0563C17.7483 22.0916 17.8719 21.968 17.9249 21.9856Z"
            fill="#204063"
          />
          <path
            d="M16.9537 19.001C16.9714 19.001 16.936 19.0186 16.936 19.0186H16.9537V19.001Z"
            fill="white"
          />
          <path
            d="M16.9712 18.9831C16.9712 18.9654 16.9889 18.9654 16.9712 18.9478V18.9831Z"
            fill="white"
          />
          <path
            d="M21.7748 20.8197L21.7395 20.7843C21.7395 20.7667 21.8631 20.8197 21.8101 20.7314C21.7572 20.6431 22.0044 20.7314 22.075 20.802H22.0927L22.0574 20.7667C22.1104 20.7667 22.181 20.7137 22.234 20.7314C22.287 20.749 22.2693 20.7667 22.2516 20.7843C22.234 20.802 22.0221 20.749 21.9867 20.908C21.9514 21.0669 21.8455 20.9609 21.7925 20.9433L21.7395 20.9786C21.7925 20.9609 21.7395 20.9256 21.7395 20.908L21.6865 20.8726C21.7042 20.855 21.7572 20.855 21.7748 20.8197Z"
            fill="#204063"
          />
          <path
            d="M17.872 21.085C17.9073 21.1026 17.9603 21.0673 17.9779 21.1203C17.9956 21.1733 17.9249 21.1556 17.9073 21.1909C17.8896 21.2262 17.8896 21.1556 17.8543 21.1733H17.872C17.8543 21.1556 17.8366 21.085 17.872 21.085Z"
            fill="#204063"
          />
          <path
            d="M17.0951 17.9589C17.1304 17.9236 17.1481 17.9236 17.1834 17.9413C17.2187 17.9589 17.2187 17.9589 17.2011 17.9766C17.1834 17.9943 17.1304 17.9943 17.0951 17.9943C17.0598 17.9943 17.0774 17.9589 17.0951 17.9589Z"
            fill="#204063"
          />
          <path d="M17.13 17.959L17.0947 17.9766V17.959H17.13Z" fill="white" />
          <path
            d="M18.2959 21.4026C18.2783 21.4026 18.2959 21.3673 18.2959 21.3673C18.2959 21.3673 18.3489 21.3319 18.3666 21.3673C18.3842 21.4026 18.3489 21.4026 18.3489 21.4202L18.2959 21.4026Z"
            fill="#204063"
          />
          <path
            d="M18.3136 21.3848H18.3312V21.4025L18.2959 21.3848L18.3136 21.3672V21.3848Z"
            fill="white"
          />
          <path
            d="M18.8784 21.2261C18.8961 21.1908 18.9314 21.1555 18.9667 21.1732C18.9821 21.175 18.9968 21.1809 19.0092 21.1902C19.0216 21.1995 19.0313 21.2119 19.0374 21.2261C19.0374 21.2791 18.9667 21.2791 18.9314 21.2968C18.9138 21.2615 18.8961 21.2791 18.8608 21.2615C18.8255 21.2438 18.8784 21.2261 18.8784 21.2261Z"
            fill="#204063"
          />
          <path
            d="M19.0905 22.2856C19.0905 22.2809 19.0886 22.2764 19.0853 22.2731C19.082 22.2698 19.0775 22.2679 19.0728 22.2679H19.0552C19.1082 22.2502 19.1611 22.1973 19.2318 22.2326C19.3024 22.2679 19.2141 22.3032 19.1788 22.3032C19.1435 22.3032 19.0905 22.3032 19.0552 22.3032L19.0905 22.2856Z"
            fill="#204063"
          />
          <path
            d="M17.6954 17.7116L17.8014 17.6763C17.8367 17.6763 17.8543 17.6939 17.872 17.7292C17.8734 17.7457 17.8709 17.7623 17.8648 17.7776C17.8587 17.7929 17.849 17.8066 17.8367 17.8175C17.8014 17.8175 17.7837 17.7999 17.7484 17.8352C17.7131 17.8705 17.6777 17.8175 17.7131 17.7646H17.6777C17.6954 17.7646 17.6954 17.7292 17.6954 17.7116Z"
            fill="#204063"
          />
          <path
            d="M19.0905 21.5262C19.1435 21.5438 19.2141 21.4732 19.2494 21.5438C19.2848 21.6145 19.2141 21.6145 19.1788 21.6498C19.1435 21.6851 19.1435 21.6498 19.1258 21.6498H19.1435C19.0905 21.6498 19.1258 21.6321 19.0905 21.6321H19.0552C19.0905 21.5615 19.0552 21.5262 19.0905 21.5262Z"
            fill="#204063"
          />
          <path
            d="M18.0134 18.6652L17.9781 18.7005H17.9251C17.9251 18.7358 17.9605 18.7182 17.9605 18.7182V18.6829C17.9251 18.6475 17.9075 18.6829 17.8898 18.6829H17.8545C17.9075 18.6475 17.9781 18.6122 18.0134 18.6652Z"
            fill="#204063"
          />
          <path
            d="M19.6734 20.8023C19.6734 20.807 19.6752 20.8115 19.6785 20.8148C19.6819 20.8181 19.6864 20.82 19.691 20.82H19.6734V20.7847C19.6557 20.82 19.6734 20.8023 19.6734 20.8023Z"
            fill="#204063"
          />
          <path
            d="M19.7438 18.9125C19.7615 18.8949 19.7438 18.9125 19.7438 18.9302H19.7791C19.7968 18.9302 19.7791 18.9125 19.7791 18.8949L19.7262 18.9302C19.7398 18.9164 19.7565 18.906 19.7749 18.8999C19.7933 18.8938 19.8129 18.892 19.8321 18.8949V18.9302C19.816 18.9459 19.7954 18.956 19.7732 18.9592C19.751 18.9624 19.7283 18.9584 19.7085 18.9479L19.7438 18.9125Z"
            fill="#204063"
          />
          <path
            d="M19.797 18.9479L19.7793 18.9303L19.797 18.9126V18.9479Z"
            fill="white"
          />
          <path
            d="M21.0861 20.6963C21.1214 20.6963 21.1214 20.7316 21.1038 20.7669L21.0508 20.8022C21.0508 20.8022 21.0508 20.7493 21.0155 20.7669C20.9801 20.7846 21.0155 20.8022 20.9801 20.8199H20.9448C20.9752 20.7628 21.0255 20.7189 21.0861 20.6963Z"
            fill="#204063"
          />
          <path
            d="M20.3442 19.4249C20.3972 19.4249 20.4325 19.3896 20.4855 19.4249C20.486 19.4409 20.4811 19.4567 20.4714 19.4695C20.4618 19.4823 20.4481 19.4915 20.4325 19.4955H20.3619V19.4602H20.3442C20.3442 19.4602 20.3619 19.4425 20.3442 19.4249Z"
            fill="#204063"
          />
          <path
            d="M20.4153 19.4248H20.3976C20.4027 19.4266 20.4073 19.4295 20.4111 19.4334C20.4149 19.4372 20.4177 19.4419 20.4194 19.447C20.4211 19.4521 20.4217 19.4575 20.4209 19.4629C20.4202 19.4682 20.4183 19.4733 20.4153 19.4778C20.4153 19.5131 20.3623 19.4954 20.3623 19.4954C20.3623 19.4954 20.3623 19.4425 20.4153 19.4248Z"
            fill="white"
          />
          <path
            d="M20.8036 20.9259V20.9613L20.7329 20.9966L20.7682 20.9613V20.9259C20.7682 20.9436 20.7506 20.9613 20.7329 20.9436C20.742 20.9345 20.7533 20.9281 20.7658 20.925C20.7782 20.9218 20.7913 20.9222 20.8036 20.9259Z"
            fill="#204063"
          />
          <path
            d="M20.5918 19.1597H20.6095L20.5741 19.195H20.4858L20.5918 19.1597Z"
            fill="#204063"
          />
          <path
            d="M24.477 21.0673C24.477 21.0143 24.424 21.0496 24.4063 21.0496C24.3887 21.0496 24.4593 21.0496 24.4593 21.0143H24.3887C24.424 20.979 24.4946 20.9967 24.5123 20.9437C24.53 20.8907 24.477 20.926 24.4946 20.9084C24.5123 20.8907 24.5476 20.8554 24.6006 20.8377H24.7066C24.6712 20.7847 24.7772 20.8201 24.7595 20.7671C24.7419 20.7141 24.8302 20.8201 24.8478 20.7847C24.8655 20.7494 24.9715 20.8554 24.9715 20.926C24.9715 20.9967 24.9715 20.9613 24.9715 21.0143C24.9715 21.032 24.9538 21.0496 24.9715 21.0673C24.9891 21.085 24.9185 21.085 24.9185 21.1026C24.9185 21.1203 24.9008 21.1733 24.8832 21.1733C24.8655 21.1733 24.8655 21.1733 24.8655 21.1909H24.8478C24.7772 21.2262 24.7242 21.2262 24.6712 21.2969L24.6359 21.3499C24.6359 21.3145 24.6712 21.2969 24.6359 21.2616H24.6006C24.5829 21.2439 24.5476 21.2969 24.5123 21.2792C24.477 21.2616 24.5123 21.2086 24.477 21.1909H24.4063C24.4227 21.2003 24.4422 21.2028 24.4604 21.1978C24.4786 21.1928 24.4941 21.1808 24.5035 21.1644C24.5128 21.148 24.5153 21.1286 24.5103 21.1104C24.5054 21.0922 24.4934 21.0767 24.477 21.0673Z"
            fill="#204063"
          />
          <path
            d="M20.9623 19.3542C20.9446 19.3542 20.9446 19.3542 20.9446 19.3718H20.9976V19.3365C20.98 19.3188 20.9623 19.3542 20.9623 19.3365C20.9623 19.3188 21.0153 19.3188 21.0329 19.3188C21.0506 19.3188 21.0153 19.3718 20.98 19.3718C20.9446 19.3718 20.927 19.3542 20.9093 19.3542C20.8917 19.3542 20.9446 19.3365 20.9623 19.3542Z"
            fill="#204063"
          />
          <path
            d="M21.4393 19.3896C21.4746 19.4073 21.5099 19.4426 21.5099 19.4603C21.5099 19.4779 21.5099 19.4956 21.4923 19.4956C21.4746 19.4956 21.5806 19.5309 21.5629 19.5662C21.5453 19.6016 21.351 19.5662 21.2804 19.5486V19.5133H21.2627C21.2766 19.4775 21.3008 19.4467 21.3323 19.4247C21.3637 19.4027 21.4009 19.3905 21.4393 19.3896Z"
            fill="#204063"
          />
          <path
            d="M26.5431 18.948H26.5255C26.5608 18.9303 26.5608 18.9127 26.5785 18.895H26.5431C26.5431 18.8774 26.5961 18.8774 26.5608 18.8597C26.6314 18.8597 26.6314 18.8067 26.6844 18.8067C26.7374 18.8067 26.7904 18.7891 26.8257 18.7891C26.861 18.7891 26.861 18.8067 26.8787 18.8244V18.948L26.8257 19.0186C26.861 19.0363 26.914 19.054 26.9317 19.0893C26.9493 19.1246 26.8963 19.1599 26.8787 19.2129L26.7904 19.2482C26.808 19.1952 26.7197 19.2129 26.6844 19.2129H26.6668C26.6844 19.1952 26.7021 19.1952 26.7021 19.1776H26.6668C26.6668 19.1599 26.6844 19.1599 26.6844 19.1423H26.6668C26.6844 19.1599 26.6844 19.1423 26.6844 19.1246H26.7021C26.6668 19.1246 26.6491 19.1246 26.6491 19.0893H26.5608V19.054H26.5078C26.5255 18.9833 26.5961 18.9657 26.5431 18.948Z"
            fill="#204063"
          />
          <path
            d="M22.9054 20.855H22.8877C22.923 20.8197 22.9407 20.749 23.029 20.749C23.1173 20.749 23.0996 20.749 23.1526 20.7667C23.2056 20.7843 23.1526 20.8726 23.1173 20.9256C23.082 20.9786 23.029 20.9786 22.976 20.9786H22.8877C22.9054 20.908 22.8877 20.8726 22.9054 20.855Z"
            fill="#204063"
          />
          <path
            d="M21.9867 19.7603C21.9867 19.7427 21.969 19.725 21.9514 19.7427C21.9337 19.7603 21.9867 19.7427 21.9867 19.7603Z"
            fill="#204063"
          />
          <path
            d="M22.2515 19.7603H22.2339C22.2339 19.7603 22.2692 19.7427 22.2515 19.725C22.2339 19.7074 22.3752 19.8133 22.4281 19.725C22.4811 19.6367 22.5341 19.725 22.5694 19.778C22.5684 19.8004 22.5612 19.8221 22.5488 19.8408C22.5363 19.8594 22.5191 19.8744 22.4988 19.884L22.4281 19.9193C22.4281 19.9146 22.4263 19.9101 22.423 19.9068C22.4197 19.9035 22.4152 19.9016 22.4105 19.9016H22.3752C22.3928 19.8663 22.3398 19.9016 22.3222 19.8663C22.3222 19.831 22.2692 19.8486 22.2515 19.831H22.2339C22.2162 19.778 22.2339 19.778 22.2515 19.7603Z"
            fill="#204063"
          />
          <path
            d="M24.1059 19.6192C24.0883 19.6016 24.1413 19.6016 24.1059 19.5839C24.0706 19.5663 24.1413 19.5486 24.1589 19.5309H24.1413C24.1942 19.5486 24.1766 19.4426 24.2649 19.478C24.3532 19.5133 24.3355 19.5133 24.3532 19.4956C24.3708 19.478 24.4238 19.5663 24.4062 19.6192C24.3885 19.6722 24.3885 19.6369 24.3532 19.6899V19.7252C24.3355 19.6722 24.3179 19.7782 24.2825 19.7252L24.2296 19.7605V19.7252H24.1413V19.6899H24.1059C24.0883 19.6369 24.1589 19.6369 24.1059 19.6192Z"
            fill="#204063"
          />
          <path
            d="M24.2297 19.9194L24.1768 19.9371H24.2121L24.2297 19.9194Z"
            fill="white"
          />
          <path
            d="M25.5186 20.7491C25.5363 20.7491 25.5363 20.7314 25.5363 20.7137C25.5363 20.6961 25.6423 20.6961 25.6599 20.7314V20.802C25.6246 20.7844 25.6069 20.8197 25.5893 20.8374C25.5716 20.855 25.554 20.8374 25.554 20.8374H25.501C25.5186 20.7844 25.5363 20.7667 25.5186 20.7491Z"
            fill="#204063"
          />
          <path
            d="M25.5366 20.7847L25.5719 20.7671V20.7847H25.5366Z"
            fill="white"
          />
          <path
            d="M25.9602 22.3034C25.9955 22.2858 26.0485 22.3211 26.0132 22.3741C25.9778 22.427 25.9778 22.4094 25.9425 22.3917C25.9072 22.3741 25.8895 22.3034 25.9602 22.3034Z"
            fill="#204063"
          />
          <path
            d="M26.3311 19.9015V19.8662H26.4194C26.4371 19.8839 26.4371 19.9015 26.4194 19.9369H26.3841L26.3135 19.9015H26.3311Z"
            fill="#204063"
          />
          <path
            d="M26.4899 19.7778C26.4899 19.7955 26.4899 19.8132 26.4722 19.8132C26.4676 19.8132 26.4631 19.8113 26.4598 19.808C26.4564 19.8047 26.4546 19.8002 26.4546 19.7955L26.4899 19.7778Z"
            fill="#204063"
          />
          <path
            d="M25.9604 21.0495C25.9687 21.0385 25.9793 21.0296 25.9916 21.0235C26.0039 21.0174 26.0174 21.0142 26.0311 21.0142C26.0311 21.0318 26.0487 21.0318 26.0311 21.0495L25.9781 21.0848C25.9781 21.0848 25.9428 21.0671 25.9781 21.0495H25.9604Z"
            fill="#204063"
          />
          <path
            d="M25.9957 21.0494H26.0133C26.031 21.0317 25.978 21.0847 25.978 21.0494C25.978 21.0141 25.9957 21.0494 25.9957 21.0494Z"
            fill="white"
          />
          <path
            d="M26.8079 21.4029H26.7726C26.8079 21.4029 26.8079 21.3852 26.8256 21.3675C26.8433 21.3499 26.8256 21.3499 26.8079 21.3499C26.7903 21.3499 26.8433 21.3322 26.8609 21.3146H26.8433C26.9139 21.3146 27.0375 21.2439 27.1082 21.3499V21.4558H27.0905C27.0905 21.5088 27.0375 21.5265 27.0199 21.5618H26.9845C26.9669 21.5795 26.9669 21.5441 26.9492 21.5618L26.8962 21.5971V21.5618C26.8786 21.5441 26.8609 21.5618 26.8609 21.5795C26.8609 21.5971 26.8256 21.5265 26.7903 21.5088H26.7373C26.7726 21.4205 26.8256 21.4382 26.8079 21.4029Z"
            fill="#204063"
          />
          <path
            d="M26.7903 20.3254V20.29H26.7726C26.755 20.3077 26.7903 20.29 26.8079 20.3077C26.8256 20.3254 26.8079 20.2547 26.8433 20.2547C26.8786 20.2547 26.8256 20.2371 26.8079 20.2194C26.7903 20.2017 26.8609 20.2371 26.8962 20.2194C26.9316 20.2017 26.9845 20.2194 27.0199 20.1841H27.0728L27.1611 20.2547L27.1965 20.29C27.1965 20.29 27.1965 20.3077 27.2318 20.3254C27.2671 20.343 27.2848 20.3607 27.2318 20.3783C27.1788 20.396 27.2494 20.4137 27.2671 20.4137H27.2141C27.2671 20.449 27.1788 20.4666 27.2141 20.5196L27.1788 20.5549C27.1435 20.5373 27.1258 20.5903 27.1082 20.6079C27.0905 20.6256 27.0199 20.5549 27.0022 20.6256C26.9845 20.6962 26.9492 20.5549 26.9139 20.6079H26.8962C26.8786 20.5903 26.9316 20.5726 26.8962 20.5549C26.8609 20.5373 26.8786 20.5726 26.8609 20.5903C26.8433 20.6079 26.8962 20.5196 26.8433 20.5196H26.7903C26.8079 20.502 26.8079 20.4843 26.8079 20.449C26.8079 20.4137 26.7726 20.4843 26.7726 20.449C26.7726 20.4137 26.8079 20.4313 26.7903 20.4137H26.7373C26.7903 20.396 26.7726 20.343 26.7903 20.3254Z"
            fill="#204063"
          />
          <path
            d="M28.2384 20.9434C28.2384 20.9081 28.2737 20.8728 28.256 20.8375C28.2384 20.8022 28.2737 20.7492 28.3267 20.7668C28.3797 20.7845 28.3267 20.7139 28.3797 20.7315C28.4326 20.7315 28.4856 20.6962 28.5563 20.7315C28.6269 20.7668 28.5916 20.7845 28.6269 20.7668H28.6092C28.6269 20.7845 28.6799 20.8022 28.6622 20.8375V20.8728C28.6403 20.9039 28.628 20.9407 28.6269 20.9788C28.6092 20.9964 28.5739 20.9964 28.5916 21.0317C28.6092 21.0671 28.5563 21.0671 28.5386 21.0847H28.4856C28.4621 21.0847 28.4444 21.1024 28.4326 21.1377C28.4326 21.12 28.415 21.12 28.4326 21.1024C28.4503 21.0847 28.3973 21.12 28.3797 21.12H28.362C28.3443 21.1024 28.309 21.1377 28.2914 21.1377C28.2737 21.1377 28.309 21.1024 28.2914 21.0847H28.256V21.0317C28.2207 21.0141 28.2207 21.0671 28.2031 21.0494C28.1854 21.0317 28.2207 20.9788 28.2384 20.9434Z"
            fill="#204063"
          />
          <path
            d="M27.4967 19.1245C27.4967 19.1422 27.5144 19.1422 27.5144 19.1598C27.5144 19.1775 27.4614 19.1775 27.4614 19.1598C27.4614 19.1422 27.4614 19.1245 27.4967 19.1245Z"
            fill="#204063"
          />
          <path
            d="M27.638 17.8706H27.6733C27.691 17.8883 27.6557 17.9059 27.638 17.9236C27.6204 17.9412 27.638 17.9059 27.6027 17.8883C27.5674 17.8706 27.6204 17.8883 27.638 17.8706Z"
            fill="#204063"
          />
          <path
            d="M28.4681 20.3608H28.5211L28.4857 20.4138H28.4681C28.4504 20.3962 28.5034 20.3785 28.4681 20.3608V20.3962C28.4651 20.3846 28.4651 20.3724 28.4681 20.3608Z"
            fill="#204063"
          />
          <path
            d="M28.3796 19.3189C28.3788 19.3094 28.38 19.2997 28.383 19.2906C28.3861 19.2815 28.3909 19.2731 28.3973 19.2659C28.4091 19.249 28.425 19.2352 28.4435 19.2259C28.462 19.2167 28.4826 19.2122 28.5033 19.213C28.5562 19.2483 28.5916 19.2483 28.5916 19.3013C28.5916 19.3542 28.5562 19.3366 28.6092 19.3542C28.6622 19.3719 28.5562 19.3719 28.5739 19.4072C28.5916 19.4425 28.5386 19.4072 28.5209 19.4072H28.5033C28.4856 19.4425 28.4679 19.4072 28.4326 19.4249H28.4503C28.4503 19.4202 28.4484 19.4157 28.4451 19.4124C28.4418 19.4091 28.4373 19.4072 28.4326 19.4072C28.4279 19.4072 28.4235 19.4091 28.4201 19.4124C28.4168 19.4157 28.415 19.4202 28.415 19.4249L28.3796 19.3896V19.3189Z"
            fill="#204063"
          />
          <path
            d="M28.5562 19.478C28.5562 19.4603 28.6091 19.478 28.6091 19.4427H28.6445C28.6621 19.4427 28.6445 19.425 28.6621 19.4074H28.7328C28.7681 19.372 28.7857 19.4427 28.8211 19.4427C28.8564 19.4427 28.8387 19.4956 28.8917 19.4956C28.9447 19.4956 28.927 19.5839 28.874 19.6546H28.8564C28.8387 19.6722 28.8564 19.6899 28.8564 19.7076H28.8211C28.8211 19.7605 28.7504 19.7429 28.7328 19.7605C28.7151 19.7782 28.6974 19.7605 28.6974 19.7429H28.6798V19.6899C28.6621 19.7076 28.6445 19.6899 28.6445 19.7252C28.6445 19.7605 28.6268 19.6369 28.5915 19.6546C28.5962 19.6546 28.6006 19.6527 28.604 19.6494C28.6073 19.6461 28.6091 19.6416 28.6091 19.6369C28.6091 19.6322 28.6073 19.6278 28.604 19.6244C28.6006 19.6211 28.5962 19.6193 28.5915 19.6193C28.5208 19.5839 28.6091 19.5133 28.5562 19.478Z"
            fill="#204063"
          />
          <path
            d="M29.3158 19.7603C29.3334 19.7426 29.2981 19.725 29.2804 19.725C29.2628 19.725 29.2981 19.7073 29.2981 19.6897H29.2628C29.2628 19.672 29.3158 19.6897 29.2981 19.6543C29.3121 19.6543 29.3256 19.6487 29.3356 19.6388C29.3455 19.6289 29.3511 19.6154 29.3511 19.6014V19.5131C29.3864 19.5131 29.3334 19.4601 29.3864 19.4777C29.3773 19.437 29.3773 19.3948 29.3864 19.3541C29.4041 19.3541 29.3864 19.3365 29.4041 19.3188H29.4394C29.4217 19.2658 29.457 19.3188 29.457 19.2835C29.457 19.2482 29.51 19.3188 29.5453 19.3011C29.5807 19.2835 29.5807 19.3365 29.5807 19.3718C29.5807 19.4071 29.563 19.3188 29.5983 19.3011C29.6336 19.2835 29.5983 19.3718 29.6513 19.3718H29.669C29.6866 19.3718 29.6866 19.4248 29.7219 19.3894V19.4248H29.7396C29.7573 19.4424 29.7396 19.4601 29.7573 19.4601H29.7749L29.8102 19.5131H29.8279V19.566C29.8632 19.566 29.8279 19.619 29.8632 19.619C29.8985 19.619 29.8985 19.672 29.9162 19.672C29.9339 19.672 29.8809 19.672 29.8809 19.6897C29.8809 19.7073 29.9162 19.7073 29.9339 19.725H29.8985C29.8809 19.7426 29.8985 19.7603 29.9162 19.7779C29.9162 19.7956 29.8632 19.8309 29.9162 19.8309C29.9115 19.8309 29.907 19.8328 29.9037 19.8361C29.9004 19.8394 29.8985 19.8439 29.8985 19.8486C29.8985 19.8839 29.9162 19.8839 29.9339 19.9016C29.9515 19.9192 29.8632 19.8486 29.8632 19.9016V19.9722L29.8279 19.9192C29.7573 19.9545 29.8279 20.0605 29.7573 20.0782C29.7596 20.0688 29.7581 20.0589 29.7532 20.0506C29.7482 20.0423 29.7401 20.0364 29.7308 20.034C29.7214 20.0317 29.7115 20.0331 29.7032 20.0381C29.6949 20.0431 29.689 20.0511 29.6866 20.0605C29.6513 20.0605 29.6866 20.1135 29.6336 20.1135C29.5807 20.1135 29.563 20.0605 29.5277 20.0782C29.4924 20.0958 29.5277 20.1311 29.51 20.1311C29.4924 20.1311 29.5277 20.0782 29.4924 20.0605C29.51 20.0428 29.4924 20.0252 29.4747 20.0075H29.457C29.457 19.9899 29.4747 19.9722 29.4394 19.9722H29.4217C29.4041 19.9545 29.4394 19.9545 29.4217 19.9369C29.4041 19.9192 29.3864 19.9016 29.3687 19.9192C29.3511 19.9369 29.3864 19.8839 29.3511 19.8839H29.3334C29.3334 19.8662 29.3687 19.8662 29.3511 19.8309H29.2981V19.7956H29.2451C29.2804 19.7956 29.3158 19.7956 29.3158 19.7603Z"
            fill="#204063"
          />
          <path
            d="M25.2184 18.9302C25.236 18.9302 25.289 18.9125 25.3067 18.9479C25.3243 18.9832 25.3067 19.0715 25.2537 19.0538H25.236L25.183 19.0185C25.2184 18.9832 25.1477 18.9832 25.183 18.9479C25.2184 18.9125 25.2184 18.9655 25.2184 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5189 18.9302L25.4659 18.9655V18.9478L25.4482 18.9655V18.9478L25.5189 18.9302Z"
            fill="#204063"
          />
          <path
            d="M25.5896 18.8595H25.5719C25.5719 18.8419 25.5896 18.8419 25.5896 18.8242H25.5543C25.5896 18.8066 25.5896 18.7889 25.6073 18.7712H25.5896C25.6424 18.7374 25.7035 18.7191 25.7662 18.7183C25.8015 18.7359 25.8368 18.7889 25.8898 18.7536C25.9428 18.7183 25.8545 18.7889 25.8898 18.7889L25.9428 18.8949C25.9075 18.9125 25.9251 18.9478 25.9251 18.9832C25.9251 19.0185 25.8722 19.0008 25.8898 19.0361H25.8722C25.8368 19.0538 25.8722 19.0715 25.8722 19.0891H25.8192C25.8192 19.1244 25.7485 19.1244 25.7309 19.1421C25.7132 19.1598 25.6602 19.1598 25.6426 19.1951C25.6249 19.2304 25.6779 19.1068 25.6249 19.0891C25.6249 19.0938 25.6231 19.0983 25.6197 19.1016C25.6164 19.1049 25.6119 19.1068 25.6073 19.1068C25.5719 19.0715 25.6426 19.0361 25.6073 19.0361L25.5366 19.0891C25.5719 18.9655 25.6249 18.9302 25.5896 18.8595Z"
            fill="#204063"
          />
        </g>
        <path
          d="M15.3112 4.09618L15.2759 2.11828C15.267 2.03021 15.267 1.94146 15.2759 1.85339C15.2936 1.81807 15.3289 1.78275 15.3289 1.76509C15.3289 1.74743 15.3465 1.76509 15.2936 1.76509C15.2406 1.76509 15.2582 1.76509 15.2936 1.78275L15.3819 1.81807L16.4238 2.18892L17.3068 2.52446C17.3689 2.54219 17.434 2.54664 17.4979 2.53751C17.5618 2.52838 17.623 2.50588 17.6777 2.47148C17.7306 2.43616 17.8366 2.3302 17.7306 2.27722L15.788 1.57083C15.592 1.48555 15.3706 1.47923 15.1699 1.55317C15.0486 1.5845 14.9411 1.65529 14.8644 1.75439C14.7876 1.85349 14.746 1.97529 14.7461 2.10062C14.7638 2.45382 14.7638 2.80702 14.7814 3.17787V4.2198C14.7814 4.37874 15.2936 4.27278 15.2936 4.09618H15.3112Z"
          fill="#00244C"
        />
        <path
          d="M31.9647 8.29902L32.3179 8.10476C32.2473 8.10476 32.3356 8.12242 32.3002 8.10476H32.1413C32.1236 8.10476 32.0883 8.0871 32.1236 8.0871H32.053L31.9647 8.03412C31.84 7.97115 31.7312 7.88055 31.6468 7.76922C31.4682 7.53825 31.386 7.24714 31.4172 6.95687L31.064 7.15113C31.0287 7.13347 31.117 7.15113 31.064 7.15113H31.1347L31.2406 7.18645C31.2406 7.18645 31.2936 7.20411 31.2583 7.18645L31.3113 7.22177L31.4172 7.27475L31.5762 7.38071L31.7351 7.53964C31.9089 7.77299 31.9907 8.0622 31.9647 8.352C31.947 8.45795 32.106 8.47561 32.1943 8.47561C32.2826 8.47561 32.4592 8.40498 32.4768 8.28136C32.5075 7.93365 32.4067 7.58708 32.1943 7.31007C31.9575 7.03374 31.621 6.86232 31.2583 6.83325C31.1523 6.81559 30.9228 6.88623 30.9051 7.00985C30.8832 7.18247 30.897 7.35773 30.9456 7.5248C30.9942 7.69187 31.0766 7.84719 31.1877 7.98114C31.3027 8.12195 31.4448 8.23826 31.6056 8.32319C31.7663 8.40813 31.9425 8.45995 32.1236 8.47561C32.2296 8.49327 32.4592 8.42264 32.4768 8.28136C32.4945 8.01646 31.9824 8.10476 31.9647 8.29902Z"
          fill="#00244C"
        />
        <path
          d="M24.2827 7.2746C24.205 7.25069 24.122 7.24964 24.0438 7.27156C23.9655 7.29347 23.8951 7.33744 23.8412 7.39822C23.7618 7.54904 23.7131 7.7141 23.698 7.88385C23.6828 8.0536 23.7015 8.22467 23.7529 8.38716C23.8047 8.55139 23.8893 8.70338 24.0016 8.83391C24.114 8.96445 24.2516 9.07081 24.4063 9.14654C24.4759 9.16794 24.5498 9.17106 24.6209 9.1556C24.6921 9.14013 24.758 9.1066 24.8125 9.05824L24.8478 9.02292C25.0003 8.70974 25.0318 8.35126 24.9361 8.01631C24.8206 7.69495 24.5869 7.4297 24.2827 7.2746Z"
          fill="#00244C"
        />
        <path
          d="M36.4856 14.7097C36.3917 14.5685 36.2694 14.4484 36.1265 14.3572C35.9835 14.266 35.8231 14.2056 35.6555 14.1799C35.5657 14.1651 35.4735 14.1774 35.3906 14.2152C35.3377 14.2329 35.2494 14.2682 35.2494 14.3388C35.2141 14.5054 35.2131 14.6775 35.2465 14.8445C35.2799 15.0115 35.347 15.1699 35.4436 15.3101C35.64 15.5921 35.9371 15.7881 36.2736 15.8576H36.3266C36.3859 15.8696 36.4475 15.8635 36.5032 15.8399H36.5209C36.5209 15.8352 36.5227 15.8307 36.5261 15.8274C36.5294 15.8241 36.5339 15.8223 36.5385 15.8223L36.6798 15.734C36.6798 15.7163 36.6975 15.6986 36.6975 15.681C36.7324 15.5133 36.7316 15.3401 36.6951 15.1727C36.6586 15.0054 36.5872 14.8476 36.4856 14.7097Z"
          fill="#00244C"
        />
        <path
          d="M29.492 13.7382V13.6323L29.3684 13.7735C29.3283 13.8128 29.2801 13.843 29.2271 13.8618L29.1918 13.8972C29.2095 13.8795 29.1918 13.8972 29.1742 13.8972H29.0682C29.0682 13.8972 29.0152 13.9148 29.0505 13.9148H28.8386L28.6444 13.8795C28.5156 13.8459 28.3953 13.7858 28.2912 13.7029V13.7912C28.3621 13.6967 28.4524 13.6184 28.5561 13.5616H28.662C28.662 13.544 28.715 13.544 28.6797 13.544H28.9446L29.1212 13.5793C29.2579 13.6152 29.3847 13.6816 29.492 13.7735C29.544 13.7999 29.6015 13.8137 29.6598 13.8137C29.7181 13.8137 29.7756 13.7999 29.8276 13.7735C29.8806 13.7559 30.0572 13.6499 29.9689 13.5793C29.3331 13.0848 28.3088 13.2437 27.8143 13.8618C27.7967 13.8972 27.779 13.9325 27.8143 13.9678C28.4501 14.4799 29.4744 14.3033 29.9689 13.6676C29.9865 13.6499 30.0042 13.5969 29.9689 13.5793C29.8806 13.5086 29.7393 13.544 29.6333 13.5793C29.5274 13.6146 29.4037 13.6676 29.492 13.7382Z"
          fill="#00244C"
        />
        <path
          d="M18.7728 6.42692V6.32096C18.7411 6.37065 18.6989 6.41284 18.6492 6.44458C18.6101 6.48943 18.5619 6.52553 18.5079 6.55054L18.4549 6.58586C18.4726 6.58586 18.4902 6.5682 18.4549 6.58586H18.349C18.3313 6.58586 18.296 6.60352 18.3313 6.58586C18.3666 6.5682 18.296 6.60352 18.296 6.60352H18.1194L17.9251 6.5682C17.7992 6.52732 17.6802 6.46779 17.5719 6.3916V6.4799C17.6377 6.38068 17.7293 6.30129 17.8368 6.25032C17.8368 6.23266 17.8545 6.23266 17.8721 6.21501C17.8898 6.19735 17.8721 6.23266 17.8898 6.21501H17.9428C17.9428 6.21501 17.9781 6.19735 17.9604 6.21501C17.9428 6.23266 17.9781 6.19735 17.9781 6.19735H18.2253L18.4019 6.23266C18.5371 6.27254 18.6631 6.33854 18.7728 6.42692C18.8253 6.45373 18.884 6.46622 18.9429 6.46312C19.0019 6.46002 19.0589 6.44144 19.1083 6.40926C19.1613 6.3916 19.3379 6.3033 19.2496 6.23266C18.6139 5.72053 17.5896 5.87947 17.0951 6.51522C17.0774 6.53288 17.0598 6.58586 17.0951 6.60352C17.7309 7.11566 18.7551 6.95672 19.2496 6.32096C19.2673 6.3033 19.2849 6.25032 19.2496 6.23266C19.1976 6.20629 19.1402 6.19255 19.0819 6.19255C19.0236 6.19255 18.9661 6.20629 18.9141 6.23266C18.8788 6.25032 18.6845 6.35628 18.7728 6.42692Z"
          fill="#00244C"
        />
        <path
          opacity="0.15"
          d="M6.69337 12.1489C6.61866 13.5954 6.03252 14.9684 5.0395 16.0228C4.04648 17.0773 2.71117 17.7447 1.27173 17.906C1.25616 17.8425 1.25021 17.777 1.25407 17.7118V13.0849C1.25172 12.9628 1.27374 12.8415 1.31884 12.728C1.36394 12.6146 1.43121 12.5113 1.51672 12.4241C1.60223 12.337 1.70426 12.2677 1.81684 12.2205C1.92942 12.1732 2.0503 12.1489 2.1724 12.1489H6.69337Z"
          fill="url(#paint0_linear_2037_8001)"
        />
        <path
          opacity="0.15"
          d="M19.02 18.6301H10.0664C10.138 17.4914 10.6408 16.4227 11.4725 15.6416C12.3042 14.8606 13.4023 14.4258 14.5432 14.4258C15.6842 14.4258 16.7823 14.8606 17.614 15.6416C18.4457 16.4227 18.9485 17.4914 19.02 18.6301Z"
          fill="url(#paint1_linear_2037_8001)"
        />
        <path
          d="M38.3752 15.0983C36.9801 15.84 35.32 15.7341 33.8366 15.3456C32.348 14.9516 30.9544 14.2608 29.7395 13.3147C28.5562 12.3611 27.6909 11.0895 27.4613 9.58846C27.2317 8.08738 27.6379 6.69225 28.8211 5.86224C30.0044 5.03223 31.2582 5.01457 32.2119 5.86224C32.4984 6.10041 32.6922 6.4317 32.7593 6.79821C32.7909 7.19259 32.6709 7.58417 32.4238 7.89312C31.9823 8.4759 31.2936 8.86441 30.6048 9.11165C29.245 9.58846 27.6909 9.53548 26.2781 9.30591C24.8861 9.09292 23.5345 8.67017 22.2693 8.05206C19.7362 6.8278 17.591 4.92704 16.0706 2.55986C15.8712 2.25804 15.6885 1.94559 15.5231 1.62389C15.4172 1.44729 14.9227 1.60623 15.011 1.76516C16.4716 4.47978 18.7184 6.68967 21.4569 8.10504C22.8091 8.8129 24.2626 9.30734 25.766 9.5708C27.32 9.8357 28.9977 9.90634 30.5165 9.42953C31.2885 9.21183 31.9971 8.81213 32.5827 8.26398C33.1302 7.71652 33.5187 6.92183 33.1125 6.18012C32.4061 4.90861 30.6754 4.78499 29.4392 5.22649C28.7617 5.46486 28.1653 5.88966 27.7185 6.45201C27.2718 7.01435 26.9929 7.6914 26.9139 8.40526C26.7196 10.0123 27.373 11.6017 28.4679 12.7672C29.5629 13.9328 31.064 14.7805 32.6004 15.3279C34.1368 15.8754 35.9205 16.1756 37.5629 15.7164C37.9535 15.6002 38.332 15.4464 38.6931 15.2573C38.7814 15.2043 38.8344 15.116 38.7284 15.0453C38.6225 14.9747 38.4635 15.0453 38.3752 15.0983Z"
          fill="#00244C"
        />
        <g opacity="0.3">
          <path
            d="M14.0042 27.0007C14.2773 27.0007 14.4987 26.7793 14.4987 26.5062C14.4987 26.2331 14.2773 26.0117 14.0042 26.0117C13.7312 26.0117 13.5098 26.2331 13.5098 26.5062C13.5098 26.7793 13.7312 27.0007 14.0042 27.0007Z"
            fill="white"
          />
          <path
            d="M14.2339 26.5242C14.2382 26.572 14.2322 26.6202 14.2163 26.6655V26.7008C14.2115 26.7273 14.1992 26.7518 14.181 26.7715H14.1633C14.1633 26.8068 14.1986 26.7361 14.1633 26.7715C14.128 26.8068 14.128 26.8068 14.128 26.8244H14.0044L13.9337 26.7891C13.8984 26.7715 13.9514 26.8068 13.9337 26.7891H13.9161L13.8631 26.7185L13.8278 26.6655C13.8278 26.6832 13.8454 26.7008 13.8278 26.6655C13.8176 26.6565 13.8112 26.6438 13.8101 26.6302C13.7905 26.5916 13.7785 26.5497 13.7748 26.5066C13.7748 26.4713 13.7748 26.4536 13.7924 26.4359C13.7898 26.411 13.7961 26.386 13.8101 26.3653C13.8101 26.3476 13.8101 26.33 13.8278 26.33C13.8454 26.33 13.8454 26.2947 13.8631 26.277C13.8807 26.2593 13.8278 26.2947 13.8454 26.277H13.8807C13.8807 26.2593 13.8984 26.2593 13.8984 26.2417C13.8984 26.224 13.8454 26.277 13.8807 26.2593H13.9337C13.9867 26.2417 13.8631 26.277 13.9161 26.277H13.9514C13.8984 26.2947 13.9161 26.277 13.9337 26.2947H14.0044L14.075 26.33H14.1103L14.1633 26.3829L14.1986 26.4359C14.181 26.4183 14.1986 26.4536 14.2163 26.4536V26.4889C14.2339 26.5066 14.2339 26.5419 14.2516 26.5595V26.5949C14.2489 26.6158 14.2525 26.6371 14.2619 26.6559C14.2713 26.6748 14.2862 26.6905 14.3046 26.7008C14.331 26.7164 14.3605 26.726 14.391 26.729C14.4214 26.7321 14.4522 26.7285 14.4812 26.7185C14.5497 26.7201 14.6172 26.7016 14.6755 26.6655C14.7108 26.6302 14.7638 26.5949 14.7638 26.5419C14.7645 26.4107 14.7277 26.282 14.6578 26.171C14.5761 26.0695 14.4651 25.9955 14.3399 25.9591C14.1819 25.9099 14.013 25.907 13.8534 25.9508C13.6937 25.9946 13.55 26.0833 13.4392 26.2064C13.3433 26.3016 13.2813 26.4257 13.2626 26.5595C13.2497 26.6896 13.2808 26.8202 13.3509 26.9304C13.4332 27.0497 13.5503 27.1408 13.6861 27.1914C13.8219 27.2419 13.9701 27.2495 14.1103 27.213C14.4282 27.1423 14.7638 26.8951 14.7638 26.5419C14.7638 26.4889 14.7638 26.4712 14.7108 26.4359H14.5342L14.3399 26.5066C14.2869 26.4359 14.2339 26.4889 14.2339 26.5242Z"
            fill="white"
          />
        </g>
        <g opacity="0.3">
          <path
            d="M14.499 32.3163C15.0159 32.3163 15.435 31.8972 15.435 31.3803C15.435 30.8634 15.0159 30.4443 14.499 30.4443C13.982 30.4443 13.563 30.8634 13.563 31.3803C13.563 31.8972 13.982 32.3163 14.499 32.3163Z"
            fill="white"
          />
          <path
            d="M15.1699 31.3983C15.1667 31.5671 15.1178 31.7318 15.0286 31.8751L14.905 31.9988C14.8956 31.9988 14.8866 32.0025 14.88 32.0091C14.8734 32.0157 14.8697 32.0247 14.8697 32.0341H14.7284C14.7637 32.0341 14.6931 32.0517 14.6931 32.0517H14.3575C14.2162 32.0004 14.0932 31.9082 14.0043 31.7868C13.8997 31.6635 13.8352 31.5112 13.8195 31.3503C13.8037 31.1894 13.8374 31.0275 13.916 30.8862L14.0573 30.7272H14.075L14.1279 30.6919L14.1633 30.6566C14.1279 30.6919 14.1986 30.6389 14.2162 30.6389H14.6931L14.799 30.6919L14.9756 30.8509C15.1004 30.9923 15.1694 31.1744 15.1699 31.363C15.1699 31.4866 15.2935 31.5219 15.3995 31.5219C15.5054 31.5219 15.682 31.4336 15.682 31.3277C15.689 31.1015 15.622 30.8792 15.4914 30.6944C15.3608 30.5096 15.1735 30.3724 14.958 30.3034C14.7147 30.2214 14.4527 30.2128 14.2045 30.2787C13.9564 30.3447 13.7332 30.4822 13.5628 30.6743C13.4135 30.8445 13.3226 31.0581 13.3036 31.2838C13.2845 31.5094 13.3382 31.7352 13.4569 31.9281C13.7041 32.352 14.2339 32.5109 14.7107 32.4226C15.1876 32.3343 15.682 31.8751 15.682 31.3277C15.682 31.1864 15.5584 31.1511 15.4525 31.1687C15.3465 31.1864 15.1699 31.2747 15.1699 31.3983Z"
            fill="white"
          />
        </g>
        <g opacity="0.3">
          <path
            d="M19.7263 36.8374C20.1652 36.8374 20.521 36.4816 20.521 36.0427C20.521 35.6038 20.1652 35.248 19.7263 35.248C19.2874 35.248 18.9316 35.6038 18.9316 36.0427C18.9316 36.4816 19.2874 36.8374 19.7263 36.8374Z"
            fill="white"
          />
          <path
            d="M20.2563 36.1133C20.2617 36.2533 20.218 36.3907 20.1327 36.5019L20.0091 36.6255L19.9738 36.6608H19.9208C19.9561 36.6431 19.8855 36.6608 19.8855 36.6608H19.6559C19.5247 36.6082 19.4134 36.5155 19.338 36.3959C19.2518 36.2869 19.2006 36.1543 19.1911 36.0156C19.1817 35.8769 19.2144 35.7386 19.285 35.6189L19.338 35.5306L19.391 35.4776L19.4616 35.4069H19.5499C19.4793 35.4423 19.5499 35.4069 19.5676 35.4069H19.7265C19.8818 35.4532 20.0176 35.549 20.1133 35.6798C20.209 35.8105 20.2592 35.969 20.2563 36.131C20.2563 36.1663 20.327 36.184 20.3623 36.184C20.4216 36.196 20.4831 36.1899 20.5389 36.1663C20.6272 36.1487 20.7685 36.0957 20.7685 35.9897C20.7649 35.8063 20.703 35.6287 20.5919 35.4827C20.4808 35.3367 20.3262 35.2298 20.1504 35.1774C19.9248 35.1164 19.6868 35.1187 19.4625 35.1842C19.2382 35.2496 19.0362 35.3755 18.8788 35.5482C18.7618 35.6903 18.692 35.8654 18.6793 36.049C18.6667 36.2327 18.7117 36.4157 18.8082 36.5725C19.0554 36.9433 19.5146 37.0316 19.9208 36.9433C20.1505 36.9068 20.3605 36.7918 20.515 36.618C20.6695 36.4441 20.7591 36.2221 20.7685 35.9897C20.7685 35.9544 20.6978 35.9367 20.6802 35.9367C20.615 35.9243 20.5477 35.9304 20.4859 35.9544C20.3976 35.9544 20.2563 36.0074 20.2563 36.1133Z"
            fill="white"
          />
        </g>
        <path
          d="M1.25386 28.7313C1.94635 28.7313 2.50773 28.17 2.50773 27.4775C2.50773 26.785 1.94635 26.2236 1.25386 26.2236C0.561374 26.2236 0 26.785 0 27.4775C0 28.17 0.561374 28.7313 1.25386 28.7313Z"
          fill="#00244C"
        />
        <path
          d="M39.6113 14.8685C39.8356 14.8685 40.0174 14.6867 40.0174 14.4623C40.0174 14.238 39.8356 14.0562 39.6113 14.0562C39.3869 14.0562 39.2051 14.238 39.2051 14.4623C39.2051 14.6867 39.3869 14.8685 39.6113 14.8685Z"
          fill="#00244C"
        />
        <path
          d="M14.4282 37.2613L21.6335 38.5681C22.1326 38.6615 22.6471 38.6297 23.1309 38.4756C23.6148 38.3215 24.0529 38.0499 24.4061 37.6851L26.9491 35.0891C27.02 35.0133 27.075 34.924 27.1108 34.8265C27.1466 34.729 27.1625 34.6254 27.1575 34.5217C27.1526 34.418 27.1269 34.3163 27.082 34.2227C27.0371 34.129 26.9739 34.0454 26.8961 33.9766C26.7702 33.8751 26.6157 33.8155 26.4543 33.806C26.2928 33.7965 26.1325 33.8376 25.9955 33.9236L23.0992 35.7779C22.7601 35.9914 22.3552 36.0751 21.9592 36.0134C21.5632 35.9518 21.2028 35.7489 20.9447 35.4423L19.4613 33.6587C19.3803 33.5598 19.3243 33.4428 19.2982 33.3176C19.2721 33.1924 19.2765 33.0628 19.3112 32.9398C19.3459 32.8167 19.4097 32.7038 19.4973 32.6107C19.585 32.5176 19.6937 32.447 19.8145 32.4049L21.5098 31.8221C21.6663 31.7668 21.7991 31.6595 21.8859 31.518C21.9727 31.3766 22.0083 31.2096 21.9867 31.045C21.9781 30.9487 21.9499 30.8552 21.9038 30.7702C21.8576 30.6852 21.7945 30.6106 21.7184 30.551C21.6422 30.4914 21.5546 30.4481 21.461 30.4237C21.3674 30.3993 21.2699 30.3944 21.1743 30.4093L20.0617 30.5329C19.3512 30.6217 18.6788 30.9043 18.1181 31.3497C17.5574 31.7952 17.1301 32.3862 16.8829 33.0583H13.916"
          fill="white"
        />
        <path
          d="M14.2163 37.3669L20.2384 38.4618L21.3157 38.6561C21.9709 38.7687 22.6436 38.7203 23.2759 38.5148C23.8715 38.2816 24.4081 37.9198 24.8477 37.4552L26.1192 36.1484L27.1435 35.1065C27.2456 35.0145 27.3233 34.8985 27.3695 34.769C27.4157 34.6396 27.4291 34.5007 27.4084 34.3648C27.3377 33.9233 26.9139 33.676 26.4724 33.7114C26.0309 33.7467 25.5894 34.0645 25.1832 34.3118L23.5585 35.3537C23.2053 35.5833 22.7814 35.9541 22.3399 35.9365C21.8984 35.9188 21.2274 35.4067 20.8212 34.9122L19.7439 33.6231C19.6395 33.504 19.5721 33.3569 19.5501 33.2C19.5282 33.0432 19.5526 32.8833 19.6203 32.7401C19.7439 32.4928 19.9382 32.4398 20.1678 32.3692L21.5982 31.8747C21.9867 31.7335 22.3046 31.4156 22.2516 30.9741C22.2168 30.7678 22.1038 30.5828 21.936 30.4578C21.7682 30.3328 21.5586 30.2774 21.351 30.303C20.8112 30.3377 20.2743 30.4085 19.7439 30.5149C18.8068 30.7035 17.9571 31.1934 17.3245 31.9101C17.0293 32.2656 16.791 32.6647 16.6181 33.0933L17.0419 32.952H14.0927C13.9612 32.9492 13.832 32.9861 13.7218 33.0579C13.6512 33.1109 13.6335 33.1462 13.7572 33.1462H16.7064C16.8124 33.1462 17.0949 33.1109 17.1302 33.005C17.4489 32.1238 18.0849 31.3933 18.9139 30.9564C19.5143 30.6385 20.1854 30.6032 20.8388 30.5326C21.1567 30.4796 21.4569 30.5149 21.6512 30.8328C21.8455 31.1507 21.7572 31.6275 21.404 31.7864C21.0508 31.9454 20.415 32.122 19.9382 32.2809C19.7228 32.3386 19.5195 32.4343 19.3377 32.5635C19.1914 32.6807 19.0891 32.8439 19.0474 33.0267C19.0057 33.2095 19.0271 33.401 19.1082 33.5701C19.1938 33.7156 19.2944 33.8517 19.4084 33.9762L19.9735 34.6473C20.2737 35.0005 20.5386 35.4067 20.8742 35.7069C21.5452 36.2897 22.5695 36.219 23.2936 35.7776L25.7837 34.1882C25.9064 34.0956 26.0363 34.0129 26.1722 33.9409C26.5077 33.7643 26.8609 34.2411 26.8962 34.5414C26.9316 34.8416 26.5254 35.3184 26.2428 35.601L24.1766 37.7201C23.8779 38.0304 23.5073 38.2621 23.0975 38.3946C22.6877 38.527 22.2516 38.5562 21.8278 38.4795L21.0508 38.3382L14.7991 37.208L14.6402 37.1727C14.5181 37.1617 14.3954 37.1862 14.287 37.2433C14.2516 37.261 14.1104 37.3493 14.2163 37.3669Z"
          fill="#00244C"
        />
        <path
          d="M16.6181 33.0936L16.4944 33.5174V33.5704C16.4768 33.6057 16.5121 33.641 16.5474 33.6587H16.7064L16.9006 33.5881C16.9359 33.5527 16.9889 33.5351 17.0066 33.4821L17.1302 33.0583V33.0053C17.1479 32.9523 17.1125 32.9347 17.0772 32.917H16.9183L16.724 32.9876C16.677 33.0089 16.6393 33.0465 16.6181 33.0936Z"
          fill="#00244C"
        />
        <path
          d="M15.7175 37.5086C14.0398 36.4667 12.9802 31.9105 15.0464 33.0584C15.4173 32.1224 11.4967 31.1158 11.1435 32.0518V32.193C10.0663 31.7339 8.40621 31.5396 8.17663 32.1401C5.47465 32.4756 6.85213 39.2746 9.20091 38.9921C9.66008 39.7868 11.2318 39.5219 12.1678 38.9038C12.9095 40.1753 16.4592 38.7625 15.7175 37.5086Z"
          fill="#00244C"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2037_8001"
          x1="25.1905"
          y1="13.9891"
          x2="47.1808"
          y2="13.0089"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0068CA" />
          <stop offset="0.1" stopColor="#1475D2" stopOpacity="0.84" />
          <stop offset="0.27" stopColor="#348BE0" stopOpacity="0.59" />
          <stop offset="0.43" stopColor="#4E9CEB" stopOpacity="0.38" />
          <stop offset="0.59" stopColor="#62AAF4" stopOpacity="0.21" />
          <stop offset="0.74" stopColor="#71B4FA" stopOpacity="0.1" />
          <stop offset="0.88" stopColor="#7ABAFE" stopOpacity="0.02" />
          <stop offset="1" stopColor="#7DBCFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2037_8001"
          x1="26.0876"
          y1="16.0341"
          x2="48.0761"
          y2="15.0557"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0068CA" />
          <stop offset="0.1" stopColor="#1475D2" stopOpacity="0.84" />
          <stop offset="0.27" stopColor="#348BE0" stopOpacity="0.59" />
          <stop offset="0.43" stopColor="#4E9CEB" stopOpacity="0.38" />
          <stop offset="0.59" stopColor="#62AAF4" stopOpacity="0.21" />
          <stop offset="0.74" stopColor="#71B4FA" stopOpacity="0.1" />
          <stop offset="0.88" stopColor="#7ABAFE" stopOpacity="0.02" />
          <stop offset="1" stopColor="#7DBCFF" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_2037_8001">
          <rect
            width="40"
            height="37.9863"
            fill="white"
            transform="translate(0 1.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
